export const QUESTIONS = [
    {
       "id":4041,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following can be determined solely from the balance sheet except the:",
       "choice_a":"Current ratio",
       "choice_b":"Acid test ratio",
       "choice_c":"EPS",
       "choice_d":"Book value of the corporation",
       "correct_answer":"C",
       "explanation":"The corporation\u0027s EPS can not be determined solely from the balance sheet. The earnings available to common stockholders are found on the income statement."
    },
    {
       "id":4042,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following indicate a down turn in the business cycle except:",
       "choice_a":"Rising inventories",
       "choice_b":"High consumer debt",
       "choice_c":"Falling inventories",
       "choice_d":"Falling stock prices",
       "correct_answer":"C",
       "explanation":"Falling inventories are a sign of a pick up in the economy."
    },
    {
       "id":4043,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An economist looking at the consumer price index has noticed that it has been consistently rising over the last four quarters. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Consumer prices are rising  </li><li>Bond yields are falling </li><li>Bond yields are rising </li><li>Bond prices are falling</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and IV",
       "choice_c":"I and II",
       "choice_d":"I, III, and IV",
       "correct_answer":"D",
       "explanation":"As the CPI rises, bonds prices are falling, while interest rates and consumer prices are rising."
    },
    {
       "id":4044,
       "topic_id":1,
       "practice_test_id":1,
       "question":"Depreciation is not: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Accumulated to a liability </li><li>Recovery of the cost of an asset </li><li>Included as an entry on the income statement </li><li>Accumulated to an asset</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I and II",
       "choice_d":"I, II and III",
       "correct_answer":"A",
       "explanation":"Choice I is the only answer that is not true about depreciation."
    },
    {
       "id":4045,
       "topic_id":1,
       "practice_test_id":2,
       "question":"During an inflationary period you would expect: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Bond prices to go up </li><li>Bond prices to go down </li><li>Yields to go up </li><li>Yields to go down</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II only",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Anytime you have inflation, bond prices go down and the yields on the bonds go up."
    },
    {
       "id":4046,
       "topic_id":1,
       "practice_test_id":3,
       "question":"During an inflationary period, the FED will:",
       "choice_a":"Reduce spending",
       "choice_b":"Lower rates",
       "choice_c":"Increase spending",
       "choice_d":"Raise rates",
       "correct_answer":"D",
       "explanation":"The Federal Reserve Board controls monetary policy and will always raise rates to fight inflation."
    },
    {
       "id":4047,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Economics involves all of the following except:",
       "choice_a":"The study of supply and demand",
       "choice_b":"As demand rises, price tends to rise",
       "choice_c":"As supply rises, price tends to fall",
       "choice_d":"As supply rises, prices tend to rise",
       "correct_answer":"D",
       "explanation":"The main theory of economics is one of supply and demand; if the supply outpaces the demand, the price of the goods will fall."
    },
    {
       "id":4048,
       "topic_id":1,
       "practice_test_id":5,
       "question":"Economists chart the health of a nation\u0027s economy by measuring which of the following:",
       "choice_a":"The country\u0027s GDP",
       "choice_b":"The country\u0027s supply and demand models",
       "choice_c":"The country\u0027s business cycle",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Economists gain a clearer picture of a nation\u0027s economic state by measuring its GDP, by monitoring supply and demand models, and by charting its business cycle."
    },
    {
       "id":4049,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Fiscal policy is controlled by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>President </li><li>FOMC </li><li>Congress </li><li>FRB</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"I and II",
       "correct_answer":"B",
       "explanation":"Fiscal policy is controlled by the President and Congress."
    },
    {
       "id":4050,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Fiscal policy:",
       "choice_a":"Is controlled by the President and the Executive branch",
       "choice_b":"Determines how to manage the budget and governmental spending",
       "choice_c":"May change levels of interest, taxation, and spending",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"Fiscal policy is controlled by the President and Congress, and it may change levels of Federal spending and Federal taxation."
    },
    {
       "id":4051,
       "topic_id":1,
       "practice_test_id":"",
       "question":"If a corporation should go bankrupt, whatever assets remained would be distributed in which of the following order of priorities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Common stockholders </li><li>Secured bondholders  </li><li>Internal Revenue Service </li><li>Debenture bondholders</li></ol>",
       "choice_a":"I, II, III and IV",
       "choice_b":"IV, III, II and I",
       "choice_c":"III, II, I and IV",
       "choice_d":"III, II, IV and I",
       "correct_answer":"D",
       "explanation":"Common stockholders will always be paid last."
    },
    {
       "id":4052,
       "topic_id":1,
       "practice_test_id":"",
       "question":"If the amount on the balance sheet representing shareholders equity declines as a result of a corporate transaction, while assets remain unchanged, which must occur?",
       "choice_a":"A decrease in accrued expenses",
       "choice_b":"A decrease in prepaid expenses",
       "choice_c":"An increase in total liabilities",
       "choice_d":"An increase in total net worth accounts",
       "correct_answer":"C",
       "explanation":"The transaction must have resulted in an increase in total liabilities."
    },
    {
       "id":4053,
       "topic_id":1,
       "practice_test_id":"",
       "question":"If XYZ Corporation split its $1 par common stock 2 for 1, the result would be: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The par value would be reduced to 50¢ </li><li>The par value would be increased to $2 per share </li><li>The retained earnings would decrease </li><li>The number of authorized shares would be reduced</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"II and III",
       "choice_d":"III only",
       "correct_answer":"A",
       "explanation":"In the case of a forward stock split only, the par value would be reduced from $1 to 50 cents. All of the other choices listed are incorrect."
    },
    {
       "id":4054,
       "topic_id":1,
       "practice_test_id":"",
       "question":"In an inverted scale, the nearer maturities have yields to maturity in relation to the longer maturities which are:",
       "choice_a":"Unrelated",
       "choice_b":"Higher",
       "choice_c":"Lower",
       "choice_d":"The same",
       "correct_answer":"B",
       "explanation":"An inverted yield curve will have higher interest rates for short term maturities than for long term maturities."
    },
    {
       "id":4055,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Overall interest rates depend on:",
       "choice_a":"The supply and demand for money",
       "choice_b":"Any rise in the cost of goods and services",
       "choice_c":"Any changes in the discount rate, the federal funds rate, the broker call loan rate, or the prime rate",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the factors help to determine the overall interest rates."
    },
    {
       "id":4056,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Regarding cash dividends, which of the following statements is correct?",
       "choice_a":"A cash dividend becomes a current liability when it is declared",
       "choice_b":"The amount of the dividend may never exceed the current earnings of the corporation",
       "choice_c":"Cash dividends must be paid if the earnings for the year exceed the amount of the stated dividend",
       "choice_d":"Dividends are taxed in the same manner as long-term capital gains",
       "correct_answer":"A",
       "explanation":"A cash dividend becomes a current liability when it is declared by the corporation."
    },
    {
       "id":4057,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The balance sheet equation is:",
       "choice_a":"Assets= liabilities + net worth",
       "choice_b":"Assets + liabilities = net worth",
       "choice_c":"Net income after taxes + depreciation = cash flow",
       "choice_d":"Income before taxes + depreciation = cash flow",
       "correct_answer":"A",
       "explanation":"The balance sheet equation may be written two ways: <br>Assets - liabilities = net worth<br>or <br>Assets = liabilities + net worth"
    },
    {
       "id":4058,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The best description of a balance sheet would be:",
       "choice_a":"Assets = Stockholders Equity",
       "choice_b":"Assets = Liabilities + Profits",
       "choice_c":"Total Assets = Total Liabilities + Profits",
       "choice_d":"Total Assets = Total Liabilities + Net Worth",
       "correct_answer":"D",
       "explanation":"The balance sheet equation may be expressed two ways. <br>Assets - Liabilities = net worth <br>or <br>assets = liabilities + net worth."
    },
    {
       "id":4059,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The book value of a common share may best be described as:",
       "choice_a":"The current price of the stock",
       "choice_b":"The total par value of all the common shares",
       "choice_c":"The total market value of all of the common shares",
       "choice_d":"The theoretical liquidation value of the shares",
       "correct_answer":"D",
       "explanation":"The book value of the stock is its theoretical liquidation value, or assets minus liabilities."
    },
    {
       "id":4060,
       "topic_id":1,
       "practice_test_id":2,
       "question":"The broker call loan rate is:",
       "choice_a":"The rate that member banks charge each other for overnight loans",
       "choice_b":"The rate that banks charge their most creditworthy corporate customers on loans",
       "choice_c":"The rate that the Federal Reserve Bank charges member banks on loans",
       "choice_d":"The rate that banks charge to broker dealers to finance their customers\u0027 margin purchases",
       "correct_answer":"D",
       "explanation":"The broker call rate is the rate that banks charge to broker dealers to finance their customers\u0027 margin purchases."
    },
    {
       "id":4061,
       "topic_id":1,
       "practice_test_id":3,
       "question":"The calculation for earnings per share on a \u0027primary\u0027 basis is computed based upon:",
       "choice_a":"The outstanding common shares + the amount of shares that would be outstanding if convertible bonds and convertible preferred stock were converted into common stock",
       "choice_b":"The number of outstanding common shares only",
       "choice_c":"The number of outstanding common shares + the retained earnings",
       "choice_d":"The number of outstanding common shares + the working capital",
       "correct_answer":"B",
       "explanation":"Primary EPS is calculated based on the total number of outstanding shares only."
    },
    {
       "id":4062,
       "topic_id":1,
       "practice_test_id":4,
       "question":"The Consumer Price Inde (CPI) is all of the following except:",
       "choice_a":"A collection of goods and services which consumers use most in their daily lives",
       "choice_b":"Used to measure the rate of change in overall prices",
       "choice_c":"Predicts inflation when prices rise continually",
       "choice_d":"Predicts deflation when prices rise continually",
       "correct_answer":"D",
       "explanation":"The CPI is used to predict deflation when prices fall continually."
    },
    {
       "id":4063,
       "topic_id":1,
       "practice_test_id":5,
       "question":"The discount rate is:",
       "choice_a":"The rate that member banks charge each other for overnight loans",
       "choice_b":"The rate that banks charge their most creditworthy corporate customers on loans",
       "choice_c":"The rate that the Federal Reserve Bank charges member banks on loans",
       "choice_d":"The rate that banks charge to broker dealers to finance their customers\u0027 margin purchases",
       "correct_answer":"C",
       "explanation":"The discount rate is the rate that the Federal Reserve Bank charges member banks on loans."
    },
    {
       "id":4064,
       "topic_id":1,
       "practice_test_id":6,
       "question":"The federal funds rate is:",
       "choice_a":"The rate that member banks charge each other for overnight loans",
       "choice_b":"The rate that banks charge their most creditworthy corporate customers on loans",
       "choice_c":"The rate that the Federal Reserve Bank charges member banks on loans",
       "choice_d":"The rate that banks charge to broker dealers to finance their customers\u0027 margin purchases",
       "correct_answer":"A",
       "explanation":"The federal funds rate is the rate that member banks charge each other for overnight loans."
    },
    {
       "id":4065,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The Federal Reserve Board set all of the following except:",
       "choice_a":"Monetary policy",
       "choice_b":"Reserve requirement",
       "choice_c":"Governmental spending",
       "choice_d":"Discount rate",
       "correct_answer":"C",
       "explanation":"The Federal Reserve sets all of those except government spending."
    },
    {
       "id":4066,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The Federal Reserve Board tool most used to control money and credit is:",
       "choice_a":"Reserve requirements",
       "choice_b":"Discount rate",
       "choice_c":"Margin requirements",
       "choice_d":"Open-market operations",
       "correct_answer":"D",
       "explanation":"The tool most used by the FRB to influence the direction of interest rates is open market operations."
    },
    {
       "id":4067,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The Federal Reserve Board tries to influence the economy through the business cycle by:",
       "choice_a":"Adjusting the level of money supply and the interest rates",
       "choice_b":"Adjusting the supply and demand model",
       "choice_c":"Adjusting the business cycle model",
       "choice_d":"All of the choices listed",
       "correct_answer":"A",
       "explanation":"The Federal Reserve Board tries to influence the economy by adjusting the level of money supply and the interest rates."
    },
    {
       "id":4068,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The Federal Reserve Board wants to stimulate the economy. Which of the following are they least likely to do?",
       "choice_a":"Change the reserve requirement",
       "choice_b":"Change the discount rate",
       "choice_c":"Purchase bonds in the secondary market",
       "choice_d":"Change the margin requirement",
       "correct_answer":"A",
       "explanation":"Of all the answers listed the Fed would be least likely to change the reserve requirement for banks. It would also be very unlikely that they would change the margin requirement for securities purchases."
    },
    {
       "id":4069,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The financial ratio that would be the most stringent measure of the liquidity of a corporation would be the:",
       "choice_a":"Current ratio",
       "choice_b":"Debt to net worth ratio",
       "choice_c":"Quick ratio",
       "choice_d":"Interest coverage ratio",
       "correct_answer":"C",
       "explanation":"The quick ratio is the most stringent of the tests listed."
    },
    {
       "id":4070,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The government has two tools it can use to try to influence the direction of the economy; they are:",
       "choice_a":"Monetary policy and prime rate policy",
       "choice_b":"Fiscal policy and money market Policy",
       "choice_c":"Monetary policy and fiscal policy",
       "choice_d":"Prime rate policy and fiscal policy",
       "correct_answer":"C",
       "explanation":"The two tools of the government are monetary policy which is controlled by the Federal Reserve Board and controls the money supply, and fiscal policy which is determined by the President and Congress and controls government spending and taxation."
    },
    {
       "id":4087,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following information can be derived from the balance sheet of a corporation?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Book value for the common stock </li><li>Accounts receivable turnover </li><li>Inventory turnover </li><li>Working capital</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, III and IV",
       "correct_answer":"A",
       "explanation":"A company\u0027s book value and working capital may be determined from the balance sheet."
    },
    {
       "id":4088,
       "topic_id":1,
       "practice_test_id":2,
       "question":"Which of the following interest rates is controlled by the Federal Reserve Board?",
       "choice_a":"Prime rate",
       "choice_b":"Federal funds rate",
       "choice_c":"Broker call loan rate",
       "choice_d":"Discount rate",
       "correct_answer":"D",
       "explanation":"The discount rate is the rate that is actually controlled by the Federal Reserve Board. All of the other rates are adjusted in the market place by the lenders as a result of a change in the discount rate."
    },
    {
       "id":4089,
       "topic_id":1,
       "practice_test_id":3,
       "question":"Which of the following would be used to determine the amount of working capital?",
       "choice_a":"Current assets / current liabilities",
       "choice_b":"Current assets - inventory",
       "choice_c":"Quick assets / current liabilities",
       "choice_d":"Current assets - current liabilities",
       "correct_answer":"D",
       "explanation":"The amount of working capital is found by subtracting current liabilities from current assets."
    },
    {
       "id":4090,
       "topic_id":1,
       "practice_test_id":4,
       "question":"Which of the following would help the U.S. balance of payments?",
       "choice_a":"Helping U.S. companies build plants abroad",
       "choice_b":"Lending money to foreigners at high interest rates",
       "choice_c":"U.S. investment in foreign securities",
       "choice_d":"Foreign investment in the U.S.",
       "correct_answer":"D",
       "explanation":"Foreign investments in the US would result in payments coming into the US and help the balance of payments."
    },
    {
       "id":4091,
       "topic_id":1,
       "practice_test_id":5,
       "question":"You are working for a bank that is unable to meet its reserve requirement for the evening. The bank may borrow money to meet this short fall directly from the FRB and pay:",
       "choice_a":"The Federal funds rate",
       "choice_b":"The Banking call rate",
       "choice_c":"The discount rate",
       "choice_d":"The prime rate",
       "correct_answer":"C",
       "explanation":"A bank may borrow money from the Federal Reserve Board and may pay the discount rate."
    },
    {
       "id":4092,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Stagflation includes which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Falling prices  </li><li>Falling GDP </li><li>High unemployment </li><li>Rising prices</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"Stagflation is characterized by high unemployment and rising prices."
    },
    {
       "id":4093,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An increase in the PPI would best be described as:",
       "choice_a":"Cost push inflation",
       "choice_b":"Demand pull inflation",
       "choice_c":"Dollar based inflation",
       "choice_d":"Fiscal inflation",
       "correct_answer":"A",
       "explanation":"As the cost of goods that are used to manufacture products increase, the producers pass along the increased costs by raising prices of their finished products. This is cost push inflation."
    },
    {
       "id":4094,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The \u0022real interest rate\u0022 is best defined as the:",
       "choice_a":"Interest earned by an investor after taxes",
       "choice_b":"Interest rate charged to investors in a margin account",
       "choice_c":"Interest earned that exceeds the inflation rate",
       "choice_d":"Amount that the prime rate exceeds the discount rate",
       "correct_answer":"C",
       "explanation":"The real interest rate received by an investor is the amount of interest received minus the inflation rate. If an investor is receiving a 10% interest rate when inflation is at 6%, the real interest rate received is 4% (10% - 6%). The real interest rate is also called the inflation-adjusted return."
    },
    {
       "id":4095,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The fact that it is better to receive $1 today and invest it, as opposed to receiving $1 at some point in the future reflects the:",
       "choice_a":"Time value of money",
       "choice_b":"Effects of deflation",
       "choice_c":"Multiplier effect",
       "choice_d":"Results of monetary policy",
       "correct_answer":"A",
       "explanation":"The time value of money reflects the fact that a dollar received today and invested is worth more than a dollar received tomorrow. The future value of a dollar received today depends on how long it is invested and the rate of interest it earns."
    },
    {
       "id":4096,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following would indicate inflationary pressure on the economy except:",
       "choice_a":"Falling weekly jobless claims",
       "choice_b":"Rising retail sales figures",
       "choice_c":"Falling industrial production",
       "choice_d":"A rising consumer price index",
       "correct_answer":"C",
       "explanation":"A rising CPI is the definition of inflation. If retail sales figures are going up or jobless claims are falling, consumer demand should rise. These two situations are therefore inflationary. If industrial production is declining, the assumption is that the economy is slowing down."
    },
    {
       "id":4097,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following items might be found in a footnote to a balance sheet? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The P/E ratio </li><li>Methods of depreciation </li><li>Methods of inventory valuation </li><li>The market price of securities</li></ol>",
       "choice_a":"I and III only",
       "choice_b":"I and IV only",
       "choice_c":"I, III, and IV only",
       "choice_d":"II, III, and IV only",
       "correct_answer":"D",
       "explanation":"Footnotes to the balance sheet might disclose methods of depreciation and inventory valuation, the market price of securities, and other data necessary to make information on the balance sheet more complete. The P/E ratio would generally not appear in a corporation\u0027s financial statements."
    },
    {
       "id":4098,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which two of the following conditions are generally true when the yield curve inverts? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Interest rates are relatively low </li><li>Interest rates are relatively high </li><li>Interest rates are expected to fall </li><li>Interest rates are expected to rise</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"The yield curve often inverts when interest rates are relatively high but are expected to fall in the near future. In such an environment, investors prefer to lock in relatively high long-term rates. The increased demand for long-term debt drives these prices up (and their yields down), as compared to short-term debt, causing the yield curve to invert."
    },
    {
       "id":4099,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following economic indicators is also called payroll employment?",
       "choice_a":"Average weekly initial claims for",
       "choice_b":"Unemployment Rate (non-farm payroll)",
       "choice_c":"Employment Cost Index",
       "choice_d":"Purchasing Manager\u0027s Index",
       "correct_answer":"B",
       "explanation":"The Unemployment Rate (non-farm payroll) is a Bureau of Labor Statistics figure that shows the level of unemployment for full-time and part-time employees. It is one of the most closely watched indicators for evaluating the overall health of the economy. This indicator is also known as \u0022payroll employment.\u0022"
    },
    {
       "id":4100,
       "topic_id":1,
       "practice_test_id":6,
       "question":"Which of the following results in the highest real inflation-adjusted rate of return?",
       "choice_a":"A bond yields 8% when inflation is at 3%. unemployment insurance",
       "choice_b":"A bond yields 12% when inflation is at 8%.",
       "choice_c":"A bond yields 10% when inflation is at 7%.",
       "choice_d":"A bond yields 6% when inflation is at 4%.",
       "correct_answer":"A",
       "explanation":"The inflation-adjusted rate of return, also called the real interest rate, refers to yields adjusted for inflation (yield minus inflation rate). Choice \u0022A\u0022 provides the highest inflation-adjusted rate of return (8% bond yield - 3% inflation rate = 5% real interest rate)."
    },
    {
       "id":4101,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A yield curve that rises as maturities lengthen is a(n):",
       "choice_a":"Normal yield curve",
       "choice_b":"Inverted yield curve",
       "choice_c":"Flat yield curve",
       "choice_d":"Descending",
       "correct_answer":"A",
       "explanation":"In a normal yield curve, long-term maturities have higher yields than intermediate-term maturities, which in turn are higher than short-term maturities. A normal yield curve is also called a positive or ascending yield curve."
    },
    {
       "id":4102,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Rising inflation will tend to: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Negatively impact the stock market </li><li>Positively impact the stock market </li><li>Negatively impact the bond market </li><li>Positively impact the bond market</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"Rising inflation tends to have a negative impact on both the bond and stock markets. In the bond market, when there is rising inflation, bond investors look to trade out of fixed income investments, which will have their returns eroded by rising consumer prices. This selling pressure negatively affects bond prices in the market. In the stock market, rising inflation often translates into an assumption that the Fed will raise interest rates to curb consumer borrowing and consumer demand. Rising rates should, in theory, lead to decreased economic activity and shrinking corporate earnings. This also tends to lead to some form of a sell-off and a falling stock market. From a technical perspective, the dividend discount model would project falling stock prices during inflationary times because the discount rate used to present value the projected dividend cash flows would be higher, which would lead to a lower present value."
    },
    {
       "id":4103,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which two of the following are true regarding the causes of inflation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Demand-pull inflation occurs when the demand for money increases and pulls interest rates higher, causing inflation. </li><li>Demand-pull inflation occurs when the demand for goods and services increases faster than supply, causing inflation. </li><li>Cost-push inflation occurs when the increase in prices of raw materials leads to increasing retail prices, causing inflation. </li><li>Cost-push inflation occurs when the cost of financing the national debt increases, causing rising interest rates and inflation.</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Inflation is an increase in the general level of prices, often as measured by the Consumer Price Index. The two most commonly cited causes are known as demand-pull inflation and cost-push inflation. Demand-pull explains that inflation is caused by a rise in the demand for goods and services that is not matched by an increase in the level of supply of goods and services. When the demand for any individual item increases in relation to its supply, its price will tend to rise. The same thing is true for the economy on a larger scale. Cost-push states that when the price of raw materials increases, that leads to a corresponding increase in the cost of producing goods and services. These increased costs are passed on to the consumer in the form of higher prices."
    },
    {
       "id":4104,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The major advantage of an S corporation versus a C corporation is that an S corporation:",
       "choice_a":"Provides its owners with limited liability",
       "choice_b":"Has greater access to the capital markets",
       "choice_c":"Is exempt from state corporate income taxes",
       "choice_d":"May elect to be treated like partnerships for federal tax purposes.",
       "correct_answer":"D",
       "explanation":"For most businesses, the major advantage of forming an S corporation (or a limited liability corporation) rather than a regular C corporation is that S corporations may elect to be taxed like partnerships under Subchapter S of the Internal Revenue Code. S corporations must meet certain restrictions in order to qualify for this special treatment. The owners of both types of corporations have the protection of limited liability."
    },
    {
       "id":4105,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Ed, Edd and Eddie want to start a new business. They are trying to decide what is the best way to organize the business. They want to protect their personal assets from any debts that the business incurs, but they also want to avoid being double taxed on their profits. Based on these objectives, which of the following would be the best organizational structure for them to adopt?",
       "choice_a":"A limited partnership",
       "choice_b":"A general partnership",
       "choice_c":"A C Corporation",
       "choice_d":"A limited liability corporation",
       "correct_answer":"D",
       "explanation":"The two main advantages of a limited liability corporation are that the owners cannot be held personally liable for the corporation\u0027s debts and the IRS treats limited liability corporations the same way as partnerships for tax purposes. Ed and Stephan can limit their liability but they can also avoid paying both corporate and personal income taxes on their profits, as they would have to do if they formed a C corporation. A general partnership would not protect them from liability since all general partners are responsible for the partnership\u0027s debts. A limited partnership must have both a general partner and a limited partner, so only the limited partner would be protected from liability."
    },
    {
       "id":4106,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is / are true regarding the frequency of compounding in the basic time value of money equation?",
       "choice_a":"Increasing the frequency of compounding increases the future value.",
       "choice_b":"Decreasing the frequency of compounding increases the future value.",
       "choice_c":"Increasing the frequency of compounding has no effect on future value.",
       "choice_d":"Decreasing the frequency of compounding has no effect on future value.",
       "correct_answer":"A",
       "explanation":"More frequent compounding increases future value. For example, the future value of $1 compounded semiannually at 5% is greater than the future value of $1 compounded annually at 5%."
    },
    {
       "id":4107,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investor owns Treasury bonds that mature in 20 years. This investor is primarily exposed to:",
       "choice_a":"Credit risk",
       "choice_b":"Inflationary risk",
       "choice_c":"Currency risk",
       "choice_d":"Capital risk",
       "correct_answer":"B",
       "explanation":"Credit risk is the risk that the investor will not receive interest and/or principal when it is due. Capital risk is the risk that the investor will lose all or part of the investment. Since Treasury bonds are direct obligations of the U.S. government, there is virtually no risk that the investor would not receive interest and/or principal when due. Therefore, they are free of credit risk. However, all fixed-income securities are exposed to inflationary risk (purchasing-power risk)."
    },
    {
       "id":4108,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A business with only one owner who is responsible for all of the liabilities of the business and management decisions is called a(n):",
       "choice_a":"Limited partnership",
       "choice_b":"Sole proprietorship",
       "choice_c":"S corporation",
       "choice_d":"C corporation",
       "correct_answer":"B",
       "explanation":"A sole proprietorship is a type of business with only one owner who is wholly responsible for the management decisions, as well as all of the company\u0027s debts. A limited partnership must have at least a general partner and a limited partner. Although an S corporation and a C corporation may have only one principal, that person is not personally liable for the corporation\u0027s debts."
    },
    {
       "id":4109,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following results in the highest real interest rate?",
       "choice_a":"A bond yields 9% when inflation is 4%",
       "choice_b":"A bond yields 13% when inflation is 9%",
       "choice_c":"A bond yields 11% when inflation is 8%",
       "choice_d":"A bond yields 7% when inflation is 5%",
       "correct_answer":"A",
       "explanation":"The real interest rate, also called the real rate of return, refers to yields adjusted for inflation (yield minus inflation rate). The correct answer provides the highest real interest rate (9% bond yield minus 4% inflation rate = 5% real interest rate)."
    },
    {
       "id":4110,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following are disadvantages for a limited partner except:",
       "choice_a":"The conduit (flow-through) treatment for income and loss",
       "choice_b":"Lack of voting power",
       "choice_c":"Lack of liquidity",
       "choice_d":"Possible adverse changes in the Internal Revenue Code",
       "correct_answer":"A",
       "explanation":"Limited partnerships are not a liquid investment. Investors should have \u0022staying power\u0022 if they are considering a purchase of a limited partnership interest. Another risk would be changes in the Internal Revenue Code, which could cause the tax benefits from the program to be invalid. Also, a limited partner has no voice (vote) in the operation of the program. A major advantage is that the partnership is not a taxable entity. All income and loss flows through to the partner for treatment on the partner\u0027s own tax return."
    },
    {
       "id":4111,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The Consumer Price Index:",
       "choice_a":"Measures the average level of food and utility prices over a given period",
       "choice_b":"Measures the average prices paid by U.S. consumers over a six-month period",
       "choice_c":"Measures the average change in prices for specific goods and services",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"The Consumer Price Index (CPI) measures the average change in prices for selected goods and services purchased by consumers in certain cities. The CPI measures the change from a previous base period and is computed monthly."
    },
    {
       "id":4112,
       "topic_id":1,
       "practice_test_id":"",
       "question":"In a partnership, investors often wish to shelter taxation in the early years of operation. What is the name for the point when income begins to exceed deductions?",
       "choice_a":"Profit margin",
       "choice_b":"Crossover point",
       "choice_c":"Non-recourse point",
       "choice_d":"Point of non-returns",
       "correct_answer":"B",
       "explanation":"LP\u0027s often want to show paper losses during the early years, since those \u0022losses\u0022 can be used to offset any passive income they have from other partnerships or rental income. That\u0027s called \u0022tax shelter.\u0022 Eventually, though, the business will most likely show a profit, and when it does we\u0027ve reached the \u0022crossover point."
    },
    {
       "id":4113,
       "topic_id":1,
       "practice_test_id":"",
       "question":"In order to ease credit the FRB would:",
       "choice_a":"Buy gold bouillon",
       "choice_b":"Buy gold coins",
       "choice_c":"Sell bonds",
       "choice_d":"Buy bonds",
       "correct_answer":"D",
       "explanation":"In a Fed repo the Fed would either buy government securities to pump money into the banking system or The Fed would sell government securities to pull money out of the banking system. When the Fed buys securities it lowers rates."
    },
    {
       "id":4114,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following would not be considered a defensive industry?",
       "choice_a":"Utilities",
       "choice_b":"Supermarkets",
       "choice_c":"Heavy equipment",
       "choice_d":"Tobacco",
       "correct_answer":"C",
       "explanation":"A defensive industry makes products we can\u0027t live without, even in a recession."
    },
    {
       "id":4115,
       "topic_id":1,
       "practice_test_id":"",
       "question":"When the FRB/FOMC wants to either stimulate the economy or fight inflation, which two of the following are they least likely to do? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Alter margin requirements </li><li>Alter the discount rate </li><li>Perform open market operations </li><li>Alter the reserve requirement</li></ol>",
       "choice_a":"I, IV",
       "choice_b":"I, III",
       "choice_c":"II, III",
       "choice_d":"II, IV",
       "correct_answer":"A",
       "explanation":"The FRB rarely adjusts the margin requirements, even though they do have the power to do that under the Securities Exchange Act of 1934. Also, changing the reserve requirement is very drastic."
    },
    {
       "id":4116,
       "topic_id":1,
       "practice_test_id":"",
       "question":"During an inflationary period, we would expect that:",
       "choice_a":"Bond prices rise as interest rates rise",
       "choice_b":"Bond prices fall as interest rates rise",
       "choice_c":"Bond prices fall as yields fall",
       "choice_d":"Bond prices rise as yields fall",
       "correct_answer":"B",
       "explanation":"When you read \u0022inflationary\u0022 associate that with high interest rates. Rates up, bond prices down."
    },
    {
       "id":4117,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Two consecutive quarters of GDP decline signal a:",
       "choice_a":"Depression",
       "choice_b":"Recession",
       "choice_c":"Double-dip recession",
       "choice_d":"Fed short wave",
       "correct_answer":"B",
       "explanation":"And a depression would be 6 quarters/18 months or longer of economic malaise."
    },
    {
       "id":4118,
       "topic_id":1,
       "practice_test_id":"",
       "question":"All of the following are tax preference items for AMT except:",
       "choice_a":"Accelerated depreciation",
       "choice_b":"Assets",
       "choice_c":"Straight-line depreciation",
       "choice_d":"Interest from private purpose muni bonds",
       "correct_answer":"C",
       "explanation":"Straight-line depreciation gives no special benefit to the company. When the business accelerates the depreciation, some of that often ends up being paid for on AMT forms."
    },
    {
       "id":4119,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Cost push inflation is best measured by",
       "choice_a":"PPI",
       "choice_b":"CPI",
       "choice_c":"GDP",
       "choice_d":"Net Worth",
       "correct_answer":"A",
       "explanation":"PPI is the Producer Price Index, which shows how much raw materials are costing producers. When the cost of raw materials rises, producers pass it on to consumers, which is why we call this \u0022cost-push inflation.\u0022"
    },
    {
       "id":4120,
       "topic_id":1,
       "practice_test_id":"",
       "question":"During a period of high inflation, which of the following statements is true?",
       "choice_a":"Bond prices rise on the secondary market",
       "choice_b":"Bond yields on the primary market decrease",
       "choice_c":"Bond prices fall on the secondary market, bond yields on the primary market rise",
       "choice_d":"Bond prices are not affected if the issue is rated BBB or higher",
       "correct_answer":"C",
       "explanation":"High inflation = high interest rates. Rising rates means that the yields offered on both new and existing bonds are rising."
    },
    {
       "id":4121,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A decrease in which of the following is a positive indicator?",
       "choice_a":"Housing starts",
       "choice_b":"Payroll employment",
       "choice_c":"Inventories",
       "choice_d":"GDP",
       "correct_answer":"C",
       "explanation":"If inventories are falling it\u0027s because companies are selling products and will have to make more. This is an indication of demand and of future work payrolls."
    },
    {
       "id":4122,
       "topic_id":1,
       "practice_test_id":6,
       "question":"If GDP increases two quarters consecutively, economists conclude that we are in which of the following phases of the business cycle?",
       "choice_a":"Recession",
       "choice_b":"Depression",
       "choice_c":"Expansion",
       "choice_d":"Trough",
       "correct_answer":"C",
       "explanation":"It makes sense that if we wait 2 quarters to call it a recession, we should wait 2 quarters to call it an expansion."
    },
    {
       "id":4123,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A substantial increase in the CPI is?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Negative for the stock market </li><li>Negative for the bond market </li><li>Positive for the stock market </li><li>Positive for the bond market</li></ol>",
       "choice_a":"I, III",
       "choice_b":"II, III",
       "choice_c":"I, II",
       "choice_d":"II, IV",
       "correct_answer":"C",
       "explanation":"Stock is more resistant to inflation, but high inflation is bad news for both markets."
    },
    {
       "id":4124,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following best describes interest rate risk to a holder of preferred stock?",
       "choice_a":"As interest rates rise, prices fall",
       "choice_b":"As interest rates fall, prices rise",
       "choice_c":"Bond interest must be paid first",
       "choice_d":"All of the choices listed",
       "correct_answer":"A",
       "explanation":"There\u0027s no risk concerning falling rates, since rising market prices on your investment is a good thing."
    },
    {
       "id":4125,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following securities is most susceptible to interest rate risk?",
       "choice_a":"State revenue bond maturing in 2009",
       "choice_b":"SIA 6s debenture maturing in 2011",
       "choice_c":"T-note maturing in 2013",
       "choice_d":"T-bond maturing in 2017",
       "correct_answer":"D",
       "explanation":"The longer the time to maturity the greater the risk."
    },
    {
       "id":4126,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investor holding a large percentage of investable assets in cash and equivalents is least susceptible to which of the following risks?",
       "choice_a":"Opportunity cost",
       "choice_b":"Purchasing power",
       "choice_c":"Interest rate",
       "choice_d":"Default",
       "correct_answer":"D",
       "explanation":"The money market might not pay a lot of interest, but the risk of default is almost nothing. There are opportunity costs associated with holding cash instead of investment which may provide better returns."
    },
    {
       "id":4127,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investor holding a large percentage of her portfolio in corporate pass-through certificates is most susceptible to:",
       "choice_a":"Default risk",
       "choice_b":"Credit risk",
       "choice_c":"Prepayment risk",
       "choice_d":"Fiduciary risk",
       "correct_answer":"C",
       "explanation":"One can never totaly escape risk, but of the four examples listed, Pre-Payment risk is the most likely. Pass-through certificates are traditionally backed by pools of mortgages or other loans. When interest rates decline, borrowers refinance and repay the loans more quickly."
    },
    {
       "id":4128,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is most susceptible to constant dollar risk?",
       "choice_a":"Fixed annuities",
       "choice_b":"ADR\u0027s",
       "choice_c":"Convertible preferred",
       "choice_d":"Variable annuities",
       "correct_answer":"A",
       "explanation":"Fixed annuities do not give you the advantage of keeping pace with the market."
    },
    {
       "id":4129,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The FRB has raised short-term interest rates. The most likely result will be:",
       "choice_a":"The rates on 5-year ARM\u0027s will rise, the rates on 30-year mortgages will drop",
       "choice_b":"The rates on 15-year mortgages will drop, the rates on 30-year mortgages will rise",
       "choice_c":"The price of 10-year bonds will drop, while their yield will rise",
       "choice_d":"The price of 10-year bonds will drop, and their yields will drop",
       "correct_answer":"C",
       "explanation":"The Federal Reserve Board has little control over long-term interest rates. On the exam, conclude that when rates rise, bond prices drop and yields will rise."
    },
    {
       "id":4130,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following is a leading indicator?",
       "choice_a":"Payroll employment",
       "choice_b":"Average hours worked by manufacturing employees",
       "choice_c":"Inventory",
       "choice_d":"Personal income",
       "correct_answer":"B",
       "explanation":"Memorize the leading, coincident, and lagging indicators. If employees are working more hours, that bodes well for the economy. Payroll employment is a coincident indicator, as is personal income. Inventory is a lagging indicator."
    },
    {
       "id":4131,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The CPI is a good measure of:",
       "choice_a":"The present value of money",
       "choice_b":"Inflation on consumer goods",
       "choice_c":"Future risk",
       "choice_d":"Economic growth",
       "correct_answer":"B",
       "explanation":"The consumer price index (CPI) is an index created from the prices of a basket of goods and services consumers use in their daily lives. It is used as a measure of inflation on consumer goods. A rise in the CPI reflects inflationary pressure."
    },
    {
       "id":4132,
       "topic_id":1,
       "practice_test_id":"",
       "question":"In which way is the value of money correlated to the CPI as the CPI goes up?",
       "choice_a":"The value of money goes down",
       "choice_b":"The value of money goes up",
       "choice_c":"There is no correlation",
       "choice_d":"The value of money stays constant",
       "correct_answer":"A",
       "explanation":"As the CPI increases the value of money declines. An increase in the CPI reduces the purchasing power of money. There is a negative correlation between the value of the dollar and the CPI"
    },
    {
       "id":4133,
       "topic_id":1,
       "practice_test_id":"",
       "question":"What happens to the yield curve if long term interest rates are expected to rise?",
       "choice_a":"The curve steepens",
       "choice_b":"The curve flattens",
       "choice_c":"The curve does not change",
       "choice_d":"The curve inverts",
       "correct_answer":"A",
       "explanation":"The yield curve would steepen as long term rates rise. Even if long term rates are simply expected to rise, investors would sell long term bonds and this action in itself would cause long term rates to rise."
    },
    {
       "id":4134,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A yield curve that slopes downwards is said to be:",
       "choice_a":"Inverted",
       "choice_b":"Positive",
       "choice_c":"Contango",
       "choice_d":"Backward",
       "correct_answer":"A",
       "explanation":"A downward sloping yield curve is one where short term interest rates are higher than long term rates. The yield curve in this situation is said to be inverted."
    },
    {
       "id":4135,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The rate at which the Federal Reserve lends money to other banks is called the:",
       "choice_a":"Federal funds rate",
       "choice_b":"Discount rate",
       "choice_c":"LIBOR",
       "choice_d":"Bank loan rate",
       "correct_answer":"B",
       "explanation":"The Federal Reserve lends money to banks at the discount rate."
    },
    {
       "id":4436,
       "topic_id":1,
       "practice_test_id":"",
       "question":"What does a proponent of fundamental analysis use to value common stock? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Trade volume </li><li>Discounted Cash Flow </li><li>P/E ratio </li><li>Moving price average</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"The correct answers are II and III. A fundamental analyst would look at the financial makeup of the company and how that financial value of the company is priced in the marketplace. Of the choices listed a fundamental analyst would use a discounted cash flow method which would be used to place a current value on the company\u0027s future earnings and a P/E ratio which would tell the analyst what people are paying in the marketplace for those earnings on a per share basis. Moving averages and trade volume would be used by an investor interested in technical analysis"
    },
    {
       "id":19500,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following economic indicators would be most useful for figuring out whether the economy is growing quickly or slowly?",
       "choice_a":"Leading",
       "choice_b":"Lagging",
       "choice_c":"Coincident",
       "choice_d":"Fiscal",
       "correct_answer":"C",
       "explanation":"Of the three economic indicators, leading, coincident and lagging, the coincident indicators will be the best measure of how fast or slow the economy is growing ."
    },
    {
       "id":19505,
       "topic_id":1,
       "practice_test_id":"",
       "question":"XYA, a manufacturer of computer circuit boards, has $50,000,000 worth of subordinated debentures outstanding. Each debenture carries an interest rate of 6.5% and has warrants attached to the debenture to purchase 5 shares of XYA at $25 per share.  XYA\u0027s stock is trading in the marketplace at $28 per share and the warrants are about to expire. The company would expect to receive proceeds of:",
       "choice_a":"$5,000,000",
       "choice_b":"$7,500,000",
       "choice_c":"$6,250,000",
       "choice_d":"$7,000,000",
       "correct_answer":"C",
       "explanation":"There are 50,000 $1,000 par bonds (50,000,000 / 1000) outstanding each bond has warrants attached to purchase 5 shares of stock at $25 per share. The company would expect that all of the warrants will be exercised as the warrants are in the money and about to expire. As a result the company would expect to  issue 250,000 new shares at $25 and receive proceeds of $6,250,000."
    },
    {
       "id":19506,
       "topic_id":1,
       "practice_test_id":"",
       "question":"XYA, a manufacturer of computer circuit boards, has $50,000,000 worth of subordinated debentures outstanding. Each debenture carries an interest rate of 6.5% and has warrants attached to the debenture to purchase 5 shares of XYA at $25 per share.  XYA\u0027s stock is trading in the marketplace at $28 per share and the warrants are about to expire. How many new shares can XYA reasonably expect to issue?",
       "choice_a":"50,000",
       "choice_b":"250,000",
       "choice_c":"500,000",
       "choice_d":"25,000",
       "correct_answer":"B",
       "explanation":"There are 50,000 $1,000  par bonds (50,000,000 / 1000) outstanding each bond has warrants attached to purchase 5 shares of stock at $25 per share. The company would expect that all of the warrants will be exercised as the warrants are in the money and about to expire. As a result the company would expect to issue 250,000 new shares."
    },
    {
       "id":19519,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following prescribe that lower taxes will encourage economic activity and help the economy grow resulting in a higher overall level tax collection?",
       "choice_a":"Supply side policy",
       "choice_b":"Fiscal policy",
       "choice_c":"Monetary policy",
       "choice_d":"Keynesian policy",
       "correct_answer":"A",
       "explanation":"Supply side economic policy beleives that lower taxes will encourage economic activity and help the economy grow resulting in a higher overall level tax collection"
    },
    {
       "id":19527,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The FOMC has been reducing the size of its balance sheet in line with its mandate. Which of the following will occur? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Interest rates will increase  </li><li>The money supply will decrease </li><li>Interest rates will decrease  </li><li>The money supply will increase</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I only",
       "correct_answer":"A",
       "explanation":"When the FOMC  reduces the size of its balance sheet it is selling bonds and removing money from  the system thereby reducing the money supply. When the FOMC sells bonds interest rates will increase ."
    },
    {
       "id":19528,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A corporation borrows money on an unsecured  intermediate basis at a rate of 4.9%. The corporation then takes the borrowed funds and invests in expanding its operations and generates a return of 9%. The corporation is employing:",
       "choice_a":"Arbitrage",
       "choice_b":"Interest rate spreading",
       "choice_c":"Leverage",
       "choice_d":"Expansionary policy",
       "correct_answer":"C",
       "explanation":"When a corporation borrows money and uses the borrowed funds to generate a return that exceeds the cost of the borrowed money the company is employing leverage."
    },
    {
       "id":19532,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The FOMC has been embarking on a bond buying program in line with its mandate. Which of the following will occur? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Interest rates will increase  </li><li>The money supply will decrease </li><li>Interest rates will decrease  </li><li>The money supply will increase</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"When the FOMC purchases bonds it is injecting money into the system increasing the money supply. When the FOMC buys bonds it will lower interest rates ."
    },
    {
       "id":19542,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following companies would be considered the most highly leveraged?",
       "choice_a":"A small cap company who has received its total capitalization from a recent stock offering",
       "choice_b":"A regulated utility company whose has issued a significant amount of bonds to build a new power plant and has a small float of common stock",
       "choice_c":"A NASDAQ listed issuer who has an active market and a credit facility available through a syndicate of banks",
       "choice_d":"A large cap company with 300,000,000 shares of common stock outstanding, 30,000,000 shares of preferred stock and 20,000,000 in long term variable rate bonds outstanding",
       "correct_answer":"B",
       "explanation":"A highly leveraged corporation is one that has borrowed a large percentage of its capital usually through the sale of bonds. When a corporation borrows money it is anticipating that it can use the borrowed funds to generate a return on the capital that is greater than the cost of that capital."
    },
    {
       "id":19550,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The largest component of the money supply (m1) is:",
       "choice_a":"Currency",
       "choice_b":"Checks",
       "choice_c":"Revolving accounts",
       "choice_d":"Debit transactions",
       "correct_answer":"A",
       "explanation":"The largest component of M1 money supply is the amount of physical currency in circulation."
    },
    {
       "id":19565,
       "topic_id":1,
       "practice_test_id":"",
       "question":"Which of the following conditions would be persistent during  a period of stagflation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>High unemployment </li><li>Inflation  </li><li>Deflation </li><li> Falling interest rates</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"III and IV",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"During  a period of stagflation the economy will experience high unemployment and inflation. Interest rates will not decline as rates will remain high  to fight inflation. High unemployment and high inflation and interest rates are persistent during a period of stagflation."
    },
    {
       "id":19566,
       "topic_id":1,
       "practice_test_id":"",
       "question":"An investor purchased a non qualified annuity by depositing a lump sum when he as 45 years old. He has enjoyed a high paying job for the last 15 years and has not annuitized the contract. At 60 years old he wants to buy a second home and withdraws $20,000 from the account  to help with the down payment. What are the tax consequences of the withdrawal?",
       "choice_a":"Ordinary income taxes plus 10% penalty tax on the total amount",
       "choice_b":"Ordinary income taxes plus 10% penalty tax up to the cost base",
       "choice_c":"Ordinary income tax up to the cost base",
       "choice_d":"No tax if the withdrawal is done on a FIFO basis",
       "correct_answer":"C",
       "explanation":"The investor is over 59\u00BD so there is no penalty tax.  All random withdrawals from an annuity are done on a LIFO basis. The IRS considers all random withdrawals to come from the growth in the account and it is taxed as ordinary income. In this case if the $20,000 exceeded the growth in the account the portion that was the return of the cost base (deposit) would be returned tax free."
    },
    {
       "id":19571,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The expansionary phase of the business cycle is characterized by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Falling prices </li><li>Falling savings </li><li>Rising prices </li><li>Rising savings</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"II only",
       "choice_d":"IV only",
       "correct_answer":"B",
       "explanation":"The expansionary phase of the business cycle is characterized by rising prices and rising savings. As people earn more they tend to spend more and save more. This will cause prices to rise as more people buy goods. Balances in savings accounts will also increase."
    },
    {
       "id":19577,
       "topic_id":1,
       "practice_test_id":"",
       "question":"$100,000 in future value would have a lower net present value with: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>High interest rates </li><li>Short compounding period </li><li>Low interest rates </li><li> Long compounding period</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"The present value of a future sum of money will be lower when interest rates  are high and with a long compounding period."
    },
    {
       "id":19582,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The present value of a dollar would be described as:",
       "choice_a":"The purchasing power of a dollar as measured by the value of goods and services",
       "choice_b":"The value of a dollar as measured by the CPI",
       "choice_c":"The amount of money that must be invested to achieve a stated dollar amount in the future",
       "choice_d":"The value of the dollar after the effects of inflation have been taken into consideration",
       "correct_answer":"C",
       "explanation":"The present value of the dollar is the amount of money that must be invested today to achieve a stated dollar amount in the future."
    },
    {
       "id":21167,
       "topic_id":1,
       "practice_test_id":"",
       "question":"XYZ manufacturing has mailed out proxies for its upcoming annual shareholders meeting. A customer of Rock Solid Brokerage has 1,000 shares held in street name. Rock Solid has forwarded the proxy to the customer in line with regulations. The customer signs and returns the proxy to Rock Solid without casting his vote. Under the rules Rock Sold:",
       "choice_a":"Must contact the customer and ask how he wants to vote",
       "choice_b":"Must void the proxy",
       "choice_c":"Must vote the shares anyway it sees fit as the shares are held in street name",
       "choice_d":"Must vote the shares in line with the recommendation of XYZ\u0027s management",
       "correct_answer":"D",
       "explanation":"If a customer signs and returns a blank proxy to a brokerage firm for shares held in street name, the brokerage firm is required to vote those shares in line with the recommendation of the company\u0027s management, in this case as XYZ recommends."
    },
    {
       "id":21168,
       "topic_id":1,
       "practice_test_id":"",
       "question":"ABC Micro has just gone public and has offered 10,000,000 common shares with a par value of $1. The IPO price was $20 per share. The difference between the par value and the IPO price would best be described as:",
       "choice_a":"A premium",
       "choice_b":"Additional paid in capital",
       "choice_c":"Capital surplus",
       "choice_d":"Proceeds to issuer",
       "correct_answer":"B",
       "explanation":"The amount by which the offering price of common shares exceeds the par value is known as additional paid in capital. The total par value along with the additional paid in capital are entered on the company\u0027s balance sheet as part of stockholders equity."
    },
    {
       "id":21170,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A fixed income investor is looking at the yield curve reflecting the current interest rate environment. The investor notices that long term debt is paying significantly higher interest rates than shorter term debt securities. The chart for this would indicate that the yield curve is:",
       "choice_a":"flat",
       "choice_b":"inverted",
       "choice_c":"stable",
       "choice_d":"positive",
       "correct_answer":"D",
       "explanation":"When the interest rates on long term bonds exceed the interest rates on short term bonds, the yield curve is said to be positive or upward sloping. The chart of the yields will increase from the lower left to the upper right when measured by the term to maturity of the bonds."
    },
    {
       "id":21183,
       "topic_id":1,
       "practice_test_id":"",
       "question":"If the Federal Reserve undertakes an accommodative monetary policy and begins to reduce interest rates, which of the following is most likely to occur?",
       "choice_a":"The value of the dollar will rise versus the Euro",
       "choice_b":"The value of the dollar will fall versus the Euro",
       "choice_c":"The value of the dollar will not be impacted versus the Euro",
       "choice_d":"The value of the dollar will be positively impacted versus the Euro",
       "correct_answer":"B",
       "explanation":"If the Federal Reserve reduces interest rates the value of the dollar will fall versus the value of all other currencies. In this case the value of the dollar will fall versus the Euro. It will now take more dollars to purchase 1 Euro."
    },
    {
       "id":21192,
       "topic_id":1,
       "practice_test_id":"",
       "question":"XYZ Construction has just purchased a $5 million piece of equipment, utilizing cash on hand. XYZ plans on depreciating the equipment under an accelerated depreciation method. Which of the following is / are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The cost of the equipment will be recovered more quickly  </li><li>XYZ\u0027s income will be reduced more in the first few years of operation  </li><li>The majority of cost of the equipment will not be recovered until the equipment is decommissioned  </li><li>XYZ\u0027s income will be reduced by a similar amount over the useful life of the equipment</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and IV",
       "correct_answer":"A",
       "explanation":"Under accelerated depreciation the majority of the cost of the equipment is recovered in the first few years of its useful life. As a result XYZ\u0027s earnings will be reduced more in the first few years. This creates a lower taxable income for the company in the first few years after purchase."
    },
    {
       "id":21194,
       "topic_id":1,
       "practice_test_id":"",
       "question":"As interest rates rise which of the following is true?",
       "choice_a":"The amount of interest paid on outstanding issues will increase",
       "choice_b":"The amount of interest paid on outstanding issues will decrease",
       "choice_c":"The amount of interest paid on outstanding issues will remain constant",
       "choice_d":"The amount of interest paid on outstanding issues will be adjusted to market rates",
       "correct_answer":"C",
       "explanation":"The amount of interest paid on bonds does not change once the bonds have been issued. The nominal yield or the coupon rate will determine the amount of interest that the bond pays over its entire maturity. Prices of bonds do change in the marketplace and that will cause a bond\u0027s current yield and yield to maturity to change based on the change in price."
    },
    {
       "id":25403,
       "topic_id":1,
       "practice_test_id":"",
       "question":"The President and Congress have been working to pass legislation that will increase the marginal tax rate. Which two of the following choices are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The stock market will most likely fall </li><li>There will be a decrease in the rate of disintermediation  </li><li>Yields on municipal bonds will most likely fall  </li><li>The yield curve will become inverted</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"If there is an increase in the marginal tax rate, income taxes will increase. As a result of the increase in income taxes investors will be more likely to purchase municipal bonds. The increase in demand for the municipal bonds will cause the yields on municipal bonds to fall. An increase in taxes is bearish for the stock market and stock prices will likely fall."
    },
    {
       "id":25410,
       "topic_id":1,
       "practice_test_id":"",
       "question":"If investors have priced in the expectation for generally increasing prices in the marketplace, the yield curve most likely to reflect that expectation would be:",
       "choice_a":"Flat",
       "choice_b":"Inverted",
       "choice_c":"Ascending",
       "choice_d":"Correlated",
       "correct_answer":"C",
       "explanation":"An ascending or upward sloping yield curve is one which displays higher interest rates for longer term maturities. The increase in interest rates over time reflect investor\u0027s expectations for inflation ( increase in prices )."
    },
    {
       "id":28955,
       "topic_id":1,
       "practice_test_id":"",
       "question":"A corporation has a balance sheet that appears as follows: --- Add Table ---",
       "choice_a":"$4,800,000",
       "choice_b":"$4,200,000",
       "choice_c":"$5,500,000",
       "choice_d":"$4,000,000",
       "correct_answer":"A",
       "explanation":"The formula for working capital is current assets - current liabilities. Current assets are: cash, inventory and accounts receivable. Current liabilities are: wages payable, accounts payable and current portion of long term debt. In this case, $7,500,000= $2,700,000 =  $4,800,000."
    },
    {
       "id":4136,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An annuitant is interested in the largest monthly payment from her annuity now that she has retired; which of the following payout options will give her the greatest monthly payment?",
       "choice_a":"Joint with last survivor",
       "choice_b":"Life with period certain",
       "choice_c":"Life without period",
       "choice_d":"Life only/straight life",
       "correct_answer":"D",
       "explanation":"The payout options in order from largest monthly payment to smallest are: life only/straight life, life with period certain, and lastly, joint with last survivor."
    },
    {
       "id":4137,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A fixed annuity guarantees all of the following except:",
       "choice_a":"Income for life",
       "choice_b":"Protection from inflation",
       "choice_c":"Rate of return",
       "choice_d":"Protection from investment risk",
       "correct_answer":"B",
       "explanation":"A fixed annuity provides all of those listed except protection from inflation. If inflation rises, the holder of a fixed annuity may end up worse off due to the loss of value of the dollar."
    },
    {
       "id":4138,
       "topic_id":2,
       "practice_test_id":2,
       "question":"A principal in a school has deposited $15,000 in a tax deferred annuity through a payroll deduction plan. The account has grown in value to $22,000. The principal plans to retire and take a lump sum distribution. On what amount does he pay taxes?",
       "choice_a":"$22,000",
       "choice_b":"$15,000",
       "choice_c":"$7,000",
       "choice_d":"$0",
       "correct_answer":"C",
       "explanation":"This is a non-qualified plan, meaning the money is deposited after taxes so the retiree will only pay taxes on the growth."
    },
    {
       "id":4139,
       "topic_id":2,
       "practice_test_id":3,
       "question":"All of the following are true about annuity units except:",
       "choice_a":"When an investor annuitizes a contract, he trades in his accumulation units for annuity units",
       "choice_b":"The number of annuity units is variable depending upon the fluctuation of the investments",
       "choice_c":"The number of annuity units an investor receives depends partially upon the annuitant\u0027s age and sex",
       "choice_d":"The number of annuity units an investor receives depends partially upon the payout option selected, the value of the account, and the assumed interest risk",
       "correct_answer":"B",
       "explanation":"The number of annuity units is fixed and represents the proportion of the owner\u0027s shares in the separate accounts portfolio."
    },
    {
       "id":4140,
       "topic_id":2,
       "practice_test_id":4,
       "question":"All of the following are ways an investor may purchase a variable annuity except:",
       "choice_a":"Periodic payment deferred annuity",
       "choice_b":"Single payment deferred annuity",
       "choice_c":"Single payment immediate annuity",
       "choice_d":"Periodic payment immediate annuity",
       "correct_answer":"D",
       "explanation":"There is no such thing as a periodic payment immediate annuity."
    },
    {
       "id":4141,
       "topic_id":2,
       "practice_test_id":5,
       "question":"All of the following have their portfolios held in the separate account except:",
       "choice_a":"Variable annuity",
       "choice_b":"Variable life policy",
       "choice_c":"Universal variable life policy",
       "choice_d":"UIT",
       "correct_answer":"D",
       "explanation":"The portfolios of a UIT are held by the UIT, and it in turn issues shares of beneficial interest to the investors."
    },
    {
       "id":4142,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An annuitant wants a guaranteed rate of return for her annuity; which type of annuity should a representative recommend for her?",
       "choice_a":"Fixed annuity",
       "choice_b":"Variable annuity",
       "choice_c":"Contractual annuity",
       "choice_d":"Combination annuity",
       "correct_answer":"A",
       "explanation":"A fixed annuity guarantees a fixed rate of return regardless of whether or not the portfolio produces the guaranteed rate of return."
    },
    {
       "id":4143,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An annuity has an AIR of 4 %. The separate account earns 5 % in April, and 7% in May, if the separate account earns 4% in June the payment to annuitants in July will be:",
       "choice_a":"Higher than the payment in June",
       "choice_b":"Lower than the payment in June",
       "choice_c":"The same as the payment in June",
       "choice_d":"Lower than the payment in May",
       "correct_answer":"C",
       "explanation":"The separate account\u0027s performance equals the AIR, so the payment will remain the same as the payment in June"
    },
    {
       "id":4144,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An annuity is a contract between:",
       "choice_a":"An individual and a corporation",
       "choice_b":"An individual and a mutual fund company",
       "choice_c":"An individual and an insurance company",
       "choice_d":"An individual and a plan company",
       "correct_answer":"C",
       "explanation":"An annuity is a contract between an individual and an insurance company."
    },
    {
       "id":4145,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An investor buying an immediate annuity buys:",
       "choice_a":"Accumulation units that are fixed in number",
       "choice_b":"Annuity units that are fixed in number",
       "choice_c":"Accumulation units that vary in number",
       "choice_d":"Annuity units that vary in number",
       "correct_answer":"B",
       "explanation":"An investor who purchases an immediate annuity buys annuity units that remain fixed in number."
    },
    {
       "id":4146,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investor has annuitized her variable annuity. Which of the following are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Accumulation units have been exchanged for annuity units </li><li>Annuity units have been exchanged for accumulation units </li><li>The number of accumulation units is fixed </li><li>The number of annuity units is fixed</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"When an investor annuitizes a contract, they trade in their accumulation units for annuity units and the number of annuity units remains fixed."
    },
    {
       "id":4147,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investor has deposited $14,500 into a variable annuity over a three-year period. The money has grown to $17,800. The investor is 61 years old and must make a random withdrawal of $3,000. On what amount must he pay taxes?",
       "choice_a":"$0",
       "choice_b":"$3,000",
       "choice_c":"$700",
       "choice_d":"$2,300",
       "correct_answer":"B",
       "explanation":"The money taken from a variable annuity during a random withdrawal will be done on a LIFO basis, which means the growth will come out first and will be taxed. The investor will pay taxes on the entire $3,000."
    },
    {
       "id":4148,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investor has just begun the payout phase of their variable annuity and is wondering about the tax consequences of their payments. You should tell them:",
       "choice_a":"Your payments will be tax free",
       "choice_b":"You will have to pay capital gains on the money",
       "choice_c":"You will have to pay ordinary income taxes on the entire amount",
       "choice_d":"You will only be taxed on the growth portion of the payment",
       "correct_answer":"D",
       "explanation":"The investor will only be taxed on the distribution of growth, and it will be taxed as ordinary income."
    },
    {
       "id":4149,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An investor in a variable annuity may change their payout option:",
       "choice_a":"Under no circumstances",
       "choice_b":"If their financial needs change significantly",
       "choice_c":"To convert to a lump sum withdrawal",
       "choice_d":"Upon the death of a spouse for joint with last survivor",
       "correct_answer":"A",
       "explanation":"An investor may never change their payout option once it has been set."
    },
    {
       "id":4150,
       "topic_id":2,
       "practice_test_id":1,
       "question":"An investor is considered an annuitant because:",
       "choice_a":"He has entered into a contract with an insurance company",
       "choice_b":"He has retired from a company and is collecting an annual annuity called a pension",
       "choice_c":"He has invested his money with an annuity firm",
       "choice_d":"He has retired and is living off his retirement income called his annuity",
       "correct_answer":"A",
       "explanation":"The individual who enters into a contract, called an annuity, with an insurance company, is called an annuitant."
    },
    {
       "id":4151,
       "topic_id":2,
       "practice_test_id":2,
       "question":"An investor is interested in investing in an annuity which achieves a higher rate of return and is not opposed to taking some risk; which type of annuity should she invest in?",
       "choice_a":"Fixed annuity",
       "choice_b":"Variable annuity",
       "choice_c":"Contractual annuity",
       "choice_d":"Combination annuity",
       "correct_answer":"B",
       "explanation":"This investor should invest in a variable annuity which not only offers the potential for a higher rate of return but also has a higher risk."
    },
    {
       "id":4152,
       "topic_id":2,
       "practice_test_id":3,
       "question":"An investor purchases a tax deferred annuity through a payroll deduction plan. They have deposited $20,000 over a seven year period. Over the seven years the money has grown to $28,300. The investor annuitizes the contract and wants to known what his tax liability is for each payment you should tell them:",
       "choice_a":"It is 100% taxed because it was purchased with pre tax dollars",
       "choice_b":"The exclusion ratio tells you what the tax liability is for each payment",
       "choice_c":"It will be taxed on the growth at the capital gains rate",
       "choice_d":"It will be 100% taxed as ordinary income",
       "correct_answer":"B",
       "explanation":"The investor purchased the annuity with after tax dollars and will only pay taxes on the growth. The exclusion ratio will tell the investor how much of each payment is subject to tax."
    },
    {
       "id":4153,
       "topic_id":2,
       "practice_test_id":4,
       "question":"An investor is seeking maximum safety of principal. Which type of investment should a representative recommend for him?",
       "choice_a":"Fixed annuity",
       "choice_b":"Variable annuity",
       "choice_c":"Contractual annuity",
       "choice_d":"Combination annuity",
       "correct_answer":"A",
       "explanation":"A fixed annuity has no investment risk, so the investor should be offered a fixed annuity."
    },
    {
       "id":4154,
       "topic_id":2,
       "practice_test_id":5,
       "question":"An investor who is 55-years-old withdraws money from a variable annuity to meet a family emergency will pay:",
       "choice_a":"Ordinary income taxes only",
       "choice_b":"Capital gains taxes only",
       "choice_c":"Ordinary income taxes plus a 10% penalty",
       "choice_d":"No taxes because the money deposited into a variable annuity are after tax dollars",
       "correct_answer":"C",
       "explanation":"The investor will have to pay the ordinary income taxes on the money, as well as a 10% penalty because he is under 59\u00BD."
    },
    {
       "id":4155,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An investor who is 55 years old withdraws money from a variable annuity to meet a family emergency will pay:",
       "choice_a":"Ordinary income taxes only",
       "choice_b":"Capital gains taxes only",
       "choice_c":"Ordinary income taxes plus a 10% penalty",
       "choice_d":"No taxes because the money deposited into a variable annuity are after tax dollars",
       "correct_answer":"C",
       "explanation":"The investor will have to pay the ordinary income taxes on the money as well as a 10% penalty because he is under 59\u00BD."
    },
    {
       "id":4156,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investor who owns a fixed annuity is subject to:",
       "choice_a":"Expense risk",
       "choice_b":"Investment risk",
       "choice_c":"Purchasing power risk",
       "choice_d":"Mortality risk",
       "correct_answer":"C",
       "explanation":"An investor who purchases a fixed annuity is subject to purchasing power risk."
    },
    {
       "id":4157,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An investor who purchases an annuity is known as:",
       "choice_a":"Annuitized",
       "choice_b":"Annuitant",
       "choice_c":"Annuitor",
       "choice_d":"Annuitee",
       "correct_answer":"B",
       "explanation":"An investor who purchases an annuity is known as the annuitant."
    },
    {
       "id":4158,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investors feels that a fixed annuity is too conservative and that a variable annuity is too risky; what should he invest in as an annuity?",
       "choice_a":"Contractual annuity",
       "choice_b":"Combination annuity",
       "choice_c":"Payment deferred annuity",
       "choice_d":"Immediate payment annuity",
       "correct_answer":"B",
       "explanation":"For this investor the combination annuity is perfect since it has a fixed portion with no risk and a variable portion with risk."
    },
    {
       "id":4159,
       "topic_id":2,
       "practice_test_id":"",
       "question":"If an investor wants to purchase an annuity by making regular scheduled payments into the contract, he should invest in which of the following types of annuities?",
       "choice_a":"Single payment deferred annuity",
       "choice_b":"Multiple payment periodic annuity",
       "choice_c":"Regular payment immediate annuity",
       "choice_d":"Periodic payment deferred annuity",
       "correct_answer":"D",
       "explanation":"A periodic payment deferred annuity allows an investor to make regularly scheduled payments into a contract annuity which has a deferred pay out time."
    },
    {
       "id":4160,
       "topic_id":2,
       "practice_test_id":2,
       "question":"If your customer wants to purchase an annuity by making regular scheduled payments into the contract, he should invest in which of the following types of annuities?",
       "choice_a":"Single payment deferred annuity",
       "choice_b":"Multiple payment periodic annuity",
       "choice_c":"Regular payment immediate annuity",
       "choice_d":"Periodic payment deferred annuity",
       "correct_answer":"D",
       "explanation":"A periodic payment deferred annuity allows an investor to make regularly scheduled payments into a contract annuity which has a deferred payout time."
    },
    {
       "id":4161,
       "topic_id":2,
       "practice_test_id":3,
       "question":"Insurance companies deduct a fee from the separate account of an annuity to cover the risk involved in issuing these annuity contracts. Which is not one of the risks involved?",
       "choice_a":"Operating expense risk",
       "choice_b":"Sales risk",
       "choice_c":"Mortality risk",
       "choice_d":"Unexpected rise in the cost of doing business risk",
       "correct_answer":"B",
       "explanation":"There is no such thing as a sales risk involved in issuing annuities."
    },
    {
       "id":4162,
       "topic_id":2,
       "practice_test_id":4,
       "question":"Random withdrawals from a variable annuity are done by:",
       "choice_a":"FIFO",
       "choice_b":"LIFO",
       "choice_c":"Average cost",
       "choice_d":"Exclusion ratio",
       "correct_answer":"B",
       "explanation":"Random withdrawals from a variable annuity will always be done on a LIFO basis. The growth always comes out first and is taxed."
    },
    {
       "id":4163,
       "topic_id":2,
       "practice_test_id":5,
       "question":"The assumed interest rate (AIR) is all of the following except:",
       "choice_a":"The benchmark selected by the insurance company for the separate account\u0027s performance",
       "choice_b":"A guaranteed rate of return",
       "choice_c":"Used to adjust the value of the annuity based on the actual performance of the separate account",
       "choice_d":"An earnings target that the insurance company sets for the separate account",
       "correct_answer":"B",
       "explanation":"The AIR is not a guaranteed rate of return; rather it is used to adjust the value of the annuity based on the actual performance of the separate account."
    },
    {
       "id":4190,
       "topic_id":2,
       "practice_test_id":6,
       "question":"If a bond is selling at a premium and is callable at par, how is the yield generally calculated?",
       "choice_a":"As a percentage of the par value",
       "choice_b":"By dividing the annual income by the current price",
       "choice_c":"To the final maturity date",
       "choice_d":"To the call date",
       "correct_answer":"D",
       "explanation":"The yield for a bond is generally calculated to the lower of either the yield to maturity or the yield to call. The yield to call measures the yield that would be earned if the bonds were the called at the first call date and not held to the maturity date. If a bond is selling at a premium and is callable at par, yield to call will be lower than yield to maturity. If the bond is selling at a discount, the bond is quoted on a yield to maturity basis. If the bond sells at a premium and is callable at a premium, the yield might be to the final maturity or the call date, depending on the results of the calculation."
    },
    {
       "id":4191,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Who is permitted to participate in a tax-sheltered annuity established under Internal Revenue Code Section 403(b)?",
       "choice_a":"An employee of a school district",
       "choice_b":"Only self-employed individuals",
       "choice_c":"Any employee of a corporation who meets the eligibility standards",
       "choice_d":"Any employee who participates in a nonqualified retirement plan",
       "correct_answer":"A",
       "explanation":"Tax-sheltered annuities are funded with pre-tax dollars and represent an immediate deduction to the investor. They are made available to employees of public school systems under IRS Code 403 (b) and to employees of certain nonprofit organizations under IRS Code 501(c )(3)."
    },
    {
       "id":4192,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Which of the following describes the greatest risk associated with mortgage-backed securities?",
       "choice_a":"Borrowers might default on their mortgage payments.",
       "choice_b":"The market for mortgage-backed securities is illiquid.",
       "choice_c":"The market price of the bonds might fall due to a rating downgrade.",
       "choice_d":"Falling interest rates might accelerate early repayment of principal.",
       "correct_answer":"D",
       "explanation":"Mortgage-backed securities (MBSs) are subject to prepayment risk. The early return of principal would then have to be reinvested when rates are low. Many mortgages that underlie mortgage-backed securities are backed by government guarantees or private mortgage insurance, which insulates many holders of MBSs from defaults on the underlying mortgages."
    },
    {
       "id":4193,
       "topic_id":2,
       "practice_test_id":"",
       "question":"When comparing variable annuities to fixed annuities, which two of the following are correct? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Investment risk is assumed by the investor in a variable annuity. </li><li>Investment risk is assumed by the annuity company in a variable annuity. </li><li>Investment risk is assumed by the investor in a fixed annuity. </li><li>Investment risk is assumed by the annuity company in a fixed annuity.</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"In a fixed annuity, the annuity company guarantees a rate of return on the annuity, although this rate may be reset periodically. The company, therefore, must invest the monies and assume the investment risk. In a variable annuity, the annuity company makes no guarantee. The company will invest the investor\u0027s money and the investor\u0027s annuity benefits will depend on the value of the investments. The investor, therefore, assumes the investment risk in a variable annuity."
    },
    {
       "id":4194,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following is not considered a security?",
       "choice_a":"A certificate of interest in an oil and gas leasing program",
       "choice_b":"An endowment policy",
       "choice_c":"A voting trust certificate",
       "choice_d":"A certificate of interest in a real estate investment trust",
       "correct_answer":"B",
       "explanation":"Any insurance policy, endowment policy, or annuity contract under which an insurance company promises to pay a fixed sum of money either in a lump sum or periodically is not considered a security. Variable life insurance or annuity contracts are considered securities."
    },
    {
       "id":4195,
       "topic_id":2,
       "practice_test_id":6,
       "question":"Which of the following is a characteristic of a variable annuity?",
       "choice_a":"Fixed payments during the annuity period",
       "choice_b":"Different investment options or sub-accounts",
       "choice_c":"A guaranteed rate of return",
       "choice_d":"Investment risk assumed by the insurance company",
       "correct_answer":"B",
       "explanation":"During the payout period of a variable annuity, the benefit payments may vary depending upon how the underlying investments perform. Many variable annuity contracts also allow for variable premium payments during the accumulation period. Most variable annuities allow investors to allocate their funds among different investment options or sub-accounts. The investor assumes the investment risk in a variable annuity contract and there is no guaranteed rate of return."
    },
    {
       "id":4196,
       "topic_id":2,
       "practice_test_id":1,
       "question":"Which bond has the most interest-rate risk?",
       "choice_a":"A 3-month Treasury bill",
       "choice_b":"A zero-coupon 30-year Treasury STRIP",
       "choice_c":"A 6%-coupon 30-year Treasury bond",
       "choice_d":"A 3%-coupon 5-year Treasury note",
       "correct_answer":"B",
       "explanation":"The bond with the most interest-rate risk or price volatility is the one with the longest maturity and lowest coupon."
    },
    {
       "id":4197,
       "topic_id":2,
       "practice_test_id":2,
       "question":"What type of risk do zero-coupon bonds eliminate?",
       "choice_a":"Credit risk",
       "choice_b":"Purchasing power risk",
       "choice_c":"Reinvestment risk",
       "choice_d":"Market risk",
       "correct_answer":"C",
       "explanation":"Zero-coupon bonds are issued at a discount and do not pay semiannual interest. Therefore, there are no dividends to reinvest, eliminating reinvestment risk. When investing in fixed-income investments, one of the uncertainties is whether interest rates will allow an investor to realize the total return that was calculated at the time of the investment (yield to maturity). Zero-coupon bonds do not have reinvestment risk, but they do have extreme interest-rate risk because the bonds\u0027 duration will equal the years to maturity."
    },
    {
       "id":4198,
       "topic_id":2,
       "practice_test_id":3,
       "question":"Income earned within a qualified retirement plan or variable annuity is:",
       "choice_a":"Tax-deferred",
       "choice_b":"Tax-exempt",
       "choice_c":"Tax-deductible",
       "choice_d":"Tax-free",
       "correct_answer":"A",
       "explanation":"Income earned within a qualified retirement plan or variable annuity will accumulate on a tax-deferred basis until it is withdrawn. This is a major advantage for investors since the money can continue to grow and earn a return instead of being paid to the government. The income is not tax-free or tax-exempt, however, since the investor will eventually have to pay taxes on it when it is withdrawn. Tax-free or tax-exempt income is income that will never be subject to taxes. The investor may receive a tax deduction for contributions to retirement plans but not for the income that accumulates within the plans. Also, there is no tax deduction for premium payments to variable annuities."
    },
    {
       "id":4199,
       "topic_id":2,
       "practice_test_id":4,
       "question":"A convertible bond is convertible at $25. The bond is currently selling in the market at $960. What should the stock be selling at to be at parity with the bond?",
       "choice_a":"$10",
       "choice_b":"$23",
       "choice_c":"$24",
       "choice_d":"$25",
       "correct_answer":"C",
       "explanation":"The bond is convertible at $25. This means the conversion ratio is 40 to 1. ($1,000 par value divided by the conversion price of $25 equals the conversion ratio of 40 to 1.) To find parity for the stock, divide the market value of the bond by the conversion ratio (market value of the bond [$960] divided by the conversion ratio of 40 equals $24 parity price for the stock)."
    },
    {
       "id":4200,
       "topic_id":2,
       "practice_test_id":5,
       "question":"Which of the following is not a security?",
       "choice_a":"XYZ common shares",
       "choice_b":"SIA debentures",
       "choice_c":"A variable annuity separate account providing an investor with an option to receive fixed payments for a specified period",
       "choice_d":"A Treasury futures contract",
       "correct_answer":"D",
       "explanation":"Futures contracts are not considered to be securities. A variable annuity separate account is always a security, regardless of the payment options available."
    },
    {
       "id":4201,
       "topic_id":2,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, which of the following are not considered to be a security?",
       "choice_a":"Whiskey warehouse receipts",
       "choice_b":"Fixed annuity contracts",
       "choice_c":"Preorganization certificates",
       "choice_d":"Option contracts",
       "correct_answer":"B",
       "explanation":"A fixed annuity is a contract between an insurance company and an investor promising to pay a fixed amount at a future date. It is not considered a security. Individuals selling fixed annuities need not be registered as securities agents; however, they would have to be registered as insurance agents with the State Insurance Commission."
    },
    {
       "id":4202,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The least suitable investment for an 80-year old investor, would be a:",
       "choice_a":"Treasury note",
       "choice_b":"Utility stock fund",
       "choice_c":"Fixed annuity",
       "choice_d":"Raw land limited partnership",
       "correct_answer":"D",
       "explanation":"Raw land limited partnerships are highly speculative and do not provide the current income return that the majority of elderly investors are seeking."
    },
    {
       "id":4203,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following meets the definition of a \u0022security\u0022?",
       "choice_a":"Drilling leases",
       "choice_b":"Fixed annuity",
       "choice_c":"Investment contract",
       "choice_d":"Endowment policy",
       "correct_answer":"C",
       "explanation":"An “investment contract” is a security and was defined in the Howey Decision."
    },
    {
       "id":4204,
       "topic_id":2,
       "practice_test_id":2,
       "question":"The income generated in a variable annuity through investing in the separate account\u0027s subaccount is",
       "choice_a":"Tax-exempt",
       "choice_b":"Tax-deferred",
       "choice_c":"Tax-deductible",
       "choice_d":"Taxable at long-term capital gains rates",
       "correct_answer":"B",
       "explanation":"Tax-deferred. Investment growth and income in an annuity are tax-deferred."
    },
    {
       "id":4205,
       "topic_id":2,
       "practice_test_id":3,
       "question":"The purchaser of a fixed annuity would be affected most by:",
       "choice_a":"GDP",
       "choice_b":"CPI",
       "choice_c":"Systematic risk",
       "choice_d":"Non-systematic risk",
       "correct_answer":"B",
       "explanation":"In a fixed annuity, you\u0027re guaranteed a minimum rate of return, so the rate of return is the insurance company risk. Your risk is that the payout will be fixed at and inflation will reduce your return. ”Purchasing Power Risk.”"
    },
    {
       "id":4206,
       "topic_id":2,
       "practice_test_id":4,
       "question":"Which of the following investment-grade bonds would probably have the highest yield?",
       "choice_a":"Aa",
       "choice_b":"A",
       "choice_c":"BBB",
       "choice_d":"Ba",
       "correct_answer":"C",
       "explanation":"The \u0022Ba\u0022 rating is the lowest rating/highest yield. But, it\u0027s not an \u0022investment-grade bond.\u0022 Therefore the BBB rated bond would be the correct answer."
    },
    {
       "id":4207,
       "topic_id":2,
       "practice_test_id":5,
       "question":"What does a warrant attached to a bond entitle the holder to?",
       "choice_a":"Trade the bond for stock at a set market price",
       "choice_b":"The purchase of preferred stock at a set price over a range of dates",
       "choice_c":"The purchase of common stock at set price over range of dates",
       "choice_d":"The purchase of set number shares of stock at set price on a certain date",
       "correct_answer":"C",
       "explanation":"A warrant attached to a bond entitles the holder to purchase a set number of shares of common stock at a set price over a period of time not on a set date."
    },
    {
       "id":4208,
       "topic_id":2,
       "practice_test_id":6,
       "question":"The yield to maturity will be less than yield to call when:",
       "choice_a":"Interest rates are going up",
       "choice_b":"Interest rates are below the coupon rate",
       "choice_c":"The issuer has had its rating increased by a major rating service",
       "choice_d":"Inflation expectations are going down",
       "correct_answer":"A",
       "explanation":"The yield to maturity for a bond will be lower than the yield to call for the bond when the bond is trading at a discount from par. Of the choices listed a bond would only fall in price and be trading at a discount if interest rates are going up."
    },
    {
       "id":4209,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The major difference between preferred stock and a preferred or secured bond is:",
       "choice_a":"Holders of a secured bond are creditors of the corporation and have claim to specific assets",
       "choice_b":"Preferred stockholders receive a higher yield",
       "choice_c":"Preferred stockholders are guaranteed to receive the stated dividend",
       "choice_d":"Secured bondholders are creditors and as such are allowed to vote while preferred stockholders do not vote",
       "correct_answer":"A",
       "explanation":"The major difference between preferred stock and a preferred or secured bond is that holders of a secured bond are creditors of the corporation and have claim to specific assets. Neither preferred stockholders nor secured bondholders are entitled to vote."
    },
    {
       "id":4210,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The biggest benefit of preferred stock for an investor is:",
       "choice_a":"A low unit price and guaranteed return of the face amount of the shares",
       "choice_b":"A low unit price and guaranteed semi annual payment",
       "choice_c":"A low unit price and secured as a general creditor of the issuer in case of bankruptcy",
       "choice_d":"A stated dividend payment",
       "correct_answer":"D",
       "explanation":"The biggest benefit to an investor in preferred stock is the stated dividend. The dividend is promised at a stated rate but is not guaranteed. A low unit price is generally not a benefit for an investor in preferred shares."
    },
    {
       "id":4211,
       "topic_id":2,
       "practice_test_id":1,
       "question":"A mutual fund announces a dividend on December 1st with a record date of December 15th and a payment date of December 30th. When could an investor first buy the mutual fund to avoid receiving the dividend?",
       "choice_a":"December 30th",
       "choice_b":"December 1st",
       "choice_c":"December 16th",
       "choice_d":"December 31st",
       "correct_answer":"C",
       "explanation":"An open end mutual fund unlike a stock goes ex dividend on the day after the record date, or in this case December 16th. The first day an invest could purchase the mutual fund and not receive the dividend is the ex date."
    },
    {
       "id":4212,
       "topic_id":2,
       "practice_test_id":2,
       "question":"You own a long term corporate bond. Which of the following risks should you be least concerned about?",
       "choice_a":"Default",
       "choice_b":"Interest rate risk",
       "choice_c":"Market risk",
       "choice_d":"Liquidity risk",
       "correct_answer":"D",
       "explanation":"Of the risks listed the holder of a corporate bond would be least concerned about liquidity risk, which is the ability to sell the bond quickly without adversely impacting the bond\u0027s price."
    },
    {
       "id":4213,
       "topic_id":2,
       "practice_test_id":3,
       "question":"A bond has 6% coupon and is selling in the marketplace at 105. The bond is currently:",
       "choice_a":"Selling at par value",
       "choice_b":"Selling at discount",
       "choice_c":"Selling at premium",
       "choice_d":"Selling with a 6% yield to maturity",
       "correct_answer":"C",
       "explanation":"A bond trading in the marketplace at 105 is selling at a premium to its par value."
    },
    {
       "id":4215,
       "topic_id":2,
       "practice_test_id":4,
       "question":"A city is going to build a new dam. The city hires a contractor to build it and floats bonds to pay for the dam that will be financed by new water fees. What type of bond is this?",
       "choice_a":"Revenue bond because they are paying for the bond with future fees",
       "choice_b":"Corporate bond because the bond is floated by the contractor",
       "choice_c":"General obligation bond",
       "choice_d":"Build America bond",
       "correct_answer":"A",
       "explanation":"A municipal bond that is issued to finance a revenue producing facility with the interest and principal payments being made from the fees generated by the facility are revenue bonds."
    },
    {
       "id":4216,
       "topic_id":2,
       "practice_test_id":5,
       "question":"What type of option can be converted to the underlying security early?",
       "choice_a":"American",
       "choice_b":"European",
       "choice_c":"Binary",
       "choice_d":"B-H",
       "correct_answer":"A",
       "explanation":"American style options may be exercised or converted in to the underlying securities at any time prior to expiration. European options may only be exercised at expiration."
    },
    {
       "id":4217,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An advantage of variable annuities over mutual funds would be:",
       "choice_a":"The investor can move money within annuity without fees",
       "choice_b":"The investor receives tax advantages",
       "choice_c":"The investor achieves diversification",
       "choice_d":"The investor achieves a higher return with lower risk",
       "correct_answer":"B",
       "explanation":"An annuity allows the investor\u0027s money in the annuity to grow tax deferred. The growth is only taxed when the money is taken out. While the growth in mutual funds is subject to taxation."
    },
    {
       "id":4218,
       "topic_id":2,
       "practice_test_id":"",
       "question":"When comparing closed end versus open end mutual funds, which of the following is true regarding closed end funds but not of open end funds?",
       "choice_a":"There are fewer transaction costs",
       "choice_b":"The investor might have to trade stock at inopportune times",
       "choice_c":"Closed end funds are always looking for new opportunities for new money",
       "choice_d":"Closed end funds may be traded any time the market is open and the investor pays a fee to execute the order",
       "correct_answer":"D",
       "explanation":"Closed end funds may be traded any time the market is open and the investor pays a fee to execute the order. Open end funds may not be traded intra day."
    },
    {
       "id":4219,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Common stock typically has voting rights, these rights entitle the owner to: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Send a proxy </li><li>Dividends </li><li>Nominate board members  </li><li>Vote on corporate policy</li></ol>",
       "choice_a":"II and III",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"While stockholders have the right to receive dividends they do not have the right to vote for them. Stockholders also do not get to vote for general corporate policy. Stockholders are entitled to cast their votes by sending proxies and may nominate a person for the board of directors. Generally only large shareholders will try to nominate a board member."
    },
    {
       "id":4220,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The advantages of a zero coupon bond are:",
       "choice_a":"Tax free interest",
       "choice_b":"Taxation of phantom income",
       "choice_c":"The ability to choose a maturity date and to receive a known amount on that date",
       "choice_d":"Higher interest rates than coupon bonds",
       "correct_answer":"C",
       "explanation":"An advantage of a zero coupon bonds is the ability to purchase a bond with a set maturity date and the ability to receive a known amount on that date."
    },
    {
       "id":4447,
       "topic_id":2,
       "practice_test_id":"",
       "question":"What happens to the yield curve if long term interest rates are expected to rise?",
       "choice_a":"The curve steepens",
       "choice_b":"The curve flattens",
       "choice_c":"The curve does not change",
       "choice_d":"The curve inverts",
       "correct_answer":"A",
       "explanation":"The yield curve would steepen as long term rates rise. Even if long term rates are simply expected to rise, investors would sell long term bonds and this action in itself would cause long term rates to rise."
    },
    {
       "id":4448,
       "topic_id":2,
       "practice_test_id":6,
       "question":"A yield curve that slopes downwards is said to be:",
       "choice_a":"Inverted",
       "choice_b":"Positive",
       "choice_c":"Contango",
       "choice_d":"Backward",
       "correct_answer":"A",
       "explanation":"A downward sloping yield curve is one where short term interest rates are higher than long term rates. The yield curve in this situation is said to be inverted."
    },
    {
       "id":19499,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The written agreement that contains the specific details related to a bond issue is called the bond:",
       "choice_a":"Indenture",
       "choice_b":"Contract",
       "choice_c":"Subscription",
       "choice_d":"Prospectus",
       "correct_answer":"A",
       "explanation":"The written agreement that contains the specific details related to a bond issue is called the bond indenture. The indenture spells out all of the terms and conditions of the bond."
    },
    {
       "id":19501,
       "topic_id":2,
       "practice_test_id":2,
       "question":"Which one of the following rights is never directly granted to all  common shareholders of a publicly-held corporation?",
       "choice_a":"Pre emptive right",
       "choice_b":"Voting right",
       "choice_c":"Right to receive declared dividends",
       "choice_d":"Right to elect the CEO",
       "correct_answer":"D",
       "explanation":"The CEO of a company is appointed by the Board of Directors. Shareholders do not vote directly for the CEO of the company. Shareholders vote for the Board of Directors and the Board determines who should run the day to day operations of the company"
    },
    {
       "id":19503,
       "topic_id":2,
       "practice_test_id":3,
       "question":"1 mill when determining tax liability for real property would best be described as:",
       "choice_a":"$10 per $1,000",
       "choice_b":"$1 per $1,000",
       "choice_c":"$10 per $100,000",
       "choice_d":"$1 per $100",
       "correct_answer":"B",
       "explanation":"1 mil equals $1 of tax for every $1,000 of assessed value of property ."
    },
    {
       "id":19504,
       "topic_id":2,
       "practice_test_id":4,
       "question":"Which of the following municipal bond issues would have the debt supported by revenue received based on a mil rate?",
       "choice_a":"PHA issue",
       "choice_b":"State issued GO",
       "choice_c":"Locally issued GO",
       "choice_d":"State bond anticipation note",
       "correct_answer":"C",
       "explanation":"A locally issued GO bond would have the debt supported by revenue received based on a mil rate. Local GOs are supported by property taxes. State issued GOs are supported by sales taxes."
    },
    {
       "id":19507,
       "topic_id":2,
       "practice_test_id":5,
       "question":"A bridge connecting two states would like to issue new bonds to be supported by the same toll revenue as the outstanding issue. The outstanding bonds have an open end covenant. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bonds may not have an equal claim on the facility as the original bonds </li><li>The bonds are subject to a study to ensure that the facility can support the payments for both bond issues </li><li>The bonds as an additional issue would be subject to a mandatory sinking fund </li><li>The new issue must amortize at the same rate as the original bond issue</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II only",
       "choice_c":"III and IV",
       "choice_d":"I, II and IV",
       "correct_answer":"B",
       "explanation":"A facility with an outstanding bond issue with an open end covenant may issue bonds with the same claim on the facility and its revenue.  The new issues will be subject to an additional bonds test to make sure that the revenue received by the facility can support the total outstanding debt.  The new issue will not be subject to a mandatory sinking fund and there is no amortization requirement."
    },
    {
       "id":19509,
       "topic_id":2,
       "practice_test_id":6,
       "question":"The US Government guarantees the payments on which of the following local issues?",
       "choice_a":"IDB for a project in a low income area",
       "choice_b":"Low income housing PHA issue",
       "choice_c":"Historical Rehab issue",
       "choice_d":"HHA low income housing issue",
       "correct_answer":"B",
       "explanation":"Bonds issued by the public housing authority / PHA are back by the full faith and credit of the federal Government. If the rent received from the tenants is not sufficient to support the bond payments the federal Government will make up the shortfall."
    },
    {
       "id":19510,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A municipality after years of financial difficulty defaults on an outstanding issue of GO bonds. The bond issue was rather small and had no legal opinion issued.  Which of the following are not required in order for the bonds to be considered good delivery? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bonds must be accompanied by an official default notice </li><li> All past unpaid coupons must be attached </li><li> All coupons for future payment must be attached </li><li> The bonds must be accompanied by an escrow receipt</li></ol>",
       "choice_a":"I only",
       "choice_b":"IV only",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"D",
       "explanation":"In order for a bond in default to be considered to be in good deliverable form, all unpaid past coupons and all coupons for future payment must be attached. The bonds do not need to be accompanied by an official default notice or an escrow receipt."
    },
    {
       "id":19520,
       "topic_id":2,
       "practice_test_id":"",
       "question":"A long term growth oriented investors is long 400 shares of EXT at $19. The stock over the last three years has appreciated to $74 and the company declares a 3:2 stock split. The investor\u0027s account will receive how many additional shares of EXT on the payable date?",
       "choice_a":300,
       "choice_b":200,
       "choice_c":400,
       "choice_d":600,
       "correct_answer":"B",
       "explanation":"To determine the number of shares the investor will own after the split multiply the number of shares owned by the split. In this case 400 X 3/2 = 1200 / 2 = 600 shares. As the investor is long 400 the investor will receive an additional 200 shares of EXT on the payable date."
    },
    {
       "id":19524,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Which of the following features would benefit a preferred stock investor during a period of inflation?",
       "choice_a":"Cumulative",
       "choice_b":"Callable",
       "choice_c":"Convertible",
       "choice_d":"Participating",
       "correct_answer":"C",
       "explanation":"During times of inflation the value of fixed payments will become less valuable and the price of the preferred stock may decrease as a result.  If the preferred stock is convertible it would lend support to the price of the preferred stock and allow the investor to convert the preferred shares for common shares which tend to do better during times of inflation."
    },
    {
       "id":19574,
       "topic_id":2,
       "practice_test_id":6,
       "question":"One reason an investor would not use internal rate of return to analyze a potential investment in common stock is:",
       "choice_a":"The market price of common stock moves to quickly",
       "choice_b":"There is no maturity date",
       "choice_c":"The issuance of new shares can cause dilution",
       "choice_d":"Preferred stock has a senior claim on corporate earnings and assets",
       "correct_answer":"B",
       "explanation":"In order to calculate the internal rate of return an investor would need a price and maturity date. Common stock has no maturity date"
    },
    {
       "id":21164,
       "topic_id":2,
       "practice_test_id":1,
       "question":"An investor who is long a variable rate demand obligation is looking to offset his position and liquidate the security. The investor may accomplish this by doing which of the following?",
       "choice_a":"Selling the security in the market",
       "choice_b":"Putting the security to the dealer at any time",
       "choice_c":"Putting the security to a third party at any time",
       "choice_d":"Putting the security to the dealer on the reset date only",
       "correct_answer":"D",
       "explanation":"An investor may only liquidate the variable rate demand obligation by putting the security to the dealer or to a third party on the reset date."
    },
    {
       "id":21172,
       "topic_id":2,
       "practice_test_id":2,
       "question":"Which of the following investments does not allow for the flow through of income and expenses?",
       "choice_a":"A real estate limited partnership",
       "choice_b":"An oil and gas drilling program",
       "choice_c":"A real estate investment trust",
       "choice_d":"A partnership organized to lease heavy equipment",
       "correct_answer":"C",
       "explanation":"All of the choices listed pass through both income and expenses to investors except a real estate investment trust or a REIT. A REIT must pass through 90 percent of its income, but does not pass expenses through to investors."
    },
    {
       "id":21179,
       "topic_id":2,
       "practice_test_id":3,
       "question":"A municipal bond scale reflects which of the following?",
       "choice_a":"Various yields to maturity for bonds of different maturities",
       "choice_b":"Various prices for revenue bonds",
       "choice_c":"Various mil rates for local GO bonds",
       "choice_d":"Various ratings for GO bonds of different quality",
       "correct_answer":"A",
       "explanation":"A municipal bond scale reflects the various yield to maturities for GO bonds with different maturity dates. Bonds with shorter maturities will have lower yields than bonds with longer maturities in a normal interest rate environment."
    },
    {
       "id":21185,
       "topic_id":2,
       "practice_test_id":4,
       "question":"A county is offering a new issue of  10 year GO bonds that are not in high demand. As a result the issue must be sold to investors at a price that is equal to 92. An investor who holds the bonds until they mature will have which of the following?",
       "choice_a":"A tax liability of $80 per bond",
       "choice_b":"A reduced yield to maturity",
       "choice_c":"Zero tax liability per bond",
       "choice_d":"Significant reinvestment risk",
       "correct_answer":"C",
       "explanation":"When an investor purchases an original issue discount bond and holds the bonds until maturity, the investor will not have any taxable gain on the appreciation to par."
    },
    {
       "id":21189,
       "topic_id":2,
       "practice_test_id":5,
       "question":"Common stockholders have the right to vote on which of the following?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The use of retained earnings to repurchase shares for the treasury </li><li>The issuance of convertible bonds  </li><li>The compensation for senior executives  </li><li>The declaration of bankruptcy</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II only",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"Of the choices listed the only item that common stockholders may vote on would be the issuance of convertible debt. Common stockholders are entitled to vote for the issuance of any securities that could result in the dilution of shareholder\u0027s equity."
    },
    {
       "id":21196,
       "topic_id":2,
       "practice_test_id":6,
       "question":"A bond issue that is said to trade \u0022flat\u0022 indicates to the investor:",
       "choice_a":"the bond is trading at par value",
       "choice_b":"the bond is in default",
       "choice_c":"the bond price is very stable",
       "choice_d":"the bond does not pay interest",
       "correct_answer":"D",
       "explanation":"A bond that is said to trade flat does not trade with accrued interest. Zero coupon bonds, and other issues that are issued at a discount like T\u0027 bills, commercial paper and banker\u0027s acceptances all trade flat and do not make regular interest payments. These securities are issued at a discount and appreciate up to par."
    },
    {
       "id":21198,
       "topic_id":2,
       "practice_test_id":"",
       "question":"As it relates to the issuance of Eurodollar bonds issued by a US corporation, which of the following is / are not true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The corporation is subject to currency risk </li><li>The bonds must be registered with the SEC prior to sale  </li><li>The investors will receive payments in their domestic currency  </li><li>The bonds may only be sold to qualified institutional buyer in the US</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Eurodollar bonds are bonds issued by a US corporation denominated in US dollars and sold to investors who reside outside of the US. Because the bonds are issued in US Dollars the corporation does not have any currency risk. The bonds are issued outside of the US which is beyond the jurisdiction of the SEC. Therefore the bonds do not need to register with the SEC. Eurodollar bonds are not sold to any US investors and investors receive payments in US dollars."
    },
    {
       "id":21204,
       "topic_id":2,
       "practice_test_id":"",
       "question":"As it relates to a variable interest rate municipal security, which of the following are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bond has a fixed coupon rate </li><li>The bond has a stable principal value  </li><li>The bond has a coupon rate that varies  </li><li>The bond has a principal amount that varies</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"A variable interest rate municipal security has a coupon rate that is regularly adjusted to the prevailing interest rates in the market. As such the principal value of the bond tends to be very stable and always close to par. If rates increase the interest rate  paid on the bond is increased., if rates fall the interest rate paid on the bond is reduced."
    },
    {
       "id":25365,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An income oriented investor purchased a 7 percent bond at 90 when the issuer was having financial trouble. After a series of corporate initiatives the issuer\u0027s prospects are looking up. The bond is now trading in the marketplace at 120. What is the investor\u0027s current yield?",
       "choice_a":"7.77%",
       "choice_b":"5.83%",
       "choice_c":"6.36%",
       "choice_d":"8.10%",
       "correct_answer":"A",
       "explanation":"When an investor purchases a bond the investor locks in the current yield at the time of purchase. In this case it is 7.77%. Found using the formula: CY= AI/CMP 70/ 900 = 7.77. The current yield on the bond for new purchasers will be less because the bond has increased in price. However, the current yield for this investor has not changed"
    },
    {
       "id":25366,
       "topic_id":2,
       "practice_test_id":6,
       "question":"Which of the following would not carry currency risk for A U.S. based issuer or investor?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Eurobond </li><li>Yankee bond </li><li>Eurodollar bond </li><li>Eurodollar deposit</li></ol>",
       "choice_a":"III only",
       "choice_b":"II and IV",
       "choice_c":"I and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are denominated and pay interested in US dollars, except a Eurobond. A Yankee bond is a bond issued by an overseas corporation denominated in US dollars. Eurodollar bonds are sold by US corporations to overseas investors and are denominated in US dollars. A Eurodollar deposits is an overseas account denominated in US dollars."
    },
    {
       "id":25375,
       "topic_id":2,
       "practice_test_id":2,
       "question":"Which of the following is true relating to the taxation of annuities?",
       "choice_a":"They are deferred until the annuity phase or until the investor closes out the contract",
       "choice_b":"They are fully taxable in the annuity phase of the contract",
       "choice_c":"They are fully taxable during the accumulation phase",
       "choice_d":"They are taxed annually after the annuity phase ends",
       "correct_answer":"A",
       "explanation":"An annuity is a non qualified account and as such the money is deposited with after tax dollars. The investor\u0027s deposits will be returned to them tax free. The taxation on the growth will be deferred until the investor annuitizes the contract or until the investor closes out the contract and takes a lump sum distribution."
    },
    {
       "id":25359,
       "topic_id":2,
       "practice_test_id":3,
       "question":"Which of the following would not be a short term money market instrument?",
       "choice_a":"Banker\u0027s acceptance",
       "choice_b":"Commercial paper",
       "choice_c":"CDs",
       "choice_d":"A warrant with 7 months remaining to maturity",
       "correct_answer":"D",
       "explanation":"Only short term debt securities may be traded in the money market. A warrant is an equity security and therefore not a money market instrument."
    },
    {
       "id":25355,
       "topic_id":2,
       "practice_test_id":4,
       "question":"A client who is risk averse is speaking to his registered representative about brokered CDs as an option for  $200,000 he has in his investment account. Which of the following choices are not features of negotiable  CDs sold to clients of broker dealers?",
       "choice_a":"The CDs are available in a wide maturity range",
       "choice_b":"The CDs trade flat in the secondary market",
       "choice_c":"The CDs will be covered under FDIC Insurance for $250,000",
       "choice_d":"The greater the number of compounding periods the greater the return",
       "correct_answer":"B",
       "explanation":"The question asks which is not a feature of negotiable CDs sold through brokers. All of the choices are true except the CDs do not trade flat. The negotiable CDs trade with accrued interest."
    },
    {
       "id":25381,
       "topic_id":2,
       "practice_test_id":5,
       "question":"Which of the following investments would subject the investor the the greatest interest rate risk?",
       "choice_a":"A 20 year floating rate security",
       "choice_b":"A 15 year zero coupon bond",
       "choice_c":"A 20 year zero coupon bond",
       "choice_d":"A 30 year zero coupon bond",
       "correct_answer":"D",
       "explanation":"As interest rates change the bond with the longest time until maturity and trading the furthest away from par will fall the most in price if interest rates rise. In this case the 30-year zero coupon bond is the correct choice."
    },
    {
       "id":25787,
       "topic_id":2,
       "practice_test_id":6,
       "question":"Which of the following choices would be a way to value a share of common stock based on cash flow?",
       "choice_a":"Earnings per share",
       "choice_b":"Earnings before taxes and depreciation",
       "choice_c":"Internal rate of return",
       "choice_d":"Dividend growth model",
       "correct_answer":"D",
       "explanation":"The question is asking how to value common stock based on its cash flow. The cash flow generated by common stock is a dividend. Of the choices listed only the dividend growth model would be a way  to  value common stock based on its cash flow. Internal rate of return may never be used to value common stock because it requires a termination or end date and common stock is perpetual."
    },
    {
       "id":31798,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An investor who is risk averse is reviewing an opportunity to purchase a corporate bond issued by ABC Corporation. Which of the following would provide the investor with the greatest understanding of the bond\u0027s risk?",
       "choice_a":"Term",
       "choice_b":"Collateral",
       "choice_c":"Yield",
       "choice_d":"Price",
       "correct_answer":"C",
       "explanation":"The bond\u0027s yield is the best measure of risk. The higher the yield, the greater the risk associated with the bond. Bonds with a significant amount of risk of default or credit risk will have the highest yield to compensate investors for taking on that risk."
    },
    {
       "id":31799,
       "topic_id":2,
       "practice_test_id":"",
       "question":"SIA & Co. is considering borrowing funds through the sale of zero coupon bonds. As it relates to the interest payments on the issue, which of the following is true?",
       "choice_a":"Investors will pay taxes at maturity and SIA & Co. will take the interest tax deduction at maturity",
       "choice_b":"Investors will pay taxes annually and SIA & Co. will take the interest tax deduction at maturity",
       "choice_c":"Investors, will pay taxes at maturity and SIA & Co. will take the interest tax deduction annually",
       "choice_d":"Investors, will pay taxes annually and SIA & Co. will take the interest tax deduction at annually",
       "correct_answer":"B",
       "explanation":"Investors who purchase zero coupon bonds must pay taxes annually on the phantom income produced by the appreciation of the bonds. Issuers of zero coupon bonds, in this case SIA & Co must take the interest tax deduction at maturity when the interest is actually paid by the issuer."
    },
    {
       "id":32604,
       "topic_id":2,
       "practice_test_id":6,
       "question":"FastGrowth Advisers has several large portfolios that they benchmark to the S&P 400. Which of the following is most likely correct as it relates to these portfolios?",
       "choice_a":"They are low beta large cap stocks",
       "choice_b":"They are high beta mid cap stocks",
       "choice_c":"They low beta high yielding stocks",
       "choice_d":"They are high beta small cap stocks",
       "correct_answer":"B",
       "explanation":"The S&P 400 index is a mid cap index. Mid cap stocks tend to have higher betas and therefore contain more risk. The portfolios are most likely designed to provide high growth to investors."
    },
    {
       "id":32603,
       "topic_id":2,
       "practice_test_id":1,
       "question":"A portfolio manager would require the greatest predictive ability if the manager employs which of the following?",
       "choice_a":"A fundamental approach",
       "choice_b":"A technical approach",
       "choice_c":"A tactical approach",
       "choice_d":"A balanced approach",
       "correct_answer":"C",
       "explanation":"A manager who takes a tactical approach feels that he / she can time the market and move assets between classes based on what is predicted to happen. A tactical manager feels that they can use the approach to outperform the overall market and to add excess returns ( alpha)"
    },
    {
       "id":32601,
       "topic_id":2,
       "practice_test_id":2,
       "question":"An investor who is seeking to diversify her portfolio and smooth out its change in value, is considering adding international equities. Which of the following would be the most attractive option for her?",
       "choice_a":"An equity listed on the Canadian exchange with a correlation of .8 to the S&P 500",
       "choice_b":"An equity listed on the German exchange with a correlation of .7 to the S&P 500",
       "choice_c":"An equity listed on the Chinese exchange with a correlation of .4 to the S&P 500",
       "choice_d":"An equity listed on the London exchange with a correlation of .9 to the S&P 500",
       "correct_answer":"C",
       "explanation":"The most diversification would be added by the Chinese equity as it has the lowest correlation to the S&P 500. That is to say that Chinese equity would be least influenced by the change in the S&P 500. Stating that another way the price of the Chinese equity is the most independent from the US index and would provide the most diversification."
    },
    {
       "id":32602,
       "topic_id":2,
       "practice_test_id":3,
       "question":"An investment manager who subscribes to CAPM is using the formula to calculate the projected return of a conservative portfolio with a beta of .6. The manager expects the market to increase by 12 percent this year and the risk free return to remain constant at 2 percent. The manager therefore would calculate the portfolio\u2019s estimated return to be:",
       "choice_a":"7.20%",
       "choice_b":"9.20%",
       "choice_c":"8.20%",
       "choice_d":"8%",
       "correct_answer":"D",
       "explanation":"The CAPM pricing model requires you to take the risk premium into account to calculate the estimated rate of return. It is not simply based on beta. You must multiply the risk premium provided by the market by the beta then add back the risk free return. In this case 12 \u2013 2 = 10. 10 X .6 = 6.  6 + 2 = 8"
    },
    {
       "id":37239,
       "topic_id":2,
       "practice_test_id":4,
       "question":"An individual has been promised a future payment of $100,000 from a family trust . As it relates to the current value of this future payment, which of the following two choices are correct? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>the higher the interest rate, the higher the net present value of the payment </li><li> the greater the time until the payment is received, the lower the net present value of the payment </li><li>The lower the interest rate, the higher the net present value of the payment </li><li> the shorter the time until the payment is received, the lower the net present value of the payment</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"III and IV",
       "choice_d":"I and II",
       "correct_answer":"A",
       "explanation":"The net present value of the payment would be the greatest when the time to receive the payment is short and the interest rate used to calculate the net present value is low."
    },
    {
       "id":37238,
       "topic_id":2,
       "practice_test_id":5,
       "question":"An investor owns an equity-indexed annuity contract with a minimum guaranteed rate of 3%. The contract has been designed so that the account holder will receive  80% of the performance of the S&P 500 Index up to a maximum of 12%. The S&P 500 was up 3.8% in the previous period. During that same time frame the CPI increased by 1%.  Given this scenario, the investor would expect the value of their account to:",
       "choice_a":"increase by 3%",
       "choice_b":"increase by 3.8%",
       "choice_c":"increase by 3.04%",
       "choice_d":"increase by 2.8%",
       "correct_answer":"C",
       "explanation":"The investor would expect the value of their account to increase by 3.04%. The S&P 500 was up 3.8% and the investor is entitled to receive 80% of the increase in the index. 3.8% X 80% equals 3.04%"
    },
    {
       "id":37236,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An Investor who is looking to begin to save for retirement is concerned that they will not have enough assets to generate significant income during their retirement years. The  investor explains to the representative that these will be the first contributions they are making to any retirement accounts. Which of the following is the least suitable for this client?",
       "choice_a":"A traditional IRA",
       "choice_b":"A Roth IRA",
       "choice_c":"Participating in his / her employer\u0027s 401K program",
       "choice_d":"A variable annuity",
       "correct_answer":"D",
       "explanation":"The variable annuity would be least suitable for this investor as it is clear that they have not contributed any money to retirement accounts. A variable annuity would only be appropriate if the investor was looking to supplement or augment other retirement assets."
    },
    {
       "id":37237,
       "topic_id":2,
       "practice_test_id":"",
       "question":"An Investor who is concerned about the tax implications of owning an open-end mutual fund Is looking for the value of his holdings to increase over time. This investor would be best  suited for which of the following funds?",
       "choice_a":"A municipal bond Fund",
       "choice_b":"An equity fund with a low turnover ratio",
       "choice_c":"A balanced mutual fund",
       "choice_d":"An equity fund with a low expense ratio",
       "correct_answer":"B",
       "explanation":"The investor has a growth objective, therefore the municipal bond fund is out automatically. Of the remaining funds, the equity fund with a low turnover ratio would be best suited for this investor as the question clearly states that the investor is concerned about the tax implications of owning open-end mutual funds. An open-end mutual fund with a low turnover ratio tends to hold the securities in the portfolio for a long period of time thus reducing the taxable events to the investor."
    },
    {
       "id":37233,
       "topic_id":2,
       "practice_test_id":6,
       "question":"An investor who is reviewing the performance data of their managed account, notices that the portfolio has an r-squared value of .625.  From this value the investor would conclude:",
       "choice_a":"that the portfolio has an above average amount of systematic risk",
       "choice_b":"that the portfolio has less volatility than the market as a whole",
       "choice_c":"that a significant amount of the return of the portfolio will be based on the return of the market",
       "choice_d":"that the standard deviation of the portfolio is greater than the market as a whole",
       "correct_answer":"C",
       "explanation":"The r-squared value for a portfolio determines the amount of the return that is the result of the overall performance of the market. In this case 62.5% of the  portfolio\u0027s return would be based on the performance of the market as a whole."
    },
    {
       "id":37231,
       "topic_id":2,
       "practice_test_id":"",
       "question":"The expected return of a security would best be described as which of the following?",
       "choice_a":"The product of the beta X the return of the benchmark",
       "choice_b":"The product of the beta X the risk premium",
       "choice_c":"The sum of the weighted returns for the security",
       "choice_d":"The sum of the benchmark return + the risk premium",
       "correct_answer":"C",
       "explanation":"The expected return of a security is the sum of the weighted returns for all possible outcomes for that security."
    },
    {
       "id":37212,
       "topic_id":2,
       "practice_test_id":"",
       "question":"Any short-term capital gains, ones that are earned or realized in less than one year, would subject an individual to which of the following?",
       "choice_a":"a 25% tax",
       "choice_b":"a 15% tax",
       "choice_c":"a tax based on their level of income",
       "choice_d":"a 20% tax",
       "correct_answer":"C",
       "explanation":"Short-term capital gains are taxed at the same rate as ordinary income therefore, an individual who realizes a short-term capital gain, one that has been earned in 12 months or less would be subject to ordinary income taxes on that short-term gain. income taxes are progressive taxes and the rate is based on the level of income earned by the individual."
    },
    {
       "id":3616,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A 401K retirement plan is all of the following except:",
       "choice_a":"A defined contribution plan",
       "choice_b":"Allows employee to contribute a portion of his salary to the plan each month",
       "choice_c":"Based on the concept of profit sharing",
       "choice_d":"Allows the employer to match some or all of the employee\u0027s contribution",
       "correct_answer":"C",
       "explanation":"A 401K retirement plan is not involved with profit sharing."
    },
    {
       "id":3617,
       "topic_id":3,
       "practice_test_id":1,
       "question":"A 42-year-old investor wants to put $20,000 into a plan to help meet the educational expenses of their 12-year-old son. They want to make a lump sum deposit. Which would you recommend?",
       "choice_a":"A 529 plan",
       "choice_b":"A Coverdell IRA",
       "choice_c":"A Roth IRA",
       "choice_d":"A Growth mutual fund",
       "correct_answer":"A",
       "explanation":"A 529 plan would allow the investor to make a lump sum deposit"
    },
    {
       "id":3618,
       "topic_id":3,
       "practice_test_id":2,
       "question":"A 45-year-old investor has rolled over $10,000 from an IRA to buy a home. How long does he have to deposit the money in another qualified plan?",
       "choice_a":"45 days",
       "choice_b":"60 days",
       "choice_c":"30 days",
       "choice_d":"90 days",
       "correct_answer":"B",
       "explanation":"An investor may roll over their IRA once per year and has 60 days to get the money into a qualified plan."
    },
    {
       "id":3619,
       "topic_id":3,
       "practice_test_id":3,
       "question":"A client who is 65-years-old has invested $10,000 in a Roth IRA. It has now grown to $14,000. He plans to retire and take a lump sum distribution. He will pay taxes on:",
       "choice_a":"$14,000",
       "choice_b":"$4,000",
       "choice_c":"$10,000",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"The money has been deposited in a Roth IRA after taxes.  It is allowed to grow tax deferred.  If you are over 59\u00BD and the money has been there for at least 5 years, then it may all be returned without paying taxes on the growth."
    },
    {
       "id":3620,
       "topic_id":3,
       "practice_test_id":4,
       "question":"A client who is a lawyer making $230,000 per year makes the maximum contribution to his Keogh plan. He has a full time paralegal that earns $65,000 per year and wants to know what he must do for his employee\u0027s retirement. You should tell him:",
       "choice_a":"Since you are self-employed, you can decide what to pay your own people",
       "choice_b":"You must contribute the same amount of money to the employees Keogh as you did to yours",
       "choice_c":"You must make a contribution to the employee\u0027s Keogh at the same percentage rate as your own",
       "choice_d":"The employee is not self-employed and may not have a Keogh plan",
       "correct_answer":"C",
       "explanation":"A self-employed individual who has a full time employee must make a contribution for that employee at the same rate as his or her own contribution."
    },
    {
       "id":3621,
       "topic_id":3,
       "practice_test_id":5,
       "question":"A customer has an unexpected expense to meet and would like to take a loan from his variable life insurance policy. Which of the following is not true?",
       "choice_a":"At least 75% of their cash value must be made available to them in the form of a loan",
       "choice_b":"Loans must be made available after three years",
       "choice_c":"Interest must be charged to the loan",
       "choice_d":"Interest must be charged on the loan and the rate must be equal to the prime rate at the time the loan is made",
       "correct_answer":"D",
       "explanation":"All of the answers in the question are true except there is no requirement that the interest rate be equal to the prime rate."
    },
    {
       "id":3622,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A customer has just had their first child and they want to start putting money away for his future. They ask about the maximum contribution to an educational IRA. You should tell them:",
       "choice_a":"The maximum contribution is $2,000 per year after tax",
       "choice_b":"The maximum contribution is $2,000 per year pre-tax",
       "choice_c":"The maximum contribution is $500 per year after tax",
       "choice_d":"The maximum contribution is $500 per year pre-tax",
       "correct_answer":"A",
       "explanation":"The maximum contribution to an educational IRA is $2,000 made after taxes."
    },
    {
       "id":3623,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A Keogh plan (HR-10) is which of the following?",
       "choice_a":"A qualified retirement plan",
       "choice_b":"Usually set up by individuals, sole proprietors, or unincorporated businesses",
       "choice_c":"May be funded only with earned income during a period when the business showed a gross profit",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A Keogh plan allows individuals, sole proprietors, and unincorporated small businesses to establish a retirement plan for themselves and their employees."
    },
    {
       "id":3624,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A Keogh plan is available for all of the following except:",
       "choice_a":"An independent coffee shop owner",
       "choice_b":"A lawyer",
       "choice_c":"A janitor at a local college",
       "choice_d":"A nurse at a local doctor\u0027s office",
       "correct_answer":"C",
       "explanation":"The janitor at a local college is not self-employed nor do they work for someone who is self-employed."
    },
    {
       "id":3625,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A qualified retirement plan differs from a non-qualified retirement plan in all of the following ways except:",
       "choice_a":"Contributions for the qualified plan are pre-tax, while contributions for the non-qualified plan are after tax",
       "choice_b":"Participation must be allowed for everyone in the qualified plan, while the corporation may choose who participates in the non-qualified plan",
       "choice_c":"IRS approval is required for both plans",
       "choice_d":"Withdrawals from a qualified plan are 100% taxed as ordinary income, while growth in excess of the cost base is taxed as ordinary income in a non-qualified plan",
       "correct_answer":"C",
       "explanation":"IRS approval is required for participation in a qualified plan, but IRS approval is not required for a non-qualified plan."
    },
    {
       "id":3680,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Who executes customers\u0027 orders?",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Neither",
       "choice_d":"Both",
       "correct_answer":"A",
       "explanation":"One of the jobs of a broker is to execute customers\u0027 orders."
    },
    {
       "id":3681,
       "topic_id":3,
       "practice_test_id":"",
       "question":"What is an order called which stipulates the price to be met, regardless of the number of shares?",
       "choice_a":"Not-Held Order",
       "choice_b":"All or None Order",
       "choice_c":"Fill or Kill Order",
       "choice_d":"Immediate or Cancel Order",
       "correct_answer":"D",
       "explanation":"An Immediate or Cancel Order will buy or sell whatever can be bought or sold immediately at the stipulated price, and the rest of the order will be canceled."
    },
    {
       "id":3682,
       "topic_id":3,
       "practice_test_id":1,
       "question":"Which of the following is an order to buy that allows the floor broker to exercise judgment as to the price?",
       "choice_a":"Market Order",
       "choice_b":"Not Held Order",
       "choice_c":"Fill or kill",
       "choice_d":"AON",
       "correct_answer":"B",
       "explanation":"A not held order allows the floor broker to determine the best time and price to execute and order."
    },
    {
       "id":3683,
       "topic_id":3,
       "practice_test_id":2,
       "question":"What is the name of a special order that must be executed for the entire amount of shares or not at all without regard to time?",
       "choice_a":"FOK",
       "choice_b":"IOC",
       "choice_c":"AON",
       "choice_d":"DNR",
       "correct_answer":"C",
       "explanation":"An All or None Order requires that all the shares be bought or sold. It may be entered as a day order or GTC."
    },
    {
       "id":3684,
       "topic_id":3,
       "practice_test_id":3,
       "question":"When the underlying common stock sells ex-dividend, a GTC Buy Limit Order will:",
       "choice_a":"Remain unchanged",
       "choice_b":"Be reduced",
       "choice_c":"Be increased",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"Buy Limit Orders entered GTC are entered below the market price and will be reduced by the amount of the dividend."
    },
    {
       "id":3685,
       "topic_id":3,
       "practice_test_id":4,
       "question":"Assume an order was placed prior to the opening-\u0027Sell Short 500 XYZ 67.20 STOP LIMIT GTC.\u0027 At what price was the stop activated? (Assume trades occurred as follows): Open 67.22 ...67.19.... 67.20",
       "choice_a":67.19,
       "choice_b":67.2,
       "choice_c":67.22,
       "choice_d":"The stop was not activated",
       "correct_answer":"A",
       "explanation":"The price that activated the order was 67.19. In order for a stop to be activated, the stock has to trade at or through the stop price."
    },
    {
       "id":3687,
       "topic_id":3,
       "practice_test_id":5,
       "question":"A broker enters a day order for a customer. Later in the day the customer changes the order to a Good-Til-Cancelled (GTC) order, leaving the price and the quantity the same. The order:",
       "choice_a":"Loses its position",
       "choice_b":"Does not lose its position",
       "choice_c":"Is automatically cancelled",
       "choice_d":"None of the choices listed",
       "correct_answer":"A",
       "explanation":"Any change to the terms of an order causes it to lose its place on the DMM\u0027s book."
    },
    {
       "id":3688,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A stock listed on the NYSE stopped trading because of an influx of orders. Trading of the stock in other markets will appear on the Network A (consolidated tape):",
       "choice_a":"As it occurs, even though it stopped trading on the NYSE.",
       "choice_b":"Will not be shown during the time it stopped trading on the NYSE.",
       "choice_c":"The trades are held back and printed after trading starts on the NYSE again.",
       "choice_d":"Trades in other markets will not resume until trading starts on the NYSE again.",
       "correct_answer":"D",
       "explanation":"If a stock is halted on the NYSE it will be halted in all markets"
    },
    {
       "id":3689,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A customer enters a sell-limit order at 85 GTC. The last sale in the stock was 70. A 60¢ dividend is declared. On the ex-dividend date how much will the DMM reduce the order on his book?",
       "choice_a":"60 cents",
       "choice_b":"62.5 cents",
       "choice_c":"Nothing only if marked do not reduce",
       "choice_d":"Nothing",
       "correct_answer":"D",
       "explanation":"Orders placed above the market are not reduced for dividends. Only orders placed below the market are reduced for dividends.  Buy limits and sell stops are placed below the market and sell limits and buy stops are placed above the market."
    },
    {
       "id":3690,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A woman who is short 1,000 shares of XYZ at 105 is going on vacation. She enters orders to buy either 1,000 shares of XYZ at 101 GTC (to cover her short sale should the stock decline to 101), or 1,000 at 109 buy-stop GTC (to cover her short sale if the stock should go up to 109). She tells the R.R. she wants to close out her short position of 1,000 XYZ by either buying the stock at a lower price than she bought it at (101), or at a higher price if it should advance (at 109). The stock declines to 101, but only 700 shares are bought at 101. The GTC orders would now be changed to:",
       "choice_a":"Buy 300 XYZ at 101 or 300 XYZ at 109 buy-stop GTC",
       "choice_b":"Buy 300 XYZ at 101 or 1,000 XYZ at 109 buy-stop GTC",
       "choice_c":"Buy 300 XYZ at 101 or 700 XYZ at 109 buy-stop GTC",
       "choice_d":"Buy 700 XYZ at 100 or 300 XYZ at 109 buy-stop GTC",
       "correct_answer":"A",
       "explanation":"Both orders would have to be reduced by the amount of stock that was purchased at 101, in this case 700 shares."
    },
    {
       "id":3691,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A customer is short 100 ABC at 120. The market is moving up sharply and the customer decides to cover his short position. The customer instructs his R.R. to cover the short position at the market on the close. The order:",
       "choice_a":"Will be executed on the closing price of the day",
       "choice_b":"Will be executed at or as near to the closing price as possible",
       "choice_c":"Will be executed at the closing bid price",
       "choice_d":"Will be executed at the closing price offer",
       "correct_answer":"B",
       "explanation":"A market on close order will be executed at the close or as a close to the closing price as possible"
    },
    {
       "id":3692,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An open buy order entered above the current market price of a security would be a:",
       "choice_a":"All or none order",
       "choice_b":"Stop order",
       "choice_c":"Limit order",
       "choice_d":"Not Held order",
       "correct_answer":"B",
       "explanation":"Only a Buy Stop order would be entered above the market."
    },
    {
       "id":3693,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is the most useful in determining the price volatility of a bond to a significant change in interest rates?",
       "choice_a":"Duration",
       "choice_b":"Convexity",
       "choice_c":"Standard deviation",
       "choice_d":"Sharpe ratio",
       "correct_answer":"B",
       "explanation":"Convexity will tell the investor how sensitive the bond\u0027s price will be to a significant change in interest rates."
    },
    {
       "id":3694,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is the most useful in determining the price volatility of a bond to a small change in interest rates?",
       "choice_a":"Duration",
       "choice_b":"Convexity",
       "choice_c":"Standard deviation",
       "choice_d":"Sharpe ratio",
       "correct_answer":"A",
       "explanation":"The bond\u0027s duration will tell the investor how sensitive the bond\u0027s price is to a small change in interest rates"
    },
    {
       "id":3695,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Under modern portfolio theory, all portfolios should operate:",
       "choice_a":"Inside the efficient frontier",
       "choice_b":"At least equal to the efficient frontier",
       "choice_c":"Outside the efficient frontier only for equities",
       "choice_d":"Outside the efficient frontier only for bonds",
       "correct_answer":"B",
       "explanation":"All portfolios should operate at least equal to the efficient frontier. Any portfolio that is not operating at least at the efficient frontier is said to be taking too much risk for too little return."
    },
    {
       "id":3696,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A portfolio manager who adds which of the following is adding the most value?",
       "choice_a":"Positive convexity",
       "choice_b":"Negative convexity",
       "choice_c":"Positive alpha",
       "choice_d":"Positive beta",
       "correct_answer":"C",
       "explanation":"A portfolio manager who is adding positive alpha is said to be adding value by generating excess returns for the investor given a certain level of risk."
    },
    {
       "id":3697,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor purchases 1000 shares of XYZ at $10 per share. The shares decline to $8 and the investor gives the securities to their adult child. Which of the following is true?",
       "choice_a":"To determine if there is a loss when the child sells the shares, the cost base will be the donor\u0027s cost base or the shares value on the day the gift was made, which ever is lower",
       "choice_b":"To determine if there is a loss when the child sells the shares, the cost base will be the donor\u0027s cost base or the shares value on the day the gift was made, which ever is higher",
       "choice_c":"The child\u0027s cost base is the value of the shares on the day the gift is received",
       "choice_d":"The child\u0027s cost base is equal to the donor\u0027s cost base",
       "correct_answer":"A",
       "explanation":"When a gift is given during a person\u0027s life, the recipient\u0027s cost base to determine if there is a loss will be the donor\u0027s cost base or the share\u0027s value on the day the gift was made, whichever is lower."
    },
    {
       "id":3698,
       "topic_id":3,
       "practice_test_id":1,
       "question":"For estate tax purposes, the IRS will include which of the following when determining the estate\u0027s tax liability?",
       "choice_a":"Assets transferred within 5 years of death",
       "choice_b":"Assets transferred within 3 years of death",
       "choice_c":"Assets transferred within 2 years of death",
       "choice_d":"Assets transferred within 6 years of death",
       "correct_answer":"B",
       "explanation":"The IRS will include assets transferred within three years of death in the taxable estate."
    },
    {
       "id":3699,
       "topic_id":3,
       "practice_test_id":2,
       "question":"An investor who believes that the prices in the marketplace are efficient would most likely employ what type of strategy?",
       "choice_a":"Systematic rebalancing",
       "choice_b":"Tactical asset allocation",
       "choice_c":"Market timing",
       "choice_d":"Buy and hold",
       "correct_answer":"D",
       "explanation":"An investor who believes that the prices in the marketplace are efficient would most likely employ a buy and hold strategy."
    },
    {
       "id":3700,
       "topic_id":3,
       "practice_test_id":3,
       "question":"An investor who believes that investment advisers can out perform the market would most likely use what type of strategy?",
       "choice_a":"Strategic asset allocation",
       "choice_b":"Tactical asset allocation",
       "choice_c":"Quarterly rebalancing",
       "choice_d":"Semi-annual rebalancing",
       "correct_answer":"B",
       "explanation":"An investor who believes that investment advisers can out perform the market as conditions change would use tactical allocation."
    },
    {
       "id":3701,
       "topic_id":3,
       "practice_test_id":4,
       "question":"Which of the following is most appropriate for an estate account?",
       "choice_a":"Commercial paper",
       "choice_b":"Treasury bonds",
       "choice_c":"Municipal bonds",
       "choice_d":"Mortgage backed securities",
       "correct_answer":"A",
       "explanation":"Estate accounts are accounts that are to be liquidated after a short period of time. Excess funds should be invested in short term liquid investments."
    },
    {
       "id":3702,
       "topic_id":3,
       "practice_test_id":5,
       "question":"A 401K plan from a former employer can be rolled over without creating a current tax liability into: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Another 401K  </li><li>A Roth IRA </li><li>A traditional IRA </li><li>A Coverdell IRA</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I and III",
       "choice_d":"I, III, and IV",
       "correct_answer":"C",
       "explanation":"A 401k may not be rolled over into a Roth IRA with out creating a tax liability."
    },
    {
       "id":3703,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An investor may transfer the assets from a traditional IRA to a Roth IRA </li><li>The transfer will create an additional tax liability for the owner </li><li>An investor may not transfer the assets from a traditional IRA to a Roth IRA </li><li>The transfer will not create an additional tax liability for the owner if they are under 59\u00BD</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"III only",
       "choice_c":"I and II",
       "choice_d":"I only",
       "correct_answer":"C",
       "explanation":"All investors who transfer assets from a traditional IRA to a Roth IRA will have a tax liability."
    },
    {
       "id":3704,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An individual who wants to form a business, but who wants to protect their personal assets from any liabilities could form which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A limited liability company </li><li>A subchapter S corporation </li><li>A C corporation </li><li>A general partnership</li></ol>",
       "choice_a":"III only",
       "choice_b":"I and III",
       "choice_c":"I, II, III, and IV",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"An individual who wants to protect their assets could use all of the forms of organization listed except a general partnership."
    },
    {
       "id":3705,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The provisions of ERISA would apply to:",
       "choice_a":"A traditional IRA",
       "choice_b":"A Roth IRA",
       "choice_c":"A profit sharing plan",
       "choice_d":"An educational IRA",
       "correct_answer":"C",
       "explanation":"ERISA only regulates qualified private sector employer sponsored pension plans. A profit sharing plan is a qualified plan."
    },
    {
       "id":3706,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investment adviser that identifies economic trends and companies whose earnings are likely to benefit from the trends would be using which of the following approaches?",
       "choice_a":"Tactical",
       "choice_b":"Systematic",
       "choice_c":"Top down",
       "choice_d":"Bottom up",
       "correct_answer":"C",
       "explanation":"An investment adviser that identifies trends in the economy first and then identifies companies that will do well within those trends is said to be using a top down approach."
    },
    {
       "id":3707,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A bank with a short fall meeting their reserve requirement could borrow money from another bank and pay the:",
       "choice_a":"Prime rate",
       "choice_b":"Discount Rate",
       "choice_c":"Federal funds rate",
       "choice_d":"Broker call loan rate",
       "correct_answer":"C",
       "explanation":"A bank may borrow money from another bank to meet their reserve requirement and it will pay the other bank the federal funds rate."
    },
    {
       "id":3708,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A business cycle is defined as having how many distinct stages?",
       "choice_a":2,
       "choice_b":3,
       "choice_c":4,
       "choice_d":5,
       "correct_answer":"C",
       "explanation":"The business cycle has four distinct stages: expansion, peak, contraction, and trough."
    },
    {
       "id":3709,
       "topic_id":3,
       "practice_test_id":1,
       "question":"A decline in the GDP must last at least how long to be considered a recession?",
       "choice_a":"One quarter",
       "choice_b":"Two quarters",
       "choice_c":"Four quarters",
       "choice_d":"Six quarters",
       "correct_answer":"B",
       "explanation":"A decline in the gross domestic product must last at least two quarters or six months to be considered a recession."
    },
    {
       "id":3710,
       "topic_id":3,
       "practice_test_id":2,
       "question":"A decrease in the available credit in a client\u0027s account would follow each of the following except:",
       "choice_a":"An increase in the discount rate",
       "choice_b":"The open market sale of securities by the Federal Reserve",
       "choice_c":"An increase in the reserve requirement",
       "choice_d":"A lowering of the margin requirement",
       "correct_answer":"D",
       "explanation":"A decrease in the margin requirement would result in an increase in credit in the customer\u0027s account"
    },
    {
       "id":3711,
       "topic_id":3,
       "practice_test_id":3,
       "question":"A devaluation of the U.S. dollar in comparison to other currencies would have the effect of making:  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>U.S. exports more competitive than foreign exports </li><li>U.S. exports less competitive than foreign exports </li><li>Foreign exports less competitive than U.S. exports </li><li>Foreign exports more competitive than U.S. exports</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and III",
       "choice_c":"II only",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"A fall in the value of the US Dollar would make US exports more competitive and foreign goods less competitive."
    },
    {
       "id":3712,
       "topic_id":3,
       "practice_test_id":4,
       "question":"A fundamental analyst evaluating the common stock of a corporation would look at all of the following except:",
       "choice_a":"The sales of the corporation",
       "choice_b":"The management of the corporation",
       "choice_c":"The current amount of earnings paid out as dividends to the shareholders",
       "choice_d":"The short interest in the company\u0027s stock",
       "correct_answer":"D",
       "explanation":"A fundamental analyst would not be concerned with the short interest in the company\u0027s stock."
    },
    {
       "id":3713,
       "topic_id":3,
       "practice_test_id":5,
       "question":"A software company\u0027s stock has declined dramatically over the past year and has a high short interest. A technical analyst would consider this:",
       "choice_a":"Bearish",
       "choice_b":"Bullish",
       "choice_c":"Of no value",
       "choice_d":"An indication that the stock price will remain flat",
       "correct_answer":"B",
       "explanation":"A high short interest is considered bullish."
    },
    {
       "id":3714,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A technical analysis of the market would be based on all of the following except:",
       "choice_a":"Advances and declines",
       "choice_b":"New highs and lows",
       "choice_c":"The amount of Dow Jones Industrial Stocks sold short",
       "choice_d":"An in-depth analysis of the 30 stocks in the Dow Jones Industrial Average",
       "correct_answer":"D",
       "explanation":"A technical analyst would not do an in depth analysis of the 30 stocks in the Dow Jones."
    },
    {
       "id":3715,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following are bearish for the stock market except:",
       "choice_a":"Increasing interest rates",
       "choice_b":"Falling money supply",
       "choice_c":"Falling government spending",
       "choice_d":"Falling taxes",
       "correct_answer":"D",
       "explanation":"Increasing taxes are bearish for the stock market. Falling taxes are bullish for the stock market."
    },
    {
       "id":3716,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following are bullish for the stock market except:",
       "choice_a":"Increasing interest rates",
       "choice_b":"Falling taxes",
       "choice_c":"Increasing money supply",
       "choice_d":"Increasing government spending",
       "correct_answer":"A",
       "explanation":"Falling interest rates are bullish for the stock market."
    },
    {
       "id":3717,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following are functions of the Federal Reserve except:",
       "choice_a":"It makes loans to commercial banks",
       "choice_b":"It acts as fiscal agent for the U.S. Government.",
       "choice_c":"It sets the discount rate",
       "choice_d":"It sets the prime rate",
       "correct_answer":"D",
       "explanation":"The FRB does not set the prime rate. The price rate is set by commercial banks and it is the rate charged to the most credit worthy customers."
    },
    {
       "id":3718,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following are true of stockholders\u0027 equity except:",
       "choice_a":"It consists of capital stock, capital surplus and retained earnings",
       "choice_b":"It is carried on the asset side of the balance sheet",
       "choice_c":"It is also known as book value",
       "choice_d":"It is also known as net worth",
       "correct_answer":"B",
       "explanation":"Stockholders\u0027 equity is carried on the right side of the balance sheet consisting of liabilities and stockholder\u0027s equity."
    },
    {
       "id":3719,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following are used in technical analysis except:",
       "choice_a":"Reversals",
       "choice_b":"Consolidations",
       "choice_c":"Support",
       "choice_d":"P/E compression",
       "correct_answer":"D",
       "explanation":"Technical analysis is not concerned with P/E ratios."
    },
    {
       "id":3720,
       "topic_id":3,
       "practice_test_id":1,
       "question":"An investment\u0027s beta measures:",
       "choice_a":"Systematic risk",
       "choice_b":"Nonsystematic risk",
       "choice_c":"Business risk",
       "choice_d":"Reinvestment risk",
       "correct_answer":"A",
       "explanation":"Beta is the measurement of systematic risk or volatility."
    },
    {
       "id":3913,
       "topic_id":3,
       "practice_test_id":2,
       "question":"When a firm exercises discretion in a client\u0027s account:",
       "choice_a":"A power of attorney should be obtained before the settlement date",
       "choice_b":"A power of attorney should be obtained before the first order is submitted",
       "choice_c":"The state requires that a client provide the firm with a cash deposit",
       "choice_d":"The state must be notified that an agent will exercise discretion",
       "correct_answer":"B",
       "explanation":"A power of attorney should be obtained before the first order is entered."
    },
    {
       "id":3914,
       "topic_id":3,
       "practice_test_id":3,
       "question":"An investment adviser should recommend investments to clients that:",
       "choice_a":"Are as safe as possible",
       "choice_b":"Have the highest return given the client\u0027s risk tolerance",
       "choice_c":"Have an investment-grade rating",
       "choice_d":"Are suitable for the client",
       "correct_answer":"D",
       "explanation":"One of an investment adviser\u0027s most important duties is to provide investment advice that is suitable for the client. This means providing advice that is appropriate given the client\u0027s investment objectives, financial resources, and risk tolerance."
    },
    {
       "id":3915,
       "topic_id":3,
       "practice_test_id":4,
       "question":"A corporation with assets of $1,000,000, which includes $500,000 of cash and equivalents, and liabilities of $250,000 has a net worth of",
       "choice_a":"$250,000",
       "choice_b":"$1,000,000",
       "choice_c":"$750,000",
       "choice_d":"$1,250,000",
       "correct_answer":"C",
       "explanation":"All the question is asking is, \u0022What\u0027s the difference between $1 million and $250,000?\u0022 the company has a net worth of $750,000."
    },
    {
       "id":3916,
       "topic_id":3,
       "practice_test_id":5,
       "question":"Which of the following plans are typically funded with contributions deductible from income for purposes of figuring federal income tax? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>529 </li><li>457 </li><li>403b </li><li>Deferred compensation</li></ol>",
       "choice_a":"I, III",
       "choice_b":"II, IV",
       "choice_c":"II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"529 plans are funded with contributions that are not deductible for purposes of federal income tax—the withdrawals used later for education are tax-free at the federal level. In a deferred compensation plan, the company can not deduct the compensation that is being deferred on behalf of the pilots, executives, etc."
    },
    {
       "id":3917,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which of the following retirement arrangements are tax-qualified? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>SIMPLE </li><li>Roth </li><li>403b </li><li>SEP</li></ol>",
       "choice_a":"I, III, IV",
       "choice_b":"II, IV",
       "choice_c":"I, III",
       "choice_d":"I, IV",
       "correct_answer":"A",
       "explanation":"Only the Roth has to be funded with after-tax contributions among these four plans. Don\u0027t be shocked to see phrases such as “retirement arrangements.” On the exam outlines IRA is referred to as an “individual retirement arrangement.”"
    },
    {
       "id":3918,
       "topic_id":3,
       "practice_test_id":"",
       "question":"One of your clients is a married couple. The husband is a professional drummer, and the wife has a real job. The wife names her husband the beneficiary of her 401(k) plan. Their children are the secondary or “contingency” beneficiaries. When the wife dies, the 401(k) is left to the husband but before he can take any distributions he dies suddenly in a bizarre gardening accident. The plan is now left to the children. When can the children take distributions from the account without penalty?",
       "choice_a":"When they turn 59\u00BD.",
       "choice_b":"Anytime, as long as it is for education-related expenses.",
       "choice_c":"Upon their 21st birthdays",
       "choice_d":"Anytime, in any manner, as long as it is taken within five years of the father\u0027s date of death.",
       "correct_answer":"D",
       "explanation":"The children may take distributions at anytime, in any manner, as long as it is taken within five years of the father\u0027s date of death."
    },
    {
       "id":3919,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following are used to measure the volatility of an investment portfolio except:",
       "choice_a":"R-squared",
       "choice_b":"CPI",
       "choice_c":"Standard Deviation",
       "choice_d":"Sharpe Ratio",
       "correct_answer":"B",
       "explanation":"CPI measures inflation. R-squared explains how much of a portfolio\u2019s gains are attributed to the overall market. The Sharpe Ratio measures risk-adjusted returns, using standard deviation in the formula."
    },
    {
       "id":3920,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following represent current liabilities except",
       "choice_a":"A cash dividend that has been declared",
       "choice_b":"Accounts payable",
       "choice_c":"Inventory",
       "choice_d":"Accrued wages",
       "correct_answer":"C",
       "explanation":"Inventory is an asset not a liability."
    },
    {
       "id":3921,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following represents a company\u0027s current ratio?",
       "choice_a":"Current liabilities minus current assets",
       "choice_b":"Total assets minus shareholder equity",
       "choice_c":"Current assets minus current liabilities",
       "choice_d":"Current assets divided by current liabilities",
       "correct_answer":"D",
       "explanation":"While they both measure short-term liquidity, working capital takes Current Assets minus Current Liabilities, and the current ratio takes Current Assets over/ divided by Current Liabilities."
    },
    {
       "id":3922,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following would lead to a higher dividend yield except:",
       "choice_a":"Stable dividend, falling market price",
       "choice_b":"Rising dividend, stable market price",
       "choice_c":"Rising dividend, falling market price",
       "choice_d":"Stable dividend, rising market price",
       "correct_answer":"D",
       "explanation":"If price of a security goes up, its yield goes down."
    },
    {
       "id":3923,
       "topic_id":3,
       "practice_test_id":"",
       "question":"One of your clients inquires about the composition of the Dow Jones Industrial Average. You would respond that it is which type of index?",
       "choice_a":"Value",
       "choice_b":"Large cap",
       "choice_c":"Growth",
       "choice_d":"Market cap weighted",
       "correct_answer":"B",
       "explanation":"The Dow Jones Industrial Index is 30 large cap stocks. You might make the case that they tend to be “value,\u0022 but their P/E ratio is not a factor when placing them in or out of) the index. So, the “large cap” answer is easier to defend. Also, the index is weighted by share price, not market cap. The S&P uses market cap."
    },
    {
       "id":3924,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following allow corporations to exclude much or all of the income received except for income received",
       "choice_a":"For holding another corporation\u0027s debentures",
       "choice_b":"For holding municipal bonds issued in the state where headquartered",
       "choice_c":"For holding preferred stock of other companies",
       "choice_d":"For holding common stock of other companies",
       "correct_answer":"A",
       "explanation":"Everybody gets tax-free interest on municipal bonds. Corporations also get a break from other company\u0027s dividends, whether paid on preferred or common stock."
    },
    {
       "id":3925,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Duration considers all of the following except:",
       "choice_a":"Cash flows",
       "choice_b":"Credit risk",
       "choice_c":"Sensitivity to a change in interest rates",
       "choice_d":"Maturity",
       "correct_answer":"B",
       "explanation":"Duration is not concerned with credit/default risk. That\u0027s measured by S&P, Moody\u0027s, or Fitch."
    },
    {
       "id":3926,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following represent true statements except:",
       "choice_a":"Bond prices and yields vary inversely",
       "choice_b":"Interest rates rise during inflationary periods",
       "choice_c":"If supply grows faster than demand, prices rise",
       "choice_d":"If demand outpaces supply, prices rise",
       "correct_answer":"C",
       "explanation":"When supply rises faster than demand, what kind of market is it? A buyer\u0027s market, meaning the price is headed down."
    },
    {
       "id":3927,
       "topic_id":3,
       "practice_test_id":1,
       "question":"A fundamental analyst studying a corporation\u0027s balance sheet could determine which of the following?",
       "choice_a":"Net margin",
       "choice_b":"Gross margin",
       "choice_c":"Working capital",
       "choice_d":"Operating margin",
       "correct_answer":"C",
       "explanation":"The other three choices are found on the income statement."
    },
    {
       "id":3928,
       "topic_id":3,
       "practice_test_id":2,
       "question":"In order to determine an investment\u0027s internal rate of return, which two of the following must an adviser know? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Duration </li><li>Future value </li><li>Present value </li><li>P/E ratio</li></ol>",
       "choice_a":"I, IV",
       "choice_b":"I, III",
       "choice_c":"II, III",
       "choice_d":"II, IV",
       "correct_answer":"C",
       "explanation":"Duration and P/E have nothing to do with rates of return, whereas the present value and future value would."
    },
    {
       "id":3929,
       "topic_id":3,
       "practice_test_id":3,
       "question":"If an individual would like to purchase an insurance policy that offers a guaranteed death benefit equal to the face amount as well as a guaranteed cash value that may be borrowed against, she should purchase:",
       "choice_a":"Term",
       "choice_b":"Whole life",
       "choice_c":"VLI",
       "choice_d":"VUL",
       "correct_answer":"B",
       "explanation":"The question is the definition of Whole Life. Term Insurance has no cash value. In addition, anything that has variable in its name can not be guaranteed."
    },
    {
       "id":3930,
       "topic_id":3,
       "practice_test_id":4,
       "question":"What is the basic formula for a company\u0027s balance sheet or \u0022statement of financial condition\u0022?",
       "choice_a":"Assets = Liabilities + Net Worth",
       "choice_b":"Assets - Liabilities = Net Worth",
       "choice_c":"Both choices given",
       "choice_d":"Neither choice given",
       "correct_answer":"C",
       "explanation":"Just two ways of saying the same thing. Both choices represent the balance sheet equations."
    },
    {
       "id":3931,
       "topic_id":3,
       "practice_test_id":5,
       "question":"When calculating an investor\u0027s real rate of return, which of the following would an adviser need to know?",
       "choice_a":"Customer\u0027s age",
       "choice_b":"Customer\u0027s risk tolerance",
       "choice_c":"CPI",
       "choice_d":"GDP",
       "correct_answer":"C",
       "explanation":"The word \u0022real\u0022 means \u0022inflation-adjusted.\u0022 Inflation is measured by the CPI."
    },
    {
       "id":3932,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A teacher has participated in a TSA/403b plan for 20 years. During her employment, the school district has deposited $50,000 on her behalf. If the account is worth $95,000 at retirement, the teacher will be taxed:",
       "choice_a":"On $95,000 at long-term capital gains rates",
       "choice_b":"On $50,000 at long-term capital gains rates",
       "choice_c":"On $95,000 at ordinary income rates",
       "choice_d":"On $45,000 at ordinary income rates",
       "correct_answer":"C",
       "explanation":"We never pay capital gains rates on retirement money. It\u0027s always ordinary income if it\u0027s being taxed at distribution. So, what\u0027s the teacher\u0027s \u0022cost basis\u0022? Zero. None of the money has been taxed yet—it\u0027s time to pay taxes on all of it as it comes out in distributions."
    },
    {
       "id":3933,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A computer simulation that explores various outcomes from an investment strategy and is frequently used to calculate withdrawal rates from a retirement account would be?",
       "choice_a":"Sharpe ratio",
       "choice_b":"Monte Carlo",
       "choice_c":"Future value",
       "choice_d":"Black-Scholes",
       "correct_answer":"B",
       "explanation":"The Monte Carlo simulations are used to calculate how much and how long your money will last."
    },
    {
       "id":3934,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A customer of Q & R Investment Advisers calls an adviser representative to inquire what the \u0022wrap fee\u0022 charged on her account represents. Which of the following represents the best response from the IA representative?",
       "choice_a":"A wrap fee is the same thing as a commission",
       "choice_b":"A wrap fee is just like a sales load",
       "choice_c":"A wrap fee is charged when the account achieves a certain level of return",
       "choice_d":"A wrap fee combines charges for advice as well as execution of a transaction",
       "correct_answer":"D",
       "explanation":"A wrap fee is for advisory services as well as executing transactions."
    },
    {
       "id":3935,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Performance-based compensation for an institutional portfolio manager managing a small cap fund would likely be based on which of the following benchmarks?",
       "choice_a":"S&P 500",
       "choice_b":"NASDAQ 100",
       "choice_c":"Russell 2000",
       "choice_d":"Dow Jones Industrial Average",
       "correct_answer":"C",
       "explanation":"Russell 2,000 is based on Small cap securities."
    },
    {
       "id":3936,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A married couple would like to invest for their 10-year-old daughter\u0027s college education. If they would like to invest $60,000 through a lump-sum, which of the following would you recommend?",
       "choice_a":"Coverdell",
       "choice_b":"529 Plan",
       "choice_c":"Treasury Bond",
       "choice_d":"Gift Tax limits",
       "correct_answer":"B",
       "explanation":"The Coverdell only allows two thousand dollars per child per year. Gift tax limit is $12,000 a year per person. However with the 529, a married couple can jump start the account with up to $60,000, making no other contributions for five years."
    },
    {
       "id":3937,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following debt securities would react the most to a change in interest rates?",
       "choice_a":"10-year corporate debenture",
       "choice_b":"20-year municipal bond",
       "choice_c":"30-year Treasury bond",
       "choice_d":"30-year zero coupon",
       "correct_answer":"D",
       "explanation":"A zero coupon instrument has a duration from 10 to 30 Years. And is not effected my interest rates as it\u0027s valued is accreted to face value."
    },
    {
       "id":3938,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following pieces of information is of least interest to a technical analyst?",
       "choice_a":"Market price",
       "choice_b":"Volume",
       "choice_c":"Earnings per share",
       "choice_d":"Short interest",
       "correct_answer":"C",
       "explanation":"EPS, PE, working capital, quick ratio are all fundamental concerns."
    },
    {
       "id":3939,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The major risk to an owner of common stock is:",
       "choice_a":"Common stock is the most junior security",
       "choice_b":"Has no par value.",
       "choice_c":"Market value may decline substantially",
       "choice_d":"Stocks may pay no dividends",
       "correct_answer":"C",
       "explanation":"If a company goes out of business or with market changes the stock could become basically worthless."
    },
    {
       "id":3940,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following statements concerning the relative value of currencies are true except:",
       "choice_a":"As the American dollar weakens, exports from America to other countries become more competitive with goods produced in those countries",
       "choice_b":"As the American dollar strengthens, imports from other countries become more competitive with domestically-produced goods",
       "choice_c":"As the American dollar weakens, Americans vacationing in other countries will find it harder to afford hotels, food, etc.",
       "choice_d":"ADRs are not affected by the relative value of currencies",
       "correct_answer":"D",
       "explanation":"U.S. Dollar week means foreign goods cost more, where as if the U.S. is strong, import are less expensive. ADR\u0027s are foreign securities sold on the U. S markets, securities are based on market fluctuations."
    },
    {
       "id":3941,
       "topic_id":3,
       "practice_test_id":1,
       "question":"Which of the following insurance policies would invest net premiums in the general account and allow the investor greater flexibility in terms of premium schedules and adjustments to the contract value?",
       "choice_a":"Whole life",
       "choice_b":"Universal life",
       "choice_c":"Variable life",
       "choice_d":"Term life",
       "correct_answer":"B",
       "explanation":"The word \u0022universal\u0022 means \u0022flexible.\u0022 Since the question said \u0022general account,\u0022 eliminate the word \u0022variable,\u0022 which is always linked to \u0022separate account."
    },
    {
       "id":3942,
       "topic_id":3,
       "practice_test_id":2,
       "question":"What is the name of the interest rate that banks charge the most creditworthy corporate borrowers for unsecured loans?",
       "choice_a":"Discount rate",
       "choice_b":"Prime rate",
       "choice_c":"Broker Loan Call Rate",
       "choice_d":"LIBOR plus 30 basis points",
       "correct_answer":"B",
       "explanation":"Discount Rate is a rate the Fed charges banks for over night reserves. Brokers Loan Call Rate is the rate a bank charges Broker for Margin accounts. Prime Rate is the rate the bank charge their best customers, LIBOR - London Inter Bank Offering Rate"
    },
    {
       "id":3943,
       "topic_id":3,
       "practice_test_id":3,
       "question":"When must an individual begin to receive distributions from her IRA?",
       "choice_a":"59\u00BD",
       "choice_b":72,
       "choice_c":"Either choice given",
       "choice_d":"Neither choice given",
       "correct_answer":"B",
       "explanation":"Wait until you\u0027re 59\u00BD (unless you have a qualified excuse), but you must start taking Required Minimum Distributions by age 72 ."
    },
    {
       "id":3944,
       "topic_id":3,
       "practice_test_id":4,
       "question":"The word \u0022leverage\u0022 would be associated with all the following except",
       "choice_a":"Purchasing options",
       "choice_b":"A company issuing long-term debt",
       "choice_c":"Purchasing stock in a cash account",
       "choice_d":"Purchasing government bonds on margin",
       "correct_answer":"C",
       "explanation":"Borrowing money by a corporation or by an investor is using leverage. If you pay in full you\u0027re not using leverage."
    },
    {
       "id":3945,
       "topic_id":3,
       "practice_test_id":5,
       "question":"At what age must an employee be included in a defined benefit pension plan?",
       "choice_a":18,
       "choice_b":21,
       "choice_c":"59\u00BD",
       "choice_d":"70\u00BD",
       "correct_answer":"B",
       "explanation":"ERISA. 1,000 hours worked over one year, age 21 = eligible to participate."
    },
    {
       "id":3946,
       "topic_id":3,
       "practice_test_id":6,
       "question":"To the nearest tenth of a point, calculate the real rate of return for an investor whose portfolio saw a total return of 14% when the rate of inflation was 9%. The investor is in the 30% federal income tax bracket.",
       "choice_a":"7.10%",
       "choice_b":"4.80%",
       "choice_c":"5.00%",
       "choice_d":"3.50%",
       "correct_answer":"C",
       "explanation":"To answer this question take 14% - 9% = 5%. The investor\u0027s tax rate has nothing to do with the real rate of return. An investor\u0027s real rate of return only takes into account the inflation rate."
    },
    {
       "id":3947,
       "topic_id":3,
       "practice_test_id":"",
       "question":"With your own advisory firm, you managed to trade 10 different stocks that produced a total gain of 10% over a three-month period. Therefore, which of the following is a true statement?",
       "choice_a":"The annualized rate of return is 40%, which may be cited in advertising materials",
       "choice_b":"The annualized rate of return is 40%, which may not be cited in advertising materials",
       "choice_c":"The annualized rate of return is 10% due to the truncated holding period",
       "choice_d":"The answer can not be determined",
       "correct_answer":"B",
       "explanation":"Performance claims in adviser advertising have to cover at least one year and must provide all kinds of disclosure. You can not take your quarterly gains and “times it by 4” to get an annualized rate of return in an advertising piece."
    },
    {
       "id":3948,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Why do corporations affect forward stock splits?",
       "choice_a":"To increase the market price of their common stock",
       "choice_b":"To decrease the market price of their common stock",
       "choice_c":"To increase the earnings reported at the company",
       "choice_d":"To enhance each shareholder\u0027s ownership stake",
       "correct_answer":"B",
       "explanation":"To reduce the price and to make the stock more attractive to investors is the only reason to do a forward split."
    },
    {
       "id":3949,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following is the least suitable investment for a Traditional IRA?",
       "choice_a":"Municipal Bonds",
       "choice_b":"Corporate bonds",
       "choice_c":"Treasury Bonds",
       "choice_d":"Treasury Notes",
       "correct_answer":"A",
       "explanation":"Municipal bonds pay low coupon rates that work out better for some investors because the interest is federally tax-exempt. If they put them in an IRA funded with pre-tax contributions, they\u0027ll pay tax on the income when they take withdrawals at retirement."
    },
    {
       "id":3950,
       "topic_id":3,
       "practice_test_id":"",
       "question":"What is the main difference between variable annuities and mutual funds?",
       "choice_a":"Sales loads",
       "choice_b":"Tax deferral",
       "choice_c":"Stocks vs. bonds",
       "choice_d":"Cash vs. bonds",
       "correct_answer":"B",
       "explanation":"Annuities grow tax-deferred; mutual funds do not."
    },
    {
       "id":3951,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Amber Waves deposited $100,000 into her rollover IRA, which has now grown tax-deferred to a value of $150,000. At age 53, Amber withdraws $50,000. What are the tax and penalty consequences?",
       "choice_a":"Ordinary income on $50,000 plus a penalty on the $150,000 value",
       "choice_b":"Ordinary income on the $50,000",
       "choice_c":"Ordinary income plus a penalty on the $50,000 distribution",
       "choice_d":"Capital gains rate on $50,000 plus a penalty",
       "correct_answer":"C",
       "explanation":"Since she\u0027s not 59\u00BD years old or disabled, she\u0027ll pay ordinary income plus a penalty on whatever she withdraws. Not the whole account value."
    },
    {
       "id":3952,
       "topic_id":3,
       "practice_test_id":1,
       "question":"Which of the following is a true statement?",
       "choice_a":"Long-term interest rates are more volatile than short-term",
       "choice_b":"Short-term bond prices are more volatile than long-term",
       "choice_c":"Long-term bond prices are less volatile than short-term",
       "choice_d":"Long-term bond prices are more volatile than short-term",
       "correct_answer":"D",
       "explanation":"Short-term rates such as fed funds, discount, and money market rates jump up and down frequently, while the rates on 30-year bonds and mortgages are more steady. However, when interest rates overall move in the same direction, the price of long-term bonds moves the most."
    },
    {
       "id":3953,
       "topic_id":3,
       "practice_test_id":2,
       "question":"Your clients are married, in their early 50\u0027s and are planning to retire in the next 10 years. They would both like to reduce their workloads by about 40%, so they need supplemental income but also capital appreciation. Which of the following funds would you most likely recommend?",
       "choice_a":"Money market",
       "choice_b":"Small cap",
       "choice_c":"Balanced fund",
       "choice_d":"Index fund",
       "correct_answer":"C",
       "explanation":"A balanced fund invests in stocks and bonds. They\u0027ll get growth from the stocks (we hope) and income from the bonds."
    },
    {
       "id":3954,
       "topic_id":3,
       "practice_test_id":3,
       "question":"All of the following are qualified plans except:",
       "choice_a":"401K",
       "choice_b":"403b",
       "choice_c":"Defined benefit",
       "choice_d":"Deferred compensation",
       "correct_answer":"D",
       "explanation":"Deferred compensation plans do not have to cover all eligible employees; therefore, they are not qualified plans under ERISA."
    },
    {
       "id":3955,
       "topic_id":3,
       "practice_test_id":4,
       "question":"All of the following are funded with pre-tax contributions except:",
       "choice_a":"Health Savings Account",
       "choice_b":"HR 10",
       "choice_c":"529 Savings Plan",
       "choice_d":"403 b",
       "correct_answer":"C",
       "explanation":"The 529 Savings plan allows for large contributions, but they are not deductible for purposes of federal income tax. They often are deductible from state taxes, though, which is why most people buy the plan offered by their state."
    },
    {
       "id":3956,
       "topic_id":3,
       "practice_test_id":5,
       "question":"All of the following plans pass investment risk to the participant except:",
       "choice_a":"401K",
       "choice_b":"Defined benefit pension",
       "choice_c":"403 b",
       "choice_d":"Defined contribution",
       "correct_answer":"B",
       "explanation":"If the company defines your benefit, it\u0027s up to them to invest wisely enough to pay you that benefit, which might be 70% of your salary for the rest of your life."
    },
    {
       "id":3957,
       "topic_id":3,
       "practice_test_id":6,
       "question":"The strategy of diversification is used to combat which of the following risks?",
       "choice_a":"Mortality",
       "choice_b":"Liquidity",
       "choice_c":"Market",
       "choice_d":"Non-systematic",
       "correct_answer":"D",
       "explanation":"Diversification is the only way to reduce non-systematic risk. Non-systematic is the risk associated with a particular company or industry."
    },
    {
       "id":3958,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor purchased 100 XYZ at 17 five years ago and now the investor donates the stock to a charitable organization with XYZ @35. He may take a deduction of:",
       "choice_a":"$35,000",
       "choice_b":"50% of $35,000",
       "choice_c":"$1,700",
       "choice_d":"$3,500 as long as it does not exceed 40% of adjusted gross income",
       "correct_answer":"D",
       "explanation":"He may deduct exactly what the stock is worth at time he donated it, $3,500."
    },
    {
       "id":3959,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following types of stock is associated with a high dividend yield?",
       "choice_a":"Growth",
       "choice_b":"Value",
       "choice_c":"Small Cap",
       "choice_d":"Micro Cap",
       "correct_answer":"B",
       "explanation":"Growth means “little or no dividends.” The smaller the “cap,” the less likely the company pays dividends. Value stocks are purchased at lower prices, so the dividend yields should be higher. Price down—yield up. It always works that way."
    },
    {
       "id":3960,
       "topic_id":3,
       "practice_test_id":"",
       "question":"SIA common stock appreciated 8% over an 18-month period. What is the annualized return?",
       "choice_a":"8%",
       "choice_b":"5.30%",
       "choice_c":"12%",
       "choice_d":"6%",
       "correct_answer":"B",
       "explanation":"Because 18 months is 1.5 years, divide the 8% by 1.5 for the annualized rate of return."
    },
    {
       "id":3961,
       "topic_id":3,
       "practice_test_id":"",
       "question":"CMO\u0027s and GNMA pass-through certificates primarily share which of the following risks?",
       "choice_a":"Default",
       "choice_b":"Dilution",
       "choice_c":"Interest rate",
       "choice_d":"Political",
       "correct_answer":"C",
       "explanation":"If rates go up the price of the investment will go down. Both are solid in terms of default risk ."
    },
    {
       "id":3962,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following must be entered on an order ticket except",
       "choice_a":"Time the order was entered",
       "choice_b":"Account number",
       "choice_c":"Market price of security",
       "choice_d":"The security being bought or sold",
       "correct_answer":"C",
       "explanation":"It wouldn\u0027t make sense to write the market price down, since it will change every few seconds."
    },
    {
       "id":3963,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following equal the highest risk-adjusted return?",
       "choice_a":"3% above riskless rate, standard deviation 5.5",
       "choice_b":"4% above riskless rate, standard deviation 6.0",
       "choice_c":"3% above riskless rate, standard deviation 6.5",
       "choice_d":"4% above riskless rate, standard deviation 5.0",
       "correct_answer":"D",
       "explanation":"The Sharpe Ratio looks good when the return is high above the riskless rate, with the standard deviation as low as possible."
    },
    {
       "id":3964,
       "topic_id":3,
       "practice_test_id":2,
       "question":"An investment with a 60% chance of appreciating 10% and a 40% chance of appreciating 16% has an expected return of:",
       "choice_a":"8%",
       "choice_b":"25%",
       "choice_c":"12.40%",
       "choice_d":"15%",
       "correct_answer":"C",
       "explanation":"Just take 60% of 10 (6%) and add it to 40% of 16 (6.4%) to get 12.4%."
    },
    {
       "id":3965,
       "topic_id":3,
       "practice_test_id":3,
       "question":"Discounting an investment\u0027s expected cash flows to present value determines",
       "choice_a":"Book value",
       "choice_b":"Book value per share",
       "choice_c":"Net present value",
       "choice_d":"Standard deviation",
       "correct_answer":"C",
       "explanation":"A definitional question. Discounting an investment\u0027s expected cash flows to present value determines its net present value."
    },
    {
       "id":3966,
       "topic_id":3,
       "practice_test_id":4,
       "question":"Which of the following investors can best withstand a market correction?",
       "choice_a":"Older investor with high risk tolerance",
       "choice_b":"Older investor with moderate risk tolerance",
       "choice_c":"Younger investor with moderate risk tolerance",
       "choice_d":"Younger investor with high risk tolerance",
       "correct_answer":"D",
       "explanation":"The investor is younger and has a high risk tolerance."
    },
    {
       "id":3967,
       "topic_id":3,
       "practice_test_id":5,
       "question":"Which of the following bonds has the highest duration?",
       "choice_a":"8% coupon, 20-year maturity",
       "choice_b":"8% coupon, 30-year maturity",
       "choice_c":"6% coupon, 20-year maturity",
       "choice_d":"4% coupon, 30-year maturity",
       "correct_answer":"D",
       "explanation":"The highest duration belongs to the bond with the lowest coupon and longest maturity."
    },
    {
       "id":3968,
       "topic_id":3,
       "practice_test_id":6,
       "question":"What is a company\u0027s market capitalization?",
       "choice_a":"Long-term debt minus cash",
       "choice_b":"Short-term debt plus cash and equivalents",
       "choice_c":"Share price times shares outstanding",
       "choice_d":"Long-term debt plus net worth",
       "correct_answer":"C",
       "explanation":"It is just the total value of the outstanding shares. A company with a share price of $27 and with 10.8 billion shares outstanding would have a market capitalization of $291 billion .The market capitalization changes every day with the stock price and the number of outstanding shares can change."
    },
    {
       "id":3969,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor is in the 28% marginal tax bracket. Therefore, a debenture yielding 10% would be equivalent to a general obligation bond yielding:",
       "choice_a":"7%",
       "choice_b":"7.20%",
       "choice_c":"12.40%",
       "choice_d":"12.80%",
       "correct_answer":"B",
       "explanation":"A debenture paying $100 would leave this investor with $72 after taxes If the municipal bond paid $72, it would be equivalent, since the investor doesn\u0027t have pay taxes on the income."
    },
    {
       "id":3970,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following debt securities has the highest duration?",
       "choice_a":"T-bill",
       "choice_b":"10-year T-note",
       "choice_c":"30-year T-bond",
       "choice_d":"30-year STRIP",
       "correct_answer":"D",
       "explanation":"A zero coupon, such as a STRIP or Treasury Receipt, has a duration exactly equal to the bond\u0027s maturity, since you won\u0027t receive even a thin red dime until then."
    },
    {
       "id":3971,
       "topic_id":3,
       "practice_test_id":"",
       "question":"If an investment returns -4% over Q1, what is the annualized rate of return?",
       "choice_a":"-16%",
       "choice_b":"4%",
       "choice_c":"16%",
       "choice_d":"5%",
       "correct_answer":"A",
       "explanation":"-4% times 4 quarters = a negative 16% annualized. Gee, who gets to meet with the client to discuss next year\u0027s portfolio strategy?"
    },
    {
       "id":3972,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following represents Standard & Poor\u0027s lowest investment-grade bond rating?",
       "choice_a":"AAB.",
       "choice_b":"BBB+",
       "choice_c":"BBB-",
       "choice_d":"Baa",
       "correct_answer":"C",
       "explanation":"After that BBB-, a rating lower than that would be \u0022junk\u0022. Baa is a Moody\u0027s rating."
    },
    {
       "id":3973,
       "topic_id":3,
       "practice_test_id":2,
       "question":"An investor purchased an 8% corporate bond at par last year. If the bond is now trading at 98, the investor\u0027s total return is:",
       "choice_a":"8%",
       "choice_b":"6%",
       "choice_c":"7%",
       "choice_d":"2%",
       "correct_answer":"B",
       "explanation":"They made $80 in interest but lost $20 in market value. If you make $60 from a $1,000 investment, you have a return of 6%."
    },
    {
       "id":3974,
       "topic_id":3,
       "practice_test_id":3,
       "question":"Which of the following statements by a registered representative is accurate and permissible?",
       "choice_a":"All mutual funds charge operating expenses",
       "choice_b":"If a mutual fund charges a 12b-1 fee, it can not be referred to as \u0022no load\u0022",
       "choice_c":"All mutual funds have either sales charges or a 12b-1 fee",
       "choice_d":"Sales charges are operating expenses along with management fees",
       "correct_answer":"A",
       "explanation":"Most no-load funds have 12b-1 fees. If the fee gets too big, they lose the ability to call themselves \u0022no load.\u0022"
    },
    {
       "id":3975,
       "topic_id":3,
       "practice_test_id":4,
       "question":"If a client of yours regularly reinvests dividend and capital gains distributions from the mutual funds that you sell him, which of the following best measures his performance over the long-term?",
       "choice_a":"Sharpe Ratio",
       "choice_b":"Total Return",
       "choice_c":"Average Return",
       "choice_d":"Risk-free Return",
       "correct_answer":"B",
       "explanation":"Total return would be the compounded returns an investor makes by reinvesting all dividends and capital gains distributions into more shares earning more dividends and capital gains to be reinvested into more shares, and so on, and so on. The Sharpe Ratio, remember, measures risk-adjusted returns."
    },
    {
       "id":3976,
       "topic_id":3,
       "practice_test_id":5,
       "question":"One of your clients is a husband and wife in their early 50\u0027s who recently inherited $42,000. Their primary concern is preserving their capital and, secondarily, earning income commensurate with that goal. Which of the following recommendations is probably most suitable?",
       "choice_a":"Tax-exempt money market mutual fund",
       "choice_b":"Taxable money market mutual fund",
       "choice_c":"Government bond fund",
       "choice_d":"Stock index fund",
       "correct_answer":"C",
       "explanation":"US Treasury securities pay consistent income and do not subject the holder to default risk, which preserves their capital."
    },
    {
       "id":3977,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which of the following would be an acceptable statement for an agent to make to a customer concerning Treasury securities?",
       "choice_a":"No one has lost money investing in Treasury notes and bonds",
       "choice_b":"No one can lose money investing in Treasury notes and bonds",
       "choice_c":"Treasury securities carry no default risk",
       "choice_d":"Treasury securities carry no interest rate risk",
       "correct_answer":"C",
       "explanation":"Treasury securities will pay the interest and principal, so there\u0027s no default risk. But their price will drop if interest rates go up suddenly."
    },
    {
       "id":3978,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following securities is most susceptible to interest rate risk?",
       "choice_a":"Baltimore revenue bond maturing in \u002729",
       "choice_b":"SIA 6s debenture maturing in \u002731",
       "choice_c":"A CMO pass-thru maturing in \u002730",
       "choice_d":"US Treasury bond maturing in \u002737",
       "correct_answer":"D",
       "explanation":"The longer the maturity\u2014the more interest rate risk. If interest rates increase the bonds with the longest term to maturity will fall the most in price."
    },
    {
       "id":3979,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following securities is probably most susceptible to default risk?",
       "choice_a":"Debenture rated AAB",
       "choice_b":"Secured corporate bond rated BBB-",
       "choice_c":"U.S. Agency CMO pass-thru maturing in \u002713",
       "choice_d":"T-bond maturing in \u002717",
       "correct_answer":"B",
       "explanation":"S&P factors everything into their ratings—the ratings themselves are all we need."
    },
    {
       "id":3980,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Your investor needs a debt security that bears no reinvestment risk. Which of the following would you least likely recommend?",
       "choice_a":"Treasury STRIPS",
       "choice_b":"Treasury Receipts",
       "choice_c":"Corporate zero coupon bonds",
       "choice_d":"Debentures",
       "correct_answer":"D",
       "explanation":"debentures pay interest every six months, which would presumably be reinvested. If rates are down at that point? That\u0027s reinvestment risk, which would be avoided by zero coupons, STRIPS, Treasury receipts and the like. They don\u0027t pay an income stream—you just get back a higher par value than you paid."
    },
    {
       "id":3981,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following are used in calculating internal rate of return? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Bond interest payments </li><li>cash flow from a proposed project  </li><li>Capital gains assumptions </li><li>Marginal tax rates</li></ol>",
       "choice_a":"I, II",
       "choice_b":"II, III",
       "choice_c":"II, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"Cash flow from a proposed project and interest payments represent cash flow from an investment and are used to calculate the internal rate of return."
    },
    {
       "id":3982,
       "topic_id":3,
       "practice_test_id":"",
       "question":"GDP has declined significantly the past few quarters. New claims for unemployment are rising, as is inventory, based on the direction of interest rates, bond prices are most likely",
       "choice_a":"About to fall",
       "choice_b":"About to rise",
       "choice_c":"About to flatten",
       "choice_d":"About to revert to the standard deviation",
       "correct_answer":"B",
       "explanation":"Interest rates drop when the economy contracts. Rates down/price up."
    },
    {
       "id":3983,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following represent securities associated with short-term trading except:",
       "choice_a":"Calls",
       "choice_b":"Puts",
       "choice_c":"Mutual funds",
       "choice_d":"Put spreads",
       "correct_answer":"C",
       "explanation":"Options are short-term. Mutual funds are to be used for long term investing."
    },
    {
       "id":3984,
       "topic_id":3,
       "practice_test_id":"",
       "question":"What is true of mutual fund sales charges and 12b-1 fees?",
       "choice_a":"12b-1 fees are included in the expense ratio",
       "choice_b":"Sales charges are not included in the expense ratio",
       "choice_c":"Management fees may not be covered by 12b-1 fees",
       "choice_d":"All choices listed",
       "correct_answer":"D",
       "explanation":"Even though sales charges and 12b-1 fees both cover distribution costs, there are differences. The sales charge is deducted from the investor\u0027s check when she buys (A-shares) or when she sells (B-shares). A 12b-1 fee is deducted from assets, along with other operating expenses."
    },
    {
       "id":3985,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following would not represent an inappropriate recommendation?",
       "choice_a":"Recommending growth stocks to investors with income as an objective",
       "choice_b":"Recommending municipal bonds to low-tax-bracket investors",
       "choice_c":"Recommending frequent trades to long-term investors",
       "choice_d":"Recommending stocks in your broker-dealer\u0027s inventory",
       "correct_answer":"D",
       "explanation":"Market Maker sell stock from their inventories. It is not inappropriate to recommend stock in the firn\u0027s inventory to a customer, so long as the stock meets their investment objective."
    },
    {
       "id":3986,
       "topic_id":3,
       "practice_test_id":2,
       "question":"If an investor wishes to realize the largest potential capital gain, he should",
       "choice_a":"Buy short-term bonds when interest rates are high",
       "choice_b":"Buy short-term bonds when interest rates are low",
       "choice_c":"Buy long-term bonds when interest rates are low",
       "choice_d":"Buy long-term bonds when interest rates are high",
       "correct_answer":"D",
       "explanation":"If rates go up, then bond prices goes down, if they are sold, that would result in a loss."
    },
    {
       "id":3987,
       "topic_id":3,
       "practice_test_id":3,
       "question":"Which of the following investments meet(s) the definition of a \u0022security\u0022? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Investment contract </li><li>Whiskey warehouse receipt </li><li>Pre-organization certificate </li><li>Soybean futures contract</li></ol>",
       "choice_a":"I",
       "choice_b":"II, III",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"Commodity futures contracts do not meet the definition of a “security.” However, an option on a commodity futures contract or a single-stock futures contract does."
    },
    {
       "id":3988,
       "topic_id":3,
       "practice_test_id":4,
       "question":"Interest earned on most municipal bonds is:",
       "choice_a":"Tax-exempt at the federal level",
       "choice_b":"Tax-exempt at the state level",
       "choice_c":"Tax-exempt at the local level",
       "choice_d":"Taxable at long-term capital gains rates",
       "correct_answer":"A",
       "explanation":"The federal government does not tax the interest on most municipal bonds."
    },
    {
       "id":3989,
       "topic_id":3,
       "practice_test_id":5,
       "question":"What is true of qualifying rollovers versus direct transfers?",
       "choice_a":"An investor may complete only one transfer from a Traditional IRA to another retirement plan funded with pre-tax contributions per year",
       "choice_b":"The number of direct transfers an IRA owner may perform each year may not exceed 4",
       "choice_c":"No more than one qualifying rollover may be performed per year and must be completed within 60 days to avoid penalty",
       "choice_d":"A 401K plan\u0027s proceeds may be transferred to a Roth IRA without tax consequences if completed within 60 days",
       "correct_answer":"C",
       "explanation":"A rollover is where the custodian cuts you a check in your name. You can only do one per year and must complete it in 60 days."
    },
    {
       "id":3990,
       "topic_id":3,
       "practice_test_id":6,
       "question":"An investment adviser who specializes in identifying economic trends and then determining which companies will benefit from these trends is said to be:",
       "choice_a":"Using top-down analysis",
       "choice_b":"Using bottom-up analysis",
       "choice_c":"Using technical analysis",
       "choice_d":"Using contrarian analysis",
       "correct_answer":"A",
       "explanation":"That\u0027s top-down. A top-down approach might go like this: since the price of oil and natural gas are likely to be high for a long time, which types of companies will benefit? And, of those companies, which particular companies will benefit the most? What if the premise that oil and gas prices will rise turns out to be wrong? Then the conclusions will most likely turn out to be wrong as well. A bottom-up analysis would start with a particular company."
    },
    {
       "id":3991,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following would most interest a value investor?",
       "choice_a":"Stock trading at a high price-to-earnings multiple",
       "choice_b":"Stock trading near its book value per share",
       "choice_c":"Stock trading below its book value per share",
       "choice_d":"Stock trading near the 52-week high",
       "correct_answer":"C",
       "explanation":"Buy stock below the book value."
    },
    {
       "id":3992,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor purchased shares of SIA at 20. Two years later, the shares are worth $25. Her holding period return is:",
       "choice_a":"5%",
       "choice_b":"25%",
       "choice_c":"6.25%",
       "choice_d":"10%",
       "correct_answer":"B",
       "explanation":"The stock has gone up 25% over her holding period. 5 / 20 = 25%"
    },
    {
       "id":3993,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor is in the 30% marginal tax bracket. If a general obligation bond yields 4.9%, the investor would receive an equivalent yield from a debenture yielding:",
       "choice_a":"3.40%",
       "choice_b":"4.30%",
       "choice_c":"7%",
       "choice_d":"5%",
       "correct_answer":"C",
       "explanation":"A municipal bond yielding 4.9% is putting $49 in the investor\u0027s pocket. They are in the 30% bracket. The investor would need to receive 7% on a taxable bond in order to end up with $49 after paying $21 in tax. A 7% taxable yield would be the same as a 4.9 tax-free yield for this investor."
    },
    {
       "id":3994,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A company considering investing in capital equipment would most likely be concerned with",
       "choice_a":"Net present value",
       "choice_b":"Beta",
       "choice_c":"Systematic risk",
       "choice_d":"Non-systematic risk",
       "correct_answer":"A",
       "explanation":"Net present value has to do with \u0022discounting the future cash flows\u0022 of an investment. Should we build now or wait? Calculate the investment\u0027s \u0022net present value\u0022 by projecting the cash flows it would provide and then \u0022discounting them to their present value\u0022. If the cost of the investment is lower than the net present value, build now. If not, wait."
    },
    {
       "id":3995,
       "topic_id":3,
       "practice_test_id":"",
       "question":"SIA Solid Growth Fund had a NAV of $10 at the beginning of the year, ending with a NAV of $12. The fund also paid dividends of $1 and capital gains of $1. The total return of the fund is:",
       "choice_a":"20%",
       "choice_b":"40%",
       "choice_c":"25%",
       "choice_d":"Not determinable",
       "correct_answer":"B",
       "explanation":"To determine the total return you must add the $2 of share price appreciation and the $2 of capital gains and dividends this equal $4. $4 / $10 = 40% total return."
    },
    {
       "id":3996,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Tom is a sole practitioner set up as an investment adviser. Tom studies financial statements, focusing primarily on target companies\u0027 cash flow, earnings acceleration, and revenue generation metrics. Which of the following is the most accurate way for Tom to describe his approach to rendering investment advice?",
       "choice_a":"I use the technicals of a company from a technical analysis approach",
       "choice_b":"I use the technicals of a company from a fundamentalist approach",
       "choice_c":"I use fundamental analysis to determine which companies represent strong investment opportunities",
       "choice_d":"I am certified by the state securities Administrator to perform fundamental analysis in rendering advice/recommendations",
       "correct_answer":"C",
       "explanation":"Tom is a fundamental analyst, based on the fact that he focuses on earnings and cash flow."
    },
    {
       "id":3997,
       "topic_id":3,
       "practice_test_id":2,
       "question":"A customer of SIA Investment Advisers calls an adviser representative to inquire what the \u0022wrap fee\u0022 charged on her account represents. Which of the following represents the best response from the IA representative?",
       "choice_a":"A wrap fee is the same thing as a commission",
       "choice_b":"A wrap fee is just like a sales load",
       "choice_c":"A wrap fee is charged when the account achieves a certain level of return",
       "choice_d":"A wrap fee combines charges for advice as well as execution of a transaction",
       "correct_answer":"D",
       "explanation":"A wrap fee is for advisory services as well as executing transactions."
    },
    {
       "id":3998,
       "topic_id":3,
       "practice_test_id":3,
       "question":"A value investor typically buys <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Stocks with low P/E ratios </li><li>Stocks with high P/E ratios </li><li>Stocks with low price-to-book ratios </li><li>Stocks with high price-to-book ratios</li></ol>",
       "choice_a":"I, III",
       "choice_b":"I, IV",
       "choice_c":"II, III",
       "choice_d":"II, IV",
       "correct_answer":"A",
       "explanation":"Equate \u0022value\u0022 with low P / E ratios and low price to book ratios."
    },
    {
       "id":3999,
       "topic_id":3,
       "practice_test_id":4,
       "question":"The Federal Reserve has increased short-term interest rates. The most likely result will be:",
       "choice_a":"Rates paid on adjustable rate mortgages will rise, rates on 30-year mortgages will drop",
       "choice_b":"Rates paid on 15-year mortgages will fall, rates on 30-year mortgages will rise",
       "choice_c":"The price of 10-year bonds will drop, and their yields will rise",
       "choice_d":"The price of 5-year bonds will drop, and their yields will drop",
       "correct_answer":"C",
       "explanation":"If rates go up, bond prices will go down."
    },
    {
       "id":4000,
       "topic_id":3,
       "practice_test_id":5,
       "question":"An investor most concerned with interest rate risk would least likely buy:",
       "choice_a":"T-bills",
       "choice_b":"T-notes",
       "choice_c":"T-bonds",
       "choice_d":"Money Market Mutual Funds",
       "correct_answer":"C",
       "explanation":"Long-term bonds carry more interest rate risk. T-bonds are longer-term than any of the other choices."
    },
    {
       "id":4001,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Stock of a corporation operating in a highly competitive, emerging industry is most susceptible to which of the following risks?",
       "choice_a":"Inflation",
       "choice_b":"Interest rate",
       "choice_c":"Business",
       "choice_d":"Liquidity",
       "correct_answer":"C",
       "explanation":"A risky business or industry carries \u0022business risk."
    },
    {
       "id":4002,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client informs you that she would like to receive maximum current income. Your risk profile determines that they have a moderate risk tolerance. You would recommend?",
       "choice_a":"Large cap stock",
       "choice_b":"T-bills",
       "choice_c":"T-bonds",
       "choice_d":"Investment-grade corporate bonds",
       "correct_answer":"D",
       "explanation":"Maximum current income = corporate bonds. We\u0027re dealing with the moderate risk tolerance by steering her toward investment-grade issues."
    },
    {
       "id":4003,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following stocks would tend to have the highest risk/reward ratio?",
       "choice_a":"Large cap",
       "choice_b":"Blue chip",
       "choice_c":"Mid cap",
       "choice_d":"Small cap",
       "correct_answer":"D",
       "explanation":"Small companies have the highest potential to grow and the highest potential to loose."
    },
    {
       "id":4004,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client of yours is 48 years old and has contributed to a traditional Individual Retirement Arrangement. They intend to take $10,000 out for their child\u0027s education. How is the withdrawal treated for tax purposes?",
       "choice_a":"Tax-free withdrawal",
       "choice_b":"Taxable withdrawal",
       "choice_c":"Ordinary income plus a $1,000 penalty/excise tax",
       "choice_d":"10% penalty only",
       "correct_answer":"B",
       "explanation":"From the Traditional IRA you can take out up to 10K for education without paying a penalty."
    },
    {
       "id":4005,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Rebalancing a portfolio for an older investor by reducing the percentage of equities and increasing the percentage of fixed-income investments is called",
       "choice_a":"Strategic asset allocation",
       "choice_b":"Buy and hold",
       "choice_c":"Tactical asset allocation",
       "choice_d":"Random walk theory",
       "correct_answer":"A",
       "explanation":"This would be strategic asset allocation It would be considered \u0022tactical\u0022 allocation if we were switching into bonds because we felt it was going to be a good year for bonds."
    },
    {
       "id":4006,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following are true of dividend reinvestment in a mutual fund except:",
       "choice_a":"Investors may defer taxes on the reinvestment for one calendar year",
       "choice_b":"Investors buy new shares at a net asset value basis",
       "choice_c":"Investor avoids paying sales loads on reinvestments",
       "choice_d":"Cost basis is increased by the amount of the reinvestment",
       "correct_answer":"A",
       "explanation":"Mutual funds offer no tax deferral for dividend reinvestment."
    },
    {
       "id":4007,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Non-systematic risk is reduced best by:",
       "choice_a":"Diversification",
       "choice_b":"Selling short",
       "choice_c":"Writing puts",
       "choice_d":"Arbitrage",
       "correct_answer":"A",
       "explanation":"The risk that any one investment could drop is called \u0022non-systematic risk.\u0022 The more diverse of a portfolio you hold, the less any one investment could hurt you."
    },
    {
       "id":4008,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Why would dollar cost averaging result in a lower average cost per share?",
       "choice_a":"As the share price rises, investors buy more shares",
       "choice_b":"Time value of money",
       "choice_c":"More shares are purchased at lower prices",
       "choice_d":"Parity",
       "correct_answer":"C",
       "explanation":"As a larger number of shares are purchased at a lower cost, the average cost will drop."
    },
    {
       "id":4009,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following taxes are progressive except",
       "choice_a":"Gift",
       "choice_b":"Estate",
       "choice_c":"Sales",
       "choice_d":"Income",
       "correct_answer":"C",
       "explanation":"Sales taxes are flat taxes, progressive taxes increase with value or income."
    },
    {
       "id":4010,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All of the following plans are funded with after-tax contributions except",
       "choice_a":"529 Plans",
       "choice_b":"Roth IRA\u0027s",
       "choice_c":"403b",
       "choice_d":"Deferred compensation",
       "correct_answer":"C",
       "explanation":"403b\u0027s are typically funded with pre-tax dollars."
    },
    {
       "id":4011,
       "topic_id":3,
       "practice_test_id":2,
       "question":"Your client is a small business owner saving for retirement via a SEP-IRA. If she withdraws the entire value of her account at age 47, she will:",
       "choice_a":"Be charged with intent to defraud",
       "choice_b":"Pay a 10% penalty plus capital gains on any earnings above cost basis",
       "choice_c":"Pay a 10% penalty plus ordinary income on any earnings above cost basis",
       "choice_d":"Pay a 10% penalty plus ordinary income on the entire withdrawal.",
       "correct_answer":"D",
       "explanation":"There is nothing fraudulent about taking your money out of the retirement plan. You never pay capital gains rates on retirement money. And, you have no cost basis, since the SEP is funded with pre-tax (tax-deductible) contributions."
    },
    {
       "id":4012,
       "topic_id":3,
       "practice_test_id":3,
       "question":"A client is 54 \u00BD years old and has contributed $40,000 to a traditional Individual Retirement Arrangement. The account is now worth $73,000. Her son is about to start technical school, and she intends to take $11,000 out for his education. How is the withdrawal treated for tax purposes?",
       "choice_a":"Tax-free withdrawal",
       "choice_b":"Taxable withdrawal",
       "choice_c":"Fully deductible withdrawal",
       "choice_d":"10% penalty",
       "correct_answer":"B",
       "explanation":"There will be no 10% penalty, but all withdrawals from the IRA will be taxable as ordinary income."
    },
    {
       "id":4013,
       "topic_id":3,
       "practice_test_id":4,
       "question":"If an investor purchases a 10-year zero-coupon Treasury security that will be held to maturity, which of the following risks is most relevant?",
       "choice_a":"Market",
       "choice_b":"Interest rate",
       "choice_c":"Purchasing power",
       "choice_d":"Default",
       "correct_answer":"C",
       "explanation":"Zero coupons are subject to interest rate risk (high duration), but if the investor will hold to maturity, the market price along the way is not that relevant. There is really no way to avoid purchasing power/inflation risk on debt securities, generally."
    },
    {
       "id":4014,
       "topic_id":3,
       "practice_test_id":5,
       "question":"Increases in all of the following will raise the annual expense ratio of a mutual fund except:",
       "choice_a":"Asset values",
       "choice_b":"Management fees",
       "choice_c":"12b1 fees",
       "choice_d":"Legal and consulting fees",
       "correct_answer":"A",
       "explanation":"If expenses stayed the same as asset values rose, the expense ratio would decrease, not increase."
    },
    {
       "id":4015,
       "topic_id":3,
       "practice_test_id":6,
       "question":"What does a proponent of fundamental analysis use to value common stock? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Trade volume </li><li>Discounted Cash Flow </li><li>P/E ratio </li><li>Moving price average</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"The correct answers are II and III. A fundamental analyst would look at the financial makeup of the company and how that financial value of the company is priced in the marketplace. Of the choices listed a fundamental analyst would use a discounted cash flow method which would be used to place a current value on the company\u0027s future earnings and a P/E ratio which would tell the analyst what people are paying in the marketplace for those earnings on a per share basis. Moving averages and trade volume would be used by an investor interested in technical analysis"
    },
    {
       "id":4016,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A high tax bracket investor who is looking for growth would invest in common stock for:",
       "choice_a":"Capital gains",
       "choice_b":"Protection of principal",
       "choice_c":"Avoidance of taxes",
       "choice_d":"A systematic purchase plan with a low beta",
       "correct_answer":"A",
       "explanation":"Any investor who purchases common stock is doing so for capital gains regardless of their tax bracket."
    },
    {
       "id":4017,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which view of the efficient market hypothesis would say that you can make money based on insider information? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Weak </li><li>Semi strong </li><li>Strong </li><li>Correlated</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I only",
       "choice_c":"III only",
       "choice_d":"III and IV",
       "correct_answer":"A",
       "explanation":"Both the weak and semi strong views of the efficient market hypothesis believe that unknown inside information is not reflected in asset prices and could be used to earn a profit. The weak view of this theory believes that prices in the market place reflect only past information regarding a security. The semi strong view believes that prices reflect all past and current publicly available information regarding a security. The strong view believes that past, present and even non public information is already reflected in a security\u0027s price."
    },
    {
       "id":4018,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investment strategy you may employ if you believe economic cycles are unpredictable would be:",
       "choice_a":"Buy and hold",
       "choice_b":"Technical analysis",
       "choice_c":"Fundamental analysis",
       "choice_d":"Efficient market allocation",
       "correct_answer":"A",
       "explanation":"An investor who feels that economic cycles are unpredictable and that the changes to the economic cycles are unknowable would use a buy and hold strategy."
    },
    {
       "id":4019,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The view that there is no information that could help you understand what will happen to security prices, is which form of the efficient market hypothesis?",
       "choice_a":"Weak",
       "choice_b":"Strong",
       "choice_c":"Semi strong",
       "choice_d":"Correlated",
       "correct_answer":"B",
       "explanation":"The strong view of the efficient market hypothesis believes that past, present and even non public information is already reflected in a security\u0027s price. The strong view believes that no information obtained will allow an investor to obtain an edge in predicting prices of securities."
    },
    {
       "id":4020,
       "topic_id":3,
       "practice_test_id":"",
       "question":"According to Modern Portfolio Theory, which of the following is the most efficient?",
       "choice_a":"Return 8%, Standard deviation 10",
       "choice_b":"Return 9% , Standard deviation 10",
       "choice_c":"Return 8%, Standard deviation 12",
       "choice_d":"Return 9%, Standard deviation 12",
       "correct_answer":"B",
       "explanation":"The standard deviation of an investment is a measure of the possible returns an investor may realize on that investment. The greater the standard deviation the greater the risk assumed by the investor. Therefore the highest return with the lowest standard deviation is the most efficient."
    },
    {
       "id":4021,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investment adviser works with an 82 year old woman. Her 50 year old son will be the Executor of her estate. The son calls the investment adviser saying he thinks that his mother\u0027s investments are out of line with what her objectives should be and wants information on the account. The investment adviser:",
       "choice_a":"Should provide the information because the son will be the Executor",
       "choice_b":"Cannot share the information without written permission from client",
       "choice_c":"Should share information if he is in agreement with son",
       "choice_d":"Advise the son that he should move the money to a more conservative portfolio",
       "correct_answer":"B",
       "explanation":"An investment adviser may not disclose any client information to a third party without the written permission of the client or without a court order or subpoena. The fact that the son will be the Executor of the estate is not relevant while his mother, the client is alive."
    },
    {
       "id":4022,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A 62 year old woman dies leaving her IRA to her 50 year old husband as beneficiary with her brother as conditional beneficiary. The 50 year old husband doesn\u0027t need the money and wants to preserve the value of the IRA for his children. To accomplish this he should:",
       "choice_a":"Roll it into a new IRA in his name with his children as beneficiaries",
       "choice_b":"Denounce it",
       "choice_c":"Roll it into a Coverdell IRA for each child",
       "choice_d":"Place the assets in trust for the children",
       "correct_answer":"A",
       "explanation":"A surviving spouse may elect to be treated as the owner of the IRA instead of the beneficiary so long as they are the sole beneficiary. In this case the spouse is the sole beneficiary as long as they are alive. So electing to be treated as the owner and rolling it over into a new IRA in his name is the most tax efficient way to preserve the account for the children."
    },
    {
       "id":4023,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A company defaults on its dividend due to a challenging economic environment. This is an example of:",
       "choice_a":"Business Risk",
       "choice_b":"Liquidity Risk",
       "choice_c":"Regulatory Risk",
       "choice_d":"Currency Risk",
       "correct_answer":"A",
       "explanation":"A company performing poorly due to a difficult economic environment is an example of business risk."
    },
    {
       "id":4024,
       "topic_id":3,
       "practice_test_id":"",
       "question":"You own shares in XYZ, a large multinational manufacturer that is the biggest manufacturer in its industry. The company may be ruled a monopoly by the Government. This is an example of:",
       "choice_a":"Market Risk",
       "choice_b":"Liquidity Risk",
       "choice_c":"Regulatory Risk",
       "choice_d":"Business Risk",
       "correct_answer":"C",
       "explanation":"Any action taken by the Government that may affect the prospects of an industry or a specific company would be an example of regulatory risk."
    },
    {
       "id":4025,
       "topic_id":3,
       "practice_test_id":2,
       "question":"A company\u0027s P/E ratio is useful in:",
       "choice_a":"Estimating future earnings",
       "choice_b":"Comparing companies in the same industry",
       "choice_c":"Valuing corporate bonds",
       "choice_d":"Assessing support for the company\u0027s stock price",
       "correct_answer":"B",
       "explanation":"A company\u0027s P/E ratio is useful in comparing companies in the same industry. A fundamental analyst may want to compare how the earnings of similar companies are priced in the marketplace. The analyst would then use this information to evaluate which companies stock prices are cheap or expensive relative to their industry."
    },
    {
       "id":4026,
       "topic_id":3,
       "practice_test_id":3,
       "question":"You buy stock in XYZ. You are sure that it will either go up or down a lot and you want to hedge your downside risk while keeping the opportunity to buy more if XYZ goes up. What combination of orders would you most likely place?",
       "choice_a":"Buy stop, sell limit",
       "choice_b":"Buy limit, sell stop",
       "choice_c":"Buy stop, sell stop",
       "choice_d":"Buy limit, sell limit",
       "correct_answer":"C",
       "explanation":"In the case described you would want to protect your downside risk by entering a sell stop below the market. If XYZ did well you would be able to add to your position by entering a buy stop above the market."
    },
    {
       "id":4027,
       "topic_id":3,
       "practice_test_id":4,
       "question":"You buy a stock that you think is likely to trade sideways for a period of time. Which of the following would you most likely do to allow you make money during a sideways move?",
       "choice_a":"Sell a call",
       "choice_b":"Sell a put",
       "choice_c":"Buy a call",
       "choice_d":"Buy a put",
       "correct_answer":"A",
       "explanation":"If a stock is range bound or likely to move sideways for a period of time the best strategy to profit during this time would be to sell a covered call on that stock."
    },
    {
       "id":4028,
       "topic_id":3,
       "practice_test_id":5,
       "question":"You sell a stock short. What type of order are you most likely to enter to hedge your risk?",
       "choice_a":"Buy stop",
       "choice_b":"Sell stop",
       "choice_c":"Buy limit",
       "choice_d":"Sell limit",
       "correct_answer":"A",
       "explanation":"If you sell stock short your risk is to the upside and to exit the trade you must buy the stock back. The best order would be to enter a buy stop above the market."
    },
    {
       "id":4029,
       "topic_id":3,
       "practice_test_id":6,
       "question":"What percentage of employee contributions to a 403b plan are vested after one year?",
       "choice_a":"It depends on the plan but normally at least 50%",
       "choice_b":"All employee contributions vest after 1 year",
       "choice_c":"It is required by law that all contributions to 403b vest after 10 years",
       "choice_d":"All employee contributions vest immediately",
       "correct_answer":"D",
       "explanation":"All employee contributions to a 403b plan vest immediately as the employee placed the money into the plan."
    },
    {
       "id":4030,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor is looking at the price-book ratio when considering which stocks to purchase. What type of analysis are they employing?",
       "choice_a":"Fundamental analysis",
       "choice_b":"Financial analysis",
       "choice_c":"Technical Analysis",
       "choice_d":"Price Earnings / Growth analysis",
       "correct_answer":"A",
       "explanation":"When an investor is looking at the price to book ratio of various equities they are employing fundamental analysis."
    },
    {
       "id":4031,
       "topic_id":3,
       "practice_test_id":"",
       "question":"What is a good proxy for a risk free return?",
       "choice_a":"T-bills",
       "choice_b":"Corporate commercial paper",
       "choice_c":"Money market funds",
       "choice_d":"Negotiable CDs",
       "correct_answer":"A",
       "explanation":"The proxy used for the risk free return in the Sharpe ratio and in other models are 3 month T-bills."
    },
    {
       "id":19516,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An uncle had established and contributed to a Coverdell ESA for his nephew\u0027s college education for the last 10 years.  The nephew withdraws $7,000 from the growth of the account to meet $5,000 worth of educational expenses. The remaining $2,000 is:",
       "choice_a":"Taxable to the parents",
       "choice_b":"Taxable to the nephew",
       "choice_c":"Taxable to the uncle",
       "choice_d":"Non taxable to the nephew",
       "correct_answer":"B",
       "explanation":"The excess distribution from the account and is taxable to the beneficiary as it was not used to pay for educational expenses."
    },
    {
       "id":19540,
       "topic_id":3,
       "practice_test_id":"",
       "question":"All but which of the following if established would involve a fiduciary?",
       "choice_a":"Trust account",
       "choice_b":"Transfer on Death account",
       "choice_c":"Guardian account",
       "choice_d":"Estate account",
       "correct_answer":"B",
       "explanation":"The transfer on Death or TOD account designation on an account simply states who the assets are to go to in the event of the account holder\u0027s death. This does not involve or create a fiduciary relationship."
    },
    {
       "id":19546,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor purchases an 8 percent corporate bond in the marketplace at par.  After holding the bond fully paid for, the investor has a total return of 5 percent. Why is the investor\u0027s  total return lower than the coupon rate?",
       "choice_a":"Interest rate have fallen",
       "choice_b":"The bond\u0027s total return takes into account commissions and markups paid to acquire the bond",
       "choice_c":"Interest rates have risen",
       "choice_d":"The investor paid accrued interest when the bond was purchased and the accrued interest lowers the total return",
       "correct_answer":"C",
       "explanation":"An investor\u0027s total return is found by adding the income received from the investment with any appreciation in price. If the investment falls in price the loss in value  would be subtracted from the total return. The reason the investor\u0027s total return is lower than the coupon rate is due to the fact that interest rates have increased and this caused the bond to fall in price."
    },
    {
       "id":19547,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A long standing client is seeking to make an initial deposit into a college plan for his son\u0027s college expenses. His son will start college in 11 years. Which of the following is the lowest priority when determining the amount of the initial deposit?",
       "choice_a":"Client\u0027s current income",
       "choice_b":"The current average cost of college",
       "choice_c":"The time until his son starts college",
       "choice_d":"The projected annual increase in tuition",
       "correct_answer":"A",
       "explanation":"The lowest priority would be the client\u0027s current income as the client is seeking to make an initial deposit.  The deposit will be coming from savings so the amount of the client\u0027s savings would be far more important. The other factors can be used to estimate what the anticipated cost of college may be and are therefore of high importance."
    },
    {
       "id":19555,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Who would realize the greatest benefit as it relates to a defined benefit plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Employees who have fewer years until retirement </li><li>Employees with many years until retirement  </li><li>Employees who have high salaries  </li><li>Employees who have modest salaries</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I only",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"Employees with the highest salaries with the fewest years until retirement would realize the greatest benefit from participation in a defined benefit plan. A defined benefit plan provides a stated benefit such as a set percentage of the employee\u0027s income during retirement"
    },
    {
       "id":19559,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Income from which of the following is most likely to subject a high income investor to the AMT (alternative minimum tax)?",
       "choice_a":"General Obligation (GO) bond",
       "choice_b":"Industrial revenue bond",
       "choice_c":"T Bill",
       "choice_d":"T Bond",
       "correct_answer":"B",
       "explanation":"Income from a private purpose municipal bond also known as an industrial revenue development bond is most likely to subject a high income investor to the AMT (alternative minimum tax)."
    },
    {
       "id":19573,
       "topic_id":3,
       "practice_test_id":2,
       "question":"The yield to maturity on a bond is most like which of the following?",
       "choice_a":"Yield to call",
       "choice_b":"Net present value",
       "choice_c":"Internal rate of return",
       "choice_d":"coupon rate",
       "correct_answer":"C",
       "explanation":"The yield to maturity on a bond is the bond\u0027s internal rate of return.  The calculations take into consideration all of the interest payments received as well as any gain or loss based on the purchase price of the bond."
    },
    {
       "id":19575,
       "topic_id":3,
       "practice_test_id":3,
       "question":"An investor wants to save $100,000 to purchase a second home in 5 years. He wants to make a lump sum deposit to meet this 5 year goal. To calculate his required deposit he will need to know all of the following except:",
       "choice_a":"Net present value of $100,000",
       "choice_b":"Compounding periods",
       "choice_c":"Interest rates",
       "choice_d":"Future value of $100,000",
       "correct_answer":"D",
       "explanation":"The investor will not need to know the future value of $100,000 as $100,000 is the amount he wants to have in the future. The investor will need to know the net present value of $100,000 based on interest rates and compounding periods."
    },
    {
       "id":19576,
       "topic_id":3,
       "practice_test_id":4,
       "question":"The internal rate of return is the discount rate at which the net present value of an investment:",
       "choice_a":"Exceeds its funding costs",
       "choice_b":"Generates a profit",
       "choice_c":"Generates a loss",
       "choice_d":"Equals zero",
       "correct_answer":"D",
       "explanation":"The internal rate of return is the point at which the net present value of an investment equals zero."
    },
    {
       "id":19578,
       "topic_id":3,
       "practice_test_id":5,
       "question":"An investor may use the dividend end discount model to calculate an approximate:",
       "choice_a":"PEG ratio",
       "choice_b":"Market price for the stock",
       "choice_c":"Annualized current yield",
       "choice_d":"Holding period return",
       "correct_answer":"B",
       "explanation":"The dividend discount model takes the present  value of all future dividends to be paid and is used to estimate a market price for the stock."
    },
    {
       "id":19579,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which of the following bonds would if purchased by an investor have a yield to call lower than the yield to maturity?",
       "choice_a":"A short duration treasury note",
       "choice_b":"A bond purchased at a price above par",
       "choice_c":"A zero coupon bond",
       "choice_d":"A bond purchased at a price lower than par",
       "correct_answer":"B",
       "explanation":"The bond purchased at a premium or a price above par would have a yield to call that is lower that than yield to maturity because the investor will have fewer years to amortize the premium paid for the bond."
    },
    {
       "id":19580,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor is looking at several bond investments and is trying to determine the yield to call for each bond. In order to determine the yield to call, the investor would need to know which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The amount of interest payments to be received  </li><li>The amount of time until maturity  </li><li>The current price of the bond </li><li>The price at which the bond may be called</li></ol>",
       "choice_a":"III and IV",
       "choice_b":"I and III",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"In order to determine the yield to call an investor would need to know all of the items listed except the number of years to maturity. The investor would need to know the number of years until the call date."
    },
    {
       "id":19581,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A portfolio\u0027s total return would be described as:",
       "choice_a":"A measure of the total predicted returns",
       "choice_b":"A measure of the variability of the predicted returns",
       "choice_c":"A measure of the total realized returns",
       "choice_d":"A measure of the variability of realized returns",
       "correct_answer":"C",
       "explanation":"A portfolio\u0027s total return is a measure of the total realized return. It calculates  the return that the portfolio has already achieved."
    },
    {
       "id":19583,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor placed $5,000 in a growth fund 10 years ago. The account is now worth $10,000 as the market has performed well  over the last few years. The investor\u0027s annual return is:",
       "choice_a":"7.20%",
       "choice_b":"6%",
       "choice_c":"11%",
       "choice_d":"9.10%",
       "correct_answer":"A",
       "explanation":"Using the rule of 72 an investor can calculate the return for a portfolio. To determine the return the investors would take the number 72 and divide it by the number of years it takes the investment to double in this case 10. 72 / 10 = 7.2%"
    },
    {
       "id":19584,
       "topic_id":3,
       "practice_test_id":6,
       "question":"An investor purchased 1000 shares of XYZ at $40 12 months ago. The investor has received four quarterly dividends of 50 cents and sells the shares at $42. The investor\u0027s total return is:",
       "choice_a":"5%",
       "choice_b":"2.50%",
       "choice_c":"10%",
       "choice_d":"8%",
       "correct_answer":"C",
       "explanation":"The investor received a total of $2 in dividends and realized a $2 capital gain for a total return of $4 or $4,000 for the entire investment $4 / $40 = 10%"
    },
    {
       "id":21163,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following investments would be least suitable for an investor seeking a short term, liquid investment providing safety of principal?",
       "choice_a":"T\u0027 Bills",
       "choice_b":"Auction rate securities",
       "choice_c":"Money market funds",
       "choice_d":"30-90 day brokered CDs",
       "correct_answer":"B",
       "explanation":"Auction rate securities are long term bonds that reset the interest rate paid on the bonds at set intervals. ARS are 20-30 years in maturity which pay interest based on the auction rate every 7, 28 or 35 days. If the auction fails investors will not be able to sell the bonds immediately."
    },
    {
       "id":21169,
       "topic_id":3,
       "practice_test_id":"",
       "question":"In an effort to gain exposure to the market an optimistic investor takes on risk and purchases a stock with a beta equal to 1.4. If the S& P 500 is up 5 percent over the next several weeks what would the investor\u0027s expected return be on his purchase?",
       "choice_a":"6 Percent",
       "choice_b":"7 Percent",
       "choice_c":"9 percent",
       "choice_d":"11 percent",
       "correct_answer":"B",
       "explanation":"An investment with a beta of 1.4 would be expected to have a return equal to 140 percent of the return of the overall market. In this case the market was up 5 percent. The investor would therefore expect a return of 1.4 X 5 percent or a 7 percent return."
    },
    {
       "id":21180,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Your client is looking at various options for purchasing a variable annuity your firm has recommended to her. Which of the following would be considered abusive sales practices under FINRA guidelines? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Suggesting she take a home equity loan on the home she owns which is fully paid for </li><li>Suggesting she withdraw the money from a variable life insurance police she purchased 3 years ago </li><li>Suggesting she convert the funds from an another annuity with less features she established 2 years ago </li><li>Suggesting she convert the funds from a negotiable CD with 1 year remaining until maturity</li></ol>",
       "choice_a":"I only",
       "choice_b":"II and II",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"It is never appropriate to recommend that an investor use the equity in a home to invest. Recommending that the investor convert funds from another variable contract established in the last few years would most likely subject the investor to significant surrender charges and would not be suitable. Both of these practices have been identified as being abusive sales practices by FINRA. Since the CD is negotiable it can be sold in the market without subjecting the investor to surrender charges or penalties. Using the proceeds from the sale would not be abusive."
    },
    {
       "id":21181,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A lifetime income rider would be most suitable for an investor who is considering purchasing an annuity in which of the following circumstances? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor is already retired  </li><li>The investor anticipates a long retirement  </li><li>The investor has not yet retired  </li><li>The investor does not anticipate a long retirement</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and III",
       "choice_c":"I and II",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"A lifetime income rider would be most suitable for an investor who is not yet retired and who anticipates a long retirement."
    },
    {
       "id":21184,
       "topic_id":3,
       "practice_test_id":"",
       "question":"The manager of a long only fund has been systematically liquidating securities over the past 6 months and has moved the proceeds into money market funds. The manager is now said to be in \u0022cash\u0022. Which of the following would best describe the manager\u0027s outlook?",
       "choice_a":"He is bullish on rates",
       "choice_b":"He is bullish on bonds",
       "choice_c":"He is bearish on stocks",
       "choice_d":"He expects the FRB to reduce rates",
       "correct_answer":"C",
       "explanation":"The manager of a long only fund is not allowed to sell equities short. As a result the only option for this manager when they turn bearish on the stock market is to move to the sidelines and into cash and short term money market funds."
    },
    {
       "id":21190,
       "topic_id":3,
       "practice_test_id":"",
       "question":"As it relates to an account established as joint tenants in common, Which of the following is / are not true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If one party dies the assets will become the property of the survivor  </li><li>Each party identifies a specific percentage ownership in the account </li><li>If one part dies the assets in the account will become part of the decedent\u0027s estate </li><li>Accounts must be established with equal ownership among the parties </li></ol>",
       "choice_a":"I and IV",
       "choice_b":"I only",
       "choice_c":"II and IV",
       "choice_d":"II and III",
       "correct_answer":"A",
       "explanation":"If one party in an account dies the assets belonging to that party will become part of the decedent\u0027s estate. Each party in the account must specify their ownership percentage for the assets in the account. Accounts established as JTIC do not require equal ownership among the parties."
    },
    {
       "id":21191,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A large trading fund is seeking to establish an account with your firm. The fund wants to maintain a centralized location for all of its assets and records. The fund receives research from a large number of broker dealers who also execute orders for the fund. Which type of account would be best suited for this customer?",
       "choice_a":"Joint back office account",
       "choice_b":"A proprietary trading account",
       "choice_c":"An institutional trading account",
       "choice_d":"A prime brokerage account",
       "correct_answer":"D",
       "explanation":"A prime brokerage account will allow the fund to have all of its assets held at one broker dealer while utilizing many other broker dealers for execution and research services."
    },
    {
       "id":21205,
       "topic_id":3,
       "practice_test_id":"",
       "question":"If you are interested in knowing the level of fear in the market, you would most likely look at which of the following?",
       "choice_a":"The put / call ratio",
       "choice_b":"Option open interest",
       "choice_c":"Short interest in the S&P 500",
       "choice_d":"The VIX",
       "correct_answer":"D",
       "explanation":"The VIX or volatility index is a measure of fear in the overall market and measures the expected volatility in the overall market. The VIX will increase and investors become more fearful about a big move in the overall market."
    },
    {
       "id":21209,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which of the following investors would be most likely to purchase an inverse ETF?",
       "choice_a":"A long term investor",
       "choice_b":"An institutional investor",
       "choice_c":"A bearish investor",
       "choice_d":"A bullish investor",
       "correct_answer":"C",
       "explanation":"An inverse ETF offers price performance that moves in the opposite direction of the underlying index. The S&P 500 inverse ETF will increase in price as the value of the S&P 500 falls. An investor who was bearish or who thought that the market may generally fall would be the most likely to purchase an inverse ETF."
    },
    {
       "id":21210,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor who is long a large portfolio of large cap common stocks would most likely execute which of the following to protect the portfolio from a market correction?",
       "choice_a":"Purchase an inverse bond fund ETF",
       "choice_b":"Purchase a bond fund",
       "choice_c":"Purchase the S&P 500 inverse ETF",
       "choice_d":"Purchase puts on each holding in the portfolio",
       "correct_answer":"C",
       "explanation":"An investor who is long a large portfolio of large cap common stocks would most likely purchase the S& P 500 inverse ETF to provide protection to the overall portfolio in the event of a market correction. The price of the inverse ETF will increase as the value of the S& P 500 falls. Buying the inverse ETF is more efficient than purchasing puts on each and every stock in the portfolio."
    },
    {
       "id":21211,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An inverse ETF would be suitable for which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Long term protection  </li><li>Short term protection  </li><li>Gaining short exposure </li><li>Portfolio hedging</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"An inverse ETF could be used for short term protection, to gain short exposure to the market, or to hedge an overall portfolio against a market decline. An inverse ETF is not designed for long term protection."
    },
    {
       "id":21345,
       "topic_id":3,
       "practice_test_id":"",
       "question":"When comparing a 529 plan owned by a parent to a UGMA account, which of the following are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The assets in the 529 plan will have a lower impact on any financial aid on a percentage basis than a UGMA </li><li>If the student receives a scholarship, penalties on the 529 plan may be waived  </li><li>A UGMA is considered to be an asset of the student and will have no impact on financial aid  </li><li>The 529 plan is considered to be a contributable asset </li></ol>",
       "choice_a":"II and III",
       "choice_b":"I, II and IV",
       "choice_c":"III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"Assets in a 529 plan owned by the parents will have a lower impact on any financial aid received by the student than assets held a UGMA or UTMA owned by the student. The assets held in the UGMA will impact the financial aid offered.  The assets in the 529 plan are considered to be a contributable asset of the parents and will be assessed at a contribution rate of 5.64 percent versus 20 percent for the UGMA or UTMA. If the student receives a scholarship penalties on the 529 plan may be waived."
    },
    {
       "id":25367,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Which of the following would be appropriate for an investor who has a bearish outlook on the markets?",
       "choice_a":"Go long an inverse ETF",
       "choice_b":"Write S&P 500 puts",
       "choice_c":"Write S&P 500 put spreads",
       "choice_d":"Buy Treasury bonds and CMOs",
       "correct_answer":"A",
       "explanation":"An inverse ETF is designed to provide short exposure to the market. By purchasing an inverse ETF an investor will be establishing a position that will increase in value as the market falls. All of the put option choices are bullish. And the Treasury and CMO options would be established by someone who is bullish on the debt market or who has an income objective."
    },
    {
       "id":25364,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor with a 2 year time horizon has $75,000 to invest. He is seeking semiannual payments of interest income. Which of the following would you recommend?",
       "choice_a":"Treasury note",
       "choice_b":"Treasury bond",
       "choice_c":"2 year STRIP",
       "choice_d":"Treasury bill",
       "correct_answer":"A",
       "explanation":"Of the choices listed the only option that actually pays interest is the Treasury note. All of the other choices are discount securities which do not pay interest. Discounted securities appreciate to their par or face value at maturity."
    },
    {
       "id":25363,
       "topic_id":3,
       "practice_test_id":6,
       "question":"An investor had established a Roth IRA when he was 54 years old by depositing $5,000. During each of the next two years he made equal installments totaling $12,000. When he was 57 years old he made a single contribution of $6,500. No further contributions were made. Now at 60 he wants to take a lump sum distribution with the account valued at $30,125. Which of the following is correct?",
       "choice_a":"The investor may withdraw all of the money tax free",
       "choice_b":"The investor may withdraw the deposits plus the growth on the assets that are more than 5 years old tax free",
       "choice_c":"The investor may withdraw the deposits tax free but will be subject to ordinary income taxes on the growth since not all of the money was there for more than 5 years",
       "choice_d":"In order to avoid paying income taxes the investor must take payments that are substantially similar over time",
       "correct_answer":"A",
       "explanation":"All deposits made to a Roth IRA are made with after tax dollars. As such the contributions to the plan create the investor\u0027s cost basis. Since the investor is over 59\u00BD the investor may take all of the growth out of the account tax free."
    },
    {
       "id":25358,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor has begun a dollar cost averaging plan and has made the following contributions resulting the in following purchases: <img src='/question_assets/series66/25358.png'></img> What is the investor\u0027s average cost?",
       "choice_a":"$13.33",
       "choice_b":"$15",
       "choice_c":"$7.50",
       "choice_d":"$17.50",
       "correct_answer":"A",
       "explanation":"To determine the investor\u0027s average cost use the following formula: Total dollars invested / total number of shares purchased. In this case, $400/30= $13.33."
    },
    {
       "id":25354,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A 45 year old in the 28 percent tax bracket is speaking to you as his representative seeking an investment to augment his 401K plan. Which of the following would be the best recommendation for your client?",
       "choice_a":"Variable annuity, accumulation units",
       "choice_b":"Variable annuity, annuity units",
       "choice_c":"A growth mutual fund",
       "choice_d":"An S&P 500 index fund",
       "correct_answer":"A",
       "explanation":"An investor who is looking to augment or supplement a retirement plan would be most suitable for a deferred variable annuity contract.  During the accumulation phase the money is allowed to grow tax deferred and the investor will own accumulation units."
    },
    {
       "id":25352,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A customer sells a stock he has owned at a loss and two weeks later purchases a security that is substantially the same. Which of the following is true?",
       "choice_a":"The customer may claim the loss if the stock was held for more than 1 year",
       "choice_b":"The customer may claim the loss if the stock was held for less than 1 year",
       "choice_c":"The original cost base passes to the new purchase",
       "choice_d":"The loss may only be used to offset a gain in the current year",
       "correct_answer":"C",
       "explanation":"Under the wash sale rule if a person sells a security at a loss and within 30 days purchases a security which is substantially the same, the loss will be disallowed and the investor\u0027s original cost base will be passed along to the new purchase."
    },
    {
       "id":25348,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A 90 year old man living on social security has just won a legal settlement in the amount of $250,000 and wants to invest the money to receive additional income to supplement his monthly social security check. He would also like to leave some money for his children. Which of the following would be the best selection?",
       "choice_a":"A ladder treasury bond portfolio",
       "choice_b":"A ladder municipal bond portfolio",
       "choice_c":"An index ETF and CMOs",
       "choice_d":"A portfolio of both common and preferred stock",
       "correct_answer":"A",
       "explanation":"This is an elderly person who has an investment objective of current income and preservation of capital. His objective of preservation of capital is identified by the fact that he wants to leave money to his heirs. A laddered portfolio of Treasury bonds would be the best option . A bond ladder consists of a portfolio of bonds with maturities ranging over a period of years. The interest payments will be received frequently as the interest payment dates will vary. The treasury bonds will also protect the principal investment."
    },
    {
       "id":25380,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Your client is in his mid fifties and will be retiring several years. He wants to make several changes to his portfolio and is seeking steady income and protection of principal. As his representative which of the following would you most likely recommend?",
       "choice_a":"Buy a portfolio of corporate bonds maturing in 2-7 years",
       "choice_b":"Buy a portfolio of AAA rate municipal bonds with 30 year maturity",
       "choice_c":"Buy a portfolio the highest yielding municipal securities",
       "choice_d":"Buy a portfolio of high yielding corporate bonds",
       "correct_answer":"A",
       "explanation":"The invest is looking for income and safety of principal, the High yield bonds are not appropriate as they contain too much risk. The AAA rate  munis would subject the investor to too much principal risk if interest rates changed. The short term corporate bonds therefore at the best choice in this situation."
    },
    {
       "id":25385,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor wishing to purchase open end mutual funds with the performance characteristics of the S&P index would be said to have an investing style that is:",
       "choice_a":"Aggressive",
       "choice_b":"Passive",
       "choice_c":"Based on bottom up analysis",
       "choice_d":"Based on top down analysis",
       "correct_answer":"B",
       "explanation":"An investor who is seeking an investment that tracks the performance of an index such as the S&P 500 is engaging in a passive investment strategy. The assets in the fund are selected based on the makeup of the stocks in the index. Portfolio managers do not select the assets to be purchased or sold."
    },
    {
       "id":25402,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A wealthy client is in the maximum federal tax bracket and is seeking to avoid the potential impact of the AMT. Which of the following bonds would you most likely recommend?",
       "choice_a":"A 6% taxable municipal bond",
       "choice_b":"A 5.2 % GO bond",
       "choice_c":"A 5.4 % Treasury bond",
       "choice_d":"A 5.2 % interest protected AMT bond",
       "correct_answer":"B",
       "explanation":"Certain high income earners can be subject to the AMT on certain municipal revenue bonds. As such the best recommendation for this person is the GO bond. A Treasury bond is not the correct choice as the interest will always be taxed at the federal level."
    },
    {
       "id":37230,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An Investor who is trying to estimate the anticipated return of a portfolio based on its beta, would perform which of the following calculations?",
       "choice_a":"Beta X benchmark return",
       "choice_b":"Beta X benchmark return - CPI",
       "choice_c":"Beta X Benchmark return + CPI",
       "choice_d":"Beta X risk premium",
       "correct_answer":"D",
       "explanation":"To calculate the anticipated rate of return of a portfolio based on its beta, the investor would multiply the beta time\u0027s the risk  premium. The risk premium is defined as the expected return of an investment minus the risk-free return."
    },
    {
       "id":37229,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor has just concluded a meeting with a new investment advisor. The investor is reviewing the past 12 months performance for the advisor\u0027s managed account.  The relevant data for the last 12 months is as follows: <img src='/question_assets/series66/37229.png'></img> If the investment advisor\u0027s managed account returned 14% for the year, which of the following is correct?",
       "choice_a":"The asset selection in the portfolio resulted in Alpha of 2",
       "choice_b":"The asset selection in the portfolio did not produce any additional returns",
       "choice_c":"The assets selection the portfolio resulted in Alpha of .5",
       "choice_d":"The asset selection in the portfolio resulted in risk-adjusted under performance",
       "correct_answer":"A",
       "explanation":"To determine the alpha of a portfolio you must take the return of the market and subtract the risk-free return. In this case 9% - 1% = 8%. Then you multiply the risk premium of 8% by the beta  of the portfolio of 1.5 to determine what the risk-adjusted rate of return of portfolio should be. In this case 8% X 1.5 equals 12%. Since the return of the portfolio exceeds the risk-adjusted return, the portfolio manager has produced excess returns for each unit of risk. The portfolio manager in this case would have added Alpha  of an additional 2% or 2."
    },
    {
       "id":37228,
       "topic_id":3,
       "practice_test_id":"",
       "question":"When evaluating a security, the dividend growth model would least likely be used to evaluate which of the following Investments?",
       "choice_a":"a growth stock",
       "choice_b":"a utility stock",
       "choice_c":"a blue chip stock",
       "choice_d":"a preferred stock",
       "correct_answer":"D",
       "explanation":"The correct choice is a preferred stock. A preferred stock pays a stated dividend rate usually based as a percentage of par value. Therefore, preferred stock does not have a dividend that increases over time. all of the other choices listed are shares of common stock. Common stock has a dividend that must be declared by the board of directors and is not set at a fixed rate. The dividend growth model is only used to value common stock that has a dividend payment that is likely to increase over time."
    },
    {
       "id":37227,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Which Two of the following choices would not be included in the safe harbor under ERISA 404c? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>the frequency with which a participant May purchase and sell portfolios </li><li> the cost and fees associated with the plan </li><li> the relative performance of the portfolios versus and Market benchmark </li><li> the investment objectives and profiles of the portfolios offered to participants</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and IV",
       "correct_answer":"B",
       "explanation":"The cost and fees associated with the plan and the performance of the portfolios versus a market Benchmark are not part of the ERISA Safe Harbor.  Under the Safe Harbor the plan must offer a minimum of three investment portfolios and the participant must be given ample opportunity to move money between the portfolios offered."
    },
    {
       "id":37220,
       "topic_id":3,
       "practice_test_id":"",
       "question":"As it relates to the operation of an able account, for a disabled individual, which of the following is correct?",
       "choice_a":"the maximum dollar limit in an able account is $100,000",
       "choice_b":"any money remaining in the account upon the death of the beneficiary will first go to repay the state where the individual resides",
       "choice_c":"the individual who funds the able account is deemed to be the owner of the account",
       "choice_d":"able accounts qualify for pre-tax contributions so long as the individual had a qualifying disability prior to reaching the age of 26",
       "correct_answer":"B",
       "explanation":"The only correct choice is that any money remaining in the account at the time of the person\u0027s death will go to repay the state for any supplemental insurance benefits paid to the individual during their lifetime.  contributions to an able account are made with after-tax dollars and the disabled individual is deemed to be both the owner and beneficiary of the account."
    },
    {
       "id":37217,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor has just concluded a meeting with a new investment advisor. The investor is reviewing the past 12 months performance for the advisor\u0027s managed account.  The relevant data for the last 12 months is as follows: <img src='/question_assets/series66/37217.png'></img> Given the above information the investment adviser\u2019s managed account should have returned at least:",
       "choice_a":"13.50%",
       "choice_b":"12%",
       "choice_c":"10%",
       "choice_d":"14%",
       "correct_answer":"B",
       "explanation":"The beta of 1.5% would be applied to the market return minus the risk-free return. In this case, 9% - 1% equals 8%. 1.5 X  8% equals 12%"
    },
    {
       "id":37215,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor has just concluded a meeting with a new investment advisor. The investor is reviewing the past 12 months performance for the advisor\u0027s managed account.  The relevant data for the last 12 months is as follows: <img src='/question_assets/series66/37215.png'></img> If the investment advisor\u0027s managed account returned 13% for the year, which of the following is correct?",
       "choice_a":"The investment advisor underperformed the benchmark given the additional risk associated with the managed account",
       "choice_b":"The investment advisor outperformed the benchmark given the additional risk associated with the managed account",
       "choice_c":"The Investment advisor\u0027s performance was negatively impacted by the rise in this CPI",
       "choice_d":"The investment advisor\u0027s portfolio performed at a rate less than efficient frontier",
       "correct_answer":"B",
       "explanation":"Based on the information provided in the performance data, the investment advisor outperformed the Benchmark on a risk-adjusted basis. Taking the beta and multiplying it by the market return minus the risk-free rate,  The portfolio should have returned 12%. In this case the investment advisor outperformed on a risk-adjusted basis."
    },
    {
       "id":37214,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A principal who has been reviewing the activity in a customer\u0027s account has noticed that the customer liquidated his portfolio in High Growth Fund Company and reinvested those proceeds in a conservative portfolio offered by Rock Solid Income Fund company. Which of the following choices would the principal be most concerned with?",
       "choice_a":"Whether or not the investor\u0027s investment objective has changed",
       "choice_b":"The income portfolio might be too conservative for this investor",
       "choice_c":"The risk of loss to the income portfolio in the event interest rates rise",
       "choice_d":"The fact that the investor switched fund companies",
       "correct_answer":"D",
       "explanation":"A principal would be most concerned with the fact that the customer switched fund companies. When an investor wishes to move money between portfolios or should the investor\u2019s investment objective change, a registered rep should ensure that the money stays with the same fund company. A principal would be most concerned with the fact that the customer switched fund companies. When an investor wishes to move money between portfolios or should the investor\u2019s investment objective change, a registered rep should ensure that the money stays with the same fund com"
    },
    {
       "id":39324,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A married couple having a long-term growth objective is considering a mutual fund but they express a specific aversion to high annual fund expenses. Given their objective and preferences, a suitable recommendation would be a:",
       "choice_a":"common stock fund with a low portfolio turnover.",
       "choice_b":"dividend producing fund with a high portfolio turnover.",
       "choice_c":"long-term corporate bond fund that is actively managed.",
       "choice_d":"preferred stock fund that is actively managed.",
       "correct_answer":"A",
       "explanation":"Of the choices given, common stock is the only investment capable of providing long-term growth. A preferred stock fund or a dividend producing fund will provide income via the dividends collected but not provide much growth. Bond funds provide income and are not designed to meet a growth objective. Lower portfolio turnover (less trading in and out of the fund portfolio) should result in lower annual fund expenses."
    },
    {
       "id":39322,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new customer is interested in pursuing income. Regarding risk tolerance she says; \u201CI\u2019m a bit defensive about that, I\u2019d rather be in investments that are non-volatile\u201D. Of the following which would be most suitable for her?",
       "choice_a":"Short-term government bonds",
       "choice_b":"High yield corporate debt instruments",
       "choice_c":"Growth stocks",
       "choice_d":"Raw land limited partnerships",
       "correct_answer":"A",
       "explanation":"Of the above investments only short-term government bonds will produce the objective (income) with little price volatility."
    },
    {
       "id":39323,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A registered representative\u2019s customer is bullish on US equity securities across a  number of industry categories. The customer is hoping to participate in an anticipated upward movement of an index that would represent as many of these industry categories as possible. Aligning with her market outlook, which of the following investments would you recommend as being most closely related to the movement of equities in general and therefore the most suitable recommendation?",
       "choice_a":"Standard & Poor\u0027s depository receipts (SPDRs)",
       "choice_b":"American depositary receipts (ADRs)",
       "choice_c":"Real Estate Investment Trusts (REITs)",
       "choice_d":"Variable rate demand obligations (VRDOs)",
       "correct_answer":"A",
       "explanation":"Of the choices shown, only the spider (SPDR) is an index fund designed to replicate and track the performance of the S&P 500, a broad-based equity index. None of the remaining choices represent a broad base of equities. For example, REITs represent real estate holdings and VRDOs represent short-term debt obligations."
    },
    {
       "id":39325,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new customer in his early thirties has $100,000 to invest. He is single, has no dependents and tells you he is willing to tolerate a high degree of risk. He adds confidently that he has no anticipation of tapping into these invested funds for at least 15 years. With this profile, what would be a suitable recommendation regarding asset allocation for the customer\u2019s portfolio?",
       "choice_a":"$70,000 equities, $20,000 debt, and $10,000 money-market instruments",
       "choice_b":"$45,000 debt, $35,000 equities, and $20,000 money-market instruments",
       "choice_c":"$35,000 debt, $35,000 equities, $30,000 real estate investment trusts",
       "choice_d":"$65,000 debt, $30,000 equities and $5,000 money-market instruments",
       "correct_answer":"A",
       "explanation":"Given his 15-year time horizon and his willingness to tolerate higher levels of risk, a recommendation having a higher percentage of the portfolio in equities would be most suitable for this investor. Of the asset mixes presented only one has the majority invested in equities while the others have higher or equal concentrations in debt securities and would likely be too conservative."
    },
    {
       "id":39326,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A new customer says her investment philosophy is value oriented as opposed to growth oriented. Looking for a stock recommendation and considering that value is her primary objective, which of the following stock characteristics would she be least likely to consider?",
       "choice_a":"A stock with an above average price-to-earnings ratio.",
       "choice_b":"A stock with consistent and high dividend yields.",
       "choice_c":"A stock with a low price-to-earnings ratio.",
       "choice_d":"A stock that is presently selling at a price 15% below its current book value.",
       "correct_answer":"A",
       "explanation":"A value investor focuses on stocks with low PE ratios, low price-to-book values, and historically high dividend yields. Conversely, a growth investor looks for stocks with above-average price-to-earnings ratios. Therefore, a stock with an above average price-to-earnings ratio would be least attractive or suitable for this investor."
    },
    {
       "id":39327,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A married couple expresses having an investment objective of long-term growth. They have a joint account and mutually agree that they are willing to accept a reasonable amount of risk.  Which type of mutual fund is the most suitable for them given their objective and risk tolerance?",
       "choice_a":"Common stock fund",
       "choice_b":"Money market fund",
       "choice_c":"Corporate bond fund",
       "choice_d":"Municipal bond fund",
       "correct_answer":"A",
       "explanation":"Of these broad fund categories offered, and given their willingness to accept a reasonable amount of risk, only a common stock fund could be expected to meet their long-term growth objective and would therefore be the most suitable."
    },
    {
       "id":39328,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Among factors to be discussed with clients pertaining to suitability, which of the following pairs would always be included?",
       "choice_a":"Liquidity preferences and number of dependents",
       "choice_b":"Professional licenses or designations and education level",
       "choice_c":"Income and languages spoken",
       "choice_d":"Eligibility for employment bonuses and monthly expenses",
       "correct_answer":"A",
       "explanation":"Regarding suitability a number of factors would be considered but they would primarily have to do with investment needs and objectives, risk tolerance and financial ability. The only pair noted above that would be relevant to these is the preference or need for liquidity and the number of dependents lending to one\u2019s financial abilities and responsibilities."
    },
    {
       "id":39329,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client profile can be summed up as follows; safety of principal, tax-free income and the need for liquidity. Of the following which would be the most suitable?",
       "choice_a":"Short-term municipal bond mutual fund",
       "choice_b":"High-yield dividend income mutual fund",
       "choice_c":"Income bonds",
       "choice_d":"Exploratory oil and gas DPP",
       "correct_answer":"A",
       "explanation":"Only the short-term municipal bond mutual fund would meet all three investment criteria. A mutual fund is liquid, municipal bond portfolios are relatively safe, and the bonds provide income free from federal tax. High-yield income funds usually invest in lower rated bonds to achieve a higher yield, income bonds only pay interest if the company can afford to meet the obligation, and exploratory oil & gas programs carry a high degree of risk."
    },
    {
       "id":39330,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Consider the following customer profile; joint account, married, ages 44 and 47, combined annual income of  $280,000, residents of Florida. With a conservative risk tolerance, they have been heavily invested in bonds up to this point. They are now willing to move outside their traditional comfort zone and accept higher risk to invest $150,000 of their $3,000,000 portfolio in a fund that will provide additional diversification and specifically offer a possible hedge against the effects of inflation. Which of the following mutual funds is the most suitable for this account?",
       "choice_a":"International equity opportunities fund",
       "choice_b":"Tax-free Florida State municipal bond fund",
       "choice_c":"Tax-free Florida State municipal bond fund",
       "choice_d":"US Treasury income fund",
       "correct_answer":"A",
       "explanation":"Investment in an international equity fund will not only provide diversification to a portfolio already heavily invested in bonds, but will also provide a potential hedge against U.S. inflation. The remaining choices all invest in debt securities that are generally not a suitable hedge against inflation. Nor would they add diversification to the aforementioned existing portfolio."
    },
    {
       "id":39331,
       "topic_id":3,
       "practice_test_id":"",
       "question":"You have a corporate client with the intention of investing a large sum and prefers a managed fund. The objective is simple; current income. The corporate charter allows for moderate risk. Given the profile which of the following would be suitable?",
       "choice_a":"Preferred stock fund",
       "choice_b":"Aggressive growth fund",
       "choice_c":"Money market fund",
       "choice_d":"High-yield bond fund",
       "correct_answer":"A",
       "explanation":"Preferred stock generates current income in the form of dividends and would thus be suitable here. The other choices would have to be eliminated as follows; aggressive growth funds strive for capital appreciation rather than current income, money market funds have low yields that would not align with the yields an income investor would seek, and while high-yield bonds would provide current income, they entail too high a degree of risk."
    },
    {
       "id":39332,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A client expresses that she wants the investment objective for a small $20,000 investment she wants to add to her portfolio to be income. She notes that the income stream should be reliable. She suggests four investments she thinks might be worth taking a look at. Of the four she suggests you would immediately point out that one of them is not suitable to meet her objective. Which is it?",
       "choice_a":"Income bonds",
       "choice_b":"U.S. Treasury notes",
       "choice_c":"Preferred stock",
       "choice_d":"Corporate bonds",
       "correct_answer":"A",
       "explanation":"Remember that income bonds, also known as adjustment bonds, pay interest only if the issuer has enough earnings to make those payments. They are often issued by companies coming out of bankruptcy and therefore could never be suitable for someone who has an income investment objective, particularly for someone who wants that income stream to be considered reliable."
    },
    {
       "id":39333,
       "topic_id":3,
       "practice_test_id":"",
       "question":"You are asked to make a recommendation to a client who notes having a moderate-risk tolerance. She is seeking long-term capital gains and places a high value on professional and active management to maximize potential returns. Which of the following would be best suited to her investment profile?",
       "choice_a":"Large-cap growth fund",
       "choice_b":"S&P 500 Index fund",
       "choice_c":"International index fund",
       "choice_d":"Small-cap growth fund",
       "correct_answer":"A",
       "explanation":"A large-cap growth fund is the most appropriate choice for a moderate-risk client because large capitalization stocks are generally less volatile than small capitalization stocks and generally seek to provide long-term capital growth. This is a more suitable choice than either of the index funds because those are not actively managed but invest instead to always align with the index."
    },
    {
       "id":39334,
       "topic_id":3,
       "practice_test_id":"",
       "question":"If a client is in a low tax bracket and wishes to invest only a moderate sum to gain some protection from inflation, which of the following would you offer as a suitable recommendation?",
       "choice_a":"Mutual fund with a growth objective investing in mid-cap companies.",
       "choice_b":"Municipal bond unit investment trust offering tax advantages.",
       "choice_c":"Money market mutual fund offering protection of principal.",
       "choice_d":"GNMA fund offering monthly dividends.",
       "correct_answer":"A",
       "explanation":"Historically, equities provide greater protection from inflation than debt securities do. Growth funds invest primarily in equities. Note that all of the remaining choices invest in debt securities."
    },
    {
       "id":39335,
       "topic_id":3,
       "practice_test_id":"",
       "question":"For a small portion of a $700,000 investment portfolio a client is comfortable seeking a fund with capital appreciation as its investment objective. Which of the following would meet that objective?",
       "choice_a":"Specialized fund investing primarily in the healthcare industry.",
       "choice_b":"Income fund investing primarily in high rated corporate bonds.",
       "choice_c":"Municipal bond fund investing only in Georgia State municipal bonds.",
       "choice_d":"Balanced fund actively managed to align with expected near term market conditions.",
       "correct_answer":"A",
       "explanation":"The objective of capital appreciation is most likely realized by an equity fund. Of the choices offered only a specialized fund would have such an objective. These are funds that invest in stocks of one particular industry or region."
    },
    {
       "id":39336,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A customer expresses the desire to collect regular dividends, wants a high degree of safety for the principal amount he intends to invest at this time and is seeking something that might offer tax advantages for someone like himself in a high-income tax bracket. Which of the following funds might be most suitable?",
       "choice_a":"Municipal bond fund",
       "choice_b":"Corporate bond fund",
       "choice_c":"Money market fund",
       "choice_d":"Aggressive growth fund",
       "correct_answer":"A",
       "explanation":"Of the choices offered, only the municipal bond fund could offer any tax advantages because interest received from the bonds is generally exempt from federal income tax. Regarding safety, a municipal bond fund satisfies that objective as well as they are generally considered second only to U.S. government securities. All of the funds shown could meet the dividend criteria."
    },
    {
       "id":39337,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client expresses a goal to utilize funds he currently holds for a specific purpose in 5 to 7 years. Because he knows what his timeline is and currently has the funds in hand, he notes a very conservative / risk averse tolerance for this investment. As an after-thought he mentions that some type of investment with a stated maturity or expiration date is probably what he is envisioning but not something that would preclude divesting earlier if needed. Which of the following investment vehicle groups might be suitable to begin a conversation focusing on his needs, timeline and criteria?",
       "choice_a":"Treasury bonds, unit investment trusts and corporate bonds",
       "choice_b":"Treasury bills, hedge funds and specialized funds",
       "choice_c":"Listed options, exchange traded equity funds and major market index mutual funds",
       "choice_d":"Treasury bills, municipal bonds and variable annuities",
       "correct_answer":"A",
       "explanation":"Of the groupings shown, only Treasury bonds, unit investment trusts and corporate bonds could each meet this investor\u2019s criteria. Each of these has a stated maturity but can also be divested of earlier if need be. Given the stated maturity dates each could be selected to accommodate the specified time line noted and each can be chosen to align with the client\u2019s risk-averse criteria. For example, choosing AAA rated corporate bonds or a UIT that invests solely in government or AAA rated corporate debt instruments. Within the remaining groupings at least one selection within each of them would violate one or more of the investors stated criteria."
    },
    {
       "id":39338,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client notes that a few years ago debt securities tended to do well relative to the overall market but last year equities soared. While he isn\u2019t prepared to pick individual stocks or bonds himself, he asks if there are any investments relying on the expertise of others to do that and where he can rely on them to adjust the portfolio in accordance with future market expectations. Given his investment criteria you might best recommend?",
       "choice_a":"a balanced fund.",
       "choice_b":"a hedge fund.",
       "choice_c":"a specialized fund.",
       "choice_d":"an aggressive growth fund.",
       "correct_answer":"A",
       "explanation":"Balanced funds invest in both stocks and bonds. Fund managers attempt to adjust the percentage invested in the two types of securities in accordance with market expectations in order to maximize the yield obtained. The percentages invested in each class of security are not mandated by industry regulation and are therefore at the discretion of the fund manager."
    },
    {
       "id":39339,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor\u2019s primary objective is to choose a mutual fund where dividends paid into the portfolio can be expected regardless of current market conditions. She also notes capital growth as being a reasonable secondary objective for her, given her risk tolerance. If recommending a mutual fund to this investor, which of the following industry groups would best fulfill her criteria?",
       "choice_a":"Public utilities",
       "choice_b":"Military contractors",
       "choice_c":"Blockchain technology",
       "choice_d":"Consumer retail",
       "correct_answer":"A",
       "explanation":"Utilities are defensive industries meaning that they tend to perform with some consistency regardless of market conditions. While capital growth is a reasonable expectation for utilities, their payment of dividends is historically consistent, fulfilling the investor\u2019s investment criteria."
    },
    {
       "id":39340,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A client expresses an interest in investing in a portfolio that is fixed using municipal or corporate bonds. He prefers an investment with no, or limited active management so as to avoid high expense ratios. Which of the following would be a suitable recommendation?",
       "choice_a":"A unit investment trust holding debt instruments.",
       "choice_b":"A growth fund investing primarily in new issues.",
       "choice_c":"A utilities fund paying high dividends.",
       "choice_d":"An exchange traded fund for the purpose of allowing quick liquidation.",
       "correct_answer":"A",
       "explanation":"Of the options shown only a unit investment trust offers a portfolio with no, or limited active management. A unit investment trust issues shares that represent units of a fixed portfolio; one that is not actively traded."
    },
    {
       "id":39341,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A growth investment is best described as being one where:",
       "choice_a":"the value of the investment will increase over time.",
       "choice_b":"the principal and dividends will increase over time.",
       "choice_c":"any investment appreciation will be tax-deferred.",
       "choice_d":"all interest and dividends received will be reinvested.",
       "correct_answer":"A",
       "explanation":"Growth is simply the increase in an investment\u0027s value over time. Remember that interest and dividends received, whether reinvested or not, represent income, not growth."
    },
    {
       "id":39342,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor\u2019s portfolio consists of 50% blue-chip stocks (i.e., IBM, GM) and 50% growth stocks (i.e., AMZN, MSFT). This portfolio can best be described as:",
       "choice_a":"a growth and income portfolio.",
       "choice_b":"an aggressive growth portfolio.",
       "choice_c":"a high-yield income portfolio.",
       "choice_d":"a balanced portfolio.",
       "correct_answer":"A",
       "explanation":"A growth and income portfolio typically combines equities. More conservative blue-chip securities are used for their price stability, lending to capital preservation and payment of dividends for income, along with growth stocks for their appreciation potential. An aggressive portfolio contains securities of smaller companies that might have the potential for significant capital appreciation but may not provide much income. A high-yield income portfolio lends itself to lower rated debt securities and a balanced portfolio invests in both stocks and bonds."
    },
    {
       "id":39343,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new client comes to you with an existing investment portfolio that is 45% growth stocks, 10% foreign stocks and 45% income producing stocks. She tells you she is satisfied with its performance so far but might be open to some diversification using a mutual fund or exchange traded fund. She has a moderate risk tolerance. Which of the following would best accommodate her objective to diversify?",
       "choice_a":"Corporate bond fund",
       "choice_b":"Emerging markets fund",
       "choice_c":"Global equity growth fund",
       "choice_d":"Domestic growth and income fund",
       "correct_answer":"A",
       "explanation":"All of the client\u2019s current investments are in equities. The portfolio holds income stocks, growth stocks and foreign equity securities, but what is missing are debt securities. If the objective is to further diversify the current portfolio, the corporate bond fund would be the best choice of those shown."
    },
    {
       "id":39345,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new client insists that whatever the individual securities, equities or debt, he wants to invest in managed portfolios. He notes that it is very important to him that a portfolio is being monitored and amended to meet market expectations. Given the stated criteria, which of the following would not be suitable?",
       "choice_a":"Unit investment trusts",
       "choice_b":"Open-end mutual funds",
       "choice_c":"Closed-end mutual funds",
       "choice_d":"Exchange traded funds",
       "correct_answer":"A",
       "explanation":"The Investment Company Act of 1940 defines closed and open-end funds as subclassifications of management companies; actively managed portfolios. So too are exchange traded funds. Unit investment trusts however are separate investment company classifications and do not have managed portfolios. Therefore, they would not be suitable to meet this investor\u2019s criteria."
    },
    {
       "id":39346,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A new client expresses that being able to get into and out of investments easily and quickly is important to her. She begins to talk about several investment types but you point out that two of them would not be suitable given her stated criteria. Which two are they?",
       "choice_a":"Unit investment trusts and open-end mutual funds",
       "choice_b":"Real estate investment trusts and exchange traded funds",
       "choice_c":"Exchange listed equities and closed-end funds",
       "choice_d":"Exchange traded funds and corporate bonds",
       "correct_answer":"A",
       "explanation":"Closed-end funds, exchange traded funds, listed equities, corporate bonds and real estate investment trusts trade actively in the secondary market. Open-end mutual funds and unit investment trusts do not trade in the secondary market making them unsuitable given this investor\u2019s stated criteria."
    },
    {
       "id":39347,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client is considering investing in preferred shares of a company but is concerned with inflation risk. Which preferred stock feature if available would make the issue more suitable given his concern?",
       "choice_a":"Convertible",
       "choice_b":"Callable",
       "choice_c":"Cumulative",
       "choice_d":"Noncumulative",
       "correct_answer":"A",
       "explanation":"Some investments are subject to inflation risk; bonds and preferred shares which make fixed interest or dividend distributions among them. The ability to convert to common stock helps to mitigate inflation risk because common shares are more likely to keep pace with inflation."
    },
    {
       "id":39348,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client with a well-balanced portfolio of both equity and debt securities wants to diversify allocating roughly 10% to real estate. He is concerned however about real estate being illiquid. Given this concern, which of the following real estate investments is most suitable?",
       "choice_a":"Purchasing shares of a real estate investment trust.",
       "choice_b":"Investing in a real estate limited partnership.",
       "choice_c":"Purchasing a small commercial retail building",
       "choice_d":"Purchasing a residential condominium to lease out.",
       "correct_answer":"A",
       "explanation":"Shares of a real estate investment trust (REIT) are best suited to the client because they trade in the secondary market making them easily divested of. None of the other options shown are considered liquid or easily divested of."
    },
    {
       "id":39349,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor adamant that his investments be liquid is considering investing in American depositary receipts (ADRs). He is familiar and comfortable with all of the risks associated with investing in foreign companies. Considering his concerns about liquidity though, such an investment would:",
       "choice_a":"be suitable because shares of ADRs, whether listed on a US exchange or unlisted, trade freely in US markets.",
       "choice_b":"be suitable because they are only subject to market risk as is any security that trades freely in the open market.",
       "choice_c":"be unsuitable because the potential receipt of dividends in a foreign currency makes them subject to currency risk.",
       "choice_d":"be unsuitable given they represent ownership in a foreign entity making them subject to political risk.",
       "correct_answer":"A",
       "explanation":"American depositary receipts (ADRs) may be unsuitable for investors who are averse to political, currency, or market risk in general. However, if the investors only risk aversion has to do with liquidity, they would be deemed suitable because shares trade freely on US exchanges or in over the counter markets."
    },
    {
       "id":39350,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Your client, who is in a high-income tax bracket and has a high net worth mentions several investments that she is thinking about that might be beneficial to her. Obviously, she is concerned about any tax consequences. Considering her profile, of the investments she\u2019s spoken about which of the following would be the most suitable recommendation?",
       "choice_a":"Low yielding municipal bonds",
       "choice_b":"High yielding non-investment-grade corporate bonds",
       "choice_c":"An exchange traded fund investing in blockchain technolog",
       "choice_d":"A real estate investment trust",
       "correct_answer":"A",
       "explanation":"Of the choices shown only municipal bonds offer a tax consequence that lends itself to being more suitable for high income, high net worth investors; tax-free interest payments. Conversely, corporate bond interest, ETF dividends and income from real estate investment trusts are all taxable."
    },
    {
       "id":39351,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Your customer prefers investments that are short term and liquid because he sometimes needs unanticipated access to funds for cash flow purposes to run his business. He\u2019s considering auction rate securities given the higher rates of return he can realize with them as opposed to those offered by Treasury securities he is now holding in his account. For this customer auction rate securities would be:",
       "choice_a":"unsuitable because they are variable rate bonds with 20 to 30-year maturities and are therefore intended to be held long-term.",
       "choice_b":"unsuitable because interest rates are reset at predetermined intervals, typically weekly or monthly.",
       "choice_c":"suitable given that the rate of return is guaranteed short-term and reset over predetermined intervals going forward.",
       "choice_d":"suitable because they are short-term bonds and completely liquid at all times.",
       "correct_answer":"A",
       "explanation":"Auction rate securities (ARSs) are long-term variable rate bonds and therefore not suitable for an investor favoring short-term investments. These securities however are tied to short term interest rates which are reset at predetermined intervals using a Dutch auction system. A lack of demand for the securities can perpetuate a failed auction and until that can be rectified immediate access to funds can be limited, another reason they would not be suitable for this investor."
    },
    {
       "id":39352,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Your client who has a high net worth and substantial income is interested in debt securities with favorable tax consequences. His investor profile however shows an aversion to credit risk which you must consider before making any tax favored investment recommendations. Which of the following would not be a suitable recommendation for this client?",
       "choice_a":"Industrial revenue bonds",
       "choice_b":"General obligation bonds",
       "choice_c":"New housing authority bonds",
       "choice_d":"US treasury securities",
       "correct_answer":"A",
       "explanation":"Industrial revenue bonds are a form of municipal security which are issued to build or support facilities that the municipality then leases, generally to a corporate entity. Like most municipals they offer favorable tax consequences for those in high income tax brackets or with a high net worth. However, they represent high credit risk (therefore not suitable for this investor) because the debt service is the responsibility of the corporation leasing the facility supported by the bonds, rather than the responsibility of the issuing municipality."
    },
    {
       "id":39353,
       "topic_id":3,
       "practice_test_id":"",
       "question":"As a registered municipal bond representative for your broker-dealer you have been given discretion over the account of a physician residing in New York. The client profile shows that he is conservative, avoids investment risk, and seeks long-term growth potential. Of the following choices, which would you deem to be the most suitable to include in the physician\u2019s portfolio?",
       "choice_a":"New York transit authority revenue bonds rated Aa.",
       "choice_b":"Iowa revenue bonds rated AA.",
       "choice_c":"California high-yield municipal bonds rated BB.",
       "choice_d":"Maryland Wetlands general obligation municipal bonds rated Aa.",
       "correct_answer":"A",
       "explanation":"The Iowa revenue bonds, the sub-investment grade California bonds, and the Maryland bonds have possible state disadvantages for a purchaser residing in New York. Additionally, two of them are less than investment grade. Of these choices, the in-state New York issued bonds rated Aa would be the most suitable."
    },
    {
       "id":39354,
       "topic_id":3,
       "practice_test_id":6,
       "question":"A registered representative is making a recommendation to include municipal bonds in a customer\u2019s portfolio. Assuming the representative is well acquainted with the client\u2019s investment profile including risk tolerance, which of the following would be of least consideration regarding suitability when making a recommendation?",
       "choice_a":"What purpose the funds are being raised for.",
       "choice_b":"The customer\u0027s local municipality and state of residence.",
       "choice_c":"The customer\u0027s income, tax bracket and net worth.",
       "choice_d":"How the bonds are currently rated by Moody\u0027s.",
       "correct_answer":"A",
       "explanation":"The purpose for which the funds are being raised may be of interest to the client but it would generally be of little consideration regarding suitability when making a recommendation. However, the client\u0027s residence and financial profile, including income, net worth and tax bracket factor into suitability as these will help determine the extent of the tax benefits offered by the municipal bond. The bond\u0027s rating is important in evaluating the credit risk assumed by the investor and should align with the investor\u2019s risk tolerance."
    },
    {
       "id":39355,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client\u2019s profile shows a moderate risk tolerance in general but little or no tolerance for default or credit risk. Given this preference to avoid such risk, which of the following choices would be deemed most suitable for such an investor?",
       "choice_a":"Municipal general obligation bonds.",
       "choice_b":"Municipal revenue bonds.",
       "choice_c":"High-yield corporate “junk” bonds.",
       "choice_d":"Convertible corporate debentures.",
       "correct_answer":"A",
       "explanation":"The full taxing power of a municipality backs a general obligation municipal bond lending to it being the choice shown having the least amount of credit or default risk. Taxing power does not back municipal revenue bonds. Corporate debentures which are unsecured, and \u201Cjunk\u201D or high-yield corporate bonds each have a greater or inherently high degree of risk."
    },
    {
       "id":39356,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new client has transferred her account and all of its holdings to your broker-dealer. While getting to know her and constructing a client profile, she mentions wanting to add some municipal bonds to her portfolio because she feels her income and tax bracket warrants doing so. All of the following should be used to determine the suitability of any municipal recommendations you might make except the:",
       "choice_a":"customer\u0027s marital status and number of dependents.",
       "choice_b":"customer\u0027s annual income and tax bracket.",
       "choice_c":"customer\u0027s state and local municipal residence.",
       "choice_d":"structure of the customer\u0027s existing portfolio.",
       "correct_answer":"A",
       "explanation":"While a customer\u2019s marital status and number of dependents are a part of a customer\u2019s profile, they would not be critical factors when assessing municipal bond recommendations being suitable. When recommending municipal bonds and determining suitability, a registered representative should consider the customer\u0027s tax bracket, state of residence, recognizing that intrastate issues may be double or triple tax exempt, and existing portfolio structure; debt holdings versus equity holdings and whether municipal issues are already being held."
    },
    {
       "id":39357,
       "topic_id":3,
       "practice_test_id":"",
       "question":"One of your clients is considering purchasing a bond. He has narrowed the selection down to either a 2% yielding municipal bond offered by the state he lives in, or a 4.5% yielding corporate bond.  He\u2019s at a loss as to how to determine which one would actually give him the greatest return for his investment. While many profile items would factor into suitability, one is critical for you to do the required calculation needed to answer his specific question. Which is it?",
       "choice_a":"His current tax bracket.",
       "choice_b":"His length of residency in the municipal issuers state.",
       "choice_c":"His current portfolio holdings.",
       "choice_d":"His current net worth.",
       "correct_answer":"A",
       "explanation":"In order to make the most suitable recommendation, you must do a tax-equivalent yield (corporate) or tax-free equivalent yield (municipal) calculation. For either formula you need the investor\u0027s tax bracket. Current portfolio holdings and net worth, while factoring into suitability, have no bearing on the calculation. Nor would the length of time he\u2019s resided in the state."
    },
    {
       "id":39358,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client, you are well familiar with, wants to add municipal bonds to his portfolio. You are making a recommendation you feel is suitable; the purchase of a State of Texas General Obligation bond yielding 2.8%. While a number of items concerning both the client and the security would have been needed to be considered to make the recommendation a suitable one, which of the following would not have been?",
       "choice_a":"The municipality\u0027s coverage ratio.",
       "choice_b":"The clients state of residence.",
       "choice_c":"The client\u0027s tax bracket.",
       "choice_d":"The general obligation bonds rating.",
       "correct_answer":"A",
       "explanation":"The customer\u0027s state of residence and tax bracket are always factors determining suitability for a municipal bond recommendation. The bond\u0027s rating is equally important because it should align with the investors risk tolerance. The coverage ratio is specific to revenue bonds (not GO bonds) and tells how many times annual revenue from the bond issue will cover the debt service of the issue. It is not a factor of suitability to be considered when recommending a general obligation municipal bond. Primarily it is used when comparing two municipal revenue bonds."
    },
    {
       "id":39359,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client profile shows a strong aversion to market risk. Considering this factor alone, which of the following debt issues would likely exhibit the least market risk and therefore be the most suitable recommendation for this client\u2019s portfolio?",
       "choice_a":"Revenue anticipation notes.",
       "choice_b":"Corporate bonds with long-term maturities.",
       "choice_c":"Municipal bonds with long-term maturities.",
       "choice_d":"AAA corporate debentures.",
       "correct_answer":"A",
       "explanation":"Market risk for debt securities is the risk that price will fluctuate during the time left to maturity.Of the choices shown, municipal revenue anticipation notes have the shortest term, which gives them the least market risk. If the aversion to market risk is the only consideration, of the choices shown, these would be the most suitable recommendation for this client\u2019s portfolio."
    },
    {
       "id":39360,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new client in her early 40\u2019s notes that she is finally ready to consider tax deferred growth as an objective for a sum of cash she has been setting aside specifically for retirement income. Up to this point in time she has been diligent in funding an IRA each year and contributes as much as is allowed to her employer\u2019s 401k plan. Which of the following would be the most suitable for meeting her objective?",
       "choice_a":"A variable annuity",
       "choice_b":"AAA rated corporate bond",
       "choice_c":"Tax-free municipal bond",
       "choice_d":"Growth & income mutual fund",
       "correct_answer":"A",
       "explanation":"The only investment listed here offering tax-deferred growth and suitable for achieving supplemental retirement income outside of her IRA and 401k is a variable annuity. Ideally, VAs should be funded with readily available cash rather than using funds liquidated from existing investments."
    },
    {
       "id":39361,
       "topic_id":3,
       "practice_test_id":6,
       "question":"Given the following client profiles, for which might a variable annuity be a suitable recommendation?",
       "choice_a":"Age 51, with cash available and no anticipated need to access the funds until retirement.",
       "choice_b":"Age 71, retired for five years hoping to preserve capital currently invested in corporate bonds to leave to six children.",
       "choice_c":"Age 34, recently unemployed with several thousand dollars in severance pay available to invest.",
       "choice_d":"Age 29, with no need to access the funds until needed for college funding for two children beginning in roughly ten years.",
       "correct_answer":"A",
       "explanation":"Generating a supplemental income stream for retirement, not preservation of capital should be the primary objective present when considering a VA. Having cash on hand, rather than liquidating existing investments should also be a consideration for choosing a VA as suitable. Finally, for anyone who may need access to the funds invested for any reason other than supplementing retirement income, a VA would not be considered a suitable recommendation."
    },
    {
       "id":39363,
       "topic_id":3,
       "practice_test_id":"",
       "question":"One of your retail customers, uncomfortable with the recent volatile markets, suggests that she wants to invest a small sum in an inverse leveraged exchange traded fund tracking a major market index. She notes that if the market spikes downward anytime in the next month or two, she\u2019ll be positioned to realize a gain from the trade. You would correctly explain that:",
       "choice_a":"inverse leveraged exchange traded funds are considered to be non-traditional products. Additionally, FINRA has advised that these products are not suitable for retail investors intending to hold them for longer than one trading session, particularly in volatile markets.",
       "choice_b":"inverse leveraged exchange traded funds are considered to be ideal for hedging in volatile markets. Additionally, FINRA has advised that these products are most suitable for retail investors intending to hold them for longer periods of time as opposed to day trading them.",
       "choice_c":"inverse leveraged exchange traded funds are considered to be best suited for use by sophisticated investors needing to hedge large portfolios for extended periods of time. Additionally, FINRA has advised that these products were created, and therefore should be used, to offset long term volatile market exposure.",
       "choice_d":"inverse leveraged exchange traded funds were created to be used in the precise manner she intends. Additionally, FINRA has advised that these products are ideally suited for retail investors wanting to hedge volatility risk over long periods of time.",
       "correct_answer":"A",
       "explanation":"Inverse and leveraged exchange traded notes and funds are considered to be non-traditional products. FINRA has advised that NT-ETPs are not suitable for retail investors intending to hold them for longer than one trading session, particularly in volatile markets."
    },
    {
       "id":39364,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Not all products can be deemed as suitable investments for all investors. For example, FINRA has cautioned that non-traditional exchange traded products (NT-ETPs) should be used by sophisticated investors only. NT-ETPs include:",
       "choice_a":"leveraged and inverse exchange traded notes and funds.",
       "choice_b":"leveraged exchange traded notes and funds only.",
       "choice_c":"inverse exchange traded notes and funds only.",
       "choice_d":"leveraged and exchange traded notes, but not funds.",
       "correct_answer":"A",
       "explanation":"FINRA has defined non-traditional exchange traded products (NT-ETPs) to include both leveraged and inverse exchange traded notes and leveraged and inverse exchange traded funds."
    },
    {
       "id":39365,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Aligning with FINRA\u2019s suitability standards it should be understood that non-traditional exchange traded products (NT-ETPs) typically rebalance their portfolios :",
       "choice_a":"on a daily basis which is why there can be substantial risk incurred if holding them for longer than one trading session.",
       "choice_b":"on a daily basis which is why to realize any benefit they must be held over more than one trading session.",
       "choice_c":"annually which is why there should be an expectation that the holding period will be long term.",
       "choice_d":"only when deemed necessary which is why intended holding periods are not a factor to be considered when determining suitability.",
       "correct_answer":"A",
       "explanation":"Because (NT-ETPs) typically rebalance their portfolios on a daily basis, known as the daily reset, holding them for longer than a single trading session can subject investors to the effects of compounding of the daily returns. As a result, their performance over longer than a single trading session can differ significantly from the performance of the underlying index or benchmark they are intended to track."
    },
    {
       "id":39366,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new investor asks you to explain the difference regarding the standard of care that must be upheld by financial advisors and investment advisors regarding her investment account. You would correctly explain that:",
       "choice_a":"investment advisors must comply with a fiduciary standard of care while financial advisors must comply with a suitability standard and those outlined in the SEC\u0027s Regulation Best Interest.",
       "choice_b":"while their roles are different, neither acts as a fiduciary but both must comply with the SEC\u0027s Regulation Best Interest which applies a suitability standard of care.",
       "choice_c":"the SEC\u0027s Regulation Best Interest only applies to investment advisors because they are charging fees for advice and are required to pass specific licensing exams in order to do so.",
       "choice_d":"a fiduciary standard is applied to financial advisors only because there is no formal training required to act in such a capacity where charging commissions is the only form of compensation allowed.",
       "correct_answer":"A",
       "explanation":"Investment advisors must comply with a fiduciary standard of care. The SEC reaffirmed that as an investment advisor, in such a role these individuals are acting in a fiduciary capacity on behalf of their clients; giving advice for fee-based compensation. Financial advisors must comply with a suitability standard as well as the SEC\u2019s Regulation Best Interest in a capacity that allows them to charge commissions only, for buying and selling securities on behalf of clients."
    },
    {
       "id":39367,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new investor has been using the terms \u201Cfinancial advisor\u201D and \u201Cinvestment advisor\u201D interchangeably and not recognizing that there are key differences in their roles and qualifications. Understanding those differences in regards to being able to make suitable recommendations and receive compensation, which of the following is true?",
       "choice_a":"In addition to the exams a financial advisor must pass, an investment advisor must pass the Series 65; Uniform Investment Adviser Law Exam allowing the individual to offer advice in a fee-based compensation system.",
       "choice_b":"A financial advisor is an individual that, for fee-based compensation, is engaged in the business of providing advice to others. Passing the Series 6 or 7 licensing exam administered by FINRA is the only requirement.",
       "choice_c":"An investment advisor may only buy or sell securities on behalf of a client for commission-based compensation. No formal training is required other than passing the Series 63 licensing exam required by each state.",
       "choice_d":"Whether receiving fee-based or commission-based compensation an individual must pass the Series 65; Uniform Investment Adviser Law Exam. The only difference between the roles of a financial advisor and an investment advisor is defined by the type of products or services their employing firm offers.",
       "correct_answer":"A",
       "explanation":"A financial advisor buys and sells securities on behalf of a client for commission-based compensation. Passing the Series 6 or 7 licensing exam administered by FINRA and the Series 63 exam required by the state are the only requirements. In contrast, an investment advisor may charge fees for investment advice. In addition to the aforementioned licensing requirements for a financial advisor, an investment advisor must also pass the Series 65; Uniform Investment Adviser Law Exam."
    },
    {
       "id":39368,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Under examination it is determined that a registered representative made excessive and unsuitable recommendations to a client resulting in both profits and losses. It is further determined that the firm\u2019s written procedures failed to provide branch managers with adequate instructions for reviewing customer accounts to detect unsuitable trades. Consequently, such reviews were not taking place. Which of the following would apply?",
       "choice_a":"The firm, branch managers and the RR would all be found accountable and could be subject to sanctions such as censure, suspension and fines.",
       "choice_b":"The firm, branch managers and the RR would all be found accountable and subject to possible sanctions but only the firm could be fined for lack of supervision.",
       "choice_c":"The firm and the RR would be found accountable and subject to sanctions including fines but not the branch managers because they were not given adequate instructions for reviewing accounts.",
       "choice_d":"Only the branch managers would be found accountable and subject to sanctions including fines for lack of supervision over the RR.",
       "correct_answer":"A",
       "explanation":"The firm would be found liable because it failed to establish and maintain a supervisory system reasonably designed to achieve compliance with FINRA\u2019s rules on suitability and standards of commercial honor and principles of trade. The branch managers would be found liable for failure to supervise and the RR would be found liable under rules mandating suitability and that churning not occur. All could be subject to fines and other sanctions such as censure and suspension."
    },
    {
       "id":39369,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A registered representative is having an exploratory conversation with a potential new client. During the conversation and based on the information the customer offers the RR makes a securities investment recommendation. Two months later the individual becomes a client of the broker-dealer and directs the RR to go ahead and execute the commissionable transaction to purchase the security she had recommended. Which of the following is true?",
       "choice_a":"FINRA\u0027s rules on suitability apply even though the recommendation was not acted upon until the individual became a client a much later.",
       "choice_b":"FINRA\u0027s rules on suitability do not apply because the recommendation was executed as a commissionable transaction and therefore did not fall under the regulations applicable to giving investment advice.",
       "choice_c":"FINRA\u0027s rules on suitability would only apply if the recommended security execution occurs within 10 business days of the initial recommendation being made.",
       "choice_d":"FINRA\u0027s rules on suitability do not apply to conversations had with individuals who are not clients regardless of what occurs after.",
       "correct_answer":"A",
       "explanation":"When a registered representative makes a recommendation to purchase a security to a potential investor, the suitability rule would apply to the recommendation if that individual executes the transaction through the broker-dealer with which the registered representative is associated or the broker-dealer receives or will receive, directly or indirectly, compensation as a result of the recommended transaction."
    },
    {
       "id":39370,
       "topic_id":3,
       "practice_test_id":6,
       "question":"FINRA rules require that a broker-dealer or associated person have a reasonable basis to believe that a recommended transaction or investment strategy involving a security is suitable for the customer. The SEC\u2019s Reg. BI\u2019s Care Obligation addresses the same conduct with respect to retail customers that is addressed by FINRA\u2019s suitability rules, but employs a best interest, rather than a suitability, standard. Considering the above, which of the following is true?",
       "choice_a":"Broker-dealers are held to both the suitability standards of FINRA\u0027s rules and the best interest application of the SEC\u0027s Reg. BI.",
       "choice_b":"Broker-dealers are held only to the suitability standards of FINRA\u0027s rules.",
       "choice_c":"Broker-dealers are held only to the best interest application outlined in the SEC\u0027s Reg. BI.",
       "choice_d":"Broker-dealers are given the option to be accountable under either FINRA\u0027s suitability rules or to apply the SEC\u0027s Reg. BI\u0027s best interest standard depending on which is best suited to their business model; customer base and the types of securities offered.",
       "correct_answer":"A",
       "explanation":"Broker-dealers are held to both the standards of FINRA\u2019s rule addressing suitability (Rule 2111) and the care obligation outlined in the SEC\u2019s Reg. BI."
    },
    {
       "id":39371,
       "topic_id":3,
       "practice_test_id":"",
       "question":"To ensure that suitable recommendations are being made by registered personnel, broker-dealers must establish, maintain, and enforce written policies and procedures reasonably designed to identify and eliminate sales contests, quotas, bonuses, or non-cash compensation that are based on the sales of specific securities or specific types of securities within a limited time period. Not doing such is a violation of:",
       "choice_a":"Regulation Best Interest (Reg. BI).",
       "choice_b":"Regulation D.",
       "choice_c":"Regulation A.",
       "choice_d":"Securities Exchange Act of 1934.",
       "correct_answer":"A",
       "explanation":"While the SEC adopted Reg. BI under the Securities Exchange Act of 1934, Reg BI specifically establishes a \u201Cbest interest\u201D standard of conduct for broker-dealers and associated persons when they make a recommendation to a retail customer. Additionally, it addresses the arrangements noted above under the conflict-of-interest obligation for broker-dealers."
    },
    {
       "id":39653,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor is 60 years old and has the following asset allocation: <img src='/question_assets/series66/39653-1.png'></img> After a discussion with his registered representative the customer changes his allocation as follows:  <img src='/question_assets/series66/39653-2.png'></img> Which of the following is correct with regard to the change in the investor\u2019s portfolio?",
       "choice_a":"Political risk has increased, credit risk has decreased",
       "choice_b":"Reinvestment risk has increased, systematic risk has increased",
       "choice_c":"Political risk has increased, interest rate risk has decreased",
       "choice_d":"Purchasing power risk has increased, systematic risk has increased",
       "correct_answer":"C",
       "explanation":"The investor has increased the political risk of the portfolio by allocating a greater percentage of his assets to emerging markets. Emerging markets are based in lesser developed foreign countries which tend to have a greater degree of political instability. The investor also substantially reduced the portion of the portfolio in long term bonds. As a result the investor has lowered his interest rate risk. The investor was not subject to a substantial amount of credit risk as the bonds were all AAA corporate bonds and government bonds."
    },
    {
       "id":39654,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client\u2019s investment portfolio is as follows: <img src='/question_assets/series66/39654-1.png'></img> After a discussion with his registered representative, over several weeks the investments are reallocated as follows:  <img src='/question_assets/series66/39654-2.png'></img> Which of the following best reflects the changes made?",
       "choice_a":"Both interest rate and liquidity risk have been lessened, market risk is higher.",
       "choice_b":"Interest rate risk is lower, liquidity risk is higher, market risk is lower.",
       "choice_c":"Interest rate risk, market risk and liquidity risk are all higher.",
       "choice_d":"Interest rate risk, market risk and liquidity risk have all been lessened.",
       "correct_answer":"A",
       "explanation":"The new allocation lowers interest rate risk given the smaller portion in long term bonds, both government and corporate. Liquidity risk has been lowered as well, moving from commercial real estate (real property is generally considered less liquid), to REITs which are marketable securities and liquid. A larger allocation to US equities raises market risk."
    },
    {
       "id":39655,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client\u2019s investment portfolio is as follows: <img src='/question_assets/series66/39655-1.png'></img> She meets with her registered representative and agrees to the following reallocation: <img src='/question_assets/series66/39655-2.png'></img> Which of the following best reflects the changes made?",
       "choice_a":"Market risk, and reinvestment risk have decreased.",
       "choice_b":"Market risk has decreased, reinvestment risk is higher.",
       "choice_c":"Market risk has increased, reinvestment risk is lower.",
       "choice_d":"Market risk, and reinvestment risk have increased.",
       "correct_answer":"D",
       "explanation":"Market risk has increased with a larger portion of the portfolio in US equities, and moving from noncallable to callable bonds increases reinvestment risk, as callable bonds are likely to be called when interest rates are falling, leaving the investor challenged to find equal returns for the funds if they are to be reinvested."
    },
    {
       "id":39656,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client tells you that given he is now age 55 he thinks he\u2019s becoming a bit more intolerant of market risk. His current portfolio has the following allocations: <img src='/question_assets/series66/39656-1.png'></img> The client suggests reallocating as follows: <img src='/question_assets/series66/39656-2.png'></img> If the client\u2019s reallocation suggestion were to be followed, would he have generally attained his goal of having less market risk?",
       "choice_a":"Yes, market risk and interest rate risk have both decreased.",
       "choice_b":"Yes, market risk has decreased and he\u0027s added to liquidity.",
       "choice_c":"No, nothing has been done to decrease interest rate risk.",
       "choice_d":"No, nothing has been done to add to liquidity",
       "correct_answer":"B",
       "explanation":"Yes, the suggested portfolio would incur less risk as follows; market risk decreases with a smaller US equities allocation. Additionally, money market funds and more cash are obviously less risky than hedge funds and much more liquid."
    },
    {
       "id":39657,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client in his early thirties expresses the desire to \u201Cget this conservative portfolio moving\u201D. Currently his investments are as follows: <img src='/question_assets/series66/39657-1.png'></img> He works with his registered representative over several weeks to reconstruct the portfolio as follows: <img src='/question_assets/series66/39657-2.png'></img> Which of the following best characterizes the risks associated with his new portfolio?",
       "choice_a":"Interest rate risk is lower, and market risk and legislative risk are higher.",
       "choice_b":"Interest rate risk, market risk and legislative risk are higher.",
       "choice_c":"Interest rate risk, market risk and legislative risk are lower.",
       "choice_d":"Interest rate risk and market risk are lower, and legislative risk is higher.",
       "correct_answer":"A",
       "explanation":"Interest rate risk has decreased given the smaller T-bond allocation. Market risk has increased given the new allocations to a growth fund, crypto currency and digital assets. Additionally, legislative risk has increased given the new investments in crypto currency and digital assets as these are currently unregulated markets with potential regulations likely to occur."
    },
    {
       "id":39658,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A young client\u2019s portfolio, mostly inherited from his grandfather, is structured as follows: <img src='/question_assets/series66/39658-1.png'></img> His registered representative suggests the following allocation: <img src='/question_assets/series66/39658-2.png'></img> Primarily, the suggested new allocation does which of the following:",
       "choice_a":"Diversification is greater, market risk is greater and credit risk has been decreased.",
       "choice_b":"Diversification is unaffected, market risk and credit risk are both greater.",
       "choice_c":"Diversification is unaffected, market risk and credit risk are both lower",
       "choice_d":"Diversification has been lessened, market risk is lower and credit risk has been increased.",
       "correct_answer":"A",
       "explanation":"Credit risk, the risk of losing principal due to the failure of the issuer, is greatly lessened given the much lower allocations to single stocks. Overall diversification is increased with the addition of the two equity funds (S&P index and Wilshire) as well as the two bond funds (government and corporate). With the diversification however, comes a greater exposure to market risk; the risk of losing principal due to volatility in the markets."
    },
    {
       "id":39659,
       "topic_id":3,
       "practice_test_id":6,
       "question":"The portfolio of a client, age 46 is as follows: <img src='/question_assets/series66/39659-1.png'></img> After expressing his amended investment objectives to his registered representative, it is agreed to reallocate the portfolio in the following way: <img src='/question_assets/series66/39659-2.png'></img> Which of the following best characterizes the changes in risk associated with the new allocation?",
       "choice_a":"Interest rate risk and market risk are higher, while purchasing power risk is lower.",
       "choice_b":"Interest rate risk, market risk and purchasing power risk are all higher.",
       "choice_c":"Interest rate risk, market risk and purchasing power risk are all lower.",
       "choice_d":"Interest rate risk and market risk are lower, while purchasing power risk is higher.",
       "correct_answer":"D",
       "explanation":"Interest rate risk has been decreased due to the smaller allocation in long-term Treasury securities. So too has market risk been decreased given the reduction in growth mutual funds. Purchasing power risk has increased substantially with the addition of the fixed annuity. The fixed payments lend themselves to being worth less as prices of goods and services increase over time; inflation."
    },
    {
       "id":39660,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor has a small portfolio that he characterizes as being strictly for the purpose of  speculation. It is structured as follows: <img src='/question_assets/series66/39660-1.png'></img> He amends the portfolio as follows: <img src='/question_assets/series66/39660-2.png'></img> Which of the following has been accomplished?",
       "choice_a":"Business risk has been reduced, while a small portion of capital risk has been incurred.",
       "choice_b":"Purchasing power has been increased, while a small portion of capital risk has been incurred.",
       "choice_c":"Reinvestment risk has been reduced, while a small portion of capital risk has been lessened.",
       "choice_d":"Political risk has been increased, while a small portion of capital risk has been lessened.",
       "correct_answer":"A",
       "explanation":"The investor chose to hedge downside risk in each of his equity positions by purchasing puts on those stocks. Hedging the downside risk primarily reduced his exposure to business risk in these positions; generally defined as an operating risk due to poor management decisions. The fewer the positions that are held in a portfolio, the higher the business risk will be. Hedging those positions reduces the risk. Long options are generally associated with capital risk; the risk of losing all of the dollars invested. The low percentage allocated to the options positions increases capital risk slightly."
    },
    {
       "id":39661,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor\u2019s portfolio is structured as follows: <img src='/question_assets/series66/39661-1.png'></img> He decides he wants to diversify by investing in a few foreign companies. To accomplish that he amends the portfolio as follows:  <img src='/question_assets/series66/39661-2.png'></img>  Which of the following best characterizes the changes made?",
       "choice_a":"Currency risk is increased, while interest rate risk and credit risk are decreased.",
       "choice_b":"Currency risk, interest rate risk and credit risk are all decreased.",
       "choice_c":"Currency risk, interest rate risk and credit risk are all increased.",
       "choice_d":"Currency risk and interest rate risk are increased, while credit risk is decreased.",
       "correct_answer":"A",
       "explanation":"The purchase of ADRs representing the shares of foreign companies introduces currency risk to the portfolio. Dividends paid by foreign companies are paid in the currency of the country of origin. The necessary conversion to US dollars at a time that may or may not be favorable is the risk. The corporate bond and Treasury fund positions having both been reduced lowers interest rate risk associated with fixed income securities. Finally, because the corporate bonds were BB rated, a small amount of credit risk was eliminated by the reduction in that position."
    },
    {
       "id":39662,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor\u2019s portfolio is as follows: <img src='/question_assets/series66/39662-1.png'></img> She opts to amend her investments as follows: <img src='/question_assets/series66/39662-2.png'></img> Which of the following best characterizes what has occurred with the portfolio changes?",
       "choice_a":"Interest rate risk and liquidity have both been reduced.",
       "choice_b":"Interest rate risk is reduced while liquidity is unaffected.",
       "choice_c":"Interest rate risk is increased while liquidity is unaffected.",
       "choice_d":"Interest rate risk and liquidity have both been increased.",
       "correct_answer":"A",
       "explanation":"With the reduction in the Treasury bond position, interest rate risk is reduced. While real estate DDPs and REITs are both ways to invest in real estate, DPPs are highly illiquid. REITs trade on exchanges and OTC making them very liquid. Essentially, replacement of the REITs with the DPP reduces liquidity."
    },
    {
       "id":39663,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor\u2019s portfolio is as follows: <img src='/question_assets/series66/39663-1.png'></img> After some thought about risk, he alters his portfolio as follows: <img src='/question_assets/series66/39663-2.png'></img> The altered portfolio now has:",
       "choice_a":"less interest rate risk and less market risk.",
       "choice_b":"less interest rate risk and more market risk.",
       "choice_c":"more interest rate risk and less market risk.",
       "choice_d":"more interest rate risk and more market risk.",
       "correct_answer":"A",
       "explanation":"The reduction in fixed income securities (government and corporate bond funds) lowers interest rate risk. The addition of the broad-based market index inverse fund, intended to move opposite the market and therefore essentially hedging the S&P and Wilshire index funds, reduces market risk."
    },
    {
       "id":39664,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client has the following portfolio: <img src='/question_assets/series66/39664-1.png'></img> After noting that her income over the past two years has increased substantially moving her into a high-income tax bracket, she and her registered representative agree to alter the portfolio as follows:  <img src='/question_assets/series66/39664-2.png'></img> Which of the following best characterizes the result of the portfolio alterations?",
       "choice_a":"Market risk is increased, but tax liability and liquidity have been reduced.",
       "choice_b":"Market risk, liquidity and potential tax liability have all been reduced",
       "choice_c":"Market risk, liquidity and potential tax liability have all been increased.",
       "choice_d":"Market risk is reduced, but tax liability and liquidity have been increased.",
       "correct_answer":"A",
       "explanation":"The equity positions have been cut in half, reducing market risk. The addition of the government assisted housing direct participation program (DPP) does two things; reduces liquidity because DDPs are considered highly illiquid, and it reduces potential tax liability as government assisted housing programs allow for tax credits. Because tax credits reduce tax liability dollar for dollar, this would be a valuable tax consequence for someone in a high-income tax bracket."
    },
    {
       "id":39665,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Consider the following client portfolio: <img src='/question_assets/series66/39665-1.png'></img> The client wants to reallocate as follows: <img src='/question_assets/series66/39665-2.png'></img> What will the result of this reallocation be?",
       "choice_a":"Income will be reduced but the opportunity to participate in the market is increased. Interest rate risk is increased.",
       "choice_b":"Income will be reduced as will the opportunity to participate in the market. Interest rate risk is unaffected.",
       "choice_c":"Income will be reduced as will the opportunity to participate in the market. Interest rate risk is decreased.",
       "choice_d":"Income will be reduced but the opportunity to participate in the market is increased. Interest rate risk is unaffected.",
       "correct_answer":"A",
       "explanation":"The reallocation from non-convertible bonds to convertible bonds will reduce the income produced from the corporate bond position. While convertible bonds allow for potential participation in the market, they have lower coupons than non-convertible bonds. The lower coupon means less income. Also note that interest rate risk would be somewhat increased because now there is a larger allocation of corporate bonds compared to the reduction in the more stable Treasury bond position."
    },
    {
       "id":39666,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor\u2019s portfolio is structured as follows: <img src='/question_assets/series66/39666-1.png'></img> After a discussion with her registered representative, it is agreed to alter the portfolio as follows: <img src='/question_assets/series66/39666-2.png'></img> The new portfolio could be characterized as being",
       "choice_a":"slightly less conservative with a greater exposure to interest rate risk.",
       "choice_b":"slightly more conservative with a greater exposure to interest rate risk.",
       "choice_c":"slightly less conservative with a lower exposure to interest rate risk.",
       "choice_d":"slightly more conservative with a lower exposure to interest rate risk.",
       "correct_answer":"A",
       "explanation":"Moving a greater allocation of Treasury securities to T-bonds, from T-notes, exposes the portfolio to more interest rate risk; fixed securities with longer maturities (bonds vs notes) have greater interest rate risk. Incurring more risk, the portfolio has become slightly less conservative."
    },
    {
       "id":39667,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor\u2019s portfolio is as follows: <img src='/question_assets/series66/39667-1.png'></img> The investor proposes to reallocate as follows: <img src='/question_assets/series66/39667-2.png'></img> Which of the following best characterizes what the investor\u2019s goal would be with the new allocation he proposes?",
       "choice_a":"To protect against regulatory risk while increasing exposure to interest rate risk.",
       "choice_b":"To protect against regulatory risk and lower exposure to interest rate risk.",
       "choice_c":"To protect against inflation while increasing exposure to interest rate risk.",
       "choice_d":"To protect against inflation and lower exposure to interest rate risk.",
       "correct_answer":"D",
       "explanation":"With the addition of the Treasury Inflation Protection Securities (TIPS) position, it is clear that the goal would be to protect against inflation risk. TIPS are issued with a fixed interest rate, but the principal amount is adjusted semiannually to align with any change in the Consumer Price Index (CPI), the standard by which inflation is measured. Additionally, interest rate risk has been lowered given the smaller allocations to long-term fixed securities, both government and corporate. Longer term fixed income security maturities have greater exposure to interest rate risk."
    },
    {
       "id":39668,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor\u2019s portfolio is as follows: <img src='/question_assets/series66/39668-1.png'></img> She has decided to amend her portfolio as follows: <img src='/question_assets/series66/39668-2.png'></img> Which of the following best characterizes the changes?",
       "choice_a":"Systematic risk and opportunity cost are both increased.",
       "choice_b":"Systematic risk and opportunity cost are both reduced.",
       "choice_c":"Systematic risk is reduced, but opportunity cost is higher.",
       "choice_d":"Systematic risk is increased, but opportunity cost is lower.",
       "correct_answer":"C",
       "explanation":"Remember that systematic risk is the risk that changes in the overall market will have a negative impact on securities, equity and/or debt. With the addition of the MM fund and cash positions, funded by reductions in all of the other positions, systematic risk has been reduced. However, the ability to participate in the markets has also been lessened and this is the cost that has been paid to reduce the systematic risk; opportunity cost."
    },
    {
       "id":39680,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Spouses in their early 40s note to their registered representative that they are willing to accept some risk in order to hopefully keep pace with inflation. Of the following investment choices which would be the most suitable for them to attain their investment objective?",
       "choice_a":"A diversified equity growth and income portfolio.",
       "choice_b":"A Treasury bond portfolio.",
       "choice_c":"An exchange-traded note (ETN) portfolio.",
       "choice_d":"A digital asset portfolio.",
       "correct_answer":"A",
       "explanation":"Of the choices given, and considering the couple\u0027s willingness to accept some risk, stock would be the most likely to keep pace with inflation with the income oriented (dividend paying) securities used to hedge some of the risk. Notably safer, Treasury bonds would not likely have yields high enough to achieve the objective. Exchange-traded notes (ETNs) are a more complicated investment incurring credit risk, and digital assets are unregulated, volatile, and have no appreciable risk or investment history; therefore speculative."
    },
    {
       "id":39681,
       "topic_id":3,
       "practice_test_id":"",
       "question":"An investor has a well-diversified portfolio consisting of both equity and debt securities. This singular bit of information tells you that the portfolio is best protected from which of the following types of risk?",
       "choice_a":"Nonsystematic.",
       "choice_b":"Systematic.",
       "choice_c":"Market.",
       "choice_d":"Purchasing power.",
       "correct_answer":"A",
       "explanation":"Diversification reduces nonsystematic risk; risk associated with the decline of an individual security\u0027s value, equity or debt. Systematic risk, such as market or inflationary risk, affects all securities and therefore is not eliminated by diversifying one\u2019s portfolio. Remember that purchasing power risk, usually associated with fixed payments, accompanies inflation."
    },
    {
       "id":39682,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A registered representative is completing the customer account form with a new client. They discuss risk tolerance and the customer says she is comfortable with some risk for whatever initial dollars she commits to the account in exchange for what she hopes will be higher returns. The registered representative feels compelled to clarify that the willingness to accept some risk should ideally allow the account to keep pace with inflation but that it also means the account could lose value. Assuming the customer acknowledges that she understands, the RR would best characterize her risk tolerance as:",
       "choice_a":"moderate aggressive.",
       "choice_b":"aggressive.",
       "choice_c":"conservative.",
       "choice_d":"moderate.",
       "correct_answer":"D",
       "explanation":"This investor is willing to accept some risk for the initial dollars invested, and understands that this means there is the possibility of loss. Given she is willing to accept this risk in exchange for the opportunity to earn higher returns, her risk tolerance would be best noted as moderate. Moderate aggressive by comparison means that one is willing to accept a much more appreciable amount of risk to attain one\u2019s investment objectives."
    },
    {
       "id":39683,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new customer, in his mid-twenties wants to list capital appreciation as the primary investment objective on his new account form. At this time in his life, he sees no reason why assuming a moderate amount of risk wouldn\u2019t be suitable. He also notes an immediate concern about inflation and how it will impact his portfolio both short and long term. Given his objective and concerns, which of the following investments would be the most suitable recommendation?",
       "choice_a":"Common and preferred stock",
       "choice_b":"Long-term corporate bonds",
       "choice_c":"Long-term municipal bonds",
       "choice_d":"Crypto currency",
       "correct_answer":"A",
       "explanation":"Given the customer\u2019s age, his stated capital appreciation investment objective and willingness to accept moderate risk, equities both common and preferred would be the most suitable recommendation of those listed. The long-term debt choices, corporate or government, are not likely to meet the capital appreciation objective and volatile crypto currencies would not align with a moderate risk tolerance."
    },
    {
       "id":39686,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client tells you that he is interested in zero coupon bonds. He tells you he knows how they work and that no interest will be received until they mature. His sudden interest in zeros is completely unexpected, and given that, what specific issue might your next best follow-up question address first to determine if zeros are suitable?",
       "choice_a":"Whether he intends to fund the purchase of these bonds with available cash or with funds gotten from liquidating current investments?",
       "choice_b":"Whether or not he is aware that they are highly sensitive to interest rate movements?",
       "choice_c":"Whether or not the client has a particular investment target and a date for that target to occur?",
       "choice_d":"Whether or not he realizes receiving no interest until they mature doesn\u0027t necessarily avoid taxes on the interest prior to maturity?",
       "correct_answer":"C",
       "explanation":"Inquiries to determine suitability would be first. Zero coupon bonds are generally considered most suitable when there is a specific target investment to be met and a specific time frame within which it will occur. Saving to fund an upcoming college education is a prime example. No doubt that once zeros have been determined to be suitable to meet the objective, a discussion about tax consequences, they\u2019re sensitivity to interest rate movements, and how best to fund the purchase would also need to be had."
    },
    {
       "id":39687,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client laments that his portfolio, set up to align with his investment objective of maximizing income, has no convertible bonds in it. She says that if there were, she could consider converting some and possibly participate in the current strong bull market. How might you best begin to continue this discussion?",
       "choice_a":"Reminding the client that convertible bonds have lower coupons than non-convertible bonds and therefore are generally avoided if one\u0027s primary objective is to maximize income",
       "choice_b":"Reminding the client that convertible bonds, generally issued by corporations, are taxable at all levels and paying more in taxes does not lend itself to maximizing income.",
       "choice_c":"Reminding the client that convertible bonds are only deemed suitable when growth is listed as an investment objective.",
       "choice_d":"Reminding the client that convertible bonds are usually issued by companies with lower bond ratings and therefore not suitable for someone who wants to maximize income.",
       "correct_answer":"A",
       "explanation":"Because of the additional feature they offer the investor, convertible bonds tend to have lower coupons than non-convertible bonds. Reminding the client that the lower coupon generally would not align with an objective of maximizing income would be the best place to continue the discussion from. Note; convertible bonds can be suitable for meeting both income and growth objectives, are not necessarily associated with lower debt ratings and the tax consequences when issued by corporations are the same, whether the bonds are convertible or nonconvertible."
    },
    {
       "id":39688,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client with a balanced (equity vs debt) portfolio says that some research he\u2019s done clearly indicates that callable corporate bonds tend to pay a bit more in interest than noncallable bonds from the same issuer. He wonders why there are no callable bonds in his portfolio and thinks there should be. How might you best begin this discussion?",
       "choice_a":"Explaining that rules mandate your recommendation of a callable bond must be preceded by the client signing a risk waiver document.",
       "choice_b":"Explaining why callable bonds tend to pay more in interest and that they inherently have reinvestment risk attached to them.",
       "choice_c":"Explaining why callable bonds have no place in a balanced portfolio.",
       "choice_d":"Explaining why inevitably all callable bonds will be called and why that is not good.",
       "correct_answer":"B",
       "explanation":"Callable bonds do tend to pay more in interest than non-callable bonds because the added callable feature works to the advantage of the issuer who will call them if interest rates should decline. The added yield acts as an enticement to purchase them. In addition, because they will be called in a declining interest rate environment the investor is left to shoulder reinvestment risk; reinvesting the proceeds in a lower interest rate environment. This is the discussion that should be had first. Note; callable bonds can be suitable for balanced portfolios, are only likely to be called when interest rates fall, and no risk disclosure or waiver is required to recommend them."
    },
    {
       "id":39689,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A long-standing client contacts you and says that he and his wife, both retired and in their late sixties, are barely getting by on their social security payments. He notes that they have friends who receive monthly payments from a variable annuity and he thinks they\u2019d like to know more and possibly purchase a VA themselves. They have a small savings account and IRAs neither has withdrawn from yet. Which of the following is the best course to take first in an ensuing  conversation about VAs?",
       "choice_a":"A discussion about the suitability of VAs for seniors who are already retired should occur.",
       "choice_b":"A discussion regarding how much will be needed in monthly payments to make their retirement more comfortable should occur.",
       "choice_c":"A discussion about how much of their IRAs would be suitable to divest of in order to fund the VA should occur.",
       "choice_d":"A discussion about the differences between fixed and variable annuities should occur to determine if a VA is the best option.",
       "correct_answer":"A",
       "explanation":"Purchasing a VA is generally not considered suitable for seniors, particularly when no way to fund one with available cash is possible. Given what we know here, other options should be explored first. The most obvious might be to begin taking distributions from their IRAs to ease their financial situation but suggesting that those distributions be used to fund a VA would not be at all suitable."
    },
    {
       "id":39691,
       "topic_id":3,
       "practice_test_id":"",
       "question":"New clients, a married couple in their early thirties with one young child and a combined annual income of $75,000 have transferred a small investment portfolio currently valued at $50,000 to your firm. They note that they are finally in a position to put away approximately $50 a week and think that saving for their child\u2019s education is probably the next best step they should take. Given this is all you know about them, of the following choices, which might be the best way for a discussion to begin so that you might broaden your understanding of their financial picture?",
       "choice_a":"Affirming that they are aware that contributions to an education savings account (ESA) are not tax deductible.",
       "choice_b":"Exploring whether either has done anything in the way of retirement planning for themselves.",
       "choice_c":"Establishing their risk tolerance for the new funds to be allocated for their child\u0027s education.",
       "choice_d":"Exploring whether or not they would consider speculative investing such as options, crypto currencies or digital assets for this purpose.",
       "correct_answer":"B",
       "explanation":"Before a discussion about ways to finance higher education for their child should begin, or the tax consequences of different vehicles available, a broader picture is needed. Included in that picture would be knowing whether any retirement planning for themselves has begun yet. If not, that may also be a priority to consider."
    },
    {
       "id":39692,
       "topic_id":3,
       "practice_test_id":"",
       "question":"In getting to know a new client, age 45, he mentions that he makes the maximum contributions to his employer\u2019s 401K plan and to his IRA annually. He now wants to supplement those retirement funds by making a lump sum contribution to a variable annuity. He goes on to note that liquidating $100,000 from an investment account, or refinancing his home would both be feasible ways to fund the VA. Your best follow-up question should be which of the following?",
       "choice_a":"Do you have any readily available cash to fund the VA?",
       "choice_b":"How do your potential heirs feel about you tying funds up in a VA?",
       "choice_c":"Given you\u0027ve maxed out other retirement plan contributions, would you consider more than $100,000 as a contribution to the VA?",
       "choice_d":"Would you object if we look at several different companies offering VAs?",
       "correct_answer":"A",
       "explanation":"The client\u2019s age and current ability to max out contributions to other available retirement plans makes a VA a good option to supplement retirement income for him; therefore suitable. However, liquidating assets or refinancing property are considered unsuitable methods of funding a VA. The best source for VA funding is readily available cash, and knowing if any is available for this purpose would be the next best inquiry."
    },
    {
       "id":39693,
       "topic_id":3,
       "practice_test_id":"",
       "question":"You are conducting a new client interview. When you ask about marital status the client tells you he is divorced. Of the following, which might be the next best exploratory question?",
       "choice_a":"Is the ex-spouse also in need of guidance for investments or brokerage services?",
       "choice_b":"What is the name and social security number of the ex-spouse?",
       "choice_c":"How long has the client been divorced?",
       "choice_d":"Is the client receiving or paying out income as a result of the divorce?",
       "correct_answer":"D",
       "explanation":"Of the possibilities offered, knowing whether the new client is receiving or paying out income as a result of the divorce would be most relevant to completing the client profile. For instance, if receiving income, the purpose for the payments such as alimony or child support would determine the tax liability for the payments received."
    },
    {
       "id":39694,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client tells you that they are receiving a lump sum payment due to a judgment issued in the form of a qualified domestic relations order (QDRO). Which of the following should be the most important follow-up question?",
       "choice_a":"Are you the ex-spouse of the party making the payment?",
       "choice_b":"What is the amount of the payment?",
       "choice_c":"What is the name and social security number of the party making the payment?",
       "choice_d":"Is the payment taxable income to you?",
       "correct_answer":"A",
       "explanation":"While QDRO\u2019s are most often associated with divorce proceedings, they may be issued in other domestic judgements as well. Therefore, knowing if your client, the payment recipient, is the ex-spouse of the party from whom the payment is coming is most important as it will determine if the lump sum can be rolled over into a qualified plan. For ex-spouses, it can be. For someone other than an ex-spouse it cannot be. If the recipient is an ex-spouse, deferring taxation on the amount received is possible if rolled over to another qualified plan."
    },
    {
       "id":39695,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A new client expresses the importance of his long-term goal which primarily is to secure some financial independence from his family. He tells you that he has substantial dividend income received quarterly from stock he inherited from his father. Aligning with his long-term goal he tells you he wants to set up an IRA for later in life. Regarding his specific request to set up an IRA, what would be the most relevant question to ask the client now?",
       "choice_a":"Does he have any income in addition to the dividend income?",
       "choice_b":"How much is the quarterly amount received from the dividends?",
       "choice_c":"Where is the dividend yielding stock held?",
       "choice_d":"Is he considering a traditional IRA or a ROTH IRA?",
       "correct_answer":"A",
       "explanation":"An IRA contribution can only be made from earned income. Dividends and interest are investment income and therefore not an eligible source of funding for IRA\u2019s. Therefore, the most relevant follow-up question would be to ask if he has any other income sources for the purpose of determining if they might be deemed earned income eligible to fund an IRA."
    },
    {
       "id":39701,
       "topic_id":3,
       "practice_test_id":"",
       "question":"Your client will soon receive distributions awarded in a qualified domestic relations order (QDRO) during a divorce proceeding. Asked about the tax consequences of these distributions you would correctly state that:",
       "choice_a":"the payments must be reported by your client as if they were the plan participant and that they will be allocated a share of the participants cost basis if the payments are taxable.",
       "choice_b":"the payments must be reported by your client as if they were the plan participant but their cost basis will be zero if the payments are taxable.",
       "choice_c":"the payments only need to be reported if the distributions under the qualified domestic relations order (QDRO) were for alimony, but not reported if for child support.",
       "choice_d":"the payments need not be reported as they were mandated to occur by a court order under a qualified domestic relations order (QDRO).",
       "correct_answer":"A",
       "explanation":"The payments must be reported by your client as if they were the plan participant themselves no matter what the purpose of the distributions; alimony, child support or marital property rights. While the payments must be reported, the tax liability depends on the intended use of the payments; alimony or child support for example. If taxable, under the QDRO your client will be allocated a share of the ex-spouse\u2019s cost basis."
    },
    {
       "id":39702,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A client, age 45 and recently divorced, will be receiving distributions from her spouse\u2019s  traditional IRA and her spouse\u2019s employer\u2019s 401K plan, to meet the judgment issued via a qualified domestic relations order (QDRO) during the divorce proceedings. You correctly advise that the distributions from both would be taxable if they are not rolled over and that:",
       "choice_a":"a 10% early distribution penalty (tax) would apply to the IRA only.",
       "choice_b":"a 10% early distribution penalty (tax) would apply to the employer qualified 401K plan only.",
       "choice_c":"a 10% early distribution penalty (tax) would apply to both plans.",
       "choice_d":"a 10% early distribution penalty (tax) wouldn\u0027t apply to either plan due to the QDRO decree.",
       "correct_answer":"A",
       "explanation":"A qualified domestic relations order (QDRO) allows distributions from an employer qualified plan such as a 401K to avoid the 10% early distribution penalty, also referred to as a penalty tax. It does not however apply to IRAs of any kind. The recipient reports the distributions received as if they were the plan participant. If rolled over into another qualified plan the distributions are not taxable. However, if not rolled over, the distributions are taxable but the early 10% distribution penalty (tax) would apply only to the IRA distribution and not the 401K distribution."
    },
    {
       "id":39703,
       "topic_id":3,
       "practice_test_id":"",
       "question":"A qualified domestic relations order (QDRO) issued in the course of divorce proceedings allows for an exemption applicable to distributions from a:",
       "choice_a":"ROTH IRA or a SEP IRA plan.",
       "choice_b":"traditional IRA or a ROTH IRA plan.",
       "choice_c":"qualified employer plan or a traditional IRA.",
       "choice_d":"qualified employer plan.",
       "correct_answer":"D",
       "explanation":"A QDRO is an order or decree, generally issued in the course of divorce proceedings. While premature distributions from retirement plans are subject to a 10% penalty, a QDRO distribution is exempt from the penalty in the case of qualified employer plans only. The exemption from the penalty tax does not apply to IRA\u2019s."
    },
    {
       "id":4769,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The party responsible for enforcing the Uniform Securities Act within a state may be all of the following except:",
       "choice_a":"The Administrator",
       "choice_b":"Attorney General",
       "choice_c":"Any party appointed by the Governor",
       "choice_d":"SEC Commissioner",
       "correct_answer":"D",
       "explanation":"All of the parities listed could enforce the USA within a state except an SEC Commissioner. An SEC commissioner is a federal regulator."
    },
    {
       "id":4770,
       "topic_id":4,
       "practice_test_id":1,
       "question":"The purpose of the USA is all of the following except:",
       "choice_a":"To require minimum standards for State Administrators",
       "choice_b":"To set model legislation for all states to follow",
       "choice_c":"To ensure that all states have the exact same securities laws so that issuers can register their securities easily",
       "choice_d":"To ensure that administrators can effectively enforce the provisions of the USA in their own state",
       "correct_answer":"C",
       "explanation":"The USA is designed to provide model legislation for the states, which allows the states to adopt their own rules as needed."
    },
    {
       "id":4771,
       "topic_id":4,
       "practice_test_id":2,
       "question":"The State Securities Administrator is required to enforce all of the following except:",
       "choice_a":"Anti-fraud provisions of the USA",
       "choice_b":"State securities regulations",
       "choice_c":"Fraud provisions of the USA",
       "choice_d":"State registration requirements",
       "correct_answer":"C",
       "explanation":"The State Securities Administrator enforces the anti-fraud provisions of the USA not the fraud provisions."
    },
    {
       "id":4772,
       "topic_id":4,
       "practice_test_id":3,
       "question":"The State Securities Administrator may: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Rule that investment advisors within their jurisdiction may not have custody of funds </li><li>Require that investment advisors file sales literature </li><li>Require that securities sold within their borders are sold on a state approved subscription form </li><li>Inspect broker dealers outside of their state without notice.</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"The State Securities Administrator is very powerful and may do all of the answers listed."
    },
    {
       "id":4773,
       "topic_id":4,
       "practice_test_id":4,
       "question":"The statute of limitations for taking action against a firm at the state level is:",
       "choice_a":"6 years",
       "choice_b":"2 years",
       "choice_c":"2 years from discovery or 3 years from the triggering event which ever occurs first",
       "choice_d":"3 years from discovery or 6 years from the triggering event, which ever occurs first",
       "correct_answer":"C",
       "explanation":"The statute of limitation at the state level is two years from discovery or three years from the triggering event, which ever occurs first."
    },
    {
       "id":4774,
       "topic_id":4,
       "practice_test_id":5,
       "question":"To maintain registration, the Administrator may require:",
       "choice_a":"All sales literature and advertising to be distributed to the public be filed prior to use",
       "choice_b":"All accounting records and financial records, as well as customer account files, order tickets, and correspondence, be kept on file for at least three years",
       "choice_c":"An Investment Advisory Brochure be provided to prospective clients 48 hours before entering into an advisory contract",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The Administrator, in order for a professional to maintain registration, may require all of the above."
    },
    {
       "id":4775,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Under The Act who can issue an injunction? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The Administrator </li><li>The court </li><li>FINRA </li><li>The district attorney</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I, II, III, IV",
       "choice_d":"II only",
       "correct_answer":"D",
       "explanation":"Only a court can enter an injunction."
    },
    {
       "id":4776,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, it is illegal to willfully omit material facts about a security to a customer when soliciting client business. Which of the following actions would constitute omission of material facts? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Failure to notify a customer of negative news about a company  </li><li>Failure to notify a customer of an impending lawsuit about a company  </li><li>Failure to notify a customer about an officer of the firm that has been indicted for fraud  </li><li>Failure to notify a customer about the Chief Executive officer announcing his resignation from the firm</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I,II,III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the listed actions would constitute the omission of material facts to a customer when soliciting client business. Negative news about a company, a pending lawsuit, criminal action against an officer of a firm and a resignation of a key senior officer would all be considered acts that a client should be informed of prior to the solicitation of business."
    },
    {
       "id":4777,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following actions by a broker dealer is prohibited under the Uniform Securities Act regarding customer accounts?",
       "choice_a":"Allowing a client to trade in a margin account without signing the margin agreement within 15 days",
       "choice_b":"Allowing a client to trade in an option account without signing the option agreement within 15 days",
       "choice_c":"Signing a customer\u0027s signature with their verbal approval for a trading authorization in a discretionary account",
       "choice_d":"Allowing a customer to open an account with no name, and only a number designating the account",
       "correct_answer":"C",
       "explanation":"Under the Uniform Securities Act, it is strictly prohibited for a broker to sign a customer signature to any account documentation, regardless of whether the customer has given their verbal approval to the broker to do so. Under no circumstances can a broker sign a customer signature to any document pertaining to the account."
    },
    {
       "id":4778,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following actions would constitute a criminal action, as opposed to a civil action against, a broker under the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The broker has willfully intended to defraud his customers  </li><li>The broker has violated a prohibited action under the Uniform Securities Act </li><li>The broker has unintentionally defrauded a customer  </li><li>The broker has not violated a prohibited action under the Uniform Securities Act</li></ol>",
       "choice_a":"I Only",
       "choice_b":"I and II",
       "choice_c":"II and III",
       "choice_d":"III and IV",
       "correct_answer":"A",
       "explanation":"The only action listed that would initiate a criminal investigation by a State Administrator would be the intentional act of fraud by the broker. The line between criminal and civil in scope is determined under the Uniform Act as the willful and intentional act of fraud being perpetuated by the broker dealer or agent."
    },
    {
       "id":4779,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are true regarding an administrator\u0027s hearing? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is usually a public hearing  </li><li>It can be held in private </li><li>The Administrator can have witnesses testify under oath </li><li>The Administrator may compel testimony</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"The hearings are usually public, but may be held in private, and the Administrator can have witnesses testify under oath and can compel testimony."
    },
    {
       "id":4780,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is not subject to the USA?",
       "choice_a":"Any of the 50 states",
       "choice_b":"Any territory or possession of the United States",
       "choice_c":"The District of Columbia",
       "choice_d":"All of the choices are subject to the USA",
       "correct_answer":"D",
       "explanation":"All of the 50 states, territories, possessions and the Commonwealth of Puerto Rico, and the District of Columbia are subject to the USA."
    },
    {
       "id":4781,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Who is responsible for administering The Uniform Securities Act within a state?",
       "choice_a":"Anyone designated by the Governor",
       "choice_b":"The SEC",
       "choice_c":"The State Supreme Court",
       "choice_d":"The District Attorney",
       "correct_answer":"A",
       "explanation":"Anyone designated by the Governor is responsible for the administration of the USA within the state. It will usually be someone appointed to the position of State Securities Administrator."
    },
    {
       "id":4782,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker dealer with $200,000 in net capital is subject to all of the following except:",
       "choice_a":"Anti-fraud provisions of the USA",
       "choice_b":"$35,000 surety bond requirement",
       "choice_c":"Surprise audits",
       "choice_d":"Having their registration revoked for fraudulent acts",
       "correct_answer":"B",
       "explanation":"A broker dealer who meets the SEC\u0027s net capital requirement is not subject to the $35,000 surety bond requirement."
    },
    {
       "id":4783,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A Canadian broker dealer regularly conducting business with an insurance company within the state is:",
       "choice_a":"Required to notify the administrator",
       "choice_b":"Required to file an application for registration",
       "choice_c":"Required to file a consent to service of process",
       "choice_d":"Not required to register",
       "correct_answer":"D",
       "explanation":"A Canadian firm conducting business with an institutional investor is not required to register."
    },
    {
       "id":4784,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A local appliance store is promoting its annual Fourth of July sale. It has significantly marked down large screen TVs. Also anyone who purchases a large screen TV will receive a $100 US Savings Bond. Which of the following is true?",
       "choice_a":"The salesman at the store must be registered as the gift of the bond attached to a sale is considered a sale",
       "choice_b":"The salesman at the store need not register as the savings bond is an exempt security",
       "choice_c":"Using a security as an enticement for a person to make a large purchase is a violation of the USA",
       "choice_d":"Using a government security as an enticement for a person to make a large purchase is fraudulent and subject to criminal prosecution",
       "correct_answer":"B",
       "explanation":"The US savings bond is an exempt security and the sales person does not need to register. The practice of offering savings bonds during a promotion is not fraudulent or in violation of the USA."
    },
    {
       "id":4785,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A new advisory client has just signed the contract for advisory services. Their portfolio manager has just given them Form ADV II. The client has how long to cancel the contract?",
       "choice_a":"48 hours",
       "choice_b":"5 days",
       "choice_c":"10 days",
       "choice_d":"3 days",
       "correct_answer":"B",
       "explanation":"A client who is given Form ADV II at the time they sign the contract must be given five days to cancel."
    },
    {
       "id":4786,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A new FINRA member is applying for registration in order to accept the firm. The firm must have at last how many registered principals?",
       "choice_a":1,
       "choice_b":2,
       "choice_c":4,
       "choice_d":"At least one principal for every 10 registered representatives",
       "correct_answer":"B",
       "explanation":"There must be at least two principals per firm before the firm will be approved for membership with FINRA."
    },
    {
       "id":4787,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A New York agent representing a New Jersey broker dealer has several clients in Pennsylvania and three clients in Florida. Where must the agent be registered?",
       "choice_a":"New Jersey and Pennsylvania",
       "choice_b":"New Jersey, New York, and Pennsylvania",
       "choice_c":"Pennsylvania and Florida",
       "choice_d":"New York, New Jersey, Pennsylvania, and Florida",
       "correct_answer":"D",
       "explanation":"The agent must register in their home state, in their state of employment and in the states where they have clients."
    },
    {
       "id":4788,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A person will be considered an investment adviser if he does all of the following except:",
       "choice_a":"Engages in the business of advising others, directly or indirectly, about the merits of securities, either for purchase or for sale",
       "choice_b":"Provides reports or analysis concerning securities in the regular course of his business",
       "choice_c":"Solely participates in the buying and selling of the securities for the accounts of clients",
       "choice_d":"Receives compensation for his securities advice",
       "correct_answer":"C",
       "explanation":"The person will be considered only a broker dealer if they solely purchase and sell securities for clients."
    },
    {
       "id":4789,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A regional firm is acquiring a local firm in state. The regional firm is not registered as a broker dealer in the state of the firm that it is acquiring. All of the following are true except:",
       "choice_a":"The acquiring firm\u0027s registration will be effective upon completion of the transaction",
       "choice_b":"The acquiring firm will have to pay new registration fees",
       "choice_c":"The acquiring firm will not have to pay registration fees",
       "choice_d":"The acquiring firm must file an application with the Administrator",
       "correct_answer":"B",
       "explanation":"All of the answers listed are true except that the firm will have to pay new registration fees. The acquiring firm will pay the registration fees at year end for the next year."
    },
    {
       "id":4790,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A small broker dealer is applying for registration in a nearby state. The State Securities Administrator is asking that the broker dealer post a surety bond. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Cash can be substituted for the bond </li><li>A deposit of qualified securities may be substituted for the bond </li><li>An agent of the firm subject to the surety bond requirements may not make substitutions for the bond </li><li>If the broker dealer meets the SEC\u0027s minimum net capital requirement they are exempt from the surety bond requirement.</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I, II and IV",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"All of the choices listed are correct except, number II. An agent may substitute a deposit of cash or securities for the bond."
    },
    {
       "id":4791,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act an investment adviser is considered to have custody of client\u0027s funds under which of the following circumstances? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The adviser has full discretion </li><li>The adviser self-clears </li><li>The adviser has limited discretion. </li><li>The adviser accepts client\u0027s securities for deposit</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"An adviser is considered to have custody if they have full discretion to withdraw cash and securities as well as when they accept customer\u0027s securities for deposit. An adviser that self-clears holds all of the customer\u0027s cash and securities."
    },
    {
       "id":4792,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act an agent is: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The representative of a broker dealer in a neighboring state who sells securities to existing customers who are non residents </li><li>The representative of an issuer selling large denomination commercial paper  </li><li>A registered broker dealer transacting business with the general public. </li><li>A representative of a broker dealer who sells nonexempt securities to residents</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"IV only",
       "correct_answer":"D",
       "explanation":"Of the choices listed, only IV would have to register as an agent."
    },
    {
       "id":4793,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are registration requirements of a broker dealer except for which, under the Uniform Securities Act?",
       "choice_a":"A minimum net capital requirement",
       "choice_b":"The requirement of a blanket fidelity bond for registered representatives of the broker dealer",
       "choice_c":"Supervisory personnel must be registered as principals",
       "choice_d":"Owners must have a minimum net worth of $1,000,000",
       "correct_answer":"D",
       "explanation":"There is no minimum net worth requirement for a broker dealer owner to meet in order to be permitted to open a B/D (broker dealer). They would be required to meet net capital requirements for the firm, secure a blanket fidelity bond for agents against fraud, and would be required to have a supervisor oversee the sales force at the firm."
    },
    {
       "id":4794,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are true about the effective date and expiration of registrations except:",
       "choice_a":"Registrations become effective 30 days from the filing date",
       "choice_b":"If the registration application is amended, the registration becomes effective 60 days after the amendment filing date",
       "choice_c":"All registrations expire on December 31, unless renewed",
       "choice_d":"All registrations become effective at noon",
       "correct_answer":"B",
       "explanation":"If the registration application is amended, it becomes effective 30 days from the filing date of the amendment."
    },
    {
       "id":4795,
       "topic_id":4,
       "practice_test_id":1,
       "question":"All of the following regulations apply to the filing of a new applicant for Series 7 registration except for which?",
       "choice_a":"The completion of a U-4 application",
       "choice_b":"An affidavit that they are not subject to a consent of service of process",
       "choice_c":"The submittal of a set of fingerprints of the candidate",
       "choice_d":"The submittal of all registration fees",
       "correct_answer":"B",
       "explanation":"All of the statements are true except the consent to service of process is required for all agents."
    },
    {
       "id":4796,
       "topic_id":4,
       "practice_test_id":2,
       "question":"An agent has been terminated by an investment adviser; who must notify the Administrator?",
       "choice_a":"The agent only",
       "choice_b":"Both the firm and the agent within 30 days",
       "choice_c":"The firm only",
       "choice_d":"Both the firm and the agent with in 15 days",
       "correct_answer":"C",
       "explanation":"When an agent is terminated by an advisory firm, only the firm is required to notify the Administrator"
    },
    {
       "id":4797,
       "topic_id":4,
       "practice_test_id":3,
       "question":"An agent must do all of the following except:",
       "choice_a":"Determine if the state allows multiple registrations and whether he is allowed to work for several broker dealers at the same time if the agent wishes to work for more than one broker dealer",
       "choice_b":"Determine whether the agent will lose his registration if the broker dealer loses its registration",
       "choice_c":"Register with FINRA and determine if he is eligible to register within that state",
       "choice_d":"Determine if he is eligible for an exemption which will allow him to conduct business in a state where he is not registered in two specific situations",
       "correct_answer":"B",
       "explanation":"If a broker dealer loses its registration, the agent working for the firm automatically loses his registration; however, if the agent loses his registration, there is no effect on the broker dealer firm."
    },
    {
       "id":4798,
       "topic_id":4,
       "practice_test_id":4,
       "question":"An agent of a broker dealer with no office in the state is terminated. The Administrator must be notified by:",
       "choice_a":"The old firm only within 45 days",
       "choice_b":"The old and new firms within 30 days",
       "choice_c":"The old and new firms as well as the agent within 30 days",
       "choice_d":"The old firm and the agent only within 30 days",
       "correct_answer":"C",
       "explanation":"When an agent leaves a firm or is terminated, all parties must notify the administrator within 30 days."
    },
    {
       "id":4799,
       "topic_id":4,
       "practice_test_id":5,
       "question":"An agent representing a broker dealer in sales presentations to individual investors is subject to all of the following except:",
       "choice_a":"Net capital",
       "choice_b":"Surety bond",
       "choice_c":"Exams",
       "choice_d":"Fees",
       "correct_answer":"A",
       "explanation":"An agent is not subject to net capital requirements."
    },
    {
       "id":4800,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An agent who has passed their exam but who has not yet received notification from the state may do which of the following?",
       "choice_a":"Accept an unsolicited order",
       "choice_b":"Cold call",
       "choice_c":"Execute order\u0027s for existing clients of the firm",
       "choice_d":"None of the above",
       "correct_answer":"D",
       "explanation":"An agent may not do any of the choices listed until they have received notice of registration."
    },
    {
       "id":4801,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An executive of a local bank sells securities that were issued by the bank. Which of the following is true?",
       "choice_a":"The bank is not an issuer and may not sell securities in itself",
       "choice_b":"The executive must register prior to completing any sales",
       "choice_c":"The executive has violated the USA",
       "choice_d":"The executive need not register",
       "correct_answer":"D",
       "explanation":"The bank is an exempt issuer and the employees of exempt issuers do not need to register to sell the securities."
    },
    {
       "id":4802,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser has given portfolio advice to eight people in another state. Which of the following is true?",
       "choice_a":"The adviser only needs to register if they have an office in that state",
       "choice_b":"The adviser needs to register",
       "choice_c":"The adviser does not need to register",
       "choice_d":"The adviser may register with either the state or with the SEC depending on how much money they manage",
       "correct_answer":"B",
       "explanation":"The adviser has given advice to more than five people and must register in that state."
    },
    {
       "id":4803,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser is any person except:",
       "choice_a":"A person who produces reports regarding the value of securities",
       "choice_b":"A person who publishes a letter detailing the advisability of purchasing or selling securities",
       "choice_c":"A person who indirectly provides advice through a report to a large number of subscribers",
       "choice_d":"A tax attorney who sets up trusts to hold securities for clients",
       "correct_answer":"D",
       "explanation":"The attorney is exempt from the definition of an investment adviser unless they receive a specific fee for the advice they give regarding the value of securities or for recommending the purchase or sale of securities."
    },
    {
       "id":4804,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser managing $150,000,000 in customer assets must do which of the following: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Pay state fees  </li><li>Register with the SEC  </li><li>Register with the state </li><li>Register as an agent anyone who solicits new clients</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"II and IV",
       "choice_d":"I, II and IV",
       "correct_answer":"D",
       "explanation":"An investment adviser with $150,000,000 must do all of the things listed except register with the state. Advisers registered with the SEC must pay the state fees where they conduct business. An investment adviser with more than $110 million under management must register with the SEC."
    },
    {
       "id":4805,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser must notify a client of all of the following except:",
       "choice_a":"A regulatory action",
       "choice_b":"The departure of a partner",
       "choice_c":"The addition of a partner",
       "choice_d":"A portfolio manager who changes their state of residence",
       "correct_answer":"D",
       "explanation":"An investment adviser must notify their clients of all of the answers listed except they do not need to notify them of a change in residence of a portfolio manager."
    },
    {
       "id":4806,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser representative has just presented Form ADV II to a new advisory client. The client has just signed the contract. How long do they have to cancel the contract?",
       "choice_a":"45 days",
       "choice_b":"10 days",
       "choice_c":"5 days",
       "choice_d":"15 days",
       "correct_answer":"C",
       "explanation":"A client who is given Form ADV II at the time of signing the contract must be given a five day grace period."
    },
    {
       "id":4807,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser who is not subject to any proceedings has decided to withdraw their registration. Which of following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Their request will become effective within 60 days </li><li>The Administrator may allow the request to become effective in less than 60 days  </li><li>The Administrator may extend the 60 day period if it wishes to further review the request </li><li>The Administrator may take action against the advisor even after they\u0027re no longer registered.</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"The Administrator may allow the request to withdraw a registration to become effective in less than 60 days but may not extend the 60 day period if the adviser is not subject to any proceedings. The Administrator may take action against a registrant even after they have withdrawn their registration."
    },
    {
       "id":4808,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser with no office in the state need not register if their clients are limited to:",
       "choice_a":"Pension plans with assets exceeding $750,000",
       "choice_b":"Pension plans with assets exceeding $1,000,000",
       "choice_c":"Pension plans with assets exceeding $500,000",
       "choice_d":"Pension plans with assets exceeding $5,000,000",
       "correct_answer":"B",
       "explanation":"An investment adviser with no office in the state need not register if their clients are only pension plans with assets exceeding $1,000,000"
    },
    {
       "id":4809,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investor opening a wrap account must receive:",
       "choice_a":"Schedule H",
       "choice_b":"Schedule C",
       "choice_c":"Schedule D",
       "choice_d":"ADV II",
       "correct_answer":"A",
       "explanation":"An investor opening a wrap account must receive Schedule H."
    },
    {
       "id":4810,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Applicants cannot transact business until which of the following happens?",
       "choice_a":"A written or oral exam is taken and passed if required",
       "choice_b":"All the documents and the application are filed",
       "choice_c":"The administrator approves the registration",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the above must happen before an applicant can transact business."
    },
    {
       "id":4811,
       "topic_id":4,
       "practice_test_id":"",
       "question":"As it is covered under The Uniform Securities Act, which of the following is a broker dealer?",
       "choice_a":"A person trading large blocks of stock for their own private account",
       "choice_b":"A firm with no office in the state executing orders for banks",
       "choice_c":"A firm with no office in the state executing orders for investment companies and accredited investors only",
       "choice_d":"A firm with no office in the state who executed orders for existing customers in state for less than 30 days",
       "correct_answer":"C",
       "explanation":"A firm with no office in the state who executes orders for accredited investors in state would be considered a broker dealer in the state and would have to register."
    },
    {
       "id":4812,
       "topic_id":4,
       "practice_test_id":"",
       "question":"As it relates to a consent to service of process, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is an agreement with Administrator whereby the registrant agrees to allow actions to be commenced against them upon the receipt of notice by the office of the administrator </li><li>It is required only by broker dealers and investment advisors. </li><li>Any action arising out of the business of the broker dealer in the state served to the office of the Administrator will bind all agents as well as principals of the firm </li><li>The registrant must file an ethical business affidavit with the consent to service of process</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"All broker dealers, investment advisors and agents must sign a consent to service of process which is an agreement allowing the administrator to accept legal notices for the registrant. There is no requirement that the registrant file an ethical business affidavit."
    },
    {
       "id":4813,
       "topic_id":4,
       "practice_test_id":"",
       "question":"As it relates to the USA, a broker dealer is:",
       "choice_a":"Any person executing orders for their own account or the account of others",
       "choice_b":"A trust company entering orders for trust customers",
       "choice_c":"An investment advisor entering orders for clients",
       "choice_d":"A bank officer recommending a closed-end mutual fund to a client",
       "correct_answer":"A",
       "explanation":"Under the USA, a broker dealer is any person that executes orders for their own account or for the account of others."
    },
    {
       "id":4814,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Charles is a broker for Titan Securities in the state of New Jersey. Charles solicits business for his firm in each state in the United States. Which of the following statements are considered true of their securities registration? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Charles is required to be registered with the state of New Jersey only  </li><li>Charles is required to be registered in each state that he solicits business  </li><li>Titan Securities is required to be registered with the state of New Jersey only  </li><li>Titan Securities is required to be registered in each state that they conduct business</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"D",
       "explanation":"The Uniform Securities Act requires that all registered representatives and the broker dealers that employ them be registered in each state in which they solicit business. If the firm is based in New Jersey, they must still be registered in each state where they solicit public securities business. This would apply to the registered representatives and the broker dealer itself."
    },
    {
       "id":4815,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Excluded from the definition of broker dealers are individuals who have no place of business in the state, as well as entities who do each of the following except:",
       "choice_a":"Transact business only with other broker dealers, issuers, or financial institutions in that state",
       "choice_b":"Are licensed in the state where they transact business and make offers only to existing customers who are not residents of that state",
       "choice_c":"Make no more than five public offerings during a 12-month period",
       "choice_d":"Act on behalf of issuers in the sale of non-exempt securities to the public in state.",
       "correct_answer":"D",
       "explanation":"A person that represents an issuer in the sale of non exempt securities to the public must be registered as a broker dealer."
    },
    {
       "id":4816,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Federal advisers must do which of the following before they can transact business?",
       "choice_a":"File all documents submitted to the SEC with the state",
       "choice_b":"File a consent to service of process",
       "choice_c":"Pay a state filing fee",
       "choice_d":"Register with the state",
       "correct_answer":"C",
       "explanation":"Federal advisers must file all documents submitted to the SEC with the state, and file a consent to service of process only if requested by the state. Advisers must pay a state filing fee before they can transact business within a state."
    },
    {
       "id":4817,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If a person who is a lawyer for a bank, writes a daily investment column for a local newspaper, which of the following is true?",
       "choice_a":"The person is not considered an investment advisor because lawyers and other professionals such as accountants, teachers, and engineers, give investment advice as an incidental portion of their business.",
       "choice_b":"The person is not considered an investment advisor because banks and financial institutions give advice as an incidental portion of their normal business.",
       "choice_c":"The person is not considered an investment advisor because writers for newspapers, magazines, and business journals who do not give specific investment situations to individuals are exempt.",
       "choice_d":"The writing for newspapers is incidental to his practice as a lawyer",
       "correct_answer":"C",
       "explanation":"The person is not considered an investment advisor because the writer of a financial column is not considered an investment advisor and is exempt."
    },
    {
       "id":4818,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Individuals representing issuers of specific exempt securities are not considered agents, and they are therefore not required to be registered; these exempt securities include all of the following except:",
       "choice_a":"US government, Canadian government and certain other foreign government securities",
       "choice_b":"Municipal notes and bonds and commercial paper maturing in 270 days or less",
       "choice_c":"Shares issued to a corporate employee as part of their employee stock purchase plan",
       "choice_d":"Banks, trust companies, savings institutions or credit union securities",
       "correct_answer":"C",
       "explanation":"Shares issued to an employee as a part of the employee\u0027s stock purchase plan are not exempt; however, securities issued for employee savings plans, pension plans, profit sharing plans are exempt transactions."
    },
    {
       "id":4819,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Individuals who represent issuers in exempt transactions are not considered agents; exempt transactions include:",
       "choice_a":"Transactions between the issuer and financial institutions",
       "choice_b":"Transactions between the issuer and the underwriter, or private placements",
       "choice_c":"Transactions affecting partners, employees, officers, and directors when no compensation is paid to the individual",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are considered exempt transactions."
    },
    {
       "id":4820,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Registration under the Uniform Securities Act is not required if:",
       "choice_a":"The agent receives no commissions for his sales work",
       "choice_b":"The agent performs no sales functions",
       "choice_c":"The agent handles customer account transactions only",
       "choice_d":"The agent handles more clerical work than sales work, but handles both",
       "correct_answer":"B",
       "explanation":"Registration is required regardless of whether or not a commission is paid; an agent is any individual who effects trades in any capacity and thus must be registered."
    },
    {
       "id":4821,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The Vice President of a large company sells company stock to the company\u0027s employees who are awarded options and the ability to participate in the company\u0027s stock purchase plan. Under the USA: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The executive must register if he receives compensation </li><li>Executives of the company may not oversee sales of company stock to its employees </li><li>The executive would be considered an agent of the issuer if they receive compensation </li><li>The executive would not be considered an agent if he receives no compensation</li></ol>",
       "choice_a":"II only",
       "choice_b":"I and III",
       "choice_c":"II and IV",
       "choice_d":"I, III, and IV",
       "correct_answer":"D",
       "explanation":"If the executive receives compensation on the sales, they must register and would be considered an agent of the issuer. If the person does not receive compensation, they do not need to register."
    },
    {
       "id":4822,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, any individual that represents a broker dealer is considered to be an:",
       "choice_a":"An Associated Person",
       "choice_b":"An Insider",
       "choice_c":"An Officer",
       "choice_d":"A Director",
       "correct_answer":"A",
       "explanation":"An associated person is any individual that controls, or is under the control of, the broker dealer. An associated person could be a registered representative of the broker dealer. The other choices can be associated persons, but an associated person would not be required to be an officer or director of the firm."
    },
    {
       "id":4823,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When a client took a brief vacation in Montana, his registered representative who was not registered in Montana was allowed to sell him securities even though the customer did not live in Montana; which ruling allowed this?",
       "choice_a":"Temporary Residency Rule",
       "choice_b":"De Minimis Exemption",
       "choice_c":"Local Agent Exemption",
       "choice_d":"Uniform Securities Act Exemption IIIa",
       "correct_answer":"A",
       "explanation":"The Temporary Residency Rule allows an agent to conduct business with a client who is traveling in a state for less than 30 days."
    },
    {
       "id":4824,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When an agent changes broker dealer firms, he must do which of the following?",
       "choice_a":"Notify the State Administrator within the first six months of employment",
       "choice_b":"Notify the State Administrator immediately",
       "choice_c":"Reregister immediately individually with the State Administrator by coordination",
       "choice_d":"Notify the broker dealer firm as soon as the registration is completed",
       "correct_answer":"B",
       "explanation":"When an agent changes broker dealer firms, the agent, the prior employer, and the new employer must immediately notify the state representative of the change."
    },
    {
       "id":4825,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When John Brown takes and passes the Series 66 exam, he will be qualified to register to do business as:",
       "choice_a":"A broker dealer",
       "choice_b":"An agent",
       "choice_c":"A broker",
       "choice_d":"A dealer",
       "correct_answer":"B",
       "explanation":"Taking and passing the Series 66 exam qualifies Mr. Brown to register to do business as an agent in the state so long as he has also passed the Series 7 exam."
    },
    {
       "id":4826,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are excluded from the definition of an agent under the USA? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A broker dealer representing an issuer in a public offering of non-exempt securities  </li><li>An individual who represents a local municipality in the sale of its bonds </li><li>An individual representing an issuer in the sale of non-exempt securities </li><li>An investment advisor with an office in the state that has not obtained any clients but is advertising their services</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Of the choices listed, only III would be required to register as an agent. All of the other choices are excluded from the definition of an agent."
    },
    {
       "id":4827,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are true regarding a federally covered investment adviser? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They must have at least 110 million dollars under management or expect to have more than 110 million dollars under management </li><li>They register with the SEC </li><li>They must register in the states in which they do business </li><li>They must pay fees to the states in which they do business</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"A federally covered adviser must do all of the answers listed except register with the states. They register with the SEC and pay fees to the states where they conduct business."
    },
    {
       "id":4828,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is true about registration under the Uniform Securities Act?",
       "choice_a":"Only broker dealers and agents must be registered in the state where they transact business",
       "choice_b":"A broker dealer can employ a person as an agent who is not registered as long as the agent passes the appropriate exams within 90 days of acting as an agent",
       "choice_c":"An agent\u0027s registration is good for five years regardless whether the agent changes firms",
       "choice_d":"All registrations expire on the same day",
       "correct_answer":"D",
       "explanation":"The registration of firms and agents all expire on December 31st."
    },
    {
       "id":4829,
       "topic_id":4,
       "practice_test_id":1,
       "question":"Which of the following must be included on all registration applications?",
       "choice_a":"Educational background",
       "choice_b":"The applicant\u0027s qualifications, business history, financial history, and current condition",
       "choice_c":"All non-securities related convictions for the life of the applicant",
       "choice_d":"Consent to service of process",
       "correct_answer":"D",
       "explanation":"All registration applications for agents and firms must include the consent to service of process."
    },
    {
       "id":4830,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Which of the following must be true in order for a private investment company to charge a performance based fee?",
       "choice_a":"All clients must have a net worth of at least $5,000,000",
       "choice_b":"All clients must be institutional investors",
       "choice_c":"All clients must have at least $1,000,000 under management",
       "choice_d":"Performance based compensation is directly prohibited",
       "correct_answer":"C",
       "explanation":"In order for a private investment company to charge a performance based fee, all clients must have at least $1,000,000 under the adviser\u0027s management."
    },
    {
       "id":4831,
       "topic_id":4,
       "practice_test_id":3,
       "question":"Which of the following statements are considered true of an agent? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They act on behalf of a third party  </li><li>Agents earn a commission on the purchase or sale of a security  </li><li>Agents earn a markup on the purchase or sale of a security </li><li>They are required to be registered in each state that they conduct business</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I, II, and IV",
       "choice_d":"I,III, and IV",
       "correct_answer":"C",
       "explanation":"An agent acts on behalf of a third party, and would earn a commission on the purchase and sale of securities for a client. All agents under the Uniform Securities Act are required to be registered in each state that they solicit public securities business. A principal or a dealer earns a markup."
    },
    {
       "id":4832,
       "topic_id":4,
       "practice_test_id":4,
       "question":"You\u0027re an agent for an investment adviser and you maintain custody of customer cash and securities. Your firm also has full discretion for several long standing clients. The State Administrator has required your firm to post a surety bond in the amount of $35,000. Your firm may deposit which of the following instead of posting the bond?",
       "choice_a":"Cash only",
       "choice_b":"Cash or marketable securities",
       "choice_c":"Cash, marketable securities, or real estate",
       "choice_d":"Nothing may be substituted for a surety bond",
       "correct_answer":"B",
       "explanation":"Only a deposit of cash or marketable securities may be deposited to meet the surety bond requirement."
    },
    {
       "id":4833,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Which of the following are considered to be retail communication?",
       "choice_a":"The broker dealer\u0027s intranet",
       "choice_b":"Emails to less than 25 potential customers within 30 days",
       "choice_c":"Emails to several existing customers",
       "choice_d":"Instant messages to 25 or more potential customers",
       "correct_answer":"D",
       "explanation":"The company\u0027s intranet would not be available to the public and would not be retail communication. Emails to existing customers and to fewer than 25 potential customers is considered correspondence. IMs to more that 25 people is retail communication."
    },
    {
       "id":4834,
       "topic_id":4,
       "practice_test_id":6,
       "question":"All of the following are considered correspondence under FINRA Rule 2210 except:",
       "choice_a":"Emails to several existing customer",
       "choice_b":"Emails to 20 potential customers",
       "choice_c":"Emails to 30 potential customers",
       "choice_d":"Customized written communication with an existing customer",
       "correct_answer":"C",
       "explanation":"Correspondence is customized communication with a client or with a small group. Once an email is sent to more than 25 customers it is no longer correspondence, it becomes part of retail communication and requires approval of a principal."
    },
    {
       "id":4836,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A general securities principal must approve which of the following?",
       "choice_a":"Research reports",
       "choice_b":"Emails to 35 potential customers",
       "choice_c":"Instant messages to 40 potential customers",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The principal is responsible for the approval of all advertising and sales literature. All of the choices are classified as sales literature."
    },
    {
       "id":4837,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered rep sent an email to John Q Smith, a potential client who was referred by his client Harry Jones. The email:",
       "choice_a":"Is considered advertising",
       "choice_b":"Is considered sales literature",
       "choice_c":"Is considered correspondence",
       "choice_d":"Requires FINRA approval",
       "correct_answer":"C",
       "explanation":"If an email is sent to fewer than 25 potential customers in a 30 day period, it is correspondence."
    },
    {
       "id":4838,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Copies of instant messages sent to 50 potential customers must be kept for:",
       "choice_a":"5 years",
       "choice_b":"3 years",
       "choice_c":"10 years",
       "choice_d":"The life of the firm",
       "correct_answer":"B",
       "explanation":"All electronic communication must be retained for 3 years."
    },
    {
       "id":4840,
       "topic_id":4,
       "practice_test_id":"",
       "question":"FINRA prohibits which of the following?",
       "choice_a":"The use of excessive hedge clauses in electronic communications",
       "choice_b":"Making misleading statements in electronic communications",
       "choice_c":"Implying that FINRA endorses the broker dealer",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"FINRA rules prohibit all of the choices."
    },
    {
       "id":4841,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to FINRA Conduct Rules, which of the following are considered advertisements?",
       "choice_a":"Bulletin boards",
       "choice_b":"Blogs",
       "choice_c":"Banner ads",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"FINRA Conduct Rules state that publicly available websites, as well as blogs, banner ads and bulletin boards are considered advertising."
    },
    {
       "id":4842,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Password protected websites accessible to both institutional and individual customers are:",
       "choice_a":"Advertising",
       "choice_b":"retail communication",
       "choice_c":"Correspondence",
       "choice_d":"Prohibited by FINRA Conduct Rules",
       "correct_answer":"B",
       "explanation":"Password protected websites accessible to individual customers are considered to be part of retail communication under FINRA Rule 2210."
    },
    {
       "id":4843,
       "topic_id":4,
       "practice_test_id":"",
       "question":"As per FINRA Rule 2210, electronic communications with the public:",
       "choice_a":"Must be based on the principles of fair dealing",
       "choice_b":"Must include price predictions",
       "choice_c":"Are prohibited unless the individual is an existing client",
       "choice_d":"Must be pre-filed with FINRA 15 days prior to use",
       "correct_answer":"A",
       "explanation":"All communications with the public must be based on the principles of fair dealing. It is a violation of the rule to omit material information, or to give misleading information via electronic communication."
    },
    {
       "id":4844,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are true except:",
       "choice_a":"Emails to 25 or more potential clients must be approved by the principal prior to use",
       "choice_b":"A principal must approve a research report before it is posted on the firm\u0027s website",
       "choice_c":"All correspondence requires principal approval prior to use",
       "choice_d":"Electronic advertising requires prior principal approval",
       "correct_answer":"C",
       "explanation":"A principal must approve all advertising and sales literature prior to use, whether it is written or electronic. Correspondence must be maintained at the firm, but does not require prior principal approval."
    },
    {
       "id":4845,
       "topic_id":4,
       "practice_test_id":1,
       "question":"FINRA Rule 3110, as it relates to books and records, states all of the following except:",
       "choice_a":"If a registered rep\u0027s email is sent from home, it is not part of the firm\u0027s records",
       "choice_b":"If a registered rep\u0027s email is sent from the office, it is part of the firm\u0027s records",
       "choice_c":"If a registered rep sends an instant message from home, it is part of the firm\u0027s records",
       "choice_d":"If a registered rep sends an instant message from the office, it is part of the firm\u0027s records",
       "correct_answer":"A",
       "explanation":"Rule 3110 states that when a rep sends an electronic communication regarding the firm\u0027s business (IM or email), from any location, it becomes part of the firm\u0027s records and must be maintained for 3 years."
    },
    {
       "id":4846,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered rep has created an online blog where she writes about her thoughts on the equity market. This is an example of:",
       "choice_a":"Sales literature, which is exempt from principal approval",
       "choice_b":"Sales literature, which requires principal approval",
       "choice_c":"Advertising, which is exempt from principal approval",
       "choice_d":"Advertising, which requires principal approval",
       "correct_answer":"D",
       "explanation":"FINRA Rules state that publicly available websites, including blogs, are advertising. All advertising requires prior principal approval."
    },
    {
       "id":4847,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered rep makes a recommendation to a customer via email. Which of the following is / are true?",
       "choice_a":"The rep must make a reasonable effort to obtain the customer\u0027s investment objective and financial situation",
       "choice_b":"The rep must have reasonable grounds for believing the recommendation is suitable for the client",
       "choice_c":"The email would be considered correspondence",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Regardless of how a recommendation is made to a customer, the rep must obtain suitability information from the client and then have reasonable grounds for believing the recommendation is suitable. Any email sent to an individual client is considered to be correspondence."
    },
    {
       "id":4848,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Member Conduct Rules state that registered reps must avoid conflicts of interest when dealing with customers. With respect to equity research reports,",
       "choice_a":"Written research reports are exempt from the conflict of interest rules",
       "choice_b":"Electronic research reports are exempt from the conflict of interest rules",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"D",
       "explanation":"Both written and electronic research reports require that conflicts of interest be disclosed to the public."
    },
    {
       "id":4849,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker dealer\u0027s public website is:",
       "choice_a":"Advertising",
       "choice_b":"Public appearance",
       "choice_c":"Not covered by FINRA rules",
       "choice_d":"Not covered by FINRA rules if it is password protected",
       "correct_answer":"A",
       "explanation":"A broker dealer\u0027s public website is considered advertising. If it is password protected it becomes sales literature. FINRA Rules apply to both advertising and sales literature."
    },
    {
       "id":4850,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Which of the following are important with respect to a broker dealer\u0027s website?",
       "choice_a":"The name of the firm should be prominently displayed",
       "choice_b":"Risk disclosure should clearly state the potential risks",
       "choice_c":"Information on the website must be updated to keep information current",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices are important considerations when a broker dealer maintains a public website."
    },
    {
       "id":4851,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are examples of advertising except:",
       "choice_a":"Blogs",
       "choice_b":"Chat rooms",
       "choice_c":"Websites",
       "choice_d":"Bulletin boards",
       "correct_answer":"B",
       "explanation":"Chat rooms are not advertising; they are considered public appearances."
    },
    {
       "id":4852,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If a broker dealer refers to its membership in FINRA on its website which of the following is / are true?",
       "choice_a":"It is required by the Conduct Rules",
       "choice_b":"The firm must provide a hyperlink to the FINRA website",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"B",
       "explanation":"There is no requirement that a member refer to FINRA on it\u0027s website. However, if the firm chooses to mention it\u0027s FINRA membership, it must provide a hyperlink to FINRA\u0027s homepage that is close to the FINRA reference on the site."
    },
    {
       "id":4853,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The FINRA logo:",
       "choice_a":"May be used on a firm\u0027s website",
       "choice_b":"May be used on a registered rep\u0027s website",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"D",
       "explanation":"The use of the FINRA logo is prohibited for use on both the firm\u0027s and registered rep\u0027s website."
    },
    {
       "id":4854,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A supervisor must review all:",
       "choice_a":"Employees incoming electronic communications",
       "choice_b":"Employees outgoing communications",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"All firm\u0027s must have procedures in place to have a supervisor review all employees incoming and outgoing electronic communications."
    },
    {
       "id":4855,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Regarding electronic communications between a firm\u0027s research department and non-research departments, all of the following are true except:",
       "choice_a":"Pre-approval of FINRA is required",
       "choice_b":"Pre-approval by the principal is required for certain public communications",
       "choice_c":"Copies of the electronic communications are sent to the firm\u0027s legal department",
       "choice_d":"Copies of the electronic communications are sent to the firm\u0027s compliance department",
       "correct_answer":"A",
       "explanation":"Both the NYSE and FINRA rules require that electronic communications between the research and non-research departments be copied to the firm\u0027s legal and compliance departments. Additionally, the principal is required to pre-approve all sales literature (eg: a research report). FINRA does not approve advertising or sales literature."
    },
    {
       "id":4856,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are true when a broker dealer receives a complaint from a customer?",
       "choice_a":"When a customer mails a complaint to the firm it must be reported to FINRA",
       "choice_b":"When a customer faxes a complaint to the firm it must be reported to FINRA",
       "choice_c":"When a customer emails a complaint to the firm it must be reported to FINRA",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All customer complaints are reported to FINRA."
    },
    {
       "id":4857,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If a registered rep sends a business related email to his client via his Yahoo email account, all of the following are true except:",
       "choice_a":"The communication is not required to be supervised by the firm since it was sent from outside the office",
       "choice_b":"The communication is required to be supervised by the firm",
       "choice_c":"The communication must be retained by the firm for three years",
       "choice_d":"The firm may have policies that prohibit this communication",
       "correct_answer":"A",
       "explanation":"Not all firms allow reps to send emails from their personal addresses. If the firm does not prohibit this practice, the electronic communications are to be supervised and maintained at the firm."
    },
    {
       "id":4858,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to FINRA, e-faxes:",
       "choice_a":"Are not considered electronic communications",
       "choice_b":"Do not require supervision",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"D",
       "explanation":"According to FINRA rules, e-faxes are considered to be an electronic form of communication and as such require the appropriate supervision."
    },
    {
       "id":4859,
       "topic_id":4,
       "practice_test_id":"",
       "question":"With respect to reviewing a registered rep\u0027s emails at the firm, a supervisor:",
       "choice_a":"May not delegate this responsibility",
       "choice_b":"May delegate only to Series 24 licensed principal",
       "choice_c":"Is ultimately responsible for the review",
       "choice_d":"Is required to perform this review every 30 days",
       "correct_answer":"C",
       "explanation":"Firms are required to have procedures in place for reviewing rep\u0027s emails, though not necessarily every 30 days. The review may be done by a supervisor or it may be delegated to another person with the proper knowledge, experience and training. It is not required for the reviewer to be a Series 24 principal."
    },
    {
       "id":4860,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following electronic communications require supervision by a principal?",
       "choice_a":"Blogs",
       "choice_b":"Group emails",
       "choice_c":"Bulletin boards",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The principal is required to supervise all electronic communications including blogs, group emails and bulletin boards."
    },
    {
       "id":4861,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If a broker dealer\u0027s website requires a person to type in a password to gain access to the site, this is considered:",
       "choice_a":"Customized communications with the public",
       "choice_b":"Retail communication",
       "choice_c":"Advertising",
       "choice_d":"prohibited, as FINRA Conduct Rules require that all broker dealer websites be public websites, and therefore can not be password protected sites",
       "correct_answer":"B",
       "explanation":"When a website is password protected, a firm has the ability to target their audience,  FINRA considers this to be retail communication ."
    },
    {
       "id":4862,
       "topic_id":4,
       "practice_test_id":"",
       "question":"How long is a firm required to keep copies of group emails?",
       "choice_a":"The firm is not required to keep copies of group emails",
       "choice_b":"5 years, readily accessible for 2 years",
       "choice_c":"3 years, readily accessible for 2 years",
       "choice_d":"10 years, readily accessible for 3 years",
       "correct_answer":"C",
       "explanation":"Group emails are considered sales literature and copies need to be kept for three years, with the most recent two years readily accessible."
    },
    {
       "id":4863,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Joe is a registered rep at XYZ broker dealer. According to FINRA rules if Joe sends an email to 15 prospective clients, which of the following is true?",
       "choice_a":"The emails are considered to be group emails",
       "choice_b":"The emails are classified as sales literature",
       "choice_c":"The emails are classified as correspondence",
       "choice_d":"The emails must be pre-approved by the compliance officer",
       "correct_answer":"C",
       "explanation":"If the same email is sent to fewer than 25 prospects, the email is still considered correspondence. Just like with form letters, once the email is sent to 25 or more prospects it becomes a \u0022group email\u0022 and is considered sales literature. There is no FINRA requirement that the compliance officer pre-approve correspondence."
    },
    {
       "id":4864,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Electronic advertising must:",
       "choice_a":"Be approved by the principal prior to use",
       "choice_b":"Be filed with FINRA",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"All advertising and sales literature, whether written or electronic, must be approved by the principal prior to use and filed with FINRA (not approved by FINRA)."
    },
    {
       "id":4865,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When a registered rep sends an instant message to a client, all of the following are true except:",
       "choice_a":"The instant message is considered correspondence",
       "choice_b":"The instant message must be maintained by the firm",
       "choice_c":"The instant message must be supervised by the firm",
       "choice_d":"The instant message may omit material facts",
       "correct_answer":"D",
       "explanation":"An instant message is an example of electronic correspondence. As with written correspondence, it may not contain any false or misleading information, or omit any material facts."
    },
    {
       "id":4866,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is not part of a broker dealer\u0027s  retail communication?",
       "choice_a":"An email to 35 existing clients",
       "choice_b":"A broker dealer\u0027s website",
       "choice_c":"Customized communication between an agent and multiple customers detaining investment strategies",
       "choice_d":"An instant message to 38 potential customers",
       "correct_answer":"C",
       "explanation":"Customized communication between an agent and customers is considered to be correspondence and not part of a broker dealer\u0027s retail communication. The key is that it is customized for each client and all of the communications do not contain the exact same text."
    },
    {
       "id":4867,
       "topic_id":4,
       "practice_test_id":1,
       "question":"All of the following are retail communication except:",
       "choice_a":"A research report",
       "choice_b":"A marketing letter",
       "choice_c":"Group email",
       "choice_d":"An instant message to a client at their place of bussiness",
       "correct_answer":"D",
       "explanation":"An instant message to a single client is considered to be correspondence."
    },
    {
       "id":4868,
       "topic_id":4,
       "practice_test_id":2,
       "question":"If a registered rep enters an Internet chat room which of the following is true?",
       "choice_a":"The rep may make exaggerated statements if he is not sending a research report to the customer",
       "choice_b":"The rep may make misleading statements to entice a prospective customer",
       "choice_c":"The rep may not reference past performance to indicate potential future results",
       "choice_d":"The rep may make unwarranted statements to entice a customer",
       "correct_answer":"C",
       "explanation":"In a chat room the rep and must adhere to FINRA\u0027s rules regarding fair practice. Therefore, no unwarranted or exaggerated claims or misleading statements are allowed. And as always, past performance is no indication of future performance."
    },
    {
       "id":4869,
       "topic_id":4,
       "practice_test_id":3,
       "question":"According to FINRA rules, correspondence includes all of the following except:",
       "choice_a":"A chat room",
       "choice_b":"A letter to an individual client",
       "choice_c":"50 emails to existing clients",
       "choice_d":"7 instant messages to prospective clients",
       "correct_answer":"A",
       "explanation":"A chat room is a public appearance, not correspondence. Sending emails to existing clients is considered correspondence, regardless of the number of emails sent. However, when sending emails to prospects, the number must remain under 25 to be classified as correspondence. 25 or more IMs to prospective clients is sales literature."
    },
    {
       "id":4870,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Which of the following must be maintained by the broker dealer for three years?",
       "choice_a":"A business related email sent by the rep to his customer from his personal email address",
       "choice_b":"A business related email sent by the rep to his customer from his firm\u0027s email address",
       "choice_c":"A business related instant message sent by the rep to his customer from his personal email address",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Whether the customer is communicating from home or office the firm is required to maintain copies of his business related electronic communications for three years."
    },
    {
       "id":4871,
       "topic_id":4,
       "practice_test_id":5,
       "question":"With regard to a broker dealer\u0027s website, all of the following are true except:",
       "choice_a":"Public websites are considered advertising",
       "choice_b":"Research reports must be approved by the principal before being posted on the website",
       "choice_c":"Password protected websites are considered advertising",
       "choice_d":"FINRA logos are prohibited on a broker dealer\u0027s website",
       "correct_answer":"C",
       "explanation":"Password protected websites are classified as sales literature, not advertising. All of the other choices are true of a broker dealer\u0027s website."
    },
    {
       "id":4873,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Which of the following need to be taken into consideration when a broker dealer maintains a website?",
       "choice_a":"The information contained must be current",
       "choice_b":"The firm\u0027s name must be prominently displayed",
       "choice_c":"Risk disclosures must be displayed appropriately",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices are important when a broker dealer maintains a website."
    },
    {
       "id":4874,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are true except:",
       "choice_a":"Electronic communications referring to the reliability of a firm\u0027s electronic trading systems may not be exaggerated",
       "choice_b":"A broker dealer must update the information on its website at least annually",
       "choice_c":"Risk disclosures must be displayed on the broker dealer\u0027s website",
       "choice_d":"The broker dealer is not required to mention its FINRA membership on its website",
       "correct_answer":"B",
       "explanation":"There is no exact requirement for how often a broker dealer must update its website. However, the information contained must be current so as not to mislead the public. Reference to FINRA membership on a member\u0027s website is not obligatory. If the firm chooses to mention its FINRA membership, it must furnish a hyperlink to FINRA\u0027s homepage."
    },
    {
       "id":4875,
       "topic_id":4,
       "practice_test_id":"",
       "question":"With regard to correspondence which of the following is true?",
       "choice_a":"An email to 50 potential customers is correspondence",
       "choice_b":"Each email to individual customers must be approved by the principal",
       "choice_c":"The principal may randomly select certain emails for review",
       "choice_d":"The principal need not review correspondence, only advertising and sales literature",
       "correct_answer":"C",
       "explanation":"A principal is required to review correspondence, and approve advertising and sales literature (a group email to 25 or more prospective clients is sales literature ). However, due to the volume of correspondence the firm\u0027s supervisory procedures may allow them to review correspondence randomly."
    },
    {
       "id":4876,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is/are true if a registered rep enters a chat room and details invstment services?",
       "choice_a":"It is considered retail communication",
       "choice_b":"It is subject to supervision by the firm",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"When a registered rep enters a chat room and details investment services, it is considered to be part of retail communication and is subject to appropriate firm supervision."
    },
    {
       "id":4877,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to SRO rules, under which of the following circumstances may an individual make a supervisory review of her own electronic communications?",
       "choice_a":"If the member is a sole proprietor with no other way of conducting a review",
       "choice_b":"If the member has fewer than 100 electronic communications per 60-day period",
       "choice_c":"If the member has fewer than 10 reps",
       "choice_d":"If a review is done on a monthly basis",
       "correct_answer":"A",
       "explanation":"Members may not make a supervisory review of their own individual electronic communications unless, because of their size or corporate structure, there is no other way to conduct the review. A member who is a sole proprietor with no other employees fits this scenario."
    },
    {
       "id":4878,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under FINRA rules, all of the following are retail communication when detailing investment opportunities,  except:",
       "choice_a":"An Internet bulletin board",
       "choice_b":"An email sent to 15 prospects in a 30-day period",
       "choice_c":"A broker dealer\u0027s website",
       "choice_d":"A registered rep\u0027s Internet blog",
       "correct_answer":"B",
       "explanation":"All of the choices are retail communication except an email sent to 15 prospects in a 30-day period. The email would be considered to be correspondence. If the email is sent to more than 25 retail investors in a 30 day period it will be considered retail communication."
    },
    {
       "id":4880,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered rep sends an email to a prospect with the intent of gaining her as a client. Which of the following is true?",
       "choice_a":"The email is correspondence and requires prior approval by the principal",
       "choice_b":"The email is correspondence and does not require prior approval by the principal",
       "choice_c":"The email is retail communication and requires prior approval by the principal",
       "choice_d":"The email is retail communication and does not require prior approval by the principal",
       "correct_answer":"B",
       "explanation":"An email that is sent to fewer than 25 prospective customers in a 30-day period is correspondence and does not require prior principal approval. However, the firm is required to review a rep\u0027s correspondence."
    },
    {
       "id":4881,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is / are true when a rep sends electronic communications to the public?",
       "choice_a":"The rep has the same responsibilities as she would if she were speaking face to face with the client",
       "choice_b":"The rep must abide by firm policies regarding e-communications",
       "choice_c":"The same electronic communications sent to 100 existing customers is correspondence",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Member Conduct Rules are the same for all communications with the public. In addition to SRO rules, the individual firm\u0027s have policies in place regarding e-communications that the rep is required to adhere to."
    },
    {
       "id":4882,
       "topic_id":4,
       "practice_test_id":6,
       "question":"When a registered rep sends an instant message to a client, that instant message is:",
       "choice_a":"Advertising",
       "choice_b":"Sales literature",
       "choice_c":"Correspondence",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"An IM to an individual client is correspondence."
    },
    {
       "id":4883,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If an individual who resides in Florida, works as a representative for a federally registered investment adviser based in Georgia, the individual:",
       "choice_a":"Is exempt from registration in Florida",
       "choice_b":"Must register in the state of Florida",
       "choice_c":"Is in violation as they are working for an out of state adviser",
       "choice_d":"May only advise accredited investors",
       "correct_answer":"B",
       "explanation":"The individual must register as an investment advisor representative in the state of Florida. The individual is as a representative of the investment advisory firm and lives and works in the state of Florida."
    },
    {
       "id":4884,
       "topic_id":4,
       "practice_test_id":1,
       "question":"As an investment adviser, you have a client who trades on margin. The client receives a margin call from the broker-dealer holding the account. The client requests a short-term loan from your advisory firm. Which of the following best addresses this situation?",
       "choice_a":"An adviser may not execute orders for a margin customer",
       "choice_b":"You may not loan the money unless the rate exceeds the prime rate",
       "choice_c":"You may loan money for no longer than 30 days and at no less than prime rate",
       "choice_d":"You may loan the money if your firm is a financial institution in the business of making loans",
       "correct_answer":"D",
       "explanation":"Your firm would have to be a lending institution in order to make loans."
    },
    {
       "id":4885,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Which of the following activities is / are most likely considered unethical on the part of investment advisers? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An adviser disproportionately allocates hot initial public offerings (\u0022IPOs\u0022) to proprietary accounts and does not adequately disclose this practice to all clients </li><li>An adviser disproportionately allocates hot initial public offerings (\u0022IPOs\u0022) to accounts that pay performance fees and does not adequately disclose this practice to all clients </li><li>An adviser disproportionately allocates hot initial public offerings (\u0022IPOs\u0022) to newly formed investment company portfolios and does not adequately disclose this practice to all clients </li><li>An adviser has not earned either an MBA degree or CFA distinction</li></ol>",
       "choice_a":"I only",
       "choice_b":"II, III only",
       "choice_c":"I, II, III only",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"Choices I, II and III are all conflicts of interest."
    },
    {
       "id":4886,
       "topic_id":4,
       "practice_test_id":3,
       "question":"SIA, a registered investment adviser, buys securities for the advisory omnibus trading account before allocating shares to the various client accounts. Which of the following represent true statements concerning this practice?",
       "choice_a":"SIA must take great pains not to allocate the shares based on subsequent market movements",
       "choice_b":"SIA may allocate those stocks with subsequent favorable price movements to accounts that pay performance fees and allocate those stocks with subsequent unfavorable price movements to accounts that pay a % of assets-only",
       "choice_c":"Both A and B",
       "choice_d":"Neither A nor B",
       "correct_answer":"A",
       "explanation":"Advisers must do every thing they can to avoid conflicts of interest and must avoid favoring one client of the firm over another."
    },
    {
       "id":4887,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Which of the following represent violations for investment advisers? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An adviser allocates client brokerage to a broker in exchange for client referrals without full disclosure of the practice </li><li>An adviser allocates client brokerage to a broker in exchange for client referrals without full disclosure of the fact that clients pay higher brokerage commissions and do not obtain the best price and execution </li><li>An adviser makes no attempt to secure the best execution reasonably obtainable for a client transaction </li><li>An adviser allocates client brokerage to a broker in exchange for research or other products without disclosure</li></ol>",
       "choice_a":"I only",
       "choice_b":"III only",
       "choice_c":"II, III only",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Advisers must try to get the best execution of the trade for clients. And, when directing the trades to broker-dealers, the adviser must disclose to clients any compensation received, whether cash or “soft-dollar compensation.”"
    },
    {
       "id":4888,
       "topic_id":4,
       "practice_test_id":5,
       "question":"A primary responsibility of an investment adviser is the supervision of its employees, to ensure that all of its activities comply with disclosures made to clients and with the provisions of applicable securities laws. The most effective way to fulfill this responsibility is to construct and implement a comprehensive system of internal controls and supervisory procedures. Which of the following situations represent an investment adviser\u0027s failure to implement a comprehensive system of internal controls and supervisory procedures?",
       "choice_a":"An investment adviser\u0027s operating procedures allow a portfolio manager to value the securities recommended, or override values provided by a custodian, for purposes of reporting to clients and calculating advisory fees without any independent review.",
       "choice_b":"An investment adviser does not have an oversight process to determine whether risks taken in managing client portfolios are consistent with each client\u0027s stated investment objectives and/or to measure and evaluate each client\u0027s risk tolerance",
       "choice_c":"Both A and B",
       "choice_d":"Neither A nor B",
       "correct_answer":"C",
       "explanation":"An Investment Advisory firm is responsible for any and all people associated with the firm."
    },
    {
       "id":4889,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Which of the following activities on the part of an investment adviser would most likely be prohibited?",
       "choice_a":"A portfolio manager buys shares of ABC for accounts of immediate family members just before placing large purchase orders on ABC for large institutional accounts in order to gain better pricing",
       "choice_b":"A portfolio manager buys shares of ABC for accounts of affiliates just before placing large purchase orders on ABC for large institutional accounts in order to gain better pricing",
       "choice_c":"A portfolio manager buys shares of ABC for personal accounts just before placing large purchase orders on ABC for large institutional accounts in order to gain better pricing",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed detail front running, an un-ethical practice."
    },
    {
       "id":4890,
       "topic_id":4,
       "practice_test_id":"",
       "question":"In order for two agents to share commissions on a transaction or series of transactions, which of the following must apply?",
       "choice_a":"The agents must be registered",
       "choice_b":"The agents must work for the same broker-dealer directly or indirectly",
       "choice_c":"The agents must have the approval of their principals",
       "choice_d":"All choices listed",
       "correct_answer":"D",
       "explanation":"This is in NASAA\u0027s Model Rule for Broker-Dealers and Agents."
    },
    {
       "id":4891,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following statements is / are accurate concerning the use of discretion?",
       "choice_a":"An agent of a broker-dealer must have written permission from the customer before entering the first discretionary order",
       "choice_b":"An investment adviser may use discretion based on verbal authorization from the client provided written discretionary authority is obtained within 10 business days",
       "choice_c":"An investment adviser must state whether discretionary authority is granted over client accounts when filing Form ADV",
       "choice_d":"All choices listed",
       "correct_answer":"D",
       "explanation":"Broker-dealers and agents need written discretionary authority before using discretion. Technically, according to NASAA\u0027s policy statement, it would be a violation for the adviser to use any discretionary authority pursuant to verbal authorization unless they receive the written authorization within 10 business days."
    },
    {
       "id":4892,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following orders would require discretionary authorization?",
       "choice_a":"Buy 1,000 shares of SIA today",
       "choice_b":"Buy 1,000 shares of SIA when the price is right",
       "choice_c":"Buy as many shares of SIA as you think I should buy when the price is right",
       "choice_d":"All of the choices given",
       "correct_answer":"C",
       "explanation":"If the firm is merely choosing the time/price at which to enter an order where the customer has already named the action, asset, and amount of shares, that doesn\u0027t require discretion."
    },
    {
       "id":4893,
       "topic_id":4,
       "practice_test_id":"",
       "question":"From which of the following clients may an investment adviser borrow money?",
       "choice_a":"Out of a clients account",
       "choice_b":"A trust fund they manage",
       "choice_c":"Non-profit organization",
       "choice_d":"Credit union",
       "correct_answer":"D",
       "explanation":"Credit unions are lending institutions along with S&L\u0027s, thrifts, banks, etc."
    },
    {
       "id":4894,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following statements would be permissible for an agent to make to a client or prospect?",
       "choice_a":"This security has already been registered with the state, who has determined that it is a valid investment",
       "choice_b":"I am a properly registered agent, certified by the state",
       "choice_c":"These securities are neither approved nor disapproved by any regulator",
       "choice_d":"This security is federal covered and is, therefore, safer than other types of securities",
       "correct_answer":"C",
       "explanation":"A federal covered security is exempt from state registration, however, if the sale an exempt security is fraudulent, then it would be a violation of the law."
    },
    {
       "id":4895,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The Chief Financial Officer of a large, publicly traded company tells a member of his country club that his company is about to be acquired by one of the largest international conglomerates in the world. The country club member astutely purchases convertible debentures and call options on the CFO\u0027s company\u0027s stock. Who, if anyone, has violated insider trading rules?",
       "choice_a":"Neither has violated the rules",
       "choice_b":"Both have violated the rules",
       "choice_c":"Only the CFO violated the rules",
       "choice_d":"Only the buyer of the securities violated the rules",
       "correct_answer":"B",
       "explanation":"Both the \u0022tipee\u0022 and the \u0022tipper\u0022 have run violated the Insider Trading Enforcement Act of 1988."
    },
    {
       "id":4896,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker-dealer or investment adviser would need to obtain written discretionary authority in order to choose all of the following for a customer order except",
       "choice_a":"Security purchased",
       "choice_b":"Amount of security purchased",
       "choice_c":"Whether purchased or sold",
       "choice_d":"Time of day",
       "correct_answer":"D",
       "explanation":"Choosing the time/price for an order your customer gave you does not require discretionary authorization/power of attorney."
    },
    {
       "id":4897,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following orders require power of attorney except",
       "choice_a":"Buy 1,000 shares of an insurance company",
       "choice_b":"Buy as much SIA as I can afford today",
       "choice_c":"Buy 1,000 shares of SIA today",
       "choice_d":"Buy insurance company stocks and REIT\u0027s today",
       "correct_answer":"C",
       "explanation":"If the customer names the stock to be purchased and the number of shares, the broker does not need discretionary authorization to choose the time or price at which to enter the customer\u0027s order."
    },
    {
       "id":4898,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Issuers of which of the following securities are exempt from the antifraud provisions of the Securities Exchange Act of 1934?",
       "choice_a":"Bank stock",
       "choice_b":"Municipal bonds",
       "choice_c":"Both choices listed",
       "choice_d":"Neither choice listed",
       "correct_answer":"D",
       "explanation":"A security or firm might be exempt from filing requirements, No one is exempt from the anti-fraud provisions."
    },
    {
       "id":4899,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following factors may justify a higher markup on a security except:",
       "choice_a":"Price dealer paid for the security",
       "choice_b":"Dollar amount of the trade",
       "choice_c":"Price of the security",
       "choice_d":"Whether stock or bond",
       "correct_answer":"A",
       "explanation":"The price the Dealer paid for the stock is not used in calculating the marking up."
    },
    {
       "id":4900,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker-dealer receives commissions for trades directed by an investment adviser with authority to choose which broker-dealer is used for executing client trades. If the broker-dealer provides soft dollar compensation to the adviser, for which of the following may such compensation be used?",
       "choice_a":"A trip to tour the new call center of one of the companies in which the adviser maintains a large stock position",
       "choice_b":"Money to purchase a new computer for executing trades when entered by the investment adviser",
       "choice_c":"Credit toward the upgrade of a software program relating to investment research",
       "choice_d":"A gift of two tickets to a football game for an important client",
       "correct_answer":"C",
       "explanation":"All benefits of trading through a broker dealer must also benefit the clients."
    },
    {
       "id":4901,
       "topic_id":4,
       "practice_test_id":6,
       "question":"In order for an agent to share in the gains and losses of a client\u0027s account, what is required?",
       "choice_a":"Written consent of the client",
       "choice_b":"Written consent of the employing broker-dealer",
       "choice_c":"Gains and losses must be shared in proportion to the agent\u0027s capital commitment",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are covered under NASAA\u0027S Model Rule for Broker-Dealers and Agents which details what type of sharing arrangements are allowed for agents and clients."
    },
    {
       "id":4902,
       "topic_id":4,
       "practice_test_id":1,
       "question":"Although you were recently hired as an agent of a broker-dealer, you also would like to work part-time mowing lawns. Therefore",
       "choice_a":"Because the work is non-investment-related, no disclosure is required",
       "choice_b":"You must notify your broker-dealer in writing",
       "choice_c":"You must receive a no action letter from the SEC or FINRA",
       "choice_d":"No disclosure is required if compensation is less than \u00BD of average compensation earned at the firm",
       "correct_answer":"B",
       "explanation":"Always notify your firm if you\u0027re even thinking about working outside the firm in any capacity."
    },
    {
       "id":4903,
       "topic_id":4,
       "practice_test_id":2,
       "question":"All of the following are fiduciaries except",
       "choice_a":"Trustee",
       "choice_b":"Pension fund manager",
       "choice_c":"Investment adviser without discretion",
       "choice_d":"Agent",
       "correct_answer":"D",
       "explanation":"Agents represent the firm. They have to be ethical when dealing with customers, but they are not fiduciaries managing affairs for a client."
    },
    {
       "id":4904,
       "topic_id":4,
       "practice_test_id":3,
       "question":"SIA Advisers has drafted an agreement that allows non-qualified clients to compensate the firm on the basis of capital appreciation above the rate of the quarterly S&P 500 index appreciation. This type of waiver",
       "choice_a":"Is a standard clause in investment advisory contracts",
       "choice_b":"Is prohibited",
       "choice_c":"Is permissible for clients with $10,000 or more under management",
       "choice_d":"Is a prohibited practice known as \u0022selling away\u0022",
       "correct_answer":"B",
       "explanation":"No waivers of any provision are allowed. Any such contract is also deemed \u0022null and void\u0022 by the regulators and the courts."
    },
    {
       "id":4905,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Why is churning a violation?",
       "choice_a":"Because the SEC mandates only 11 trades per week for non-institutional investors",
       "choice_b":"Because the SEC allows only 11 trades per week for non-institutional investors",
       "choice_c":"Because the practice yields commissions to agents and firms, often at the expense of customers",
       "choice_d":"Because the Securities Act of 1929 defined it so",
       "correct_answer":"C",
       "explanation":"Excessive trading or the splitting of orders in an effort to generate additional commissions is clearly prohibited."
    },
    {
       "id":4906,
       "topic_id":4,
       "practice_test_id":5,
       "question":"All of the following represent prohibited practices for IA\u0027s except",
       "choice_a":"Entering into or renewing contracts that provide for compensation as a share of capital gains",
       "choice_b":"Entering into or renewing contracts that provide for compensation as a percentage of total assets under management",
       "choice_c":"Entering into or renewing contracts that provide for assignment of contract without client consent",
       "choice_d":"Entering into verbal contracts with non-institutional clients",
       "correct_answer":"B",
       "explanation":"That\u0027s why the business is often called \u0022asset-based management.\u0022 Also, no verbal contracts are allowed."
    },
    {
       "id":4907,
       "topic_id":4,
       "practice_test_id":6,
       "question":"A securities salesperson calls four of his clients two or three times a week presenting investments. Often, the salesperson encourages the clients to sell one of their existing holdings and buy the new securities he is recommending. If the salesperson talks to them and gets their permission to do the trades, this could be",
       "choice_a":"Following suitability requirements",
       "choice_b":"Churning the accounts",
       "choice_c":"Churning if the securities are held in tax-advantaged accounts",
       "choice_d":"Front running",
       "correct_answer":"B",
       "explanation":"Agents get paid whenever their clients buy and sell securities. That does not mean that agents should encourage clients to frequently buy and sell securities. If it looks as if your recommendations are based purely on their ability to generate commissions, we call it churning."
    },
    {
       "id":4908,
       "topic_id":4,
       "practice_test_id":"",
       "question":"SIA Broker-Dealers has been charging customers commissions and mark-ups that average 10% more than the industry average. According to NASAA\u0027s Policy Statement “Dishonest or Unethical Business Practices of Broker-Dealers and Agents,” what is true of this situation?",
       "choice_a":"It is fraudulent and deceptive",
       "choice_b":"It is permissible with prior NASAA-approval",
       "choice_c":"It is prohibited if deemed to be excessive and/or unreasonable",
       "choice_d":"All customers over the past 90 days are due full refunds, plus court costs, minus any income received from recommended purchases",
       "correct_answer":"C",
       "explanation":"The 5% mark up policy is a guideline, if the Broker Dealer can justify the fess and expenses and are clearly disclosed to the customer, no violation as occurred. If the fees are deemed to be excessive a violation has taken place."
    },
    {
       "id":4909,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following represent prohibited activities of investment advisers except",
       "choice_a":"Accepting prepayment of more than $500 six or more months in advance with proper disclosure of financial condition",
       "choice_b":"Placing all client transactions through a broker-dealer that compensates the adviser with commissions without disclosure",
       "choice_c":"Trading opposite of recommendations given to clients without disclosure",
       "choice_d":"Revealing client affairs, transactions, account balances, etc. in the absence of a court order",
       "correct_answer":"A",
       "explanation":"Accepting prepayment of greater than $500 for six or more months in advance is not prohibited"
    },
    {
       "id":4910,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following customer orders would require discretionary authorization except:",
       "choice_a":"Buy as many shares of SIA as you think appropriate",
       "choice_b":"Buy 300 shares of SIA today at a good price",
       "choice_c":"Buy $5,000 worth of technology stocks today",
       "choice_d":"Buy some insurance company and bank holding company stocks today",
       "correct_answer":"B",
       "explanation":"Anything more than time and price is considered discretion. A customer telling an agent to purchase 300 shares of SIA at a good price is only price discretion."
    },
    {
       "id":4911,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following advisory activities requires disclosure?",
       "choice_a":"Directing client brokerage to firms providing free research",
       "choice_b":"Recommending mutual funds paying 12b-1 fees to the adviser",
       "choice_c":"Acting as a principal on a recommended transaction",
       "choice_d":"All choices listed",
       "correct_answer":"D",
       "explanation":"Advisers must disclose all potential conflicts of interest to clients."
    },
    {
       "id":4912,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are prohibited activities except",
       "choice_a":"Painting the tape",
       "choice_b":"Arbitrage",
       "choice_c":"Selling away",
       "choice_d":"Front running",
       "correct_answer":"B",
       "explanation":"Arbitrage is a completely legal practice designed to take advantage of price discrepancies in the market place."
    },
    {
       "id":4913,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered representative may split commissions with his secretary:",
       "choice_a":"If the principal approves it",
       "choice_b":"If the secretary is registered as an agent",
       "choice_c":"If the split is at least 75/25",
       "choice_d":"Never",
       "correct_answer":"B",
       "explanation":"Commissions may only be paid to those that are registered."
    },
    {
       "id":4914,
       "topic_id":4,
       "practice_test_id":"",
       "question":"In which of the following cases can the investment adviser release information regarding the account of its clients?",
       "choice_a":"When an attorney for the wife of the account owner calls for information regarding the account in connection with a divorce filing",
       "choice_b":"When the client has given the IA permission to release the information",
       "choice_c":"Under no circumstances",
       "choice_d":"When an immediate family member inquires in writing",
       "correct_answer":"B",
       "explanation":"An adviser may only disclose client information if the client gives permission or if the regulators or courts demand it."
    },
    {
       "id":4915,
       "topic_id":4,
       "practice_test_id":"",
       "question":"You tell a customer that reinvesting all dividend and capital gains distributions from a mutual fund will insure against a loss of principal. This statement is:",
       "choice_a":"True for tax-advantaged accounts only",
       "choice_b":"An example of churning",
       "choice_c":"Misleading",
       "choice_d":"Prohibited unless accompanied by a prospectus",
       "correct_answer":"C",
       "explanation":"This is an example of a misleading statement an adviser may never make a promise of no loss."
    },
    {
       "id":4916,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is a true statement concerning material facts?",
       "choice_a":"Omitting material facts is fraudulent in the offer or sale of exempt securities",
       "choice_b":"Omitting material facts is fraudulent in the offer or sale of securities",
       "choice_c":"Omitting material facts is prohibited when offering or selling non-exempt securities",
       "choice_d":"Omitting material facts is prohibited when offering or selling securities to institutional buyers",
       "correct_answer":"B",
       "explanation":"All securities are subject to anti-fraud rules."
    },
    {
       "id":4917,
       "topic_id":4,
       "practice_test_id":"",
       "question":"In order to sell an unregistered, non-exempt security you convince your client to sign a waiver of compliance, effectively exempting both parties from the registration provisions of the Uniform Securities Act. This contract between you and the client is",
       "choice_a":"Enforceable only at the federal level",
       "choice_b":"Enforceable only at the state level",
       "choice_c":"Null and void",
       "choice_d":"Punishable up to 7 years in a state prison",
       "correct_answer":"C",
       "explanation":"No waivers of the USA are allowed. Agreements can not supersede or circumvent federal law."
    },
    {
       "id":4918,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following activities is / are prohibited? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Soliciting orders for registered, non-exempt securities </li><li>Creating the appearance of active trading in a security </li><li>Soliciting orders for unregistered, exempt securities </li><li>Failing to bring written complaints against an agent to the attention of a principal at the employing broker-dealer</li></ol>",
       "choice_a":"I, II, III, IV",
       "choice_b":"I, II, IV only",
       "choice_c":"II and IV only",
       "choice_d":"III only",
       "correct_answer":"C",
       "explanation":"There is nothing wrong with soliciting orders for registered securities, so eliminate \u0022I.” Then remember that \u0022exempt\u0022 securities are \u0022unregistered” by definition, and eliminate anything with a “III” in it."
    },
    {
       "id":4919,
       "topic_id":4,
       "practice_test_id":6,
       "question":"If a husband wants to open an account in which he trades for his wife, which of the following documents must be completed and signed?",
       "choice_a":"Power of attorney from the wife",
       "choice_b":"New account form",
       "choice_c":"Power of attorney from the husband",
       "choice_d":"Margin agreement",
       "correct_answer":"A",
       "explanation":"The wife would have to grant him that power or authority with a \u0022power of attorney.\u0022 The customer doesn\u0027t have to sign the new account form."
    },
    {
       "id":4920,
       "topic_id":4,
       "practice_test_id":"",
       "question":"While selling securities for a broker-dealer located on the premises of a retail bank, a registered representative tells a prospect that SIPC and FDIC are essentially the same. This statement is:",
       "choice_a":"Not prohibited",
       "choice_b":"Misleading and prohibited",
       "choice_c":"Accurate but prohibited",
       "choice_d":"Permissible",
       "correct_answer":"B",
       "explanation":"It\u0027s misleading and wrong. SIPC covers broker-dealer failure and missing assets, not market losses. FDIC-insured means your bank CD and your bank account can\u0027t lose value."
    },
    {
       "id":4921,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Just before placing a large buy order for your customer you buy calls on the stock yourself. This is an example of",
       "choice_a":"Market timing",
       "choice_b":"Front running, a violation",
       "choice_c":"An exempt transaction due to the derivative purchase",
       "choice_d":"Portfolio optimization",
       "correct_answer":"B",
       "explanation":"You\u0027re getting in front of the order to make an easy profit, that\u0027s called front running and it\u0027s definitely prohibited."
    },
    {
       "id":4922,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Molly has a life & health license. Pete, who also works at the firm, has both a life & health license and a Securities license. Therefore, when Molly refers clients who purchase variable annuities and mutual funds from Pete, Molly:",
       "choice_a":"May share in the commissions, since she and Pete share a common employer",
       "choice_b":"May not share in the commissions, since she is not securities licensed",
       "choice_c":"May share in the commissions if a principal approves it",
       "choice_d":"Is guilty of a fraudulent securities transaction",
       "correct_answer":"B",
       "explanation":"Unless you are registered as a securities rep, you may not share in commissions or fees from the sale of a security."
    },
    {
       "id":4923,
       "topic_id":4,
       "practice_test_id":1,
       "question":"Which of the following transactions is/are exempt from the state\u0027s filing requirements and anti-fraud rules?",
       "choice_a":"Isolated non-issuer transactions in outstanding securities",
       "choice_b":"Transactions between an issuer and an institutional investor",
       "choice_c":"Both A and B",
       "choice_d":"Neither A nor B",
       "correct_answer":"D",
       "explanation":"Nothing is exempt from anti-fraud rules."
    },
    {
       "id":4924,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Amber Waves is a certified public accountant who also owns an investment advisory firm. She has earned her MBA as well as being certified by the College of Financial Planners. Amber may print all of the following initials after her name except:",
       "choice_a":"CPA",
       "choice_b":"MBA",
       "choice_c":"CFP",
       "choice_d":"RIA",
       "correct_answer":"D",
       "explanation":"RIA is not a certification or credential for an individual. The RIA is the firm."
    },
    {
       "id":4925,
       "topic_id":4,
       "practice_test_id":3,
       "question":"SIA Broker-Dealers is a wholly owned subsidiary of WIDGET, Inc. If SIA would like to sell shares in a private placement of WIDGET stock:",
       "choice_a":"This is a fraudulent, unethical practice",
       "choice_b":"The Administrator must grant prior approval",
       "choice_c":"Full disclosure must be provided to non-institutional buyers",
       "choice_d":"Full disclosure must be provided to all buyers",
       "correct_answer":"D",
       "explanation":"If the underwriter is actually owned by the issuer, that needs to be disclosed since there is a potential conflict of interest."
    },
    {
       "id":4926,
       "topic_id":4,
       "practice_test_id":4,
       "question":"In order for a registered representative to borrow money from a client:",
       "choice_a":"The client must sign a waiver",
       "choice_b":"The client must be a bank or lending institution",
       "choice_c":"The agent must maintain a certain minimum net capital",
       "choice_d":"The Administrator must grant approval",
       "correct_answer":"B",
       "explanation":"You can borrow from your client, if your client is a bank or other lending institution."
    },
    {
       "id":4927,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Providing a fictitious quote to a customer is:",
       "choice_a":"Misleading and fraudulent",
       "choice_b":"A violation known as pegging",
       "choice_c":"A violation known as capping",
       "choice_d":"Not prohibited for fictitious accounts established at the firm",
       "correct_answer":"A",
       "explanation":"This is an example of a misleading statement agents may not give fictitious quotes and a firm may not establish fictitious accounts."
    },
    {
       "id":4928,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An agent is making a sales presentation to a high net worth investor. The agent is convinced the particular growth stock is an excellent opportunity and perfectly suitable for the investor\u0027s objective of growth and relatively high risk tolerance. All of the following activities on the part of the agent would be prohibited except:",
       "choice_a":"Promising to repurchase the stock if it drops more than 10%",
       "choice_b":"Guaranteeing a specific result",
       "choice_c":"Omitting immaterial information",
       "choice_d":"Refusing to provide a prospectus or other disclosure document",
       "correct_answer":"C",
       "explanation":"Immaterial information is immaterial and does not need to be disclosed to investors."
    },
    {
       "id":4929,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete is an investment adviser who happens to hold 100,000 warrants on Widget common stock. Whenever large numbers of purchase orders on Widget hit the market, Pete notices that the stock tends to rise sharply. Therefore, he:",
       "choice_a":"Must refrain from recommending XYZ",
       "choice_b":"Must refrain from recommending XYZ to non-institutional clients",
       "choice_c":"Must provide disclosure to clients on the potential conflict of interest",
       "choice_d":"May recommend XYZ freely, provided he rebates a reasonable percentage of the commissions to his clients",
       "correct_answer":"C",
       "explanation":"If there is something that gives the adviser some incentive to convince a client to accept the advice, that potential conflict of interest must be disclosed."
    },
    {
       "id":4930,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following represent prohibited practices for IA\u0027s except:",
       "choice_a":"Entering into or renewing contracts that provide for compensation as a share of capital gains",
       "choice_b":"Entering into or renewing contracts that provide for compensation as a percentage of total assets under management",
       "choice_c":"Entering into or renewing contracts that provide for assignment of contract without client consent",
       "choice_d":"Entering into verbal contracts with non-institutional clients",
       "correct_answer":"B",
       "explanation":"That\u0027s why the business is often called \u0022asset-based management.\u0022 Also, no verbal contracts are allowed."
    },
    {
       "id":4931,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A stock listed on the NYSE is not exempt from which of the following requirements of the Uniform Securities Act?",
       "choice_a":"Filing of advertising materials",
       "choice_b":"Registration",
       "choice_c":"Anti-fraud provisions",
       "choice_d":"Progress reports",
       "correct_answer":"C",
       "explanation":"No securities are exempt from the anti-fraud provisions of the USA."
    },
    {
       "id":4932,
       "topic_id":4,
       "practice_test_id":"",
       "question":"To be considered an \u0022insider\u0022 for purposes of insider trading rules, the person in question:",
       "choice_a":"Possesses material, non-public information",
       "choice_b":"Must be a vice-president of a public company or higher-level executive",
       "choice_c":"Must be the CEO or CFO of a large, publicly traded company",
       "choice_d":"Must be CEO or member of the Board of Directors",
       "correct_answer":"A",
       "explanation":"Material non public information can not be used for profit or protection from loss. Anyone who possesses such information is deemed to be an insider."
    },
    {
       "id":4933,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to NASAA\u0027s Statement of Policy on Unethical Business Practices, if an advisory firm is contacted by a catalogue company to provide names of clients to add to a mailing list, the advisory firm should:",
       "choice_a":"Not make any disclosures about its clients unless required to do so by law",
       "choice_b":"Provide client names if the request seems reasonable",
       "choice_c":"Provide only limited financial information",
       "choice_d":"Ask for samples of the company\u0027s products",
       "correct_answer":"A",
       "explanation":"It is considered unethical to divulge client information. However, there are times when an advisory firm is required to do so by law, such as in the case of a subpoena from a state or the SEC, or during an IRS inquiry."
    },
    {
       "id":4934,
       "topic_id":4,
       "practice_test_id":6,
       "question":"SIA Advisers allows IARs and clients to negotiate the fee for some of its advisory services. When considering what level of fees to charge a client, which of the following is true?",
       "choice_a":"There are no restrictions on the advisory fees that may be charged as long as the client consents to the fees.",
       "choice_b":"Fees may be negotiated with clients only within the specified limits set by the SEC.",
       "choice_c":"Fees negotiated with clients must be reasonable, taking into account the nature of the services provided.",
       "choice_d":"The level of fees charged by investment advisers is not an issue of concern to the SEC.",
       "correct_answer":"C",
       "explanation":"An investment adviser has a duty of loyalty to the client and must put the client\u0027s interests first. Considering whether the fee charged for advisory services is reasonable is part of making a suitability judgment about investment advice. This is especially important in programs in which an IAR has some control over the level of fees charged."
    },
    {
       "id":4935,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to NASAA\u0027s Statement of Policy on Unethical Business Practices, if an advisory firm is contacted by a catalogue company to provide names of clients to add to a mailing list, the advisory firm should:",
       "choice_a":"Not make any disclosures about its clients unless required to do so by law",
       "choice_b":"Provide client names if the request seems reasonable",
       "choice_c":"Provide only limited financial information",
       "choice_d":"Ask for samples of the company\u0027s products",
       "correct_answer":"A",
       "explanation":"It is considered unethical to divulge client information. However, there are times when an advisory firm is required to do so by law, such as in the case of a subpoena from a state or the SEC, or during an IRS inquiry."
    },
    {
       "id":4936,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, an investment adviser that has no place of business in a state is exempt from registration if:",
       "choice_a":"The adviser has no more than five clients who are residents of the state",
       "choice_b":"The adviser has no more than fifteen clients who are residents of the state",
       "choice_c":"All of the adviser\u0027s clients are accredited investors",
       "choice_d":"All of the adviser\u0027s clients were obtained on an unsolicited basis",
       "correct_answer":"A",
       "explanation":"Under the Uniform Securities Act, an adviser does not have to register if it has no place of business in a state and does not have more than five clients who are residents of that state. This is referred to as the de minimis exemption."
    },
    {
       "id":4937,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete is the new compliance officer for SIA Financial, Inc., a registered investment adviser. Which of the following should be the highest priority for further investigation to determine if there are conflicts of interest that must be disclosed to customers?",
       "choice_a":"SIA accepts only individual clients that have at least $250,000 in investable assets.",
       "choice_b":"SIA requires its clients to select the broker-dealer that will hold the customer\u0027s securities and execute customer trades.",
       "choice_c":"SIA permits its investment adviser representatives to purchase the same securities that they recommend to clients.",
       "choice_d":"SIA does not permit its investment adviser representatives to recommend limited partnership investments to clients.",
       "correct_answer":"C",
       "explanation":"While it is not illegal for IARs to purchase the same securities they recommend to customers, advisory firms will typically have in place procedures designed to minimize conflicts of interest and unethical practices. For example, if an IAR purchased a specific stock and then recommended that clients purchase the same stock, this could be considered front running. In addition, the SEC has stated that investment advisers generally must disclose if their personal securities transactions are inconsistent with the advice given to clients."
    },
    {
       "id":4938,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under NASAA\u0027s Statement of Policy on Unethical Business Practices, in which of the following circumstances can a security be sold without first receiving written discretionary authority from the client?",
       "choice_a":"The client discloses the name of the security he or she wants to purchase.",
       "choice_b":"The broker\u0027s only decision relates to the price and time of the transaction.",
       "choice_c":"The broker\u0027s only decision relates to the amount of money involved in the transaction.",
       "choice_d":"Transactions involving less than $10,000.",
       "correct_answer":"B",
       "explanation":"If a client does not give written discretionary approval, a broker can only decide the time and price involved in the transaction."
    },
    {
       "id":4939,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, which of the following is a non-issuer transaction?",
       "choice_a":"A 100-share traded on The NYSE",
       "choice_b":"A mutual fund redemption",
       "choice_c":"The sale of securities to an employee where no commission is paid",
       "choice_d":"A limited partner buying directly from the sponsor",
       "correct_answer":"A",
       "explanation":"A secondary market transaction, such as a 100-share trade executed on the NYSE, is referred to as a non-issuer transaction under the Uniform Securities Act."
    },
    {
       "id":4940,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under SEC Release 1092, money managers are prohibited from directing commission dollars to obtain which of the following items from registered broker-dealers?",
       "choice_a":"Office space",
       "choice_b":"Computer software",
       "choice_c":"In-house research reports",
       "choice_d":"Third-party research reports",
       "correct_answer":"A",
       "explanation":"A money manager may not direct commissions to a registered broker-dealer in order to obtain office space or furniture."
    },
    {
       "id":4941,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Securities Act of 1933, the registration statement that the issuer of new securities files with the SEC must include all of the following information except:",
       "choice_a":"Certified financial statements",
       "choice_b":"Biographies of all the issuer\u0027s officers and directors",
       "choice_c":"Results of the due diligence meeting",
       "choice_d":"The issuer\u0027s capitalization",
       "correct_answer":"C",
       "explanation":"The due diligence meeting is customarily held after the registration statement is filed with the SEC. Its results are not required as part of the registration statement. All the other answers refer to information that the issuer must include in the registration statement."
    },
    {
       "id":4942,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Investment Advisers Act of 1940, which of the following would not be considered investment adviser advertising?",
       "choice_a":"A television commercial for services provided free of charge",
       "choice_b":"Form letters sent accompanied by a brochure highlighting past performance",
       "choice_c":"A radio commercial by the chief economist of an investment advisory firm",
       "choice_d":"A letter addressed to an individual client discussing that person\u0027s specific investment objectives",
       "correct_answer":"D",
       "explanation":"Investment adviser advertising is defined as a notice, circular, letter, written communication addressed to more than one person, or an announcement in any publication or by radio or television that offers investment advisory services. A letter written to a specific client concerning that person\u0027s specific investment objectives would not be considered advertising."
    },
    {
       "id":4943,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The Investment Company Act of 1940 specifies that no more than 49% of the directors of an investment company can be:",
       "choice_a":"Related persons",
       "choice_b":"Interested persons",
       "choice_c":"Control persons",
       "choice_d":"Designated persons",
       "correct_answer":"B",
       "explanation":"No more than 49% of the board of directors of an investment company may be \u0022interested persons.\u0022 Interested persons include affiliated persons (officers, directors, employees, principal underwriter, investment adviser), broker-dealers, and registered representatives."
    },
    {
       "id":4944,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Which of the following is true regarding SEC sanctions imposed under the Investment Advisers Act of 1940?",
       "choice_a":"SEC sanctions may not be appealed",
       "choice_b":"SEC sanctions may be appealed to the federal court system within 60 days",
       "choice_c":"SEC sanctions may be overturned by an arbitration panel",
       "choice_d":"SEC sanctions may be appealed to the FINRA Division of Enforcement",
       "correct_answer":"B",
       "explanation":"SEC orders may be appealed to the federal appeals court system within 60 days of the date of the order."
    },
    {
       "id":4945,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete, an investment adviser representative, has been discussing with Amber, a potential client, the advantages of purchasing a financial plan. Pete unexpectedly runs into Amber on the sidewalk while returning from another client meeting. Amber tells Pete that she has decided that a financial plan would be a great idea and is ready to sign the contract on the spot. Pete, however, has not yet given Amber a copy of his firm\u0027s ADV Part II and does not have a copy with him. Which of the following is true?",
       "choice_a":"Pete may obtain Amber\u0027s signature on the contract as long as he delivers an ADV Part II to her within five business days.",
       "choice_b":"Pete does not have to provide Amber with the ADV Part II until she gives him payment for the plan.",
       "choice_c":"Pete may use any approved marketing brochure in lieu of the ADV Part II.",
       "choice_d":"Pete may not obtain Amber\u0027s signature on the contract until he has provided her with a copy of ADV Part II.",
       "correct_answer":"D",
       "explanation":"The Advisers Act Brochure Rule requires delivery of ADV Part II or an equivalent brochure either; 48 hours prior to entering into any advisory contract; or, at the time the contract is signed providing that the client has the right to terminate the contract without penalty within five business days. It would not be acceptable to obtain the client\u0027s signature prior to delivering the brochure."
    },
    {
       "id":4946,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete is a registered representative with SIA Company, a broker-dealer. Pete also conducts his own investment adviser business, Pete\u0027s Advice, Inc. Pete has disclosed his investment advisory business to SIA, but SIA does not supervise Pete\u0027s advisory activities. When Pete creates a financial plan for one of his advisory clients, he often helps the client implement the plan by executing securities transactions through SIA. Which of the following is (are) true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>This arrangement is acceptable, but Pete may not earn commissions from his clients\u0027 securities transaction if he is also charging them a fee for financial planning. </li><li>Pete should disclose to his clients that he is an RR for SIA Company and that he may receive compensation for client transactions executed through SIA in addition to his advisory fees. </li><li>Pete should disclose to his clients that they may implement their financial plans through broker-dealers other than SIA Company. </li><li>Pete should disclose that his advisory activities not supervised by SIA Company.</li></ol>",
       "choice_a":"I only",
       "choice_b":"III only",
       "choice_c":"II and III only",
       "choice_d":"II, III, and IV only",
       "correct_answer":"D",
       "explanation":"An investment adviser that is also a registered representative of a broker - dealer and that provides investment advisory services outside the scope of employment with the broker- dealer must disclose to his advisory clients that these advisory activities are independent from his employment with the broker - dealer. Additional disclosures would be required, depending on the circumstances, if the investment adviser recommends that his clients execute securities transactions through the broker - dealer with which the investment adviser is associated. For example, the investment adviser would be required to disclose fully the nature and extent of any interest the investment adviser has in such recommendation, including any compensation the investment adviser would receive from the employer in connection with the transaction. In addition, the investment adviser would be required to inform his clients of their ability to execute recommended transactions through other brokers - dealers"
    },
    {
       "id":4947,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Investment Advisers Act of 1940, the term investment supervisory services refers to which of the following?",
       "choice_a":"A branch manager of a broker-dealer monitoring the sales efforts of the agents in that branch office",
       "choice_b":"An investment adviser giving continuous investment advice to a client based on the individual needs of the client",
       "choice_c":"The compliance manager of a broker-dealer monitoring the trades of employees and clients for possible insider trading violations",
       "choice_d":"An investment adviser maintaining custody over client funds or securities",
       "correct_answer":"B",
       "explanation":"The definition of investment supervisory services is found in ADV Part II. It means providing advice on a continuous basis to a client based on her needs, current asset holdings, and personal and family obligations. If applicable, the adviser must disclose in ADV Part II the percentage of its total advisory billings derived from investment supervisory services."
    },
    {
       "id":4948,
       "topic_id":4,
       "practice_test_id":1,
       "question":"SIA Financial, Inc. is a registered investment adviser. It is in the same family of companies as SIA Company, a broker-dealer. IARs managing client portfolios for SIA Financial use SIA Brokerage to execute securities transactions. Which of the following is true?",
       "choice_a":"This arrangement is illegal, since RIAs may not execute client transactions through affiliated brokers.",
       "choice_b":"RIAs may execute transactions through affiliated brokers if they disclose the practice to clients and ensure that their clients are receiving the best executions possible.",
       "choice_c":"This practice is normal and does not have to be disclosed as long as the cost of execution is indicated on the confirmation for each transaction.",
       "choice_d":"This practice does not have to be disclosed if the investment adviser thinks it is in the client\u0027s best interest.",
       "correct_answer":"B",
       "explanation":"While an investment adviser may execute securities transactions through an affiliated broker-dealer, this practice must be clearly disclosed to clients, since it is a conflict of interest. Written disclosure is typically made in Form ADV Part II."
    },
    {
       "id":4949,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Under NASAA\u0027s Statement of Policy on Unethical Business Practices, an investment adviser may not disclose the performance history of a particular client\u0027s account if:",
       "choice_a":"The adviser is subpoenaed to testify in a divorce hearing involving the client",
       "choice_b":"The adviser wishes to use the excellent performance of the account as a device to attract more clients and the client grants permission",
       "choice_c":"The adviser receives a summons to provide confidential client records to the IRS",
       "choice_d":"A reporter for a financial magazine wishes to use the client\u0027s portfolio history to illustrate the adviser\u0027s methods",
       "correct_answer":"D",
       "explanation":"It is unethical for an investment adviser to disclose the identity, affairs, or investments of any client without the client\u0027s consent, unless required to do so by law."
    },
    {
       "id":4950,
       "topic_id":4,
       "practice_test_id":3,
       "question":"According to the Securities Exchange Act of 1934, when institutional investment managers trade with discretionary authority, they must file with the SEC if holdings in:",
       "choice_a":"Investment grade bonds are valued at $1,000,000 or more",
       "choice_b":"Equity securities are valued at $1,000,000 or more",
       "choice_c":"Investment grade bonds are valued at $100,000,000 or more",
       "choice_d":"Equity securities are valued at $100,000,000 or more",
       "correct_answer":"D",
       "explanation":"Rule 13f-1 of the Securities Exchange Act of 1934 requires quarterly filings when an institutional investment manager exercises investment discretion over at least $100,000,000 in equity securities"
    },
    {
       "id":4951,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Under the Investment Advisers Act of 1940, which of the following persons engaged in the business of advising others about securities investments is required to be licensed as an investment adviser?",
       "choice_a":"A bank holding company",
       "choice_b":"A licensed broker-dealer whose advice is incidental to its business",
       "choice_c":"A person whose advice relates only to exempt securities",
       "choice_d":"A publisher of a monthly investment newsletter",
       "correct_answer":"C",
       "explanation":"The Investment Advisers Act of 1940 exempts from the definition of an investment adviser banks and bank holding companies, publishers of investment newsletters, and licensed broker-dealers if the investment advice is incidental to its profession. The Act also excludes any person whose advice or reports relates only to U.S. government securities. The exemption does not include advice on other exempt securities (e.g., municipals, nonprofit organizations)."
    },
    {
       "id":4952,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Which of the following would be considered a prohibited transaction under ERISA?",
       "choice_a":"The purchase of an over-the-counter stock",
       "choice_b":"A loan to the plan\u0027s trustee from the plan",
       "choice_c":"An investment in derivative securities",
       "choice_d":"A delegation of investment authority by plan fiduciaries",
       "correct_answer":"B",
       "explanation":"A trustee is clearly a fiduciary. ERISA prohibits plan fiduciaries and parties in interest from engaging in certain transactions with retirement plans. These prohibited transactions include: the sale, exchange, or lease of property; lending money or extending credit; furnishing goods, services, or facilities; and transferring or using plan assets for their own benefit. ERISA does not place a per se prohibition on any particular type of investment for retirement plans. A fiduciary may appoint an investment manager to oversee the investment of the plan\u0027s assets."
    },
    {
       "id":4953,
       "topic_id":4,
       "practice_test_id":6,
       "question":"According to the Investment Advisers Act of 1940, who of the following professionals may be required to register as an investment adviser? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A financial planner </li><li>An economist who works as a pension consultant </li><li>An attorney who is a sports representative</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"According to the Investment Advisers Act of 1940, all of the professionals mentioned could be classified as investment advisers."
    },
    {
       "id":4954,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, the term person could include <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An unincorporated organization </li><li>An individual </li><li>A political subdivision of a government</li></ol>",
       "choice_a":"II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"Under the Uniform Securities Act, the term person includes an individual, corporation, partnership, association, joint stock company, a trust where the interests are evidenced by a security, an unincorporated organization, a government, or a political subdivision of a government."
    },
    {
       "id":4955,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Amber Wave operates her own registered investment advisory firm and wishes to deliver written promotional materials to a prospective client disclosing her educational background and advisory practices. To satisfy the disclosure requirements of the Investment Advisers Act of 1940, Ms. Wave may deliver:",
       "choice_a":"A copy of Part I of an ADV form or a brochure that includes similar information",
       "choice_b":"A copy of Part II of an ADV form or a brochure that includes similar information",
       "choice_c":"An article about the investment adviser extracted from a financial publication",
       "choice_d":"A list of all the investment adviser\u0027s recommendations for the past ten years",
       "correct_answer":"B",
       "explanation":"According to SEC Rule 204-3 (the Brochure Rule), an investment adviser must furnish clients and potential clients with either a copy of Part II of an ADV form or a written document containing at least the information required by Part II of the ADV form."
    },
    {
       "id":4956,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, denial of an agent\u0027s registration can be based on:",
       "choice_a":"Conviction of a drug-related felony",
       "choice_b":"Conviction of a drug-related misdemeanor",
       "choice_c":"Payment made to a client based upon an FINRA arbitration settlement",
       "choice_d":"Failure to complete university studies",
       "correct_answer":"A",
       "explanation":"Of the choices given, only a felony conviction is a reason to deny, suspend, or revoke an agent\u0027s registration."
    },
    {
       "id":4957,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are paid compensation for giving investment advice. Under the Investment Advisers Act of 1940, which of the following is not provided with a general exemption from the definition of an investment adviser?",
       "choice_a":"A trust company",
       "choice_b":"An agent for an athlete",
       "choice_c":"An accountant providing incidental investment advice",
       "choice_d":"A publisher",
       "correct_answer":"B",
       "explanation":"Any person in a profession that does not have an exclusion from the definition of an investment adviser and who meets the three-prong test of SEC Release 1092 would be considered an investment adviser. The regulators are not concerned with a title; they are more interested in what a person actually does."
    },
    {
       "id":4958,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An IAR believes they have a particular conflict of interest with a specific client. Her primary obligation is to disclose the conflict to:",
       "choice_a":"That client",
       "choice_b":"All of her clients",
       "choice_c":"Her advisory firm",
       "choice_d":"The SEC",
       "correct_answer":"A",
       "explanation":"An investment adviser must disclose any conflict of interest that applies to a particular client. If the conflict is with only one client, it must be disclosed to that client."
    },
    {
       "id":4959,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following activities requires registration as an investment adviser under the Uniform Securities Act?",
       "choice_a":"Engaging in insurance activities",
       "choice_b":"Providing advice about real estate",
       "choice_c":"Providing advice about the value of precious metals",
       "choice_d":"Providing asset allocation advice that includes advice on mutual funds",
       "correct_answer":"D",
       "explanation":"Asset allocation advice involves determining the best investment mix for a client and is viewed as securities-related advice under the Uniform Securities Act. The other activities are not securities related."
    },
    {
       "id":4960,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An investment adviser representative creating a financial plan for a client has encountered an issue that she does not have the knowledge or experience to handle herself. The IAR should:",
       "choice_a":"Resign from the account",
       "choice_b":"Omit from the plan anything related to that issue",
       "choice_c":"Quickly develop the expertise needed to solve the problem",
       "choice_d":"Consult another professional with the appropriate expertise",
       "correct_answer":"D",
       "explanation":"The financial plans created for some clients can be complex. IARs may encounter issues that they cannot handle personally. It is appropriate in such situations to consult other professionals who have the required expertise. This may include other IARs that have specialized knowledge, attorneys, accountants, actuaries, etc."
    },
    {
       "id":4961,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Investment Advisers Act of 1940, the definition of an investment adviser could include which of the following?",
       "choice_a":"Pension consultants",
       "choice_b":"Coin dealers",
       "choice_c":"English antique furniture advisers",
       "choice_d":"Managed commodity fund advisers",
       "correct_answer":"A",
       "explanation":"Pension consultants may provide securities-related advice as an integral part of other financial services and may be considered investment advisers under SEC Release 1092. Coin dealers, furniture advisers, and commodities advisers do not provide advice about securities."
    },
    {
       "id":4962,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, the statute of limitations regarding the issuance of an indictment on a criminal charge is:",
       "choice_a":"Within five years of the alleged violation",
       "choice_b":"Within five years of discovery of the alleged violation",
       "choice_c":"No later than two years after the violation occurred",
       "choice_d":"No later than three years after discovery of the alleged violation",
       "correct_answer":"A",
       "explanation":"An indictment must be brought on a criminal charge within five years of the date of the alleged violation."
    },
    {
       "id":4963,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Investment Advisers Act of 1940, which of the following statements is true concerning investment adviser contracts?",
       "choice_a":"If a client does not receive a disclosure document at least 48 hours prior to entering into the contract, the client may terminate the contract without penalty within five business days after signing the contract",
       "choice_b":"The advice given to other clients with the same net worth and income must be similar",
       "choice_c":"The adviser must choose the S&P 500 as a comparative measure of investment performance for the client.",
       "choice_d":"An assignment of the contract may be made without the client\u0027s consent",
       "correct_answer":"A",
       "explanation":"The Investment Advisers Act of 1940 states that a client must receive the brochure (disclosure document) either i) 48 hours prior to entering into a contract with the adviser, or ii) at the time the contract is entered into if the client has the right to terminate the contract without penalty within five business days. Advice given to clients does not have to be similar to that offered to other clients and an adviser does not have to select the S&P 500 to measure the performance of the account. The adviser may select any relevant index as long as the use of the index can be justified. No assignment of the contract may be made without the client\u0027s consent."
    },
    {
       "id":4964,
       "topic_id":4,
       "practice_test_id":"",
       "question":"One of the main differences between investment adviser representatives and registered representatives is that:",
       "choice_a":"Investment adviser representatives have a stronger fiduciary duty to their clients than registered representatives",
       "choice_b":"Investment adviser representatives are regulated by the states while registered representatives are regulated by the SEC",
       "choice_c":"Registered representatives deal with a wider range of products than investment adviser representatives",
       "choice_d":"Registered representatives do not have any obligation to make certain that their investment recommendations are suitable whereas investment adviser representatives do",
       "correct_answer":"A",
       "explanation":"In general, advisory firms and their investment adviser representatives (IARs) have a higher fiduciary duty to clients than do broker-dealers and their registered representatives (RRs). Broker-dealers and their RRs are regulated by both the SEC and the states. Advisory firms are regulated by either the SEC or the states, depending on the nature of the advisory firm, while IARs of federal advisers are subject to registration in any state in which they have a place of business. Both RRs and IARs deal with a wide range of securities products, although the advice provided by some advisers may encompass non securities products as well, such as insurance, real estate, and collectibles. The recommendations of both RRs and IARs are subject to suitability standards."
    },
    {
       "id":4965,
       "topic_id":4,
       "practice_test_id":1,
       "question":"Jack who is an attorney is also a Certified Financial Planner. He advertises the services he provides, including investment advisory management. According to the Investment Advisers Act of 1940:",
       "choice_a":"If he charges a fee for investment advice, the Administrator would be required to make a private ruling as to whether he is an investment adviser",
       "choice_b":"If he charges a fee for investment advice, he would not be able to avail himself of the professional exemption for CFPs",
       "choice_c":"Whether he meets the definition of an investment adviser depends on the number of clients he services",
       "choice_d":"An attorney in the business of providing investment advice, who advertises and charges a fee, would be considered an investment adviser",
       "correct_answer":"D",
       "explanation":"Jack would be considered an investment adviser. He cannot take advantage of the professional exemption given to lawyers (and others) because he holds himself out as being in the business of providing advice. The fact that he is proficient in many areas is not relevant to his status as an investment adviser."
    },
    {
       "id":4966,
       "topic_id":4,
       "practice_test_id":2,
       "question":"If an investment adviser has a personal interest in a transaction that could result in the adviser favoring her interests rather than the interests of her client, the investment adviser must:",
       "choice_a":"Disclose this conflict of interest to the customer",
       "choice_b":"Refrain from proceeding with the transaction",
       "choice_c":"Notify her supervisor of the potential conflict of interest",
       "choice_d":"Do nothing as no problem exists",
       "correct_answer":"B",
       "explanation":"A conflict-of-interest situation can be so great that disclosure alone is not enough. This can result when an investment adviser has a personal interest in an investment and advises clients to engage in transactions that favor the adviser\u0027s position. The investment adviser should refrain from participating in transactions where there is the possibility that the adviser\u0027s interests outweigh the client\u0027s interests."
    },
    {
       "id":4967,
       "topic_id":4,
       "practice_test_id":3,
       "question":"According to the Investment Advisers Act of 1940, an advisory firm may use solicitors to market the services of the adviser provided that the <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Terms of the compensation arrangement between the solicitor and the adviser are disclosed to the client if the solicitor is not associated with the investment adviser </li><li>Solicitor provides a copy of the adviser\u0027s disclosure document </li><li>Solicitor is not subject to a suspension order from the SEC</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"A solicitor not associated with the adviser must disclose to a prospective client the amount of compensation received and if there is any fee differential attributable to the compensation arrangement. The solicitor must also provide the prospective client with the investment adviser\u0027s written disclosure statement. In order to perform solicitation services, the solicitor must not be subject to a suspension order nor have a misdemeanor or felony conviction in securities in the last ten years."
    },
    {
       "id":4968,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Under NASAA\u0027s Statement of Policy on Unethical Business Practices, an adviser is considered to have exercised discretionary power with respect to a customer order if the client has not specified: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The price of execution </li><li>The particular security to be bought or sold </li><li>Whether to buy or sell</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"C",
       "explanation":"The term discretionary power does not include discretion as to the price or time of the transaction if the client has directed or approved the purchase or sale of a definite amount of a particular security."
    },
    {
       "id":4969,
       "topic_id":4,
       "practice_test_id":5,
       "question":"A broker-dealer charges a wrap fee for the management of client accounts. Under the Investment Advisers Act of 1940, which of the following statements about the broker-dealer is true?",
       "choice_a":"The broker-dealer is not an investment adviser according to the exchange definition",
       "choice_b":"The broker-dealer must register as an investment adviser",
       "choice_c":"The broker-dealer need not register as an investment adviser because the wrap fee is not special compensation",
       "choice_d":"The broker-dealer must register as an investment adviser only if the clients are located in more than one state",
       "correct_answer":"B",
       "explanation":"The broker-dealer, by charging a separate fee for investment management services, is acting as an investment adviser and must register."
    },
    {
       "id":4970,
       "topic_id":4,
       "practice_test_id":6,
       "question":"US One Advisors is charging an 8% management fee for its managed accounts. According to the NASAA Statement of Policy on Unethical Business Practices:",
       "choice_a":"This is a clear violation and the advisory firm should expect severe consequences",
       "choice_b":"The Administrator has the right to evaluate fees to determine if they are excessive",
       "choice_c":"New clients should be given discounts to reduce the average fee charged",
       "choice_d":"Advisers should adhere to the 2% fee guideline",
       "correct_answer":"B",
       "explanation":"Under the ethical standards provisions of the NASAA Statement of Policy, the Administrator has the right to determine if fees are excessive by comparing fees charged by other advisers for similar services. There is no particular amount that makes a fee excessive."
    },
    {
       "id":4971,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The plan documents of a qualified retirement plan require that the investment manager purchase securities issued by the plan\u0027s sponsor. These are securities that a prudent investor clearly would not purchase. What is the only course of action that the investment adviser may take in order to avoid violating the fiduciary responsibility provisions of ERISA?",
       "choice_a":"Purchase the securities",
       "choice_b":"Purchase only a small amount of the securities",
       "choice_c":"Refuse to purchase the securities",
       "choice_d":"Appeal to the Department of Labor for an individual exemption from the prohibited transaction rules",
       "correct_answer":"C",
       "explanation":"ERISA states that a fiduciary must follow the terms of the plan documents unless these documents are inconsistent with ERISA. In this case, purchasing these securities would violate the prudent expert standard of ERISA. Thus, the plan documents are in conflict with ERISA and the investment adviser should not follow them. An adviser that did purchase the securities could be held liable for violating a fiduciary duty."
    },
    {
       "id":4972,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Investment Company Act of 1940, if a mutual fund has an exemptive order from the SEC, it may engage in: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Selling short </li><li>Trading on margin </li><li>Joint trading accounts</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"The general rule under the Investment Company Act of 1940 is that mutual funds may not engage in these activities. However, an exemptive order provides funds with an exception."
    },
    {
       "id":4973,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to NASAA\u0027s Statement of Policy on Unethical Business Practices, which of the following statements is true regarding the use of reports or recommendations prepared by someone other than the investment adviser using such information?",
       "choice_a":"Reports or recommendations prepared by third parties may be provided to clients without disclosing the source if the adviser has paid a fee for their use",
       "choice_b":"Reports or recommendations prepared by another party may be provided to clients if the adviser discloses their source",
       "choice_c":"Reports prepared by third parties may not be provided to clients, but recommendations from third parties may be provided if the adviser agrees with them",
       "choice_d":"Reports or recommendations provided by an investment adviser to clients may not be obtained from third-party sources",
       "correct_answer":"B",
       "explanation":"It is unethical for an investment adviser to provide a report or a recommendation to a client that has been prepared by someone other than the adviser without disclosing that fact to the client. This prohibition does not apply to the use of outside source materials to formulate a recommendation provided by the adviser."
    },
    {
       "id":4974,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following must be registered in a state in order to sell a nonexempt security to an investor in that state? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A broker-dealer in the state </li><li>A broker-dealer outside the state </li><li>A financial planner in the state</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"Any broker-dealer or financial planner selling securities in a particular state must be registered in that state."
    },
    {
       "id":4975,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Ann is a registered representative working for a discount brokerage. Ann provides investment advisory services in her spare time and uses her firm\u0027s business card and office letterhead for this purpose. Ann must:",
       "choice_a":"Notify the SEC she is taking on business that is separate and distinct from her responsibilities as a registered rep",
       "choice_b":"Avoid misleading potential clients but otherwise take no special steps",
       "choice_c":"Disclose to all advisory clients the advice she provides is separate from her employment with the discount brokerage firm",
       "choice_d":"Cease her advisory business as it conflicts with her duties as a registered representative",
       "correct_answer":"C",
       "explanation":"A conflict-of-interest situation arises when registered representatives of a broker-dealer provide investment advisory services that are outside the scope of their duties as registered reps. Such advisers must disclose to all investment advisory clients that the advisory services they provide are separate from their employment with the broker-dealer."
    },
    {
       "id":4976,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A portfolio manager was offered the opportunity to purchase some fixed income securities for the fund under his management, which he turned down. The manager later learned that another firm wanted to buy these bonds at a higher price. The manager purchased the bonds for his personal account and resold them the same day at a profit. The manager\u0027s firm learned about the trade later but did not take any action. Is this a violation of the manager\u0027s fiduciary duty?",
       "choice_a":"Yes, the manager violated his duty of loyalty by misappropriating an investment opportunity for his own benefit",
       "choice_b":"Yes, but only since the manager did not obtain preapproval of the trade from his firm",
       "choice_c":"No, since the manager\u0027s firm sanctioned the manager\u0027s trade after the fact",
       "choice_d":"No, since the fund did not incur any losses as a result of the manager\u0027s investment decision",
       "correct_answer":"A",
       "explanation":"The duty of loyalty includes the duty not to misappropriate investment opportunities, provided the client is legally and financially able to take advantage of the opportunity. The SEC sanctioned a portfolio manager under just these circumstances. The SEC also sanctioned the firm for failure to supervise."
    },
    {
       "id":4977,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Securities Exchange Act of 1934, a beneficial owner of more than 5% of a Section 12 security must file a report with the SEC within:",
       "choice_a":"1 day",
       "choice_b":"10 days",
       "choice_c":"45 days",
       "choice_d":"90 days",
       "correct_answer":"B",
       "explanation":"The Securities Exchange Act of 1934 requires that a Schedule 13D be filed within 10 days of attaining a 5% or greater ownership interest."
    },
    {
       "id":4978,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Investment Advisers Act of 1940, which of the following is true regarding the written disclosure statement required to be given to each advisory client or prospective advisory client? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It may be a copy of Part II of Form ADV </li><li>It may be a brochure prepared by the adviser containing at least the information in Part II of Form ADV </li><li>The statement may omit any information from Part II of Form ADV that is not relevant to the services or fees for a particular client</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"The written disclosure statement or brochure may either be a copy of Part II of Form ADV or another document that contains at least that information. Information not relevant to a particular client\u0027s investment advisory contract may be omitted."
    },
    {
       "id":4979,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Investment Company Act of 1940, an issuer that is in the business of investing and trading in securities and owns or will acquire investment securities exceeding 40% of its assets is called a(n):",
       "choice_a":"Holding company",
       "choice_b":"Investment company",
       "choice_c":"Common trust fund",
       "choice_d":"Leveraged buyout fund",
       "correct_answer":"B",
       "explanation":"According to the Investment Company Act of 1940, investment companies engage in the business of investing, reinvesting, owning, holding, or trading in securities and invest at least 40% of its assets in such activities."
    },
    {
       "id":4980,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Securities Act of 1933, which of the following is not a provision of a Regulation D offering?",
       "choice_a":"Purchasers must sign an investment letter",
       "choice_b":"The size of the offering must be limited",
       "choice_c":"The offering must be directly negotiated between the issuer and the buyer or purchaser representative",
       "choice_d":"The number of non accredited buyers is limited",
       "correct_answer":"B",
       "explanation":"According to Regulation D, certain conditions must be met for securities to be exempt from the provisions of the Securities Act of 1933. The offering must be restricted to persons who are knowledgeable and experienced in business and financial matters and who are able to afford the economic risks involved. The issuer must provide the buyer with detailed financial information. The number of non accredited purchasers must be limited to 35 nationally and 10 in each state. The offering must be made in direct negotiations between the issuer and the buyer or the purchaser representative. The buyer must sign an investment letter stating that the purchase was made for investment and not for short-term trading purposes. Section 506 of Regulation D allows an issuer to raise an unlimited amount of money."
    },
    {
       "id":4981,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An attorney wishes to place orders for a client\u0027s account with an investment adviser. Under NASAA\u0027s Statement of Policy on Unethical Business Practices, which of the following statements is not true?",
       "choice_a":"The investment adviser should accept the order as is",
       "choice_b":"The order can be accepted provided written trading authorization was granted from the client to the attorney",
       "choice_c":"If written trading authorization was not granted, the investment adviser would commit an unethical business practice by accepting the order",
       "choice_d":"If trading authorization was not granted, the investment adviser could be liable for civil liabilities",
       "correct_answer":"A",
       "explanation":"The order can only be accepted if the attorney was granted trading authorization from the client. If not, the investment adviser would commit an unethical business practice by accepting the order, which could result in civil liability."
    },
    {
       "id":4982,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, which of the following statements are correct? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>When an agent\u0027s license is suspended, the broker-dealer\u0027s registration is suspended </li><li>When an investment adviser\u0027s license is suspended, the investment adviser representative\u0027s license is no longer in effect </li><li>When a broker-dealer is suspended, the agent\u0027s license is no longer in effect</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"C",
       "explanation":"If an agent\u0027s license is suspended, the broker-dealer\u0027s registration remains intact. However, an agent\u0027s license is only effective when the broker-dealer\u0027s registration remains in effect. When an investment adviser\u0027s license is suspended, the investment adviser representative\u0027s license is no longer in effect."
    },
    {
       "id":4983,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which two of the following are true when a firm executing a trade acts as an agent? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A markup is charged </li><li>The firm buys or sells on a client\u0027s behalf </li><li>The firm buys or sells for its own account </li><li>A commission is charged</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"II and IV",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"When a firm acts as an agent, it buys or sells on a client\u0027s behalf and charges a commission for this service. The firm takes no risk when acting in this \u0022middleman\u0022 or \u0022matchmaker\u0022 capacity."
    },
    {
       "id":4984,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Sam Jones is an investment adviser who is also an RR for SIA, Inc., a registered broker-dealer. He usually uses SIA to implement recommendations to clients. Before making recommendations for his new client, Ann, Mr. Jones should:",
       "choice_a":"Notify Ann he will be acting as an agent and will receive compensation for the transaction in addition to his advisory fee",
       "choice_b":"Notify his supervisor to determine if he should abstain from participating in this transaction",
       "choice_c":"Sever his links with the broker-dealer",
       "choice_d":"Seek SEC approval",
       "correct_answer":"A",
       "explanation":"A conflict of interest could exist when an adviser acts in more than one capacity when dealing with a specific client. In this example, The client should be notified that he will receive compensation for acting as an agent in the transaction over and above his advisory fee."
    },
    {
       "id":4985,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following would not constitute custody of client funds or securities under the Investment Advisers Act of 1940?",
       "choice_a":"Client funds and securities are held at a bank and the accounts are controlled by the investment adviser",
       "choice_b":"An adviser assesses a monthly fee by automatically deducting the proper amount from the client\u0027s checking account",
       "choice_c":"An investment adviser has full power of attorney over a client\u0027s account but the securities are actually held by a non-affiliated broker-dealer",
       "choice_d":"A client has funds in a bank in which the investment adviser has a 1% interest",
       "correct_answer":"D",
       "explanation":"Custody refers to the adviser\u0027s ability to control or have access to client funds or securities. The SEC has ruled that when an adviser deducts the management fee from a client\u0027s account, custody exists since the adviser may appropriate client funds."
    },
    {
       "id":4986,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, an entity may avoid meeting the definition of a broker-dealer if it <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Has no office in the state </li><li>Only deals with institutional clients </li><li>Does not hold customer funds or securities</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"A",
       "explanation":"If a broker-dealer has no office in a state and effects transactions only with institutional clients, it would be exempt from the definition of a broker-dealer. An institutional broker-dealer cannot qualify for this exemption if it has an office in the state, even if it avoids holding customer funds and securities."
    },
    {
       "id":4987,
       "topic_id":4,
       "practice_test_id":1,
       "question":"Which of the following would meet the business standards test under the Investment Advisers Act of 1940?",
       "choice_a":"If an investment adviser advertised in the local Yellow Pages",
       "choice_b":"If an adviser\u0027s recommendations were limited to high-grade corporate bonds",
       "choice_c":"If an adviser\u0027s only clients were insurance companies",
       "choice_d":"If an adviser\u0027s only clients were registered investment companies",
       "correct_answer":"A",
       "explanation":"When an adviser holds him- or herself out to the public by advertising or through a designation on a business card or stationery, the person meets the business standard test as described by SEC Release 1092."
    },
    {
       "id":4988,
       "topic_id":4,
       "practice_test_id":2,
       "question":"According to the Uniform Securities Act, a broker-dealer employee who is not registered as an agent may do which of the following?",
       "choice_a":"Take phone messages and post records",
       "choice_b":"Accept unsolicited orders",
       "choice_c":"Participate in an exempt transaction",
       "choice_d":"Participate in the distribution of an exempt security",
       "correct_answer":"A",
       "explanation":"A person need not be registered as an agent to take messages and post records. All of the other activities require a registered person."
    },
    {
       "id":4989,
       "topic_id":4,
       "practice_test_id":3,
       "question":"According to prudent investor standards, the main focus of a fiduciary when making investment decisions should be:",
       "choice_a":"Preservation of principal",
       "choice_b":"The trade-off between risk and reward",
       "choice_c":"Earning the maximum return possible",
       "choice_d":"Avoidance of large losses",
       "correct_answer":"B",
       "explanation":"Under the prudent investor standards as described in the Uniform Prudent Investor Act, the central consideration for a fiduciary when making investment decisions is the trade-off between risk and reward."
    },
    {
       "id":4990,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Which of the following would not violate an investment adviser\u0027s duty to obtain the best possible execution for customer transactions?",
       "choice_a":"Directing the transactions to the firm in which the adviser\u0027s spouse works even though their commissions are higher",
       "choice_b":"Having the transactions executed by a broker-dealer that does not make a market in the securities, raising the transaction costs involved",
       "choice_c":"Having the transactions executed by a full-service broker-dealer that charges higher commissions than other firms but has superior execution capability",
       "choice_d":"Directing the transactions to a registered representative who is a friend of the investment adviser\u0027s, even though the broker\u0027s firm charges higher commissions",
       "correct_answer":"C",
       "explanation":"Investment advisers have a fiduciary duty to obtain the best execution for their customers\u0027 securities transactions when they are in a position to direct brokerage transactions. Best execution does not simply mean securing the best price for clients; it also means securing low commission costs. Directing transactions to broker-dealers with higher commission charges simply because a relative or friend works there would be a violation of this duty. However, according to the SEC, the investment adviser is allowed to consider \u0022the full range and quality of a broker\u0027s services in placing brokerage including, among other things, the value of the research provided as well as the execution capability, commission rate, financial responsibility and responsiveness."
    },
    {
       "id":4991,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Which of the following is true regarding an investment adviser registered under the Investment Advisers Act of 1940?",
       "choice_a":"The adviser may inform customers that the adviser has been recommended by the SEC",
       "choice_b":"The adviser may inform customers that the adviser has been approved by the SEC",
       "choice_c":"The adviser may inform customers that the adviser is sponsored by the SEC",
       "choice_d":"The adviser may inform customers that the adviser is registered under the Act",
       "correct_answer":"D",
       "explanation":"It is unlawful for an investment adviser registered under the Investment Advisers Act of 1940 to imply that the adviser has been sponsored, recommended, or approved by any federal agency. The adviser may only state that it is registered under the Act."
    },
    {
       "id":4992,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Molly earns a living by soliciting clients for an investment adviser registered with the Securities Administrator of State A. Molly calls prospects residing in State A, State B, and State C. If Molly is supervised by the registered investment adviser, she",
       "choice_a":"Need not register in any state",
       "choice_b":"Must register in State A",
       "choice_c":"Must register in States B and C only",
       "choice_d":"Must register in all three states",
       "correct_answer":"D",
       "explanation":"If they\u0027re supervised by the adviser, they must register in all states where they conduct business."
    },
    {
       "id":4993,
       "topic_id":4,
       "practice_test_id":"",
       "question":"SEC Release IA-1092 declares that many industry professionals need to be registered as investment advisers. The so-called \u0022three-pronged\u0022 test used to determine if a person is, in fact, an investment adviser includes all of the following except the person:",
       "choice_a":"Provides advice or analysis on securities either by making direct or indirect recommendations to clients or by providing research or opinions on securities or securities markets.",
       "choice_b":"Receives compensation in any form for the advice provided.",
       "choice_c":"Engages in a regular business of providing advice on securities.",
       "choice_d":"Is registered under the Investment Advisers Act of 1940",
       "correct_answer":"D",
       "explanation":"the three prong test is ABC Advice, Business, and Compensation"
    },
    {
       "id":4994,
       "topic_id":4,
       "practice_test_id":"",
       "question":"SIA would like to register as an investment adviser in State X. Which of the following represent requirements for state registration of the firm? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Filing a complete Form ADV with the state(s) in which the firm wants to offer services. </li><li>Providing any state-specific forms required. </li><li>Filing a Form U-4 application for each investment adviser representative who will provide services on behalf of the investment adviser. </li><li>Remitting all required fees for the investment adviser and the investment adviser representative.</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I, II, IV only",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"all of the choices listed represent requirements for state registration as per the rules of the NASSA."
    },
    {
       "id":4995,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are elements of the four-part Howey test used to determine when an instrument is an investment contract except:",
       "choice_a":"There is an investment of money",
       "choice_b":"The purchaser expects a profit",
       "choice_c":"There is a common enterprise",
       "choice_d":"The issuer is a corporate or government entity",
       "correct_answer":"D",
       "explanation":"The four elements of the Howey test are: An investment of money, a common enterprise, the expectation of a profit, solely from the efforts of others. Whether the issuer is a corporation, government, or other entity is not relevant to the test."
    },
    {
       "id":4996,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, which of the following is a non-issuer transaction?",
       "choice_a":"A 100-share trade between two investors done on the NYSE",
       "choice_b":"A mutual fund redemption",
       "choice_c":"The sale of securities to an employee where no commission is paid",
       "choice_d":"A limited partner buying directly from the sponsor",
       "correct_answer":"A",
       "explanation":"A 100-share trade executed on the NYSE, a secondary market transaction, is referred to as a non-issuer transaction under the Uniform Securities Act since it does not involve the issuer of the securities."
    },
    {
       "id":4997,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following would not be considered an offer? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Pledging securities to collateralize a loan </li><li>A tombstone advertisement </li><li>A sale of securities for value</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"An offer is defined as an attempt to dispose of securities for consideration or value. Pledging stock is not a permanent disposition of shares. A tombstone does not constitute an offer, which can be made only by a prospectus. A sale is the culmination of the offer and completes the transaction."
    },
    {
       "id":4998,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, the term sale means: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Any attempt to dispose of a security </li><li>A solicitation of an offer to buy </li><li>Any contract to dispose of a security for value</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"III only",
       "choice_d":"I, II, and III",
       "correct_answer":"C",
       "explanation":"The term sale means to sell or disposition of a security or interest in a security for value. Included in the above would be a gift of assessable stock or any security given or delivered with, or as a bonus with, any purchase of securities. Attempting to dispose of a security for value or a solicitation to buy or sell a security would be considered an offer, not a sale."
    },
    {
       "id":4999,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are true regarding registration by coordination? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The state and federal registration statements must by filed at the same time </li><li>The issuer must file with the Administrator three copies of the latest prospectus filed with the SEC </li><li>State registration is effective when the federal registration statement becomes effective </li><li>Registration by coordination may not be used if the federal registration statement has already been declared effective</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, II, and III only",
       "choice_c":"II, III, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Under registration by coordination, the state and federal registration statements do not have to be filed at the same time. However, registration by coordination may not be used if the federal registration statement has already been declared effective."
    },
    {
       "id":5000,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Which of the following securities is non-exempt?",
       "choice_a":"A bank holding company\u0027s securities",
       "choice_b":"Canadian government bonds",
       "choice_c":"U.S. Treasury bonds",
       "choice_d":"Stock of a savings and loan association",
       "correct_answer":"A",
       "explanation":"Securities issued by banks, savings and loan associations, U.S. Treasury bonds, and Canadian government securities are all exempt under the Act. However, a bank holding company\u0027s stock would not be exempt. The term holding company is used to describe any entity formed to own and manage other companies. Such securities are nonexempt."
    },
    {
       "id":5001,
       "topic_id":4,
       "practice_test_id":3,
       "question":"Which of the following could be used by the Administrator as grounds for denying the registration of a security? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The spread earned by the syndicate would be larger than normal </li><li>The terms under which the offering is made are unfair to investors </li><li>The issue has no place of business in the state </li><li>The issuer has not registered the offering with the SEC</li></ol>",
       "choice_a":"III only",
       "choice_b":"I and II only",
       "choice_c":"III and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"B",
       "explanation":"The fact that the issuer has no place of business in the state is not grounds for denying the registration statement. Neither is the fact that the offering is not registered with the SEC, since it might be exempt from federal registration."
    },
    {
       "id":5002,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Which of the following are true of exempt securities under the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Any security exempt under the Uniform Securities Act is also exempt under federal regulations </li><li>Any security exempt under federal regulations is also exempt under the Uniform Securities Act </li><li>Interstate Rules regarding an exemption are more restrictive than federal rules, then state rules would govern </li><li>Federal regulations always supersede state rules</li></ol>",
       "choice_a":"III only",
       "choice_b":"I and III only",
       "choice_c":"II and IV only",
       "choice_d":"I, II, and IV only",
       "correct_answer":"A",
       "explanation":"A security can be exempt under federal law but not state law, and vice versa. When the rules overlap, the most restrictive rule applies."
    },
    {
       "id":5003,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Under the Uniform Securities Act, which of the following is a characteristic needed for commercial paper to be exempt from registration requirements?",
       "choice_a":"Issued in denominations of at least $100,000",
       "choice_b":"Issued by a company whose annual revenues exceed $100,000,000",
       "choice_c":"Issued by a religious, educational, or charitable organization",
       "choice_d":"Rated in one of the three highest rating categories from a recognized rating organization",
       "correct_answer":"D",
       "explanation":"Under the Uniform Securities Act, commercial paper that matures in nine months or less is exempt from registration if the minimum denomination is at least $50,000 and it is rated in one of the three highest rating categories by a recognized rating organization. The type of issuer and the annual revenues of the issuer are not relevant factors."
    },
    {
       "id":5004,
       "topic_id":4,
       "practice_test_id":6,
       "question":"All of the following conditions must be met for a private placement to be exempt under the Uniform Securities Act except:",
       "choice_a":"The securities cannot be offered to more than ten small investors in 12 consecutive months",
       "choice_b":"No payment is made by any subscriber",
       "choice_c":"Subscribers receive unregistered securities",
       "choice_d":"The seller must reasonably believe that all buyers are purchasing for investment purposes only",
       "correct_answer":"B",
       "explanation":"All of the items listed regarding private placements are true except no payment is made by any subscriber. The capital raised by a private placement comes from its subscribers."
    },
    {
       "id":5005,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following securities is not exempt from registration?",
       "choice_a":"Airport authority bonds",
       "choice_b":"Railroad equipment trust certificates",
       "choice_c":"Convertible bonds",
       "choice_d":"Securities issued by religious organizations",
       "correct_answer":"C",
       "explanation":"Convertible bonds are not exempt from registration. All of the other securities listed are exempt from registration under the Uniform Securities Act."
    },
    {
       "id":5006,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent who is registered in State A contacts a client in State B. The broker-dealer is registered in State B but not the agent. The agent can:",
       "choice_a":"Not sell the security",
       "choice_b":"Sell the security if it is a federal covered security",
       "choice_c":"Sell the security upon notification to a superior",
       "choice_d":"Sell the security because this is an exempt transaction",
       "correct_answer":"A",
       "explanation":"In order to sell a security in a state, the broker-dealer and the agent must both be registered in the state. Therefore, the agent cannot sell the security."
    },
    {
       "id":5007,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is not an exempt security?",
       "choice_a":"A security issued by a Canadian commercial bank",
       "choice_b":"A security issued by a foreign insurance company organized under the laws of the state",
       "choice_c":"A security issued by a foreign bank organized under the laws of the United States",
       "choice_d":"Common stock listed on the American Stock Exchange",
       "correct_answer":"A",
       "explanation":"There is no exemption under the Uniform Securities Act for securities issued by Canadian banks. The exemption is for securities issued or guaranteed by Canada or any of its provinces. Securities issued by banks and insurance companies (whether foreign or domestic) that are organized under the laws of either the state or federal government are considered exempt securities. Any security listed on the New York, American, and regional exchanges approved by the Administrator are also exempt."
    },
    {
       "id":5008,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following could not be used by the Administrator as grounds for denying the registration of a security?",
       "choice_a":"It is in the public interest of the state",
       "choice_b":"The offering is being made based upon terms that are unfair",
       "choice_c":"The weak financial condition of the issuer",
       "choice_d":"Prior willful violation of the act by the corporate officers",
       "correct_answer":"C",
       "explanation":"The Administrator cannot use the weak financial condition of an issuer as the only reason to deny a registration application. All of the other items listed above may be used by the Administrator as legitimate grounds for denial of registration of securities."
    },
    {
       "id":5009,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An exempt transaction would include: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An unsolicited order in unregistered nonexempt securities </li><li>A trade where the customer acknowledges the risk of the trade </li><li>A transaction between SIA Corp. and its underwriter </li><li>The purchase of an equipment trust certificate</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"Exempt transactions are defined by the nature or character of the transaction, not the security involved. Unsolicited trades, and trades between issuers and underwriters, are examples of exempt transactions. An equipment trust certificate is a security exempt from registration."
    },
    {
       "id":5010,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When a security is sold under an exemption from registration under the Uniform Securities Act, the burden of proof for the exemption is imposed on:",
       "choice_a":"The Administrator",
       "choice_b":"The person claiming the exemption",
       "choice_c":"Any person bringing a lawsuit against the seller",
       "choice_d":"The purchaser",
       "correct_answer":"B",
       "explanation":"The person claiming the exemption must be able to demonstrate that they are entitled to the exemption."
    },
    {
       "id":5011,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Which of the following are under the jurisdiction of the state securities administrator? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The purchase of options via the Internet by a state resident </li><li>The sale of long-term certificates of deposit by a bank </li><li>The delivery of securities to a customer who is a resident of a particular state </li><li>The offer of securities by an out-of-state broker-dealer to a resident of the state</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"State securities administrators have jurisdiction over securities transactions that are directed to their state, originate in their state, or are paid for in their state. The simple delivery of securities to a particular state does not fall under an administrator\u0027s jurisdiction, nor do general commercial banking transactions."
    },
    {
       "id":5012,
       "topic_id":4,
       "practice_test_id":2,
       "question":"In a coordinated registration, how long is the statutory cooling-off period?",
       "choice_a":"10 days for federal and state",
       "choice_b":"20 days for federal and state",
       "choice_c":"10 days for federal and 20 days for state",
       "choice_d":"10 days for North Carolina and 20 days for federal",
       "correct_answer":"D",
       "explanation":"The statutory cooling-off period is 10 days for state registration and 20 days for federal registration. The cooling-off period may be halted, extended, or shortened by either the SEC or a state securities administrator."
    },
    {
       "id":5013,
       "topic_id":4,
       "practice_test_id":3,
       "question":"Under the Uniform Securities Act, which of the following is a nonexempt transaction?",
       "choice_a":"Selling U.S. federal agency securities to a bank",
       "choice_b":"Selling U.S. Treasury bills to a mutual fund",
       "choice_c":"Selling unregistered nonexempt securities",
       "choice_d":"Selling unregistered exempt securities on an unsolicited basis",
       "correct_answer":"C",
       "explanation":"The only nonexempt transaction would be selling unregistered nonexempt securities. This would actually be a violation of the Uniform Securities Act."
    },
    {
       "id":5014,
       "topic_id":4,
       "practice_test_id":4,
       "question":"According to the Uniform Securities Act, which of the following are considered securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An investment contract </li><li>A unit investment trust </li><li>An IRA account </li><li>A warehouse receipt</li></ol>",
       "choice_a":"II only",
       "choice_b":"I and III only",
       "choice_c":"I, II, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"All of the items listed would be considered a security except an IRA account. An IRA account may contain securities but the account itself is not a security."
    },
    {
       "id":5015,
       "topic_id":4,
       "practice_test_id":5,
       "question":"According to the Uniform Securities Act, which of the following would not fall under the definition of a security?",
       "choice_a":"Variable annuities",
       "choice_b":"Whiskey warehouse receipts",
       "choice_c":"Precious metals",
       "choice_d":"Subordinated debentures",
       "correct_answer":"C",
       "explanation":"Precious metals such as gold, silver, and platinum are not securities, nor are the futures contracts covering these products."
    },
    {
       "id":5016,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, the Administrator may not do which of the following?",
       "choice_a":"Conduct investigations involving broker-dealers domiciled in other states",
       "choice_b":"Conduct an investigation without proof of wrongdoing",
       "choice_c":"Suspend an agent\u0027s registration without an opportunity for a hearing",
       "choice_d":"Issue subpoenas to individuals outside the state",
       "correct_answer":"C",
       "explanation":"An Administrator must give a reason for revoking or suspending an agent\u0027s license. Although an Administrator may suspend a license prior to a hearing, the opportunity for a hearing must then be provided. The Administrator is allowed to serve subpoenas and conduct investigations, both in and out of state."
    },
    {
       "id":5017,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following is correct regarding a State Administrator\u0027s investigative powers?",
       "choice_a":"The Administrator may initiate an investigation only when he or she feels a violation has occurred",
       "choice_b":"The Administrator may initiate an investigation only if the person investigated is registered in the Administrator\u0027s state",
       "choice_c":"The Administrator may initiate an investigation anytime it appears a violation is about to occur",
       "choice_d":"The Administrator may initiate an investigation only if a complaint has been filed by a client",
       "correct_answer":"C",
       "explanation":"The Administrator may institute an investigation if it appears that a violation of the Uniform Securities Act is about to occur. The Administrator need not wait for a violation to occur before starting an investigation."
    },
    {
       "id":5018,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following does not constitute grounds for denial, suspension, or revocation of a registration statement under the Uniform Securities Act?",
       "choice_a":"The issuer is engaged in an illegal enterprise",
       "choice_b":"The security is not registered with the SEC",
       "choice_c":"The applicant has failed to pay the proper filing fee",
       "choice_d":"The offering has been or would be made with unreasonable amounts of compensation",
       "correct_answer":"B",
       "explanation":"An Administrator may deny the registration of a security if the issuer is engaged in an enterprise that is illegal where performed (gambling and prostitution are illegal in the majority of states), if the registrant has failed to pay the proper filing fee, or if there is unreasonable underwriting compensation. The order to deny registration for failure to pay the proper filing fee can be reversed when the fee is paid. Securities that are not registered at the federal level could be either registered or exempt at the state level."
    },
    {
       "id":5019,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following persons would not be considered an agent under the act?",
       "choice_a":"A person representing a broker-dealer in non-exempt transactions",
       "choice_b":"A person representing a director of an issuer who does not receive commissions",
       "choice_c":"A person representing a director of an issuer who receives commissions",
       "choice_d":"A person employed by a broker-dealer as a sales assistant who occasionally accepts client orders",
       "correct_answer":"B",
       "explanation":"A person who represents a broker-dealer is defined as an agent even if they are selling exempt securities. A person representing an issuer executing transactions with an existing employee, partner, officer or director of an issuer who does not receive any commissions or other payment directly or indirectly for soliciting the order in that state will not be considered an agent. An employee of a broker-dealer who performs only clerical functions is not considered an agent. However, if that employee accepts client orders (even unsolicited) then that person is classified as an agent and must register."
    },
    {
       "id":5020,
       "topic_id":4,
       "practice_test_id":"",
       "question":"After examining the offices of a broker-dealer, the Administrator sanctioned the firm for keeping stock owned by customers and stock owned by the broker-dealer together in a way that did not clearly indicate who owned which shares. This prohibited practice is called:",
       "choice_a":"Re-Hypothecation",
       "choice_b":"Mixing",
       "choice_c":"Commingling",
       "choice_d":"Conversion",
       "correct_answer":"C",
       "explanation":"Commingling refers to the practice of intermixing securities belonging to customers with securities belonging to the broker-dealer. This is prohibited in order to assure that customer securities are not misused."
    },
    {
       "id":5021,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Which of the following statements is true concerning the posting of bonds by a broker-dealer?",
       "choice_a":"The bond may be waived if the broker-dealer has been in business for at least ten years",
       "choice_b":"There is no bond requirement if the broker-dealer does not have custody or discretionary authority",
       "choice_c":"The Administrator may not waive the bond requirement for any broker-dealer",
       "choice_d":"There is no bond requirement if the broker-dealer is registered in another state",
       "correct_answer":"B",
       "explanation":"The Administrator may require broker-dealers to post bonds if they have custody of or discretionary authority over client funds or securities. The bond may be waived if the broker-dealer\u0027s net capital exceeds a specified amount. The Administrator may determine this amount."
    },
    {
       "id":5022,
       "topic_id":4,
       "practice_test_id":3,
       "question":"The amount of the bond that a broker-dealer is required to post is:",
       "choice_a":"Determined by the Administrator",
       "choice_b":"Based on the number of employees the firm has",
       "choice_c":"Related to prior disciplinary action",
       "choice_d":"Waived if the filing fee is prepaid",
       "correct_answer":"A",
       "explanation":"The Administrator determines the amount of the bond that a broker-dealer must post. The Administrator is allowed to waive the bond requirement if the broker-dealer has a minimum amount of net capital, which is also determined by the Administrator."
    },
    {
       "id":5023,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Which of the following is not a prohibited practice under the Uniform Securities Act?",
       "choice_a":"An agent making an untrue statement of a material fact",
       "choice_b":"An agent omitting a material fact because the agent did not have time to cover everything in a short presentation",
       "choice_c":"An agent deliberately failing to follow a client\u0027s instructions",
       "choice_d":"An agent actively soliciting orders in unregistered exempt securities",
       "correct_answer":"D",
       "explanation":"If a security is exempt, it does not have to be registered. All other choices would be considered prohibited practices under the Uniform Securities Act."
    },
    {
       "id":5024,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Which of the following is not true when a cease and desist order has been issued?",
       "choice_a":"It is enacted when or before a violation has occurred",
       "choice_b":"It must have been issued by the SEC",
       "choice_c":"It must have been authorized by the Administrator",
       "choice_d":"It may be issued against anyone who is engaging in activities prohibited by the Uniform Securities Act",
       "correct_answer":"B",
       "explanation":"Administrators will authorize a cease and desist order if they believe a violation of the Act is about to occur or if the Act has already been violated. The order does not have to come from the SEC."
    },
    {
       "id":5025,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, which of the following is correct regarding a State Administrator\u0027s investigative powers?",
       "choice_a":"The Administrator may initiate an investigation only when he or she feels a violation has occurred",
       "choice_b":"The Administrator may initiate an investigation only if the person investigated is registered in the Administrator\u0027s state",
       "choice_c":"The Administrator may initiate an investigation anytime it appears a violation is about to occur",
       "choice_d":"The Administrator may initiate an investigation only if a complaint has been filed by a client",
       "correct_answer":"C",
       "explanation":"The Administrator may institute an investigation if it appears that a violation of the Uniform Securities Act is about to occur. The Administrator need not wait for a violation to occur before starting an investigation."
    },
    {
       "id":5026,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, in the absence of fraud, when must action be taken for recovery on a transaction made in violation of a state registration provision?",
       "choice_a":"Within two years of occurrence",
       "choice_b":"Within two years of discovery",
       "choice_c":"Within three years of occurrence and two years of discovery, whichever comes first",
       "choice_d":"Within two years of occurrence or discovery, whichever occurs last",
       "correct_answer":"C",
       "explanation":"If an agent sells a security in violation of a state registration provision, his or her client must take action for recovery within three years of occurrence of the violation, or within two years of discovery of the violation, whichever comes first."
    },
    {
       "id":5027,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Bonds must be posted by all of the following except:",
       "choice_a":"Investment advisers who do not have discretionary authority or custody of client funds or securities",
       "choice_b":"Investment advisers who have discretionary authority but do not have custody of client funds or securities",
       "choice_c":"Broker-dealers who do not have discretionary authority",
       "choice_d":"Broker-dealers who have discretionary authority",
       "correct_answer":"A",
       "explanation":"Broker-dealers customarily have custody of client funds and securities and are required by the Act to post a bond. Investment advisers must post a bond only if they have discretionary authority over client accounts or have custody of client funds or securities. A bond guarantees that funds are available so that legal fees and fines can be met if assessed against a broker-dealer or investment adviser."
    },
    {
       "id":5028,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The Administrator has the authority to make an on-site inspection of a broker-dealer or an investment adviser:",
       "choice_a":"At a time convenient for the broker-dealer or investment adviser",
       "choice_b":"At a time determined by the Administrator",
       "choice_c":"On a quarterly basis",
       "choice_d":"On a semiannual basis",
       "correct_answer":"B",
       "explanation":"The Administrator determines when to review the records and practices of an investment adviser or a broker-dealer; there is no set schedule."
    },
    {
       "id":5029,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following documents are customarily forwarded to the Administrator?",
       "choice_a":"Customer complaints",
       "choice_b":"Securities registration statements",
       "choice_c":"Municipal securities advertising",
       "choice_d":"Investment advisory contracts",
       "correct_answer":"B",
       "explanation":"Of the items listed, only securities registration statements are regularly forwarded to the Administrator. Registration by Coordination and Qualification require that a registration statement and prospectus be filed with the Administrator."
    },
    {
       "id":5030,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The Administrator has the right to deny, revoke or suspend the registration statement of an issuer of securities. Under the Uniform Securities Act, which of the following issuers is subject to this action? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Stock listed on a Canadian Exchange </li><li>Federal Savings and Loan Associations </li><li>Federal credit unions </li><li>For-profit corporations</li></ol>",
       "choice_a":"I and IV only",
       "choice_b":"II and III only",
       "choice_c":"II, III, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Choice II and III are exempt securities and would not be required to file a registration statement. Nonexempt securities would be subject to this rule."
    },
    {
       "id":5031,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is considered a fraudulent act?",
       "choice_a":"Making a delinquent filing to the Administrator",
       "choice_b":"Purposely omitting a fact that a reasonable person would need to make an informed investment decision",
       "choice_c":"Renewing an investment advisory contract when performance has been poor",
       "choice_d":"Telling a client that money market mutual funds sold by a bank are not FDIC insured",
       "correct_answer":"B",
       "explanation":"Withholding material facts is considered fraudulent. Material facts are those that a reasonable person would want to know in order to make an informed investment decision."
    },
    {
       "id":5032,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Pete has a large position in XYZ Corporation common stock. The stock is low-priced and lightly traded. Pete has given money to several other investors and directed them to purchase the stock at specific times. As the investors make their purchases, the stock begins to rise and Pete sells his position at a profit. Which of the following is true?",
       "choice_a":"This is a form of churning but is improper only if Peter is an employee of a broker-dealer",
       "choice_b":"This is an acceptable practice since the increase in the price of the security was due to demand for the stock",
       "choice_c":"The coordinated purchases are a form of market manipulation and violate the Uniform Securities Act",
       "choice_d":"This activity is called arbitrage and is proper if conducted during normal market hours",
       "correct_answer":"C",
       "explanation":"The coordinated purchases were designed solely to manipulate the price of the stock and are a violation of the antifraud section of the USA."
    },
    {
       "id":5033,
       "topic_id":4,
       "practice_test_id":3,
       "question":"All of the following are true regarding the preparation and maintenance of records by investment advisers and broker-dealers except:",
       "choice_a":"The Administrator may determine that the records prepared by investment advisers and broker-dealers may be different",
       "choice_b":"All records must be preserved for a period determined by the Administrator",
       "choice_c":"Correcting amendments must be filed promptly if information in a document previously filed becomes inaccurate",
       "choice_d":"Only an Administrator within the same state may examine the records of an investment adviser or broker-dealer",
       "correct_answer":"D",
       "explanation":"An Administrator may inspect the records of a broker-dealer or investment adviser located within or outside the state. All of the other statements regarding recordkeeping are correct."
    },
    {
       "id":5034,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Pursuant to the Uniform Securities Act, when do the licenses of broker-dealers, agents, and investment advisers expire?",
       "choice_a":"On the fiscal year-end of the state government",
       "choice_b":"On the fiscal year-end of the broker-dealer, agent, or investment adviser",
       "choice_c":"On December 31 each year",
       "choice_d":"Three years from the original registration",
       "correct_answer":"C",
       "explanation":"Under the Uniform Securities Act, licenses expire at the end of each calendar year."
    },
    {
       "id":5035,
       "topic_id":4,
       "practice_test_id":5,
       "question":"A state securities administrator has decided that a broker-dealer is in danger of becoming insolvent. The administrator orders the broker-dealer to maintain a minimum net capital of twice that of the federal minimum. How would this be viewed under NSMIA?",
       "choice_a":"Administrators are not allowed to set net capital requirements for broker-dealers",
       "choice_b":"Administrators are not allowed to impose requirements that are more stringent than SEC regulations",
       "choice_c":"Administrators are free to set whatever requirements they feel are necessary to maintain fair and equitable markets within their own state",
       "choice_d":"The broker-dealer must first be offered a hearing on the matter",
       "correct_answer":"B",
       "explanation":"Under NSMIA, state securities administrators are not allowed to impose requirements that are more stringent than SEC regulations."
    },
    {
       "id":5036,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An Administrator from North Carolina has jurisdiction over an offer made: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>On a radio or television program that originated in North Carolina </li><li>On a radio or television program broadcast in a North Carolina where the communication originated outside the state </li><li>In a newspaper circulated in North Carolina, but published in South Carolina </li><li>In a newspaper published in North Carolina, but with more than two thirds of its circulation outside the state in the last year</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II only",
       "choice_c":"I and III only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Generally, an Administrator will have jurisdiction over any offer if it originated in that state, was directed in that state, or was accepted in the Administrator\u0027s state. However, if the communication originated outside the North Carolina and was in the form of a radio or television broadcast, the Administrator would not have jurisdiction. The Administrator has jurisdiction if the newspaper is published in that North Carolina and more than one-third of the circulation is inside that state."
    },
    {
       "id":5037,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If an agent receives a written complaint from a client, the agent:",
       "choice_a":"Must forward the complaint to a supervisor",
       "choice_b":"May use his or her own discretion in handling the complaint",
       "choice_c":"May disregard the complaint",
       "choice_d":"May no longer effect securities transactions",
       "correct_answer":"A",
       "explanation":"An agent must forward all written complaints to a supervisor."
    },
    {
       "id":5038,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent unknowingly violates a provision of the Uniform Securities Act. Which of the following statements is correct?",
       "choice_a":"The minimum sanction called for is a suspension of the agent\u0027s registration",
       "choice_b":"Criminal penalties are called for if client losses exceed $5,000",
       "choice_c":"No prison sentence can be imposed if the agent had no prior knowledge of the rule or order",
       "choice_d":"After passing the Series 63, agents cannot claim they unknowingly violated a provision of the Act",
       "correct_answer":"C",
       "explanation":"Criminal liabilities exist for violations of the Uniform Securities Act. If the agent had no prior knowledge of the rule or order then a prison sentence cannot be imposed. Clients do not have to demonstrate that they were harmed and suffered damages. The state brings the criminal charges."
    },
    {
       "id":5039,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker-dealer\u0027s original application filed with the state includes all of the following except:",
       "choice_a":"Place of business",
       "choice_b":"Form of business organization",
       "choice_c":"Type of services rendered",
       "choice_d":"Fingerprints",
       "correct_answer":"D",
       "explanation":"Fingerprints are not required for a broker-dealer\u0027s registration. The other items listed are disclosures found in the broker-dealer application."
    },
    {
       "id":5040,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If an agent transfers a customer\u0027s securities into the firm\u0027s trading account, the agent would be guilty of:",
       "choice_a":"Parking",
       "choice_b":"Commingling",
       "choice_c":"Freeriding",
       "choice_d":"Backing away",
       "correct_answer":"B",
       "explanation":"Under the Uniform Securities Act, agents are prohibited from commingling client securities with the agent\u0027s or firm\u0027s securities."
    },
    {
       "id":5041,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following securities are not exempt from the antifraud provisions of the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>U.S. government securities </li><li>Securities issued by a for-profit corporation listed on a U.S. Exchange </li><li>Debt issued by a manufacturing company</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"Although U.S. government and listed securities are not required to be registered under the Uniform Securities Act, they are not exempt from the antifraud provisions of the Uniform Securities Act. All securities are subject to the antifraud provisions."
    },
    {
       "id":5042,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Jim has passed the Uniform Securities Agent State Law Examination but has not been granted registration by the Administrator. He may participate in:",
       "choice_a":"Prospecting personally",
       "choice_b":"Prospecting by mail only",
       "choice_c":"Accepting unsolicited orders only",
       "choice_d":"None of the activities of an agent",
       "correct_answer":"D",
       "explanation":"Until the Administrator grants registration, an applicant who has passed the Uniform Securities Agent State Law Examination may not transact any business."
    },
    {
       "id":5043,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is correct regarding the bond that is required to be posted under the Uniform Securities Act as a condition for registration?",
       "choice_a":"It protects clients against losses",
       "choice_b":"It protects against brokerage firm fraud",
       "choice_c":"It is used to cover the costs of possible legal actions",
       "choice_d":"Property can be accepted in lieu of a bond",
       "correct_answer":"C",
       "explanation":"A bond may be required by an Administrator to cover possible legal costs arising from violations of the Uniform Securities Act. The Administrator may accept cash or securities in lieu of a bond but property may not be accepted. This type of bond is sometimes called a surety bond as opposed to a fidelity bond, which protects a brokerage firm from employee fraud, such as embezzlement."
    },
    {
       "id":5044,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following would be a violation of the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Buying and selling the same stock on the same day on different exchanges </li><li>Offering shares of an unregistered nonexempt security to exactly 14 clients </li><li>Offering a Canadian Government bond to a resident of a state in which the agent is not registered</li></ol>",
       "choice_a":"II only",
       "choice_b":"I and II only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"C",
       "explanation":"It is a violation of the Act to offer unregistered nonexempt securities to one client, let alone fourteen. Also, the sale of exempt securities in a state does not exempt the agent from being registered in that state."
    },
    {
       "id":5045,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is not correct regarding the sharing of profits and losses in a client\u0027s account by an agent?",
       "choice_a":"The client\u0027s consent is required",
       "choice_b":"The consent of the agent\u0027s employer is required",
       "choice_c":"The sharing is strictly prohibited",
       "choice_d":"The agent\u0027s profits and losses must be in proportion to the percentage of his or her contribution",
       "correct_answer":"C",
       "explanation":"If an agent opens a joint account with a client, the agent may share in the profits, proportionate to his or her investment, provided employer and client approval was obtained."
    },
    {
       "id":5046,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The Uniform Securities Act prohibits which of the following?",
       "choice_a":"Soliciting orders for unregistered nonexempt securities",
       "choice_b":"Maintaining discretionary accounts",
       "choice_c":"Charging extraordinary commissions on certain transactions",
       "choice_d":"All of the above",
       "correct_answer":"A",
       "explanation":"Soliciting orders for unregistered nonexempt securities is prohibited by the Act. The Act allows discretionary accounts and charging for services provided by broker-dealers and their agents."
    },
    {
       "id":5047,
       "topic_id":4,
       "practice_test_id":2,
       "question":"An agent opens a new account for a client and enters a market order to buy 200 shares of WIDGET. At the end of the day, the agent turns in a new account form and a copy of the order ticket for approval by the supervisor. Which of the following is true?",
       "choice_a":"The agent\u0027s activities are not prohibited",
       "choice_b":"The agent needed approval for the new account prior to the execution of the first order",
       "choice_c":"The activity is prohibited; the agent must get prior approval for every order",
       "choice_d":"The activity is prohibited; new clients must pay for their first transaction in advance",
       "correct_answer":"B",
       "explanation":"Although prior approval from a supervisor is not required for every order, every new account must be approved by a supervisor prior to the execution of the first order."
    },
    {
       "id":5048,
       "topic_id":4,
       "practice_test_id":3,
       "question":"An agent is asked by a client to open an account and buy stock for the client\u0027s spouse. Which of the following is true?",
       "choice_a":"The agent is at risk if the stock declines",
       "choice_b":"This is a normal, acceptable practice",
       "choice_c":"The spouse must sign a trading authorization or else these actions are prohibited",
       "choice_d":"None of the above",
       "correct_answer":"C",
       "explanation":"In order to open a third party account (one party trading for another), a trading authorization must be signed by the owner of the account giving the third party the right to do so. Without a trading authorization, this would be a prohibited practice."
    },
    {
       "id":5049,
       "topic_id":4,
       "practice_test_id":4,
       "question":"An agent who knowingly gives a fictitious quote to a client:",
       "choice_a":"Must execute at that price",
       "choice_b":"Has committed a felony",
       "choice_c":"Has committed a fraudulent and misleading act",
       "choice_d":"All of the choices listed",
       "correct_answer":"C",
       "explanation":"Giving a fictitious quote or deliberately overstating the value of a client\u0027s account is a misleading and fraudulent practice."
    },
    {
       "id":5050,
       "topic_id":4,
       "practice_test_id":5,
       "question":"The term churning is defined as:",
       "choice_a":"The sale of an unregistered non-exempt security",
       "choice_b":"Trading one security for another in a client\u0027s account",
       "choice_c":"Excessive activity in a client\u0027s account",
       "choice_d":"Trading done solely to make it appeal-that there is activity in the security",
       "correct_answer":"C",
       "explanation":"Churning is defined as generating excessive activity in a client\u0027s account, usually for the sole purpose of generating commissions."
    },
    {
       "id":5051,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An agent overhears that the chairman of a large manufacturing firm may be ousted because of erratic social behavior. The agent decides to call all clients who own shares of the manufacturing corporation and tell them to liquidate their position. Which of the following is true?",
       "choice_a":"The rumor may not have an effect on the market and the agent should wait to get a better feel for the situation",
       "choice_b":"This action was based on material inside information and the agent must inform all clients of this fact",
       "choice_c":"This action constitutes a prohibited use of a rumor to induce a purchase or sale",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"Liquidating client positions based on hearsay constitutes the prohibited use of a rumor to induce a transaction. If this were material inside information, the only step the agent could take would be to notify his or her supervisor."
    },
    {
       "id":5052,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent sells 2,000 shares of a $55 stock to a new client. Two weeks later, the stock is sold out of the client\u0027s account at a loss because the client could not pay for it. In this case the agent:",
       "choice_a":"Must rebate the clients losses",
       "choice_b":"Is not liable according to the USA",
       "choice_c":"May seek punitive damages from the client",
       "choice_d":"Did not make a reasonable inquiry as to the client\u0027s financial condition",
       "correct_answer":"D",
       "explanation":"Agents are required to determine the financial status of their customers."
    },
    {
       "id":5053,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When attempting to make a sale, a client offers resistance. The agent may:",
       "choice_a":"Offer the prospect a guarantee against loss",
       "choice_b":"Attempt to overcome the objections",
       "choice_c":"Point out that the securities have been approved by the Administrator",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"In attempting to make a sale, the agent may try to overcome the client\u0027s objections. However, guaranteeing the client against loss or stating that the securities have been approved by the Administrator would be considered fraudulent and prohibited practices."
    },
    {
       "id":5054,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following would be dishonest and unethical practices if committed by an agent or investment adviser representative? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Telling clients that exchange listing of a security is anticipated, without knowledge of the truth of such a statement </li><li>Providing inaccurate market quotations, such as a bond is yielding 10% when it really is yielding 1% </li><li>Failing to inform a client of larger than ordinary commissions on a transaction </li><li>Compensating an investment adviser on the basis of a share of capital gains</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I, II, and III only",
       "choice_c":"II, III, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the items listed would be considered dishonest and unethical."
    },
    {
       "id":5055,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are prohibited practices? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Entering a discretionary order on behalf of a client while you are waiting for the U.S. Postal Service to deliver a letter from the client containing written authorization </li><li>Accepting orders from a client\u0027s secretary without written third-party authorization </li><li>Recommending securities without regard to the client\u0027s financial sources  </li><li>Quoting a price that is unrelated to the current market</li></ol>",
       "choice_a":"IV only",
       "choice_b":"I and II only",
       "choice_c":"I, II, and III only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the items listed would be considered prohibited practices."
    },
    {
       "id":5056,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A new client approaches an agent regarding opening a new account but refuses to discuss his financial status. The agent should:",
       "choice_a":"Sell any type of securities",
       "choice_b":"Accept only unsolicited orders until more information is known",
       "choice_c":"Not open an account for this individual",
       "choice_d":"Sell only high-grade securities",
       "correct_answer":"B",
       "explanation":"An agent may not solicit orders from a client when no information about the client\u0027s financial status is known."
    },
    {
       "id":5057,
       "topic_id":4,
       "practice_test_id":"",
       "question":"SIA is an investment advisory firm. SIA is creating a new standard contract for its advisory clients. Which of the following clauses should not appear in the contract?",
       "choice_a":"The Adviser will provide the following services to the Client: management of the client\u0027s portfolio on a discretionary basis, quarterly written summaries of account activity, and quarterly personal review of the Client\u0027s assets under management of the Adviser",
       "choice_b":"The Client agrees to pay a quarterly fee to the Adviser consisting of i) .25% times the value of the portfolio at the end of each quarter, plus ii) 2% of any increase in the value of the portfolio compared to the end of the previous quarter. Part ii) of the fee will not be assessed if the portfolio declines in value",
       "choice_c":"The Adviser may not assign this contract to another party without the prior written consent of the Client",
       "choice_d":"If any partner leaves the business of the Adviser, or if the Adviser adds any partner, the Adviser will notify the Client within a reasonable period, but not more than ten business days after any such change",
       "correct_answer":"B",
       "explanation":"An investment adviser may not charge a fee which is based upon a share of the capital gains in the account or a share in the capital appreciation of the funds in the account. That part of Micro\u0027s fee that consists of 2% of any increase in the value of the portfolio each quarter would not be permitted."
    },
    {
       "id":5058,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Jane would like to purchase one share of stock for her newborn niece. Her broker-dealer charges a specified minimum ticket charge for small orders. Which of the following should be disclosed to Jane?",
       "choice_a":"Common stock is not a suitable gift for children since there is no guarantee it will pay a dividend",
       "choice_b":"It is not possible to purchase one share of stock; the minimum amount is 100 shares",
       "choice_c":"The commission charged for this transaction could be unusually large as a percentage of the offering price",
       "choice_d":"Jane will need to obtain permission from her niece\u0027s parents to purchase the stock for a minor",
       "correct_answer":"C",
       "explanation":"It is considered fraudulent for a broker-dealer to fail to notify a client of larger than ordinary commissions or costs. Purchases or sales of a small amount of securities can often lead to larger than ordinary costs because of minimum charges assessed for transactions. This can lead to commissions that are large as a percentage of the purchase price. It is not illegal to assess such charges, but it is illegal not to inform the client about them."
    },
    {
       "id":5059,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A person who sells securities in violation of state securities law is civilly liable for:",
       "choice_a":"Principal and interest",
       "choice_b":"Court costs",
       "choice_c":"Attorney\u0027s fees",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A person who sells securities in violation of state securities law is civilly liable for all of the items listed."
    },
    {
       "id":5060,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent misrepresents the risks associated with U.S. Treasury bills, notes, and bonds. Under the Uniform Securities Act, which of the following would best describe the consequences?",
       "choice_a":"This is viewed as an unethical activity",
       "choice_b":"There are potential civil liabilities and a client can sue for damages",
       "choice_c":"There is no violation since the securities are issued by the U.S. government",
       "choice_d":"There are no civil liabilities because technically these are not considered securities",
       "correct_answer":"B",
       "explanation":"Misrepresenting the investment risks of a security could lead to civil liabilities as clients have the right to sue to recover their losses. U.S. Treasury bills, bonds, and notes are securities and the fact that they are exempt securities is irrelevant if misrepresentations are made."
    },
    {
       "id":5061,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent contacts a client and provides valid reasons why WIDGET Corporation shares represent an attractive purchase. He neglects to mention that the CFO has just resigned and that WIDGET is under investigation by a number of regulatory authorities. The client makes a purchase of WIDGET shares. Which of the following is false?",
       "choice_a":"The agent faces no civil liabilities since he gave valid reasons why the client should purchase WIDGET stock",
       "choice_b":"The client could recover the full purchase price paid for WIDGET stock",
       "choice_c":"The agent has committed a civil violation",
       "choice_d":"The client may file a lawsuit in state court",
       "correct_answer":"A",
       "explanation":"A purchaser has the right to bring a civil lawsuit if they believe the seller of the securities omits or makes an untrue statement concerning a material fact. This is a civil violation of the act. The client has the right to recover the full purchase price plus interest plus court cost and attorney fees."
    },
    {
       "id":5062,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following transactions are exempt under the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A secondary market transaction in an over-the-counter stock of an issuer that is required to file annual 10-K reports with the SEC </li><li>A primary offering of an OTC stock sold in one state only  </li><li>A secondary market transaction executed by a broker-dealer to fill an unsolicited customer order </li><li>A secondary market sale to a mutual fund</li></ol>",
       "choice_a":"II only",
       "choice_b":"I and III only",
       "choice_c":"I, III, and IV only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Non-issuer (secondary market) transactions that are exempt include those involving: securities of issuers subject to the registration and reporting requirements of the Securities Exchange Act of 1934, orders executed through a registered broker-dealer on an unsolicited basis, sales to institutional investors such as banks, insurance companies, and investment companies"
    },
    {
       "id":5063,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client desires a portfolio of income producing securities. An agent who has discretionary authority purchases shares of an aggressive growth fund for the client. The agent has:",
       "choice_a":"Committed a fraudulent act",
       "choice_b":"Committed an unauthorized act",
       "choice_c":"Acted inappropriately",
       "choice_d":"Acted properly",
       "correct_answer":"C",
       "explanation":"A client who desires income is looking for an investment that is high yielding (with reference to dividends and/or interest) and is relatively safe. A growth fund invests in companies that are expected to rise in market value relatively quickly. A majority of the earnings are retained by the corporation and not paid out in the form of dividends. Growth stocks can also be unstable and speculative. Therefore, the agent acted inappropriately with reference to the client\u0027s wishes and the investment was unsuitable. To be fraudulent, the action generally must involve some intent to deceive."
    },
    {
       "id":5064,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete is an agent for SIA Brokerage. Pete spends a lot of his free time playing video games with his on line friend, Victor. They notice an ad in a magazine advertising franchises that provide an online gaming business. Pete has always wanted to start a business to supplement his income from selling securities, so he and Victor form a corporation to buy the online gaming franchise. Without telling his employer, Pete sells small amounts of stock in his company to friends and neighbors to help get the enterprise started. Which of the following is true?",
       "choice_a":"This is an unacceptable practice since the venture is likely to fail and the investors will lose their money",
       "choice_b":"This is an unacceptable practice since these securities transactions are not recorded on the books of Pete\u0027s broker-dealer",
       "choice_c":"This is an acceptable practice as long as Pete does not mention his broker-dealer\u0027s name in connection with the transactions",
       "choice_d":"This is an acceptable practice because it is a small amount of stock sold to friends and neighbors of Pete and Victor",
       "correct_answer":"B",
       "explanation":"It is considered an unacceptable practice for an agent to effect securities transactions that are not recorded on the books and records of the employer. Such transactions could involve violations of the Uniform Securities Act. Before engaging in such transactions, agents should notify their broker-dealers for permission."
    },
    {
       "id":5065,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, the term offer to sell would include:",
       "choice_a":"The delivery of a dividend of stock without the payment of any compensation",
       "choice_b":"The attempt to dispose of a security for value",
       "choice_c":"The exercise of warrants previously sold by the corporation to an individual",
       "choice_d":"The tender of convertible securities as a result of an offer made exclusively to existing stockholders by another corporation",
       "correct_answer":"B",
       "explanation":"The term offer to sell includes every attempt or offer to dispose of, or the solicitation of an offer to buy, a security or interest in a security for value."
    },
    {
       "id":5066,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete is an agent for a broker-dealer in North Carolina. Pete may not do which of the following?",
       "choice_a":"Solicit orders for municipal bonds issued by a North Carolina school district",
       "choice_b":"Accept unsolicited orders for common stock in the Widget Corporation if the stock is not registered in North Carolina",
       "choice_c":"Solicit orders for the Widget Corporation bonds, which are registered in North Carolina",
       "choice_d":"Solicit orders for the Widget Corporation preferred stock if the stock is not registered in North Carolina",
       "correct_answer":"D",
       "explanation":"Agents may not solicit orders for unregistered, nonexempt securities. The agent may solicit orders for municipal bonds because municipal bonds are exempt from registration. An unsolicited order provides an exemption for the transaction. Only the preferred stock is neither registered nor exempt and may not be solicited."
    },
    {
       "id":5067,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, if an employee of an issuer is soliciting employees of that issuer for the purpose of selling securities, which of the following statements is true?",
       "choice_a":"The employee could receive commissions without being registered as an agent",
       "choice_b":"The employee would never be considered an agent of the issuer",
       "choice_c":"The employee would be considered an agent if she received commissions or other remuneration",
       "choice_d":"If the employee was an officer or director of the issuer she could receive commissions and would not be considered an agent",
       "correct_answer":"C",
       "explanation":"Any employee of an issuer soliciting employees of that issuer for the purpose of selling securities would be considered an agent of the issuer if the employee received commissions or other remuneration (such as a bonus based on securities sales)."
    },
    {
       "id":5068,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A New York Stock Exchange-listed corporation has 600,000 shares of stock outstanding and 1,000,000 shares authorized. The corporation declares a 50% stock dividend. The new securities would be registered by:",
       "choice_a":"Notification",
       "choice_b":"Qualification",
       "choice_c":"Coordination",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"Securities listed on the New York Stock Exchange are federal covered securities and are not subject to state registration or review."
    },
    {
       "id":5069,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete is an agent for SIA Securities. One of his clients, Mr. Page, works for the research department at Widget, Inc. Until now, Mr. Page has invested in bond mutual funds and conservative stock funds. Today he called Pete and places an order to buy 1000 Call contracts. Which of the following is true?",
       "choice_a":"Pete must accept the order since he may not knowingly fail to follow client instructions",
       "choice_b":"Pete should bring this order to the attention of a supervisor immediately, since it may indicate insider trading",
       "choice_c":"Pete must refuse to accept the order, since investors may not purchase stock in companies for which they work",
       "choice_d":"Pete must accept this order since it is unsolicited",
       "correct_answer":"B",
       "explanation":"It is illegal for an agent to use inside information. It may also be a violation of the USA to assist an investor who is using inside information. A situation like this should be treated as a \u0022red flag\u0022 that should be brought to the attention of a supervisor."
    },
    {
       "id":5070,
       "topic_id":4,
       "practice_test_id":2,
       "question":"A client is traveling and would like her investment adviser representative to pay some personal bills while she is away. Under the Uniform Securities Act, such an activity: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Should be backed up in writing </li><li>Constitutes custody </li><li>Falls outside the scope of securities market regulations</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"B",
       "explanation":"When an investment adviser has access to customer funds and securities, custody exists. Investment advisers would not normally pay personal bills such as rent, credit card, or cable television on behalf of their clients. Written authorization is required for this type of activity and usually is referred to as full discretionary authority. Custody arrangements are covered by securities regulations."
    },
    {
       "id":5071,
       "topic_id":4,
       "practice_test_id":3,
       "question":"Amber is a client of Pete, an agent for SIA Brokerage, Inc. Amber and Pete are also close personal friends. Amber placed an order for a new issue of stock that SIA is underwriting. Due to a mix-up in her employer\u0027s accounting department, Amber does not have enough money to pay for the stock on the settlement date. Pete deposits enough of his own funds in Amber\u0027s account to cover the shortfall, which Amber pays back when her employer\u0027s payroll problem is resolved. Which of the following is true?",
       "choice_a":"This is an acceptable practice as long as the loan is repaid within a reasonable period",
       "choice_b":"This is an acceptable practice because Pete extended the loan as a friend and not as an agent of SIA",
       "choice_c":"This is not an acceptable practice unless Amber pays Pete a reasonable rate of interest on the loan and has the permission of the broker-dealer",
       "choice_d":"This is not an acceptable practice since agents should not engage in the practice of lending money or securities to customers",
       "correct_answer":"D",
       "explanation":"It is considered an unethical practice to lend money to a customer to cover a shortfall in their account. This can lead to conflicts of interest and may be a violation of federal rules regarding the purchase of securities on credit"
    },
    {
       "id":5072,
       "topic_id":4,
       "practice_test_id":4,
       "question":"An offer to buy that is unsolicited would include:",
       "choice_a":"A person purchasing securities after receiving a prospectus in the mail",
       "choice_b":"A person purchasing securities after reading a tombstone advertisement",
       "choice_c":"Neither choice",
       "choice_d":"Both choices",
       "correct_answer":"B",
       "explanation":"A tombstone advertisement is usually placed by the underwriting syndicate. It is an announcement used to acquaint the public with a distribution of securities. It is not used to solicit orders for the purchase or sale of securities. There is a caveat (disclaimer) that is usually placed at the top of the tombstone which states that the announcement appears as a matter of record only and is not to be considered a solicitation."
    },
    {
       "id":5073,
       "topic_id":4,
       "practice_test_id":5,
       "question":"The definition of churning is:",
       "choice_a":"Delivery of an excessive amount of securities before settlement date",
       "choice_b":"Buying a security on one exchange and selling it on another",
       "choice_c":"Selling a security for a loss and buying it back within 30 days",
       "choice_d":"Excessive activity in a client\u0027s account",
       "correct_answer":"D",
       "explanation":"Churning is defined as excessive trading activity in an account, with particular attention paid to buy and sell transactions which are in conflict with the financial objectives of the client."
    },
    {
       "id":5074,
       "topic_id":4,
       "practice_test_id":6,
       "question":"A client lost money on an investment. His agent tells the client that that he will assure him that he makes money on the next trade to make up for the losses he incurred. Which of the following statements is correct concerning the action taken by the agent?",
       "choice_a":"This is allowed if the agent\u0027s supervisor approves the transaction",
       "choice_b":"This is allowed if the client is permitted to buy oversubscribed issues",
       "choice_c":"This is allowed if the client has a discretionary account",
       "choice_d":"This is a considered an unethical business practice",
       "correct_answer":"D",
       "explanation":"If an agent or broker-dealer guarantees a customer against a loss it is considered an unethical business practice."
    },
    {
       "id":5075,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Molly Hatchet, an agent for a broker-dealer, receives a call from a client who submits an order to sell 500 shares of stock at the market. After hanging up the phone, the agent notices the market turning around and decides to hold the order for a while. After half an hour, the market suddenly reverses again and Molly executes the customer\u0027s order at a loss. Which of the following is true?",
       "choice_a":"This is an unethical practice because the agent did not follow the client\u0027s instructions",
       "choice_b":"This is an unethical practice because the client lost money",
       "choice_c":"This is not an unethical practice since the agent was acting in good faith",
       "choice_d":"This is not an unethical practice as long as the agent reimburses the client for the loss",
       "correct_answer":"A",
       "explanation":"The agent failed to follow the client\u0027s instructions. This is an unethical practice under the USA even if the agent believes in good faith that she was acting in her client\u0027s best interests."
    },
    {
       "id":5076,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client is so pleased that they tell their agent that they can keep 5% of any gains in his account from now on, in addition to the commissions that he usually pays. Which of the following is true?",
       "choice_a":"This is acceptable as long as the agreement in writing",
       "choice_b":"This is acceptable only if the Broker Dealer is registered as an investment adviser",
       "choice_c":"This is not acceptable unless Broker Dealer foregoes its usual commission charges",
       "choice_d":"This is not acceptable as it is considered to be sharing in the client\u0027s profits",
       "correct_answer":"D",
       "explanation":"Sharing in the profits and / or losses in a client\u0027s account is generally not permitted There is an exception if the client and the agent have a joint account, the client and the broker-dealer consent to the arrangement in writing, and profits and losses are shared in proportion to the capital that each contributed to the account."
    },
    {
       "id":5077,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent may split commissions with which of the following?",
       "choice_a":"An agent of the same firm licensed in another state",
       "choice_b":"An insurance company officer giving the agent business",
       "choice_c":"An agent of another firm licensed in the same state",
       "choice_d":"Another licensed agent of the same firm licensed in the same state",
       "correct_answer":"D",
       "explanation":"The Uniform Securities Act allows for the splitting of commissions provided that the agents involved are employed by the same firm and are registered in the same state."
    },
    {
       "id":5078,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is a violation of the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Trades for the purpose of misrepresenting the actual trading volume of a stock </li><li>Failure to state all known facts </li><li>Inducing trades for the purpose of increasing commissions</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"B",
       "explanation":"Failure to state all known facts is not a violation of the Uniform Securities Act. Failure to state all material facts would be a violation. A material fact is information an investor would need in order to make a sound investment decision."
    },
    {
       "id":5079,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A Client gives control of his brokerage account to his brother by giving him a handwritten note giving him trading authorization over the account. According to the Uniform Securities Act:",
       "choice_a":"This is too informal",
       "choice_b":"A person cannot grant a temporary authorization to another person if they are not related",
       "choice_c":"Because the authorization is in writing it is acceptable",
       "choice_d":"Only clients who prepay their fees can grant a third party trading authorization",
       "correct_answer":"C",
       "explanation":"This arrangement would be referred to as a third party trading authorization. The standard requirement is that it be in written form. The handwritten note from Mr. Daniels would be acceptable."
    },
    {
       "id":5080,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client has an objective of income only. Under the Uniform Securities Act, an agent who has discretionary authorization in the account could:",
       "choice_a":"Not buy a speculative stock without the client\u0027s approval",
       "choice_b":"Speculate with 5% of the client\u0027s assets",
       "choice_c":"Speculate with any amount that could be reasonably justified",
       "choice_d":"Not purchase equities in the account",
       "correct_answer":"A",
       "explanation":"Regardless of the account size, any amount of speculative investing would be inappropriate in an account with an objective of income only."
    },
    {
       "id":5081,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following investment advisory practices is permissible?",
       "choice_a":"Assignment of the contract without consent",
       "choice_b":"Advisement of management changes",
       "choice_c":"Partaking in capital gains",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"It is unlawful for an investment adviser to enter into or renew an investment advisory contract unless it provides, in writing, that there will be no partaking in capital gains or capital appreciation of the client\u0027s account, no assignment of the contract will be made without consent, and provides for notification of management changes within a reasonable time after the change."
    },
    {
       "id":5082,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Bonds must be posted by all of the following except:",
       "choice_a":"Investment advisers who do not have discretionary authority or custody of client funds or securities",
       "choice_b":"Investment advisers who have discretionary authority but do not have custody of client funds or securities",
       "choice_c":"Broker-dealers who do not have discretionary authority",
       "choice_d":"Broker-dealers who have discretionary authority",
       "correct_answer":"A",
       "explanation":"Broker-dealers customarily have custody of client funds and securities and are required by the Act to post a bond. Investment advisers must post a bond only if they have discretionary authority over client accounts or have custody of client funds or securities. A bond guarantees that funds are available so that legal fees and fines can be met if assessed against a broker-dealer or investment adviser."
    },
    {
       "id":5083,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent of a broker-dealer has a business relationship with an agent of another broker-dealer. They both own a large quantity of an on line gaming stock. Which of the following statements is correct if both agents buy and sell large amounts of the stock to increase its trading volume?",
       "choice_a":"This action is permissible if the agents receive prior written approval of their broker-dealers",
       "choice_b":"This action is not permissible since the agents are employed by two different broker-dealers",
       "choice_c":"This action may be considered market manipulation",
       "choice_d":"This action is considered a matched sale and is an allowable type of securities transaction",
       "correct_answer":"C",
       "explanation":"The action by the two agents may be considered manipulation. The agents may not effect transactions to create the false or misleading appearance of trading volume."
    },
    {
       "id":5084,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The limited registration provision available to Canadian broker-dealers conducting business in a state permits which of the following?",
       "choice_a":"The broker-dealer to solicit all residents of a state",
       "choice_b":"The broker-dealer to transact business with existing clients who move to a state",
       "choice_c":"The broker-dealer to transact business with Canadian residents with whom the broker-dealer had an existing relationship",
       "choice_d":"The broker-dealer to transact business with institutional investors",
       "correct_answer":"C",
       "explanation":"The provisions allowing Canadian broker-dealers to transact business in a state are limited. A broker-dealer may effect transactions with a person from Canada who is temporarily in the state if there was an existing broker-dealer-client relationship before the person entered the United States."
    },
    {
       "id":5085,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent contacts a client and provides seven valid reasons why SIA Corporation shares represent an attractive purchase. He neglects to mention that the Chief Financial Officer has just resigned and that SIA is under investigation by a number of regulatory authorities. The client makes a purchase of SIA shares. Which of the following is false?",
       "choice_a":"The agent faces no civil liabilities since he gave valid reasons why the client should purchase SIA stock",
       "choice_b":"The client could recover the full purchase price paid for SIA stock",
       "choice_c":"The agent has committed a civil violation",
       "choice_d":"The client may file a lawsuit in state court",
       "correct_answer":"A",
       "explanation":"A purchaser has the right to bring a civil lawsuit if they believe the seller of the securities omits or makes an untrue statement concerning a material fact. This is a civil violation of the act. The client has the right to recover the full purchase price + interest + court cost and attorney fees."
    },
    {
       "id":5086,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, an advertisement placed in a periodical that offers a security for sale is considered an offer in:",
       "choice_a":"The state in which the purchaser resides",
       "choice_b":"The state in which the periodical is published",
       "choice_c":"All states in which vendors are located",
       "choice_d":"All states in which the periodical is distributed",
       "correct_answer":"B",
       "explanation":"The Uniform Securities Act provides that an advertisement in a regular newspaper, magazine, or periodical is not an offer in any state other than the state of publication. An offer to sell made on radio, television, or other electronic communication is made in the state where the broadcast studio or originating source of the transmission is located."
    },
    {
       "id":5087,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to the Uniform Securities Act, if an employee of an issuer is soliciting employees of that issuer for the purpose of selling securities, which of the following statements is true?",
       "choice_a":"The employee could receive commissions without being registered as an agent",
       "choice_b":"The employee would never be considered an agent of the issuer",
       "choice_c":"The employee would be considered an agent if she received commissions or other remuneration",
       "choice_d":"If the employee was an officer or director of the issuer she could receive commissions and would not be considered an agent",
       "correct_answer":"C",
       "explanation":"Any employee of an issuer soliciting employees of that issuer for the purpose of selling securities would be considered an agent of the issuer if the employee received commissions or other remuneration (such as a bonus based on securities sales)."
    },
    {
       "id":5088,
       "topic_id":4,
       "practice_test_id":2,
       "question":"SIA Company is registered as both a broker-dealer and an investment adviser. As a broker-dealer, the firm makes a market in WIDGET stock. SIA believes that this stock would be a very good investment for one of its advisory clients and would like to sell the client some stock from its market-maker account. Which of the following is true?",
       "choice_a":"SIA may sell the stock to the client as long as the security is suitable for the account",
       "choice_b":"SIA may sell the stock to the client as long as it does not charge a commission for the transaction",
       "choice_c":"SIA may sell the stock to the client as long as it discloses, prior to the completion of the transaction, that it is acting as a principal and it obtains the client\u0027s written consent",
       "choice_d":"SIA is not permitted to effect this transaction under any circumstances due to the conflict of interest",
       "correct_answer":"C",
       "explanation":"An investment adviser that wishes to act as principal for its own account must 1) disclose the capacity in which it is acting prior to the completion of the transaction, and 2) obtain the client\u0027s written consent."
    },
    {
       "id":5089,
       "topic_id":4,
       "practice_test_id":3,
       "question":"Amber Wave is a client of Molly Hatchet, an agent for SIA Brokerage, Inc. Amber and Molly are also close personal friends. Amber placed an order for a new issue of stock that SIA is underwriting. Due to a mix-up in her employer\u0027s accounting department, Amber does not have enough money to pay for the stock on the settlement date. Molly deposits enough of her own funds in Amber\u0027s account to cover the shortfall, which Amber pays back when her employer\u0027s payroll problem is resolved. Which of the following is true?",
       "choice_a":"This is an acceptable practice as long as the loan is repaid within a reasonable period",
       "choice_b":"This is an acceptable practice because Molly extended the loan as a friend and not as an agent of SIA",
       "choice_c":"This is not an acceptable practice unless Amber pays Molly a reasonable rate of interest on the loan and has the permission of the broker-dealer",
       "choice_d":"This is not an acceptable practice since agents should not engage in the practice of lending money or securities to customers",
       "correct_answer":"D",
       "explanation":"It is considered an unethical practice for an agent to engage in the practice of lending or borrowing money or securities from a customer. This can lead to conflicts of interest and may be a violation of federal rules regarding the purchase of securities on credit."
    },
    {
       "id":5090,
       "topic_id":4,
       "practice_test_id":4,
       "question":"The definition of churning is:",
       "choice_a":"Delivery of an excessive amount of securities before settlement date",
       "choice_b":"Buying a security on one exchange and selling it on another",
       "choice_c":"Selling a security for a loss and buying it back within 30 days",
       "choice_d":"Excessive activity in a client\u0027s account",
       "correct_answer":"D",
       "explanation":"Churning is defined as excessive trading activity in an account, with particular attention paid to buy and sell transactions which are in conflict with the financial objectives of the client."
    },
    {
       "id":5091,
       "topic_id":4,
       "practice_test_id":5,
       "question":"A client purchases $15,000 worth of a thinly traded stock. Three weeks later the stock is worth $5,000 and the client sells the stock at a loss. The agent tells the client that he will be allowed to purchase shares of a new issue that is oversubscribed to make up for the $10,000 loss. Which of the following statements is correct concerning the action taken by the agent?",
       "choice_a":"This is allowed if the agent\u0027s supervisor approves the transaction",
       "choice_b":"This is allowed if the client is permitted to buy oversubscribed issues",
       "choice_c":"This is allowed if the client has a discretionary account",
       "choice_d":"This is a considered an unethical business practice",
       "correct_answer":"D",
       "explanation":"If an agent or broker-dealer guarantees a customer against a loss it is considered an unethical business practice. The fact that the client might have a discretionary account or a supervisor approved the transaction is irrelevant."
    },
    {
       "id":5092,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Fred is a client of Jane, who represents SIA Securities. Jane\u0027s recommendations have made Fred quite a lot of money over the last ten years. Fred is so pleased that he tells Jane that she can keep 20% of any gains in his account from now on, in addition to the commissions that he usually pays. Which of the following is true?",
       "choice_a":"This is acceptable as long as SIA and Fred agree in writing",
       "choice_b":"This is acceptable only if SIA is registered as an investment adviser",
       "choice_c":"This is not acceptable unless SIA foregoes its usual commission charges",
       "choice_d":"This is not acceptable as it is considered to be sharing in the client\u0027s profits",
       "correct_answer":"D",
       "explanation":"Sharing in the profits and/or losses in a client\u0027s account is generally not permitted There is an exception if the client and the agent have a joint account, the client and the broker-dealer consent to the arrangement in writing, and profits and losses are shared in proportion to the capital that each contributed to the account."
    },
    {
       "id":5093,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent may split commissions with which of the following?",
       "choice_a":"An agent of the same firm licensed in another state",
       "choice_b":"An insurance company officer giving the agent business",
       "choice_c":"An agent of another firm licensed in the same state",
       "choice_d":"Another licensed agent of the same firm licensed in the same state",
       "correct_answer":"D",
       "explanation":"The Uniform Securities Act allows for the splitting of commissions provided that the agents involved are employed by the same firm and are registered in the same state."
    },
    {
       "id":5094,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent of a SIA broker-dealer has a business relationship with an agent of another broker-dealer. They both own a large quantity of WIDGET stock. Which of the following statements is correct if both agents buy and sell large amounts of WIDGET stock to increase its trading volume?",
       "choice_a":"This action is permissible if the agents receive prior written approval of their broker-dealers",
       "choice_b":"This action is not permissible since the agents are employed by two different broker-dealers",
       "choice_c":"This action may be considered market manipulation",
       "choice_d":"This action is considered a matched sale and is an allowable type of securities transaction",
       "correct_answer":"C",
       "explanation":"The action by the two agents may be considered manipulation. The agents may not effect transactions to create the false or misleading appearance of trading volume in WIDGET stock. This type of market manipulation is sometimes referred to as a matched sale and is considered a violation of securities law. If the agents worked at the same broker-dealer and had received prior written permission from their firm the transactions would still be considered a prohibited business practice."
    },
    {
       "id":5095,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client requests that her agent display a quote in a thinly traded security. The client is the majority shareholder in this security and the broker-dealer honors the request and displays the quote. Which of the following is correct?",
       "choice_a":"This would be permissible if the broker-dealer believed the quote was bona fide",
       "choice_b":"This would be considered an unethical business practice",
       "choice_c":"A broker-dealer may always enter a quote on behalf of a client",
       "choice_d":"A broker-dealer is not permitted to enter quotes on behalf of its clients",
       "correct_answer":"A",
       "explanation":"A broker-dealer is permitted to publish quotes (bid and ask prices) on behalf of its clients or for its own account. The broker-dealer must believe the quotes are bona fide and not intended to manipulate the market price of a security. If the quotes are not bona fide and the broker-dealer publishes them, they would have committed an unethical business practice."
    },
    {
       "id":5096,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent recommends that a client purchase a particular security. The agent believes the client has the resources to pay for the transaction. Three days after the trade is executed the client indicates that he cannot meet his financial obligation to the brokerage firm. If the agent lends personal funds to the client:",
       "choice_a":"The agent has committed fraud",
       "choice_b":"The agent has acted in an unethical manner",
       "choice_c":"The client forgoes a right to be offered a letter of rescission",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"This is unethical behavior, not fraud. An agent should not borrow or lend funds to a client."
    },
    {
       "id":5097,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following could be considered churning except:",
       "choice_a":"A portfolio was completely changed on the first and fifteenth of every month",
       "choice_b":"There was aggressive switching among mutual fund families",
       "choice_c":"Turnover was motivated by the commissions an account would generate",
       "choice_d":"There was rampant day trading in a speculator\u0027s account",
       "correct_answer":"D",
       "explanation":"A speculator\u0027s goal is to produce short-term trading profits and one would expect a high degree of turnover in this account. Such activity would generally not be considered churning since it is consistent with this investor\u0027s objectives."
    },
    {
       "id":5098,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Pete is an agent for SIA Brokerage. His client, Bill, is the CEO of a publicly traded company. Bill tells Pete about an upcoming merger between his company and a competitor. This information is not yet public knowledge. Which of the following is true?",
       "choice_a":"Pete may pass this information along to his clients, but may not use it personally",
       "choice_b":"Pete may use this information to do trades for Bill\u0027s account, but may not disclose it to anyone else",
       "choice_c":"Pete should disclose this information to a supervisor, but take no other actions based on it",
       "choice_d":"Pete should not disclose this information to any other person, and should not effect any trades based on it",
       "correct_answer":"C",
       "explanation":"Inside information is material, nonpublic information about an issuer. Agents of a broker-dealer who come into possession of such information should inform their supervisor, but should take no other actions. They should not effect trades based on this information, nor pass the information along to anyone except a supervisor."
    },
    {
       "id":5099,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A customer of a broker-dealer maintains a personal trading account. The spouse of the customer may:",
       "choice_a":"Purchase additional securities in the account",
       "choice_b":"Sell securities out of the account",
       "choice_c":"Transfer securities to another account",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"In a personal trading account, trades may only be entered by the individual or a third party designated by a written power of attorney. A spouse without power of attorney would not be eligible to trade in the account."
    },
    {
       "id":5100,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An agent has been executing transactions which are not reflected on the books of the broker-dealer. This type of activity requires:",
       "choice_a":"Suspension of the broker-dealer",
       "choice_b":"Registration as an investment adviser representative",
       "choice_c":"Registration by the agent as a broker-dealer",
       "choice_d":"Registration as an investment adviser by the agent",
       "correct_answer":"C",
       "explanation":"The agent is acting independently of the firm and would be viewed as a separate broker-dealer. The state would view the agent as acting as an unregistered broker-dealer."
    },
    {
       "id":5101,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent has just received an unsolicited order from a customer. The customer wants to purchase a large amount of a speculative stock. Although the customer has the financial resources to bear the risks of this investment, the agent does not think it fits the client\u0027s investment objectives. The agent may do all of the following except:",
       "choice_a":"Accept the order",
       "choice_b":"Attempt to convince the customer to not buy the stock",
       "choice_c":"Attempt to convince the customer to purchase another stock",
       "choice_d":"Ignore the customer\u0027s order if it is not suitable",
       "correct_answer":"D",
       "explanation":"It is considered a dishonest and unethical practice for an agent to knowingly fail to follow client instructions. However, agents may certainly attempt to convince customers to alter those instructions if they feel another course of action is more suitable for that client."
    },
    {
       "id":5102,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent for a broker-dealer has inadvertently sold a non-exempt unregistered security to a client. Which of the following would rectify the sale? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Getting the security registered as soon as possible </li><li>Buying the security back from the client </li><li>Paying the client interest from the date of the sale, less dividend or interest income received </li><li>Asking the client to sign a waiver of noncompliance</li></ol>",
       "choice_a":"IV only",
       "choice_b":"I and IV only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and IV only",
       "correct_answer":"C",
       "explanation":"If an agent discovers that he or she has inadvertently sold an unregistered nonexempt security to a client, the agent may offer to repurchase the security from the client under an offer of rescission, and pay the client the legal rate of interest from the date of purchase, less dividend or interest income received."
    },
    {
       "id":5103,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The term investment adviser includes all of the following except:",
       "choice_a":"An accountant who recommends tax-free securities as part of his tax service",
       "choice_b":"A person who sells security analyses",
       "choice_c":"A financial planner who sells written financial plans covering insurance and securities purchases",
       "choice_d":"A broker who charges for investment advice",
       "correct_answer":"A",
       "explanation":"Professionals who give investment advice that is incidental to their normal course of business (such as accountants), would not be considered investment advisers. The other individuals listed would be considered investment advisers."
    },
    {
       "id":5104,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The term agent does not include an individual who represents an issuer in:",
       "choice_a":"The sale of one-year commercial paper",
       "choice_b":"The sale of Canadian common stock",
       "choice_c":"Transactions with an underwriter",
       "choice_d":"Any transaction for the benefit of the issuer",
       "correct_answer":"C",
       "explanation":"In general, persons who represent issuers in exempt transactions are not agents. Transactions between issuers and underwriters are exempt."
    },
    {
       "id":5105,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent includes all of the following except:",
       "choice_a":"A person who represents a broker-dealer and sells listed securities",
       "choice_b":"A person who represents an issuer in selling securities through exempt transactions",
       "choice_c":"A person who sells registered securities to the public on behalf of an issuer",
       "choice_d":"A person representing a broker-dealer effecting transactions for the issuer",
       "correct_answer":"B",
       "explanation":"An individual who represents an issuer in selling securities through exempt transactions would not be considered an agent. An individual who sold securities for the issuer to the public through nonexempt transactions would be an agent. Anyone who represents a broker-dealer in a securities transaction is an agent."
    },
    {
       "id":5106,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, an officer of an issuer selling securities to the public is considered an:",
       "choice_a":"Agent of the issuer and is subject to registration",
       "choice_b":"Agent of the issuer and is not subject to registration",
       "choice_c":"Agent of a broker-dealer",
       "choice_d":"Associated person",
       "correct_answer":"A",
       "explanation":"A person acting in this capacity is referred to as an \u0022agent of the issuer,\u0022 and is subject to registration. An officer who sells issuer securities to employees or engages in certain exempt transactions is not an agent. The term associated person is defined in the rules of some self-regulatory organizations, but it is not a term used in the Uniform Securities Act."
    },
    {
       "id":5130,
       "topic_id":4,
       "practice_test_id":2,
       "question":"The compensation of an investment adviser is usually based on:",
       "choice_a":"The percentage of successful trades",
       "choice_b":"A percentage of the average value of the account",
       "choice_c":"The level of interest rates",
       "choice_d":"Profits generated in the account",
       "correct_answer":"B",
       "explanation":"Investment adviser compensation is usually based on a percentage of the assets under management. This is usually calculated based upon the average value of the account."
    },
    {
       "id":5131,
       "topic_id":4,
       "practice_test_id":3,
       "question":"According to the Uniform Securities Act, if an advisory firm concentrates its advice on New York Stock Exchange securities, the firm:",
       "choice_a":"Can seek an exemption from registration as an adviser",
       "choice_b":"Will be subject to the rules of the New York Stock Exchange",
       "choice_c":"Is not in violation of the USA",
       "choice_d":"Can only receive commissions as compensation",
       "correct_answer":"C",
       "explanation":"There is nothing wrong with giving advice that is limited to NYSE issues. Only members of the NYSE are subject to its rules."
    },
    {
       "id":5132,
       "topic_id":4,
       "practice_test_id":4,
       "question":"A sole proprietor who was registered as a broker-dealer is now charging a separate fee for securities advice. According to the Uniform Securities Act, the sole proprietor:",
       "choice_a":"Has an exemption from registration as an investment adviser",
       "choice_b":"Would have to register as an investment adviser",
       "choice_c":"Must change from sole proprietor to another business structure in order to become an investment adviser",
       "choice_d":"Must only register if the activities are called financial planning",
       "correct_answer":"B",
       "explanation":"Any business entity not specifically exempted from registration and charging a separate fee for administering advice, is subject to registration as an investment adviser. Broker-dealers are excluded from the definition of investment adviser if they provided only incidental advice with no separate, identifiable charge."
    },
    {
       "id":5133,
       "topic_id":4,
       "practice_test_id":5,
       "question":"An agent\u0027s application includes which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A filing fee </li><li>Work history </li><li>A consent to service of process</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"An agent\u0027s application contains all of the items listed."
    },
    {
       "id":5154,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Under the Uniform Securities Act, which of the following investment advisers would not have to register in the state?",
       "choice_a":"Adviser with no office in the state who advises 7 high net-worth individuals who are residents of the state",
       "choice_b":"Adviser with an office in the state who advises 5 non-institutional clients who are residents of the state",
       "choice_c":"Adviser with an office in the state who advises 11 pension funds located in the state",
       "choice_d":"Adviser with no office in the state who advises 11 pension funds located in the state",
       "correct_answer":"D",
       "explanation":"The advisers with offices in the state, must register. In the choice where the IA is over the \u00225\u0022 (the rules actually states “FEWER than SIX”) allowed for an out-of-state \u0022de minimus\u0022 exemption. If the IA is dealing with institutional investors, so the number is irrelevant. The IA in choice D does not have to register."
    },
    {
       "id":5155,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following persons are excluded from the definition of \u0022investment adviser\u0022?",
       "choice_a":"Certified financial planners",
       "choice_b":"Sports agents",
       "choice_c":"Banks",
       "choice_d":"Broker-dealers",
       "correct_answer":"C",
       "explanation":"Of these four choices, only banks are specifically excluded. Broker-dealers that do not advise for a separate fee are not an investment advisory business therefore need not register as investment advisers."
    },
    {
       "id":5156,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are investment adviser representatives except:",
       "choice_a":"Individual hired by an IA to help determine recommendations to clients",
       "choice_b":"Individual hired by an IA to sell the advisory services",
       "choice_c":"Individual hired by an IA to do filing and clerical work",
       "choice_d":"Individual who supervises a staff of solicitors for the firm",
       "correct_answer":"C",
       "explanation":"The exam might use the words \u0022clerical\u0022 or \u0022ministerial.\u0022 Those are the individuals at the IA firm who are not considered \u0022investment adviser representatives.\u0022 The people whom the regulators want to register are involved with selling the services, making recommendations, and managing accounts, plus those who supervise them."
    },
    {
       "id":5157,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are exempt transactions under the Uniform Securities Act except:",
       "choice_a":"A sheriff liquidates securities at auction",
       "choice_b":"A receiver in bankruptcy liquidates securities to pay creditors",
       "choice_c":"A manufacturing company offers shares to public investors",
       "choice_d":"An issuer offers securities in a Reg D private placement to 9 investors in the state",
       "correct_answer":"C",
       "explanation":"When a company offers shares to the general public, the stock needs to be registered. Thus, offered by prospectus."
    },
    {
       "id":5158,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following is a true statement concerning minimum net capital requirements?",
       "choice_a":"The Administrator must require minimum net capital at least as high as the federal requirement",
       "choice_b":"The Administrator may require net capital requirements in excess of federal requirements",
       "choice_c":"Rather than using a fixed dollar amount, some states use the ratio of net capital to aggregate indebtedness when determining minimum net capital requirements",
       "choice_d":"minimum net capital requirements are only for those firms with discretion or custody",
       "correct_answer":"C",
       "explanation":"The Uniform Securities Act grants the state securities Administrator the power to require a minimum net capital for firms based on their activities, but it doesn\u0027t say the Administrator has to. Agents and IAR\u0027s don\u0027t have minimum net capital requirements because they aren\u0027t firms, but if they have discretion over a customer account, they\u0027ll need to buy \u0022fidelity\u0022 or \u0022surety\u0022 bonds."
    },
    {
       "id":5159,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser representative working for a federal covered adviser with an office in the state registered last April 30th. It is now March 15th. What is true of the IAR\u0027s registration?",
       "choice_a":"It is voluntary since he is employed by a federal covered adviser in the state",
       "choice_b":"The license has expired if not renewed the previous December 31st or sooner",
       "choice_c":"The initial license will last until the next December 31st, no payment is due",
       "choice_d":"It is not required if he is also properly registered as a securities salesperson",
       "correct_answer":"B",
       "explanation":"Under the Uniform Securities Act the registration of “persons” expires each year unless properly renewed."
    },
    {
       "id":5160,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Gina just passed her Series 7 and 66 exams. Once she becomes properly registered with her state, Gina may put which of the following on her business cards? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Name of the firm and her name </li><li>Address and telephone number at the office </li><li>\u0022General securities representative\u0022 </li><li>\u0022Registered investment adviser\u0022</li></ol>",
       "choice_a":"I, II",
       "choice_b":"IV",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"If she works for a firm, she is an investment adviser representative and not an investment adviser. Don\u0027t let choices such as \u0022I\u0022 or \u0022II\u0022 make you nervous. It\u0027s a question about a business card-how could we eliminate the name, address, and telephone number?"
    },
    {
       "id":5161,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are true concerning criminal penalties under the Uniform Securities Act?",
       "choice_a":"There is no statute of limitations for securities fraud",
       "choice_b":"The statute of limitations for securities fraud is 7 years",
       "choice_c":"The maximum penalty is 3 years in jail, $5,000 fine or both",
       "choice_d":"Ignorance of the law/rule has no bearing in criminal proceedings",
       "correct_answer":"C",
       "explanation":"At the state level, it\u0027s 3 years / 5,000 or both. Under the IA Act of 1940, it\u0027s 5 years / $10,000."
    },
    {
       "id":5162,
       "topic_id":4,
       "practice_test_id":"",
       "question":"According to NASAA\u0027s Policy Statement “Dishonest or Unethical Business Practices of Broker-Dealers and Agents,” all of the following are prohibited practices except:",
       "choice_a":"A registered representative recommends a growth stock with an exceptionally high P/E ratio to all 100 of her clients across the board",
       "choice_b":"A broker-dealer affects an opening transaction in a margin account just before receiving a signed margin agreement from the customer",
       "choice_c":"A registered rep takes an order from a non-discretionary client\u0027s wife without 3rd-party trading authorization",
       "choice_d":"A broker-dealer buys REITS for a non-discretionary client before informing the client, because the investment is perfectly suitable",
       "correct_answer":"B",
       "explanation":"Addressed in NASAA\u0027S Model Rule for Broker-Dealers and Agents."
    },
    {
       "id":5163,
       "topic_id":4,
       "practice_test_id":"",
       "question":"You are a registered investment adviser and you recently signed a new client who gave you verbal authorization to use discretion in managing the client\u0027s account. You then purchase 100 shares of WDGT, 3 weeks later, the client has not returned a signed discretionary authorization form, the stock is now down by 25%. Which of the following best addresses this situation?",
       "choice_a":"According to NASAA\u0027S Model Rule “Unethical Business Practices of Investment Advisers, Investment Adviser Representatives, and Federal Covered Advisers,” advisers may not use discretion to place any trades pursuant to verbal authorization",
       "choice_b":"You should contact the client and inform him that without written authorization, you are unable to sell the stock",
       "choice_c":"You should sell the stock and then contact the client no later than the end of the business day",
       "choice_d":"You should purchase puts on margin to protect against further capital loss",
       "correct_answer":"B",
       "explanation":"NASAA model rule referenced and you\u0027ll see that the placing of the orders pursuant to verbal authority is okay for advisers (not broker-dealers), but the adviser needs the discretionary authorization in writing within 10 business days."
    },
    {
       "id":5164,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following is true of the registration period for persons, i.e. salespersons, broker-dealers, advisers, and IAR\u0027s?",
       "choice_a":"A registration fee is typically pro-rated so that an agent applying in late June would pay only\u00BD the required annual fee",
       "choice_b":"Registrations expire at the end of the calendar year unless properly renewed",
       "choice_c":"Registrations expire at the end of the firm\u0027s fiscal year",
       "choice_d":"Registrations are renewed only upon notification by the Administrator",
       "correct_answer":"B",
       "explanation":"At the end of the year, pay your renewal fee. If you don\u0027t pay it, the license expires, just like a vehicle registration."
    },
    {
       "id":5165,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are automatically registered when an investment adviser registers in another state? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>All investment adviser representatives currently working for the firm </li><li>All secretaries and support personnel </li><li>Officers, vice-presidents, and other control persons </li><li>Managers of those in charge of sales personnel</li></ol>",
       "choice_a":"I",
       "choice_b":"II, III",
       "choice_c":"III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"Secretaries don\u0027t need to register, and the firm needs to register the IAR\u0027s individually, usually with a U-4. The folks in charge of the firm are registered on the Form ADV as affiliates or “control persons.” You can view this form via NASAA\u0027s and the SEC\u0027s websites. You can also order the actual Form ADV on a particular adviser by requesting it from the SEC. Should you go to such extremes just for the Series 66? Absolutely. Why should I have all the fun?"
    },
    {
       "id":5166,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Jane has left her employment as an agent with Broker Dealer ABC in order to take a position at Broker Dealer XYZ -also located in the state-as a registered representative. Who must notify the Administrator?",
       "choice_a":"Jane only",
       "choice_b":"Broker Dealer ABC",
       "choice_c":"Broker Dealer XYZ",
       "choice_d":"Jane, Broker Dealer ABC, Broker Dealer XYZ",
       "correct_answer":"D",
       "explanation":"Both broker-dealers and the agent have to let the state know about this change of employment. This accomplished through a new filing of the U-4"
    },
    {
       "id":5167,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker-dealer could engage in transactions with which of the following investors for purposes of claiming a transactional exemption under the Uniform Securities Act? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Trust company </li><li>Investment company </li><li>Bank </li><li>Retail investors</li></ol>",
       "choice_a":"I only",
       "choice_b":"II, III only",
       "choice_c":"I, II, III only",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"Institutional investors such as banks, investment companies and trust companies would be considered sophisticated investors, therefore could be involved in exempt transactions. An individual investor Much be accredited before than can enter into an exempt transaction."
    },
    {
       "id":5168,
       "topic_id":4,
       "practice_test_id":"",
       "question":"In which of the following cases would the Administrator most likely cancel a person\u0027s registration?",
       "choice_a":"It is in the public interest to do so",
       "choice_b":"The individual can not be located",
       "choice_c":"The individual lied on an initial application",
       "choice_d":"The individual lied on a renewal application",
       "correct_answer":"B",
       "explanation":"The Administrative orders to deny, suspend, revoke, or cease & desist are all issued because they are \u0022in the public interest and provide necessary protection to investors.\u0022 In other words, somebody apparently did something wrong, like lying on their registration/application, or sticking elderly investors into deferred annuities. But \u0022cancel\u0022 just means the person is no longer in business, appears to have moved, or has died."
    },
    {
       "id":5169,
       "topic_id":4,
       "practice_test_id":2,
       "question":"All of the following investments may be subject to the state\u0027s requirements of registration and filing of advertising materials except:",
       "choice_a":"Whiskey warehouse receipt",
       "choice_b":"Whole life policy",
       "choice_c":"Debenture",
       "choice_d":"ADR",
       "correct_answer":"B",
       "explanation":"Whole life, term life, fixed annuities are not securities."
    },
    {
       "id":5170,
       "topic_id":4,
       "practice_test_id":3,
       "question":"Under the Uniform Securities Act, when does the registration for a person become effective?",
       "choice_a":"Immediately",
       "choice_b":"Immediately if accompanied by a signed and notarized affidavit",
       "choice_c":"At noon on the 30th day after filing the registration, provided no stop orders are pending",
       "choice_d":"Within 15 days of filing",
       "correct_answer":"C",
       "explanation":"By rule of the USA."
    },
    {
       "id":5171,
       "topic_id":4,
       "practice_test_id":4,
       "question":"Under the Uniform Securities Act, the statue of limitations for civil action is:",
       "choice_a":"Three years",
       "choice_b":"Five years",
       "choice_c":"Two years from discovery, three years from occurrence",
       "choice_d":"Three years from discovery, two years from occurrence",
       "correct_answer":"C",
       "explanation":"If the buyer knows the security was sold in violation of the Act, they need to sue within two years of discovery. After three years, it\u0027s too late to sue, whether the buyer knew or didn\u0027t know."
    },
    {
       "id":5172,
       "topic_id":4,
       "practice_test_id":5,
       "question":"Under the Uniform Securities Act, all of the following are excluded from the definition of \u0022investment adviser\u0022 except:",
       "choice_a":"Federal covered adviser",
       "choice_b":"Savings institution",
       "choice_c":"Sports agent",
       "choice_d":"Trust company",
       "correct_answer":"C",
       "explanation":"Many sports agents actually do end up being defined as investment advisers."
    },
    {
       "id":5173,
       "topic_id":4,
       "practice_test_id":6,
       "question":"A consent to service of process must accompany all the following except:",
       "choice_a":"Initial application for an agent",
       "choice_b":"Initial application for a broker-dealer",
       "choice_c":"Registration form for a security",
       "choice_d":"Civil complaint against an investment adviser",
       "correct_answer":"D",
       "explanation":"Agents, IARs, broker-dealers, advisers, and the issuers of securities file a consent to service of process when they register with the state."
    },
    {
       "id":5174,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Securities of all the following issuers are exempt under the Uniform Securities Act except:",
       "choice_a":"State banks",
       "choice_b":"National banks",
       "choice_c":"Savings institutions",
       "choice_d":"Bank holding companies",
       "correct_answer":"D",
       "explanation":"No exemption for bank HOLDING companies under the Uniform Securities Act."
    },
    {
       "id":5175,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If the state securities Administrator discovers that a securities agent has been making unauthorized purchases, which of the following actions may be taken?",
       "choice_a":"Impose criminal penalties on the agent",
       "choice_b":"Impose criminal penalties on the broker-dealer whom the agent represents",
       "choice_c":"Seek a court injunction against the agent and firm",
       "choice_d":"All choices listed",
       "correct_answer":"C",
       "explanation":"For criminal activities the Administrator would turn you over to the Attorney General or other prosecutor, who filed charges."
    },
    {
       "id":5176,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Jim has been soliciting and filling orders for retail customers even though he is not registered as an agent. What is true of this situation?",
       "choice_a":"It is permissible with prior approval from a registered general securities principal",
       "choice_b":"The broker-dealer can not be subjected to disciplinary actions",
       "choice_c":"It is permissible if the securities are exempt",
       "choice_d":"This represents a violation and customers may recover the original price paid for their securities plus interest",
       "correct_answer":"D",
       "explanation":"If securities are sold in violation of the Uniform Securities Act, civil remedies are available. No one may sell securities to the public without being registered as an agent."
    },
    {
       "id":5177,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If a broker-dealer\u0027s license is revoked, what is true of the licenses of agents working at the firm?",
       "choice_a":"They are no longer in effect",
       "choice_b":"The state will appoint a local broker-dealer to oversee activities of the agents",
       "choice_c":"The agents\u0027 licenses are held in escrow",
       "choice_d":"The agents\u0027 licenses are still in effect, and they may continue to sell on an unsolicited basis only",
       "correct_answer":"A",
       "explanation":"You are associated with the firm, if the firm is out of business you are out of work."
    },
    {
       "id":5178,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following would allow a security to be sold in a state without registration?",
       "choice_a":"The security is sold in a private placement",
       "choice_b":"The firm selling the security is excluded from the definition of a broker-dealer",
       "choice_c":"The security is common stock trading on the non-NASDAQ OTC market",
       "choice_d":"All choices listed",
       "correct_answer":"A",
       "explanation":"An exempt transaction means that a security that would normally have to be registered would not be registered. \u0022An exempt transaction of a non-exempt, exempt security."
    },
    {
       "id":5179,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Securities sold through a private placement are:",
       "choice_a":"Required to first be registered with the SEC",
       "choice_b":"Unregistered, non-exempt securities",
       "choice_c":"Exempt from the antifraud provisions of the Uniform Securities Act",
       "choice_d":"Allowed to be sold to 15 non-institutional buyers",
       "correct_answer":"B",
       "explanation":"Only way to sell an unregistered, non-exempt security lawfully is through an exempt transaction such as a private placement."
    },
    {
       "id":5180,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following are true regarding the registration of securities under the Uniform Securities Act except:",
       "choice_a":"A security is considered registered for one year from the effective date of its registration statement",
       "choice_b":"If the registration statement for a security is declared effective by the Administrator of one state, it is also effective in any state in which an identical registration statement has been filed",
       "choice_c":"The filing of a registration statement may be done by a person other than the issuer",
       "choice_d":"The registration statement must include the amount of securities to be offered in the state as well as the names of other states where the securities will be offered",
       "correct_answer":"B",
       "explanation":"Each state has the right to except to reject a registration."
    },
    {
       "id":5181,
       "topic_id":4,
       "practice_test_id":6,
       "question":"All of the following transactions are exempt except:",
       "choice_a":"A transaction by the administrator of an estate",
       "choice_b":"An unsolicited non-issuer transaction effected through a broker-dealer",
       "choice_c":"Transactions between an issuer and retail investors",
       "choice_d":"A bona fide pledge of securities as collateral to secure a loan",
       "correct_answer":"C",
       "explanation":"Transactions between issuers and investors are not exempt transactions. Transactions between fiduciaries and investors are exempt."
    },
    {
       "id":5182,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act which of the following information is required when registering securities for sale on the primary market? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The amount of securities to be offered </li><li>Specimen of the security </li><li>Consent to service of process </li><li>All other states where filing has been or will be made</li></ol>",
       "choice_a":"I, II only",
       "choice_b":"II, III only",
       "choice_c":"I, II, III, IV",
       "choice_d":"I, IV only",
       "correct_answer":"C",
       "explanation":"Full and fair disclosure with each state."
    },
    {
       "id":5183,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, when a security is exempt, this implies that:",
       "choice_a":"Transactions involving the security are not subject to the antifraud provisions of the Act",
       "choice_b":"The security does not need to be registered with the state to be sold there",
       "choice_c":"A broker-dealer that underwrites a new issue of the securities does not need to be registered with the state",
       "choice_d":"An agent who sells the security does not have to be registered with the state",
       "correct_answer":"B",
       "explanation":"That is all that the word \u0022exempt\u0022 means. Need not be registered."
    },
    {
       "id":5184,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, all of the following are true concerning an agent\u0027s registration except:",
       "choice_a":"An agent can only sell securities that have been properly registered in a state or qualify for an exemption from registration",
       "choice_b":"An agent can only solicit business in a state if both the agent and broker-dealer are registered in that state",
       "choice_c":"An agent\u0027s registration to sell securities expires at the end of the broker-dealer\u0027s fiscal year",
       "choice_d":"If an agent leaves a broker-dealer to go to another broker-dealer, the agent and both broker-dealers must notify the Administrator of the change",
       "correct_answer":"C",
       "explanation":"Registrations of persons (agents, broker-dealers, IA\u0027s, IAR\u0027s) all expire on December 31st unless properly renewed."
    },
    {
       "id":5185,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Renewal of an agent\u0027s license is accomplished by:",
       "choice_a":"Completing continuing education courses",
       "choice_b":"Passing an examination",
       "choice_c":"Paying a fee",
       "choice_d":"Publishing an announcement of renewal in a newspaper published in the state",
       "correct_answer":"C",
       "explanation":"Fee must be paid annually to get your registration current."
    },
    {
       "id":5186,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An unregistered agent employed by a licensed broker-dealer is allowed to sell exempt securities to the public:",
       "choice_a":"Under no circumstances",
       "choice_b":"If the transaction is exempt",
       "choice_c":"If the security is federal covered",
       "choice_d":"If the employee is not paid a salary or commission",
       "correct_answer":"A",
       "explanation":"if you want to sell SECURITIES for a broker-dealer, you must be registered."
    },
    {
       "id":5187,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, an investment advisor with no place of business in a state will not be required to register with the Administrator under which of the following conditions?",
       "choice_a":"The advisor has not been the subject of any disciplinary action",
       "choice_b":"If the advisor has been in business for five years",
       "choice_c":"The advisor will only provide advice to non-institutional investors",
       "choice_d":"The advisor will only provide advice to 401(k) plans with assets of at least $1 million",
       "correct_answer":"D",
       "explanation":"Time has nothing to do with registration, but who your client are, may."
    },
    {
       "id":5188,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Under the Uniform Securities Act, which of the following investment advisers would not have to register in the state?",
       "choice_a":"Adviser with no office in the state who advises 6 high net-worth individuals who are residents of the state",
       "choice_b":"Adviser with an office in the state who advises 5 non-institutional clients who are residents of the state",
       "choice_c":"Adviser with an office in the state who advises 11 pension funds located in the state",
       "choice_d":"Adviser with no office in the state who advises more than 10 pension funds located in the state",
       "correct_answer":"D",
       "explanation":"The advisers with offices in the state must register, so choices B and C do have to register. That leaves it up to A and D. In choice A the IA is over the \u00225\u0022 (the rules actually states “FEWER than SIX”) allowed for an out-of-state \u0022de minimus\u0022 exemption. In choice D the IA is dealing with institutional investors, so the number is irrelevant. The IA in choice D does not have to register."
    },
    {
       "id":5189,
       "topic_id":4,
       "practice_test_id":3,
       "question":"A Registered Rep has just passed their Series 7 and Series 63 exams. They may begin to sell securities within a state as soon as  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They receives written permission from a compliance officer  </li><li>They receives written permission from a principal  </li><li>They are granted registration by the Administrator  </li><li>They are affiliated with a broker-dealer</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, II only",
       "choice_c":"II, IV only",
       "choice_d":"III, IV only",
       "correct_answer":"D",
       "explanation":"You are not registered in a state until the State\u0027s securities administrator allows it."
    },
    {
       "id":5190,
       "topic_id":4,
       "practice_test_id":4,
       "question":"You have a new job is to sell the advisory services SIA Advisory Services. You will need to register as:",
       "choice_a":"An agent of the broker-dealer",
       "choice_b":"An LLC",
       "choice_c":"An investment adviser",
       "choice_d":"An investment adviser representative",
       "correct_answer":"D",
       "explanation":"To represents SIA Advisory you will need to register as an IAR (Investment Advisory Rep)"
    },
    {
       "id":5191,
       "topic_id":4,
       "practice_test_id":5,
       "question":"An investment adviser representative working for a federal covered adviser with an office in the state registered last April 30th. It is now March 15th. What is true of the IAR\u0027s registration?",
       "choice_a":"It is voluntary since he is employed by a federal covered adviser in the state",
       "choice_b":"The license has expired if not renewed the previous December 31st or sooner",
       "choice_c":"The initial license will last until the next December 31st, no payment is due",
       "choice_d":"It is not required if he is also properly registered as a securities salesperson",
       "correct_answer":"B",
       "explanation":"Under the Uniform Securities Act the registration of “persons” expires each year unless properly renewed."
    },
    {
       "id":5192,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An investment adviser may have custody of client funds and securities: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If the adviser files a consent to service of process </li><li>If the Administrator does not, by rule, prohibit custody </li><li>If the Administrator is informed of the custodial arrangement </li><li>If the adviser is registered with the SEC</li></ol>",
       "choice_a":"I, II, III, IV",
       "choice_b":"I only",
       "choice_c":"II, III only",
       "choice_d":"II, III, IV only",
       "correct_answer":"C",
       "explanation":"Some state-registered IA\u0027s take custody; as long as there\u0027s no rule against it and the Administrator is notified."
    },
    {
       "id":5193,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Before the Administrator enters an order to deny, suspend, or revoke a license, what must the affected party be given? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Consent to service of process </li><li>Prior notice </li><li>Opportunity for a hearing </li><li>Written finding of fact, conclusions of law</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, II only",
       "choice_c":"II, III only",
       "choice_d":"II, III, IV only",
       "correct_answer":"D",
       "explanation":"The IA, the agent, the broker-dealer, who provide a consent to service of process to the Administrator."
    },
    {
       "id":5194,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A customer is sold an unregistered, non-exempt security in violation of the Uniform Securities Act. What is the customer entitled to receive?",
       "choice_a":"Three times the amount paid for the security",
       "choice_b":"Original purchase price, plus interest, less income received",
       "choice_c":"Original purchase price, plus unspecified damages for pain and suffering",
       "choice_d":"Contumacy",
       "correct_answer":"B",
       "explanation":"The client must be made whole."
    },
    {
       "id":5195,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent in NC calls a customer residing in SC to try and interest her in some Widget stock. The next day while traveling to Florida, the client calls the broker and agrees to buy 1000 shares. What state would have authority over the trade?",
       "choice_a":"None because the stock is exempt",
       "choice_b":"Florida",
       "choice_c":"SC",
       "choice_d":"All three states",
       "correct_answer":"D",
       "explanation":"The offer originated in NC, was directed into SC, and was accepted in Fl. All three states have jurisdiction."
    },
    {
       "id":5196,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All Administrative orders to deny, suspend, or revoke must: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Be in the public interest </li><li>Provide protection to investors </li><li>Be approved by state legislature </li><li>Be approved by the Securities and Exchange Commission</li></ol>",
       "choice_a":"I, III only",
       "choice_b":"II, III only",
       "choice_c":"I, II only",
       "choice_d":"II, IV only",
       "correct_answer":"C",
       "explanation":"The Administrative order must protect investors and be in the public\u0027s interest."
    },
    {
       "id":5197,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If it is in the public interest and provides necessary protection to investors, the Administrator may deny, suspend, or revoke an investment adviser representative\u0027s license for all the following reasons except:",
       "choice_a":"The rep has filed a false or misleading application",
       "choice_b":"The rep failed to disclose her suspension from FINRA four years ago",
       "choice_c":"The rep is insolvent",
       "choice_d":"The rep lacks a college degree or equivalent training in finance / economics",
       "correct_answer":"D",
       "explanation":"Education is a disclosure item. However a college degree is not required."
    },
    {
       "id":5198,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following Administrative orders generally stem from violations in the securities industry except:",
       "choice_a":"Suspension",
       "choice_b":"Revocation",
       "choice_c":"Withdrawal",
       "choice_d":"Denial",
       "correct_answer":"C",
       "explanation":"Both withdrawal and cancellation are unrelated to bad behavior."
    },
    {
       "id":5199,
       "topic_id":4,
       "practice_test_id":"",
       "question":"What is the purpose of a consent to service of process?",
       "choice_a":"It insures against theft or embezzlement",
       "choice_b":"It acts as a fidelity/surety bond",
       "choice_c":"It gives the Administrator the authority to receive service of process against the applicant in non-criminal proceedings",
       "choice_d":"It certifies that the applicant has attained the highest level of training available",
       "correct_answer":"C",
       "explanation":"Consent to service of process is way the regulator could serve paper to the Administrator rather than tracking you down."
    },
    {
       "id":5200,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser with custody of client funds must send account statements to customers:",
       "choice_a":"Promptly",
       "choice_b":"Monthly",
       "choice_c":"Quarterly",
       "choice_d":"Annually",
       "correct_answer":"C",
       "explanation":"An account statement shows the market value of the stocks, bonds, and mutual funds in the account, any dividends and interest they have earned, and the cash position sitting on the sidelines. Advisers need to send the statements at least quarterly if they have custody. Since most advisers use an outside custodian, it\u0027s the custodian who sends the account statements to the client. The adviser still sends billing statements to clients showing how much money they took for services rendered."
    },
    {
       "id":5201,
       "topic_id":4,
       "practice_test_id":2,
       "question":"SIA Brokerage would like to get into the investment advisory business. When they apply to do so, the Administrator determines that the firm simply is not qualified to act as an investment adviser. Therefore, the Administrator will most likely:",
       "choice_a":"Revoke the firm\u0027s license as a broker-dealer",
       "choice_b":"Revoke the firm\u0027s license as an investment adviser",
       "choice_c":"Deny the application for broker-dealer on the firm not engaging in the investment advisory business",
       "choice_d":"Suspend the firm\u0027s license as a broker-dealer",
       "correct_answer":"C",
       "explanation":"They can still be a broker-dealer, as long as they don\u0027t try to act as an investment advisor."
    },
    {
       "id":5202,
       "topic_id":4,
       "practice_test_id":3,
       "question":"If a registered representative in North Carolina attempts to sell securities to a resident of South Carolina via email where has an offer to sell been made?",
       "choice_a":"North Carolina",
       "choice_b":"South Carolina",
       "choice_c":"Neither state",
       "choice_d":"Both states",
       "correct_answer":"D",
       "explanation":"The offer to sell was directed, where it originated, and/or where it was accepted."
    },
    {
       "id":5203,
       "topic_id":4,
       "practice_test_id":4,
       "question":"What must an investment adviser established as a partnership do if one or more members are admitted to the partnership?",
       "choice_a":"Incorporate",
       "choice_b":"Notify all clients promptly",
       "choice_c":"Notify all institutional clients promptly",
       "choice_d":"Sign a waiver of noncompliance",
       "correct_answer":"B",
       "explanation":"Who the partners are may be material to your decision to let the firm manage your assets."
    },
    {
       "id":5204,
       "topic_id":4,
       "practice_test_id":5,
       "question":"An investment adviser is sent a client\u0027s securities in error. In order to avoid being deemed to have custody, the adviser should:",
       "choice_a":"Forward the securities to the custodian within 3 days",
       "choice_b":"Return the securities to the sender within 3 days",
       "choice_c":"Update Form ADV to reflect the fact that the adviser now maintains custody",
       "choice_d":"Deliver the securities to an FDIC-insured bank",
       "correct_answer":"B",
       "explanation":"According to NASAA\u0027S Model Custody Rule, the adviser will keep records of what took place but must return the securities to the sender within 3 days to avoid being deemed to have custody."
    },
    {
       "id":5205,
       "topic_id":4,
       "practice_test_id":6,
       "question":"All of the following are exempt transactions under the Uniform Securities Act except:",
       "choice_a":"A marshal of the court liquidates unregistered securities",
       "choice_b":"A receiver in bankruptcy liquidates securities to pay creditors",
       "choice_c":"An issuer offers securities to 10 investors in the state",
       "choice_d":"An OTC Bulletin Board company offers shares of an IPO in only three states",
       "correct_answer":"D",
       "explanation":"The OTC BB stock must be registered with the SEC and with the three states where it will be offered and sold."
    },
    {
       "id":5206,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Federally registered investment advisers are subject to which of the following authorities of the state securities Administrator?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Notice filing requirements </li><li>Imposition of notice filing fees </li><li>Anti-fraud authority </li><li>Net capital requirements</li></ol>",
       "choice_a":"I, III",
       "choice_b":"II",
       "choice_c":"I, II, III",
       "choice_d":"II, IV",
       "correct_answer":"C",
       "explanation":"The Administrator can not impose net capital requirements on federal covered advisers, who will meet the SEC\u0027s requirements."
    },
    {
       "id":5207,
       "topic_id":4,
       "practice_test_id":"",
       "question":"All of the following represent prohibited activities of investment advisers except:",
       "choice_a":"Revealing client affairs to certain prospects without written authorization from the clients",
       "choice_b":"Placing all client transactions through a broker-dealer that provides only soft-dollar compensation without disclosing this arrangement to clients",
       "choice_c":"Recommending securities to clients that the adviser also purchases for its own account without disclosure",
       "choice_d":"Exercising any discretionary power in placing an order to purchase or sell securities for a client after receiving verbal authorization with written authority received in 10 business days",
       "correct_answer":"D",
       "explanation":"This is covered under NASAA\u0027S Model Rule on Unethical Business Practices for IA\u0027s, IARs, and Federal Covered Advisers. Remember that broker-dealers--unlike advisers--must obtain written discretion before any trades can be placed."
    },
    {
       "id":5208,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Sara is an IAR properly registered in State A and working for a federally registered investment adviser. Twice a month Sara meets with clients in State B at the federal covered adviser\u0027s office. What is true about Sara\u0027s registration requirements?",
       "choice_a":"Because she represents a federal covered adviser, she does not register in State B",
       "choice_b":"Because she has clients who reside in State B, she must register there",
       "choice_c":"Because she meets with clients only twice per month, she is not considered to have a place of business in State B",
       "choice_d":"Because she has a place of business in State B, she must register there",
       "correct_answer":"D",
       "explanation":"The facts don\u0027t make it clear whether the clients live in State B, but they do support the notion that Sara has a place of business in that state."
    },
    {
       "id":5209,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following investments is exempt from the anti-fraud provisions of the Uniform Securities Act?",
       "choice_a":"Treasury note",
       "choice_b":"Federal Covered security",
       "choice_c":"Whole life insurance",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"All securities are subject to the antifraud provisions of the Uniform Securities Act, but whole life insurance is not a security."
    },
    {
       "id":5210,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following represents a major thrust of the Uniform Prudent Investors Act?",
       "choice_a":"An executor of an estate is held to the same standards as a professional trustee",
       "choice_b":"Junk bonds may not be purchased by fiduciaries",
       "choice_c":"Collateralized Mortgage Obligation investments are too risky for most pension funds",
       "choice_d":"Assets should be diversified except when the trustee determines it is more prudent not to diversify the assets",
       "correct_answer":"D",
       "explanation":"This is lifted directly from the Uniform Prudent Investor Act--assume that the trustee will diversify unless there are good reasons not to."
    },
    {
       "id":5211,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Under the Uniform Securities Act, which of the following meets the definition of an “offer to sell securities”?",
       "choice_a":"Securities issued pursuant to a merger/acquisition",
       "choice_b":"A bona fide pledge of securities as collateral",
       "choice_c":"A reclassification of debt securities as common stock pursuant to a judicially approved reorganization",
       "choice_d":"Solicitation of an offer to buy a security",
       "correct_answer":"D",
       "explanation":"The other three choices are not considered offers; therefore, no registration is required."
    },
    {
       "id":5212,
       "topic_id":4,
       "practice_test_id":"",
       "question":"FINRA, formed through a merger of NASD and NYSE regulators, is an SRO with regulatory authority over which of the following?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Investment advisers </li><li>Mutual fund sponsors </li><li>Investment adviser representatives  </li><li>Broker-dealers</li></ol>",
       "choice_a":"II, IV",
       "choice_b":"II, III",
       "choice_c":"I, II, III, IV",
       "choice_d":"I, III",
       "correct_answer":"A",
       "explanation":"FINRA regulates broker-dealers, not investment advisers. Advisers and IARs are regulated by the states and the SEC only."
    },
    {
       "id":5213,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An adviser highlights a prospectus on a mutual fund to point out the important parts to their client. This action is:",
       "choice_a":"Allowable because anything you do to inform investor is is in their best interest",
       "choice_b":"Allowable because they can still read the original wording.",
       "choice_c":"Impermissible because you cannot change a prospectus in any way",
       "choice_d":"Not allowed because the advisor does not know which information the client may want to focus on",
       "correct_answer":"C",
       "explanation":"A prospectus can not be marked or changed in any way. Highlighting content or even stapling a business card to a prospectus is not allowed."
    },
    {
       "id":5214,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser needs to borrow money for gambling losses. His brother is a client who offers to loan him money from his account with his brother. This is:",
       "choice_a":"Allowed only if it is less than $1000",
       "choice_b":"Allowed only if there is a written contract",
       "choice_c":"Never allowed",
       "choice_d":"Allowed because it is family",
       "correct_answer":"D",
       "explanation":"An adviser could borrow money from an immediate family member so long as the firm does not have policy against it. Otherwise an adviser may only borrow money from a client if that client is in the business of making loans, such as if the client is a bank."
    },
    {
       "id":5215,
       "topic_id":4,
       "practice_test_id":"",
       "question":"What is an investment adviser allowed to do regarding a security?",
       "choice_a":"Push it to family and friends based on their knowledge of developments at the company",
       "choice_b":"Recommend that investors sell it short",
       "choice_c":"Act in a capacity opposite of the advise provided to clients for the purpose of building a position",
       "choice_d":"Tell clients that the covered securities they are recommending are safer than other securities and do not have to register with the state",
       "correct_answer":"B",
       "explanation":"An investment adviser may recommend that clients sell securities short so long as the clients are able to understand the risks and short selling is suitable for the client. An adviser may not suggest that a covered security is safer than a non covered security, nor may the adviser push the security based on their knowledge of developments at the company."
    },
    {
       "id":5216,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A security adviser registers May 1st with company XYZ, but then quits and goes to work with company ABC in the same state on November 1st. What must he do to register?",
       "choice_a":"Register on November 1st and again on January 1st",
       "choice_b":"Pay prorated registration on November 1st",
       "choice_c":"Reregister May 1st of the following year",
       "choice_d":"Need not do anything new",
       "correct_answer":"A",
       "explanation":"If an adviser moves from one firm to another they must register with the state as being an adviser with the new firm when the employment starts, in this case on November 1st. All advisers must renew their registration for the new year by January 1st."
    },
    {
       "id":5217,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following if committed by an adviser would be considered an unethical practice? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Not disclosing fees </li><li>Not allowing someone to register for too risky securities </li><li>Soliciting new investors in other states </li><li>Charging a larger than normal commission to execute a customer\u0027s specific order</li></ol>",
       "choice_a":"I only",
       "choice_b":"IV only",
       "choice_c":"III and IV",
       "choice_d":"III only",
       "correct_answer":"A",
       "explanation":"An adviser must always disclose the costs and fees for services. It is perfectly ok to charge a larger than normal commission for executing a specific order so long as it is disclosed."
    },
    {
       "id":5218,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent and firm are being sued for excessive trading in an account. How could the president of the firm escape liability?",
       "choice_a":"He did not know what the adviser was doing",
       "choice_b":"He performed all oversight but the adviser was hiding his actions",
       "choice_c":"The president is never liable",
       "choice_d":"The client did not lose any money in the transaction",
       "correct_answer":"B",
       "explanation":"If the president or principal of the firm is performing all of the required oversight of the agent and the agent is going to extraordinary measures to hide their actions the president or principal of the firm may escape liability."
    },
    {
       "id":5219,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When does an agent\u0027s registration expire?",
       "choice_a":"On their birthday",
       "choice_b":"December 31st",
       "choice_c":"Year to date of registration",
       "choice_d":"Never",
       "correct_answer":"B",
       "explanation":"All registrations of firms and agents expire on December 31st and must be properly renewed each year."
    },
    {
       "id":5220,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker dealer requests to withdraw their registration. Barring action by the administrator, when will the request become effective?",
       "choice_a":"45 days",
       "choice_b":"60 days",
       "choice_c":"15 days",
       "choice_d":"30 days",
       "correct_answer":"D",
       "explanation":"If a broker dealer requests that their registration within a state be withdrawn the request will become effective 30 days after the request is received so long as the administrator is not in the process of taking action against the firm."
    },
    {
       "id":5221,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An IAR works for a firm registered in New York that has clients in Florida. The IAR has a single client investing $10,000,000 in Colorado. Where does the IAR have to register? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Florida </li><li>New York </li><li>Colorado</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I and II",
       "choice_d":"I, II and III",
       "correct_answer":"C",
       "explanation":"The IAR must register where the firm is registered (NY) and where they have clients (FL). The IAR would not be required to register in Colorado because the only have 1 client in that state and because the firm is not registered in Colorado. Under the rule an adviser may have or give advice to up to five clients in a 12 month period without being required to register."
    },
    {
       "id":5222,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A firm is employing a non-registered person who is acting as an agent when making sales to customers. The state administrator can do which of the following: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Fine the agent </li><li>Fine the Broker Dealer </li><li>Bar the agent </li><li>Pursue criminal action against the agent</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The state securities administrator may take all of the actions listed except they can not bring criminal action against the agent. The administrator would have to refer the matter to the state attorney general for prosecution."
    },
    {
       "id":5223,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An Investment adviser is not allowed to do any of the following except:",
       "choice_a":"Make recommendations based on public information",
       "choice_b":"Tell an investor that the company\u0027s rival is unlikely to win a new contract",
       "choice_c":"Say that an internal audit shows the company is better off than thought",
       "choice_d":"Exercise time and size discretion over an account without written authority",
       "correct_answer":"A",
       "explanation":"An investment adviser may only make recommendations based on public information. The adviser may not cite an internal audit (\u0022non public information\u0022), exercise discretion over the amount of a security to buy or sell without discretion nor state that a company is unlikely to win a contract without stating that it is their opinion and not a fact."
    },
    {
       "id":5224,
       "topic_id":4,
       "practice_test_id":2,
       "question":"Which of the following cannot appear on the firm\u0027s website?",
       "choice_a":"The State Administrator approves our practices",
       "choice_b":"Goals of the institution",
       "choice_c":"Amount of money they control",
       "choice_d":"Quotes from customers",
       "correct_answer":"A",
       "explanation":"A firm may never state that any regulator approves or endorses the firm or its agents. All of the other choices may be placed on the firm\u0027s website."
    },
    {
       "id":5225,
       "topic_id":4,
       "practice_test_id":3,
       "question":"The administrator can investigate an agent applying for registration for which two of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A misdemeanor DUI </li><li>A misdemeanor involving securities </li><li>Citizenship </li><li>Late payments to a credit card or automobile installment account</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and III",
       "choice_c":"II and IV",
       "choice_d":"I and IV",
       "correct_answer":"A",
       "explanation":"A state securities administrator may investigate an agent applying for registration if they have been involved in a securities related misdemeanor and to determine the agent\u0027s citizenship."
    },
    {
       "id":5226,
       "topic_id":4,
       "practice_test_id":4,
       "question":"A client sends a written complaint about an agent being rude. The company is required to:",
       "choice_a":"Contact the state administrator with the charges",
       "choice_b":"Do nothing as this is not a substantial claim",
       "choice_c":"Investigate the matter",
       "choice_d":"Suspend the agent immediately",
       "correct_answer":"C",
       "explanation":"A firm that receives a written customer complaint is required to investigate the matter no matter how small the claim."
    },
    {
       "id":5227,
       "topic_id":4,
       "practice_test_id":5,
       "question":"When a broker-dealer registers, who is automatically registered as well?",
       "choice_a":"Agent",
       "choice_b":"Principal",
       "choice_c":"Office Manager",
       "choice_d":"Sales Clerk",
       "correct_answer":"B",
       "explanation":"When a broker dealer registers in a state a principal of the firm is automatically required to register in that state."
    },
    {
       "id":5228,
       "topic_id":4,
       "practice_test_id":6,
       "question":"With whom can you split a commission?",
       "choice_a":"Clerical staff who helped with the client",
       "choice_b":"Someone who has taken but not passed the registration test",
       "choice_c":"The manager of the office who is also a registered agent",
       "choice_d":"An IAR who is not registered in that state",
       "correct_answer":"C",
       "explanation":"An agent may split commissions with someone who is also registered as an agent, in this case the office manger who is also registered as an agent."
    },
    {
       "id":5229,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An administrator believes an agent will be selling an unregistered non exempt security. They can:",
       "choice_a":"Ask for an injunction in court",
       "choice_b":"Suspend the agent immediately",
       "choice_c":"Do nothing until they act",
       "choice_d":"Censure the agent",
       "correct_answer":"A",
       "explanation":"An administrator may issue a cease and desist order or may seek an injunction in court prior to a violation occurring in an effort to prevent the violation from occurring."
    },
    {
       "id":5230,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser says that they will compensate the customer for any losses that a security will have. This is:",
       "choice_a":"Not allowed because it is guaranteeing a return",
       "choice_b":"Not allowed as they may not have enough money to cover the loss",
       "choice_c":"An acceptable practice",
       "choice_d":"Allowed only if approved by the principal at the home office",
       "correct_answer":"A",
       "explanation":"No firm, adviser or agent may guarantee a result or promise no loss to a client for any reason."
    },
    {
       "id":5231,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The net capital requirement for an agent cannot exceed:",
       "choice_a":"The SEC required level",
       "choice_b":"FINRA\u0027S required level",
       "choice_c":"The fee for each state in which they are registered",
       "choice_d":"The lowest fee for a state in which they are registered",
       "correct_answer":"C",
       "explanation":"The state can not require an agent to meet any net capital requirement other than the ability to pay the registration fees in each state in which they wish to conduct business."
    },
    {
       "id":5232,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If the net capital of an adviser dips below the level that is required:",
       "choice_a":"An administrator can act only if they are registered in their state",
       "choice_b":"An administrator can act only if they are registered in their state and the SEC acts first",
       "choice_c":"An administrator can act only if they are registered in their state and FINRA acts first",
       "choice_d":"An administrator can act only if they are registered in their state and the adviser has custody of clients\u0027 cash and securities",
       "correct_answer":"A",
       "explanation":"If an adviser becomes insolvent the administrator can act and cancel the adviser\u0027s registration if the firm (adviser) is registered in their state."
    },
    {
       "id":5233,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An agent knows there will be an oversubscription to the offering of a security. He then, acting on verbal authority, opens an account for his wife where he puts many of the securities. This is:",
       "choice_a":"A violation as you cannot act for another person",
       "choice_b":"Acceptable because it is his wife",
       "choice_c":"An example of withholding and a violation",
       "choice_d":"This is acceptable if the amount of the securities is less than $10,000",
       "correct_answer":"C",
       "explanation":"All securities that are the subject of an underwriting must be offered to the public and can not be withheld for the account of a broker dealer, an agent or anyone who is financially dependent upon the agent, such as spouse or a child."
    },
    {
       "id":5234,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client asks an agent to sell his shares in company C at the market. The agent believes the stock will rise and waits until the end of the day when the stock has fallen. Which of the following is true?",
       "choice_a":"This is acceptable because the agent was acting in what he thought were the best interests of the client",
       "choice_b":"This is not acceptable only because the client lost money",
       "choice_c":"This is a violation because the agent did not listen to the client\u0027s instructions",
       "choice_d":"This is acceptable because the agent can not be expected to execute every order for all clients immediately",
       "correct_answer":"C",
       "explanation":"This is a violation because the agent did not listen to the client and sell their shares in company C at the market as soon as practical."
    },
    {
       "id":5235,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A firm is found in violation of the USA for selling unregistered non exempt securities and for making false statements. The administrator can: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Take action against the firm\u0027s agents </li><li>Take action against the broker dealer </li><li>Bring criminal charges against the agents </li><li>Award the firm\u0027s clients money and interest</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"An administrator can do all of the choices listed but can not bring criminal charges against the agents. Only a district attorney can bring criminal charges against agents."
    },
    {
       "id":5236,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent is three mutual fund sales away from a bonus. It is unethical for the representative to:",
       "choice_a":"Tell clients about the bonus",
       "choice_b":"Solicit help from family and friends to meet the bonus",
       "choice_c":"Call clients and tell them that there is a great deal on a fund",
       "choice_d":"Establish a dollar cost averaging plan for a client at the client\u0027s request",
       "correct_answer":"C",
       "explanation":"The agent may not recommend the fund for which the sales are the basis for a bonus and use that potential bonus as the basis for the recommendation."
    },
    {
       "id":5237,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent has discretionary account. The person who is the account holder tells them to pick whatever they think will be in their best interest. Which of the following is acceptable?",
       "choice_a":"The agent should pick growth stocks",
       "choice_b":"The agent can only pick time and price, not securities",
       "choice_c":"The agent should pick the securities he believes will offer the best performance",
       "choice_d":"The agent should pick only securities he believes are best suited for the client",
       "correct_answer":"D",
       "explanation":"An agent who is managing a discretionary account must always select investments that meet the client\u0027s investment profile."
    },
    {
       "id":5238,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A person needs $10,000 to cover an unexpected expense, they have $5,000 in cash in their account and $55,000 in mutual funds and stock. They tell the agent to send them $10,000. The agent should:",
       "choice_a":"Send the cash and pick which stocks he thinks will grow the least and sell them to cover the other $5,000",
       "choice_b":"Send the cash and get permission to sell $5,000 of the mutual fund",
       "choice_c":"Send the cash and take taxes into account and sell enough of the assets to cover the $5,000 and the tax",
       "choice_d":"Send the cash and sell the stock first to cover the $5,000 as this will not incur a penalty",
       "correct_answer":"B",
       "explanation":"The agent should do as the client asks and send the $5,000 to the client and get permission to sell $5,000 of the mutual fund to cover the rest of the cash need. The key is that the agent asked for permission."
    },
    {
       "id":5239,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following statements made by a representative is a violation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Covered stocks are less risky than non-covered stocks </li><li>Since a stock is covered, it does not need to be registered with the SEC or state </li><li>This covered stock has many shares outstanding </li><li>This covered stock should be bought by all my clients</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II only",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the statements if made by an agent regarding a covered security would be a violation except telling the client the amount of shares the company has outstanding."
    },
    {
       "id":5240,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A broker dealer does not need to register in a state when the firm has no office in a state, and: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Works only with banks </li><li>Works only with wealthy investors </li><li>Works only with institutional investors </li><li>Works only with savings and loans</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"The broker dealer would not have to register if there was no office in the state and did business only with banks, institutional investors or savings and loans. If the firm conducted business with individual investors the firm would have to register."
    },
    {
       "id":5241,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following if engaged in by an agent is a violation of the USA?",
       "choice_a":"Charging different fees to different clients",
       "choice_b":"Charging a fee that increases with the value of the customer\u0027s account",
       "choice_c":"Recommending a stock to all clients",
       "choice_d":"Charging different fees to execute different orders",
       "correct_answer":"C",
       "explanation":"Charging different fees for specific orders or for clients who purchase more shares is an acceptable practice. An agent may not recommend a security to all clients as it will not be suitable for all clients. Charging a fee that increases with the value of the customer\u2019s account is a normal result of fee based business. When charging a fee based as a percentage of assets, the dollar amount will increase as the account value increases."
    },
    {
       "id":5242,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Anyone who invests, including individual investors is subject to:",
       "choice_a":"Keeping documents",
       "choice_b":"Not committing fraud",
       "choice_c":"Registering securities",
       "choice_d":"Registering as a broker-dealer",
       "correct_answer":"B",
       "explanation":"No one may commit fraud including individual investors."
    },
    {
       "id":5243,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Which of the following is an exempt transaction?",
       "choice_a":"Selling a security to an investor in the same state as you",
       "choice_b":"Selling a security to an investor in a neighboring state",
       "choice_c":"A broker dealer buying a security from a client",
       "choice_d":"Selling a security to the trustee of a family trust",
       "correct_answer":"D",
       "explanation":"All transactions with fiduciaries such as a trustee are exempt transactions."
    },
    {
       "id":5244,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A Canadian agent registered in the Alberta Province wants to do business with a client while they are on vacation in New Mexico. This is:",
       "choice_a":"Not allowed as Canadians cannot perform business in the US",
       "choice_b":"Acceptable as long as they register within New Mexico",
       "choice_c":"Acceptable even without registration",
       "choice_d":"Only allowed if given special dispensation from the SEC",
       "correct_answer":"C",
       "explanation":"Canadian broker dealers and agents duly registered in Canada can transact business with a client traveling in New Mexico ( or any state) temporarily without having to register with the state of New Mexico ( or any state)."
    },
    {
       "id":5245,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A federally covered security is:",
       "choice_a":"Safer than other investments",
       "choice_b":"Exempt from registering with states",
       "choice_c":"Limited to open end investment companies whose shares are sold through a prospectus",
       "choice_d":"Subject to review by the state securities administrator",
       "correct_answer":"B",
       "explanation":"A federally covered security is exempt from state registration."
    },
    {
       "id":5246,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are not required at the time of initial registration of a broker dealer?",
       "choice_a":"Fees",
       "choice_b":"Application",
       "choice_c":"Fingerprints of president",
       "choice_d":"Consent to service of process",
       "correct_answer":"C",
       "explanation":"All of the choices listed are required at the time a broker dealer registers with the state except the finger prints of the president."
    },
    {
       "id":5247,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If an investment adviser works in state A and has a client who is a bank in state B, the investment adviser must register if: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investment adviser opens a place of business in B </li><li>The investment adviser has more than 5 banking clients in state B in the last 12 months </li><li>The investment adviser gets an individual client in state B </li><li>The investment adviser opens accounts for 11 individual clients in state B</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I only",
       "correct_answer":"A",
       "explanation":"If an investment adviser opens accounts for 11 individuals or opens an office in state B the investment adviser would be required to register in state B."
    },
    {
       "id":5248,
       "topic_id":4,
       "practice_test_id":"",
       "question":"If an investment adviser works in state A and advises institutional clients in state B the investment adviser must register if:",
       "choice_a":"The investment adviser wants to do any work in state B",
       "choice_b":"The investment adviser has up to 12 institutional clients in state B",
       "choice_c":"The investment adviser has more than 5 institutional clients in state B",
       "choice_d":"Only if the investment adviser opens a business in state B",
       "correct_answer":"D",
       "explanation":"If an investment adviser works in state A and advises only institutional clients in state B the investment adviser would only have to register in state B if the investment adviser opened up a place of business in state B."
    },
    {
       "id":5249,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser is registered with their home state on June 15th, when do they have to re register?",
       "choice_a":"30-Jun",
       "choice_b":"31-Dec",
       "choice_c":"December 31 of the next year",
       "choice_d":"12 months from issuance of registration",
       "correct_answer":"B",
       "explanation":"All registrations at the state level must be renewed or re registered on December 31st of every year."
    },
    {
       "id":5250,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser who is also an agent of a broker dealer, guarantees a client that the securities they are investing in will outperform US Bonds. This is:",
       "choice_a":"Acceptable because they are an agent as well",
       "choice_b":"Not acceptable because they are guaranteeing performance",
       "choice_c":"Acceptable because they do not cite a specific rate",
       "choice_d":"Not acceptable as an investment adviser may not represent a broker dealer",
       "correct_answer":"B",
       "explanation":"An investment adviser may never guarantee the performance of any investment, promise a return or promise no loss for any reason."
    },
    {
       "id":5251,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser has a new client sign a form before opening the account that says that the investment adviser does not follow any prudent investment guidelines. The investment adviser then engages in very risky trading (more than the client would like). The client:",
       "choice_a":"Has no rights because they signed the form",
       "choice_b":"Can take action against the investment adviser because they did not inform them they were waiving their rights",
       "choice_c":"Can take action because the clause is unenforceable",
       "choice_d":"Cannot take action because they waived all rights",
       "correct_answer":"C",
       "explanation":"A client may never sign any form or agree to waive their rights to sue an adviser. Any form or clause under which a client waves their rights would be unenforceable."
    },
    {
       "id":5252,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Your advisory company charges fees to clients for both advice and transactions. This is:",
       "choice_a":"Never allowed",
       "choice_b":"Allowed if total fees are less than 1.25% of market value of assets",
       "choice_c":"Allowed if you disclose the fact to clients",
       "choice_d":"Allowed only if the company\u0027s advisory clients are limited to institutions",
       "correct_answer":"C",
       "explanation":"An advisory company many charge fees for advice and receive commissions for executing orders for the clients so long as it is disclosed to the clients."
    },
    {
       "id":5253,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following issuers is required to register their securities with the administrator?",
       "choice_a":"A Canadian Province",
       "choice_b":"An issuer whose securities are sold only to people previously invested in the issuer\u0027s securities",
       "choice_c":"An issuer of open end mutual fund shares",
       "choice_d":"An issuer of common stock listed on the Toronto Stock Exchange",
       "correct_answer":"D",
       "explanation":"The issuer of common stock listed on the Toronto Stock Exchange would have to register the securities with the state administrator"
    },
    {
       "id":5254,
       "topic_id":4,
       "practice_test_id":6,
       "question":"A hedge fund typically: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Has manager invested in it so they are a partner </li><li>Works against a benchmark </li><li>Are private investment companies  </li><li>Must offer a prospectus to investors</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct regarding hedge funds except they are not sold by prospectus as hedge funds are not offered to the general public."
    },
    {
       "id":5255,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following are rights of a state Administrator? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Collect evidence </li><li>Administer oaths </li><li>Subpoena </li><li>Execute a search warrant</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III only",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"An administrator may do all of the items listed except execute a search warrant."
    },
    {
       "id":5256,
       "topic_id":4,
       "practice_test_id":"",
       "question":"What document sent to the general public can the administrator require to be filed?",
       "choice_a":"Advertisements",
       "choice_b":"Company Logo",
       "choice_c":"Emails",
       "choice_d":"Memos",
       "correct_answer":"A",
       "explanation":"The state securities administrator may require advertisements to be filed with their office."
    },
    {
       "id":5257,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client gives oral permission to their investment adviser to execute a trade. The investment adviser executes the order for the client at the market in line with the client\u0027s instructions. When must the adviser receive the authorization in writing?",
       "choice_a":"Before a fee is paid",
       "choice_b":"Before the next transaction",
       "choice_c":"Within 10 days",
       "choice_d":"Not at anytime if the adviser has a contract in place with the client",
       "correct_answer":"D",
       "explanation":"A client is not required to provide written authorization to document their approval to execute an order."
    },
    {
       "id":5258,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When can an investment adviser reveal information about their client?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If the client gives permission </li><li>If legally forced </li><li>At their discretion </li><li>If asked by family</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I and Iv",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"An investment adviser may only reveal information about their client if the client gives permission or if they are required to legally, such as under a subpoena."
    },
    {
       "id":5259,
       "topic_id":4,
       "practice_test_id":"",
       "question":"What is true about criminal liability for someone who sells unregistered non exempt securities to state residents?",
       "choice_a":"They are only liable if they knew they were unregistered",
       "choice_b":"They are only liable if they are registered as an agent",
       "choice_c":"They are always liable as long as they intentionally and knowingly sold the unregistered securities",
       "choice_d":"They are only liable if the customers suffered losses",
       "correct_answer":"C",
       "explanation":"Any person (even if not registered as an agent) who intentionally and knowingly sells unregistered non exempt securities may be held criminally liable regardless of any losses."
    },
    {
       "id":5260,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Who would have to register if representing a federally covered adviser?",
       "choice_a":"No one since the firm is not required to register",
       "choice_b":"Investment advisory representatives who transact business with state residents",
       "choice_c":"Only partners and portfolio managers who are only required to register with the SEC",
       "choice_d":"All employees must register in their home states",
       "correct_answer":"B",
       "explanation":"Investment advisory representatives who transact business with state residents must register in the states where they have clients as well as in their home state."
    },
    {
       "id":5261,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A principal of XYZ portfolio managers is either going to invest heavily in a company in the next 12 months or walk away and redistribute the money to investors. Where should he keep the money in the meantime?",
       "choice_a":"Money market fund",
       "choice_b":"Real Estate Investment Trust",
       "choice_c":"Medium term government bonds",
       "choice_d":"Short term pass through certificates",
       "correct_answer":"A",
       "explanation":"If the principal of XYZ portfolios is considering investing in a company or return the investors\u0027 money in the next 12 months the money should be kept in a money market fund until the decision is made to invest is a suitable company or to return the funds."
    },
    {
       "id":5262,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which organization sets the rules for margin requirements?",
       "choice_a":"SEC",
       "choice_b":"FINRA",
       "choice_c":"Federal Reserve Board",
       "choice_d":"NYSE",
       "correct_answer":"C",
       "explanation":"The Federal Reserve Board sets the rules regarding lending for securities purchases. This was granted to the FRB under The Securities Exchange Act of 1934."
    },
    {
       "id":5263,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser borrows money from a client, this is:",
       "choice_a":"Never allowed",
       "choice_b":"Allowed if given permission",
       "choice_c":"Allowed if the client is a broker-dealer",
       "choice_d":"Allowed if the client is a long time friend prior to becoming a client",
       "correct_answer":"C",
       "explanation":"An investment adviser may borrow money from a broker dealer who is in the business of making loans for such things as a margin account. An investment adviser may also borrow money from a bank so long as the bank is in the business of making such loans."
    },
    {
       "id":5264,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When an agent switches firms what notifications are required? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The agent is required to notify the administrator  </li><li>The former firm is required to notify the administrator </li><li>The new firm is required to notify the administrator </li><li>The agent must contact all old clients at the old firm to inform them he has left the firm and will no longer be servicing their account</li></ol>",
       "choice_a":"I Only",
       "choice_b":"II and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"When an agent leaves a firm the agent, the old firm and the new firm are all required to notify the administrator. The agent is not required to contact the clients to tell them that he is leaving."
    },
    {
       "id":5265,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An investment adviser purchases information from another source saying that XYZ company is going to do very well. The adviser then purchases XYZ for a client. The investment adviser must:",
       "choice_a":"Disclose the price paid for the research if any",
       "choice_b":"Disclose that their research comes from an outside source",
       "choice_c":"Not use this information as the client did not higher the writer of the research to make investment decisions for their account",
       "choice_d":"Tell the client that there are conflicting reports regarding XYZ",
       "correct_answer":"B",
       "explanation":"An investment adviser who uses outside research must disclose to the client that they use research produced by outside source to make recommendations."
    },
    {
       "id":5266,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following would be considered an IAR if employed by a registered investment adviser?",
       "choice_a":"A secretary who takes phone calls and notes from clients regarding client accounts",
       "choice_b":"A research assistant who prepares data and graphs for a research analyst",
       "choice_c":"An associate who provides quotes to clients by phone",
       "choice_d":"An individual whose sole function is to introduce new business to the registered investment adviser",
       "correct_answer":"D",
       "explanation":"The individual who is employed by the registered investment advisor whose job is to introduce new business to the firm would be considered an IAR. The other functions are support functions and not those associated with an IAR."
    },
    {
       "id":19512,
       "topic_id":4,
       "practice_test_id":6,
       "question":"A well established agent who lives in New Jersey and commutes to his office in New York City is  working out of his vacation home in Florida during the winter. How long can the agent work out of his vacation home without working in a branch office?",
       "choice_a":"30 days",
       "choice_b":"45 days",
       "choice_c":"60 days",
       "choice_d":"90 days",
       "correct_answer":"A",
       "explanation":"The agent may work out of his vacation home for 30 days without being required to report to a branch office."
    },
    {
       "id":19522,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When evaluating pension plans ERISA would regulate all but which of the following plans?",
       "choice_a":"401K",
       "choice_b":"Public sector plan",
       "choice_c":"Private sector plan",
       "choice_d":"A small business plan administered by a qualified third party",
       "correct_answer":"B",
       "explanation":"ERISA regulates private sector pension plans. ERISA does not regulate plans administered for employees of the public sector."
    },
    {
       "id":19529,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered representative invites current and prospective clients to a seminar at an exclusive restaurant in the area. The RR plans to discuss his background, the history of his employing member firm and a mutual fund he is recommending to clients . Which of the following is / are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If the cost of each individual attendee exceeds $100 attending would violate FINRA standards and could be seen as a rebate to current customers </li><li>If the RR mentions the fund\u0027s performance he must state the time frame for which the performance information is quoted </li><li>The RR\u0027s attendance at the restaurant is considered retail communication </li><li> If more than 25 people attend a principal of the firm must be there to supervise</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"When a registered rep holds a seminar the seminar is considered to be retail communication. If the RR mentions a fund\u0027s performance the RR must state the time frame during which the performance occurred. There is no requirement that a principal attend the event and a seminar at a nice restaurant would not be considered a rebate."
    },
    {
       "id":19533,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A new variable annuity product is being introduced by a large well respected company. The variable annuity product would be required to be registered with: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The SEC </li><li>The NYSE </li><li>The appropriate Insurance regulators </li><li>FINRA</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I,II,III, IV",
       "correct_answer":"A",
       "explanation":"A variable annuity is both a security and an insurance product. As such the annuity must be registered with the SEC and the appropriate insurance regulators"
    },
    {
       "id":19535,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An investment executive decides it is time for a career change after 12 years with his firm and opens up a restaurant.  After five years he sells his restaurant and returns to his old firm. He will receive notice of his regulator CE requirement based on:",
       "choice_a":"His initial date of registration",
       "choice_b":"His date of reassociation",
       "choice_c":"His date of resignation",
       "choice_d":"The date he signs his new U 4",
       "correct_answer":"B",
       "explanation":"The agent left the business for more  than 24 months and will therefore have his regulatory continuing education requirement based on his date of re association with the new  firm."
    },
    {
       "id":19536,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Congress passed the Sarbanes -- Oxley legislation to place further requirements on:",
       "choice_a":"The board of directors of public companies",
       "choice_b":"High frequency traders",
       "choice_c":"ECN operators",
       "choice_d":"ETFs",
       "correct_answer":"A",
       "explanation":"Congress passes the Sarbanes -- Oxley legislation to place further requirements on the board of public companies to help ensure that the financial statements released by the company meet higher standards of disclosure and are certified."
    },
    {
       "id":19539,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A college graduate joins a FINRA member firm and completes his licensing exam.  Shortly thereafter he is called home to deal with family issues and is forced to leave the firm.  15 months later he joins a new firm. He will receive notice of his regulatory CE requirement based on:",
       "choice_a":"His initial date of registration",
       "choice_b":"His date of reassociation",
       "choice_c":"His date of resignation",
       "choice_d":"The date he signs his new U 4",
       "correct_answer":"A",
       "explanation":"The agent left the business for less than 24 months and will therefore have his regulatory continuing education requirement based on his initial date of registration with the original firm."
    },
    {
       "id":19544,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client\u0027s secretary stops by your office and hands you your client\u0027s business  card. On the back of the card is the following order \u0022Sell my 500 shares of ABC at the market\u0022 and the back of the card is signed by the client.  You have known the client and his secretary for over 10 years. Which of the following is true?",
       "choice_a":"You may execute the order without further instructions",
       "choice_b":"You may execute the order once the back office has compared the signature with the client\u0027s signature on file",
       "choice_c":"You must call the client to verify the order",
       "choice_d":"You may execute the order if the secretary assures you that the client handed her the card within the last 24 hours",
       "correct_answer":"C",
       "explanation":"An agent may never accept an order for a client\u0027s account from a third party. Even though the client signed the card it would be difficult to authenticate such a signature without the agent seeing the client write the instructions personally."
    },
    {
       "id":19549,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When a registered representative terminates his employment with a broker dealer, the broker dealer files what form with FINRA?",
       "choice_a":"U4",
       "choice_b":"U5",
       "choice_c":"Termination notice form",
       "choice_d":"Registration removal form",
       "correct_answer":"B",
       "explanation":"When an agent joins a firm the agent fills out and the firm files form U4. When an agent is terminated or leaves the firm the firm must submit form U5 within 30 days of the agent leaving or being terminated."
    },
    {
       "id":21171,
       "topic_id":4,
       "practice_test_id":"",
       "question":"An agent at XYZ Broker Dealers, receives a call from and investment advisory client inquiring about Super Chips Inc., a computer chip company that XYZ in taking public next week. The advisor wished to purchase 500 shares of the offering for one of his clients. The interest in Super Chips is strong and the common stock is expected to open at a premium when trading begins. Which of the following is true?",
       "choice_a":"The advisor may not purchase the shares Super Chips for the client",
       "choice_b":"The agent must speak to the client and get the clients authorization to purchase Super Chips",
       "choice_c":"The agent must speak to the client to ensure that the client is not a restricted person",
       "choice_d":"The agent must obtain a representation by the advisor that the client is not a restricted person",
       "correct_answer":"D",
       "explanation":"When a third party with discretionary authority over a client\u0027s account wishes to purchase shares of a new issue on behalf of that client, the third party must provide a representation that the client is not a restricted person. In this case, it is the responsibility of the advisor placing the order."
    },
    {
       "id":21173,
       "topic_id":4,
       "practice_test_id":"",
       "question":"When reviewing content to be disseminated by the broker dealer or by a registered representative concerning business activities, which of the following determine the classification for the communication?",
       "choice_a":"The content and the number and type of recipients",
       "choice_b":"How the content was delivered",
       "choice_c":"If the content is required to be filed with FINRA",
       "choice_d":"If the content requires principal approval",
       "correct_answer":"A",
       "explanation":"When reviewing content to be disseminated by the broker dealer or by a registered representative concerning business activities the content and the number and type of recipients will be the determining factor in classifying the communication. There is no difference between electronic or written forms of distribution."
    },
    {
       "id":21174,
       "topic_id":4,
       "practice_test_id":"",
       "question":"As it relates to money laundering which of the following is the first step in the process?",
       "choice_a":"Execution",
       "choice_b":"Placement",
       "choice_c":"Layering",
       "choice_d":"Integration",
       "correct_answer":"B",
       "explanation":"The first step in the money laundering process is the placement of the funds into an account. This is when the process begins. Once the funds are placed in the account Transactions will take place to try to hide the true origin of the funds. This is known as layering."
    },
    {
       "id":21207,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Investors who purchase which of the following would be required to receive a prospectus?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Unit investment trust  </li><li>Variable annuity  </li><li>Investment company shares  </li><li>A new issue of AAA rate corporate bonds</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"An investor who purchases any of the choices listed must receive a prospectus. a UIT is a type of investment company investors must receive a prospectus when purchasing a UIT."
    },
    {
       "id":25379,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered representative has a long standing client who is 73 years old. The RR speaks to the client twice per month. The RR also has the client\u0027s 43 year old daughter as a client. During the last several months the client has consistently said that his investment objectives have changed and he is now looking for income and wants to purchase a particular income fund. The representative notices that the client often seems to forget speaking to the RR. However, each time they speak he says he wants to purchase the income fund and that his objectives have changed. The registered representative should:",
       "choice_a":"Purchase the fund for the client and mark the order unsolicited",
       "choice_b":"Invite the daughter to the next meeting with the client",
       "choice_c":"Have the daughter obtain written power of attorney for client\u0027s account",
       "choice_d":"Refuse to execute the order",
       "correct_answer":"A",
       "explanation":"The registered representative should execute the order at the customer\u0027s request. Inviting the daughter to the meeting is not a correct choice as an RR may never disclose details of the investor\u0027s holdings to another party without the customer\u0027s consent. The choices in the question make you take an action. If there was an option to consult a principal of the firm prior to executing an order, that would be a better option."
    },
    {
       "id":25382,
       "topic_id":4,
       "practice_test_id":6,
       "question":"When speaking to a client all of the following are not permissible for a registered representative to say, except:",
       "choice_a":"It think it is a good time to liquidate your oil and gas DPP and invest the proceeds into IOU stock it is going to appreciate by at least 10 points in the next few months",
       "choice_b":"If you purchase 200 shares of ABC I will make sure you get 200 share of GET enterprises, our next initial public offering",
       "choice_c":"At 35 XCV looks very attractive our research department has targeted the stock to go to 50 in the next quarter",
       "choice_d":"When thinking about an investment in a CMO, one could view it as similar to an investment in a bond or bond fund as it is designed to provide regular income",
       "correct_answer":"C",
       "explanation":"An RR may never compare a CMO to another interest bearing security. It is also a serious violation to engage in quid pro quo trading by stating that the client will get shares in an upcoming IPO if the client purchases another investment. An RR may never state that a stock WILL go up, any prediction about price must be stated as a belief and not as a fact. Of the choices listed, only the recommendation stating that there is a price target would not be a violation."
    },
    {
       "id":37235,
       "topic_id":4,
       "practice_test_id":"",
       "question":"The main focus of The Prudent investors Act of 1994 was:",
       "choice_a":"to ensure that fiduciaries perform their duties in-line with the client\u0027s needs and objectives",
       "choice_b":"to shift the focus away from performance and to capital preservation when determining if a fiduciary has acted prudently",
       "choice_c":"to shift the focus from prudent investment lists and to focus on the correlation of all Investments in a given portfolio",
       "choice_d":"to ensure the use of derivatives are not employed by investment advisors when acting as a fiduciary for retirement plan assets",
       "correct_answer":"C",
       "explanation":"The main focus of the Prudent investors Act of 1994 was to  largely eliminate the use of prudent investment lists which stated what type of Investments and securities fiduciaries may purchase.  The focus shifted to the correlation of all assets in a given portfolio and how those assets add to the diversification and performance or to the protection of that portfolio."
    },
    {
       "id":37226,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered representative sits down with a potential new customer. The potential customer is a foreign national here on a Visa. The potential customer tells a registered representative that they do a large amount of international business and as a result will be sending and receiving multiple wires from overseas.  Which of the following actions should the rep and the broker-dealer take?",
       "choice_a":"The registered rep should open the account and the broker-dealer should approve the account without restriction as the customer is a foreign business person",
       "choice_b":"The registered rep should refuse to open the account as multiple International wires are red flags for money laundering",
       "choice_c":"The registered rep should open the account, the broker-dealer should approve the account and the account will be subject to heightened supervision as part of the broker dealer\u0027s anti money laundering program",
       "choice_d":"Prior to opening the account the account would have to be approved by the broker dealer\u0027s AML officer",
       "correct_answer":"C",
       "explanation":"The registered rep should open the account and present the account to a principal for approval. The principal should approve the account and the account will be subject to heightened  supervisory requirements due to the frequent International wire transfers"
    },
    {
       "id":37225,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A sophisticated individual investor had purchased shares of restricted stock through a private placement 3 weeks ago.  Now the investor has the opportunity to sell those shares to a qualified institutional buyer. Which of the following choices is correct?",
       "choice_a":"The shares may be sold without regard to volume limits and the shares will be freely transferable once acquired by the qualified institutional buyer",
       "choice_b":"The shares may be sold but are limited to volume limitations of rule 144 and will remain restricted once acquired by the institutional buyer",
       "choice_c":"The shares may not be sold unless the investor has held the shares fully paid for for 6 months",
       "choice_d":"The shares may be sold without regard to any holding period required under rule 144 and will remain restricted",
       "correct_answer":"D",
       "explanation":"Rule 144a allows for the sale of restricted stock to qualified institutional buyers without regard to any holding.  The amount of shares that may be sold to the qualified institutional buyer are not limited under the volume limitations of rule 144.  However the shares acquired by the qualified institutional buyer will remain restricted and may not be freely sold"
    },
    {
       "id":37224,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A registered representative who is working for a broker-dealer that is part of an underwriting syndicate, has informed one of his clients that Argood Technologies will be coming public in the next few weeks.  The registered representative has sent the client a preliminary prospectus in hard copy. After reading the preliminary prospectus, the client likes what he sees and sends the representative a check in order to reserve shares in the upcoming offering.  Which of the following is correct?",
       "choice_a":"The representative may deposit the check in the client\u0027s account but may not guarantee the shares",
       "choice_b":"The representative may deposit the check in the client\u0027s account and reserve shares if the allocation remains open",
       "choice_c":"The representative may deposit the check in the client\u0027s account only if the funds are probably swept into a money market fund pending the effective date of the offering",
       "choice_d":"The registered representative should promptly return the check to the customer",
       "correct_answer":"D",
       "explanation":"During the cooling off period a registered representative may not accept checks nor may they promise customers that they will be able to buy shares when the offer is deemed effective.  The registered representative should promptly return the check to the customer."
    },
    {
       "id":37223,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Jill is a registered representative working at New York Stock Exchange member broker-dealer. Jill\u0027s firm is participating in a firm commitment underwriting of a new issue for XYZ Technologies.  Jill sends her customer a preliminary prospectus regarding the offering. the customer phones in and says he\u0027s interested in buying 500 shares. Prior to the effective date the customer sends in a check  to pay for the 500 shares. Which of the following actions should Jill take?",
       "choice_a":"Jill should promptly forward the check to the cashiering department for deposit into the customer\u0027s account to ensure the funds have cleared for payment of the shares",
       "choice_b":"Jill should promptly forward the check to the syndicate department for deposit to ensure the customer\u0027s interest is recorded",
       "choice_c":"Jill should promptly forward the check to the escrow department for deposit to ensure the customer\u0027s fund\u0027s are available to purchase the shares",
       "choice_d":"Jill should promptly return the check to the customer to ensure compliance with new issue regulations",
       "correct_answer":"D",
       "explanation":"During the cooling off period a registered rep may not promise shares to customers nor may they accept checks for payment for shares.  Therefore, the check should be promptly returned to the customer."
    },
    {
       "id":37222,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Which of the following would be deemed to be a  fiduciary when operating an account at a broker-dealer?",
       "choice_a":"The custodian on a ugma account",
       "choice_b":"The custodian on a utma account",
       "choice_c":"The owner of an account established as transfer on death for a named beneficiary",
       "choice_d":"The conservator on a guardian account",
       "correct_answer":"D",
       "explanation":"The only person who would be deemed to be a fiduciary when operating  any of the above accounts would be the conservator who is appointed by a court to manage the affairs of someone who has been deemed incompetent."
    },
    {
       "id":37221,
       "topic_id":4,
       "practice_test_id":6,
       "question":"An Investor who maintains both a cash and margin account with your firm executes in order in a non discretionary account. The investor tells the representative to buy 500 shares ABC whenever the representative feels the price is right.  Which of the following statements is correct?",
       "choice_a":"The order may not be accepted as this is a non discretionary account",
       "choice_b":"The order may be accepted if the agent receives discretionary authority in writing prior to executing the order",
       "choice_c":"The order must be approved both before and after the execution by a principal of the firm",
       "choice_d":"The order must be approved by a principal once the transaction has been completed",
       "correct_answer":"D",
       "explanation":"An investor may provide a registered representative with price and time discretion, allowing the representative to choose the price for the security.  This order would only require principal approval after the transaction has been completed."
    },
    {
       "id":37213,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client who has just purchased shares pursuant to a regulation A offering must get which of the following?",
       "choice_a":"A prospectus 48 hours prior to the sale",
       "choice_b":"A prospectus within 48 Hours of completion of the transaction",
       "choice_c":"An offering circular within 48 Hours of completion of the transaction",
       "choice_d":"An offering circular 48 hours prior to the sale",
       "correct_answer":"D",
       "explanation":"A client who is purchasing shares under regulation A offering must receive an offering circular 48 hours prior to the sale."
    },
    {
       "id":37240,
       "topic_id":4,
       "practice_test_id":"",
       "question":"Mr. Thompson, a  70 year old client of a large financial services firm, sent a letter via email to his investment professional requesting that the firm transfer $100,000 to the account of LMN Manufacturing. Which of the following would be the greatest concern to the firm?",
       "choice_a":"Mr. Thompson maybe the victim of identity theft",
       "choice_b":"Mr. Thompson Maybe the victim of elder abuse",
       "choice_c":"Mr. Thompson may be engaging in money laundering",
       "choice_d":"Mr. Thompson was not the sender of the email",
       "correct_answer":"C",
       "explanation":"While all of the choices listed would be concerns for the firm, the request to transfer money to another seemingly unrelated account is a serious red flag for money laundering and would be the biggest concern for the firm."
    },
    {
       "id":37241,
       "topic_id":4,
       "practice_test_id":"",
       "question":"A client of your broker-dealer is a foreign national  who engages in international business transactions. The products that his company makes are traditionally sold for several hundred dollars each.  The firm notices that the client has recently received a wire transfer into his account in the amount of $4,200. The wire was received from a little-known bank based in a country known to sponsor terrorism. Which of the following actions should the firm take?",
       "choice_a":"The firm should submit a suspicious activity report",
       "choice_b":"The firm should submit a currency transaction report",
       "choice_c":"The firm should maintain a record of the wire transfer",
       "choice_d":"The firm should inform FinCen of the wire transfer",
       "correct_answer":"C",
       "explanation":"Financial services firms are required to maintain a record of any International  wire greater than $3,000. The customer is known to export products overseas and the dollar value does not exceed the $5,000 threshold requiring the filing of a suspicious activity report."
    },
    {
       "id":37242,
       "topic_id":4,
       "practice_test_id":6,
       "question":"Sue is a retired schoolteacher who has maintained an account with your firm for more than 20 years.  The account has been primarily invested to generate income to help Sue meet her monthly expenses. Sue enjoys the check writing privileges afforded to her through your firm\u0027s money market account and generally spends about $3,000 per month.  One day Sue calls in and requests that a check be sent to a third party in the amount of $50,000. Which of the following would not be an appropriate action based on this request?",
       "choice_a":"Withhold sending the check for 15 days",
       "choice_b":"Call the trusted contact and inquire about the validity of the request",
       "choice_c":"Investigate the recipient of the payment",
       "choice_d":"Forward the check as requested by the client",
       "correct_answer":"D",
       "explanation":"The request is significantly outside the normal course of business for the retired account owner. The large sum being sent to a third party is a substantial red flag for elder abuse.  The registered rep and the firm should do all they can to ensure that the request is indeed valid. All of the choices listed would be appropriate actions for the firm to take with the exception of Simply forwarding the check as requested by the client."
    }
  ]